import React from 'react';
import styles from './Dashboard_Detail.module.css';
import Navbar from '../Navbar';

interface Dashboard_DetailProps {}

const Dashboard_Detail: React.FC<Dashboard_DetailProps> = () => {
    return (
        <>
    <div className={styles.dashboard}>
      <Navbar stepNumber={0}/>
      <div className={styles.frame_293}>
        <div className={styles.nav_menu}>
          <div className={styles.menu}>
            <div className={styles.menu2}>
              <div className={styles.remix_icons_line_system_arrow_left_line}>
                <svg
                  className={styles.group}
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.52337 9.16786H16.6667V10.8345H6.52337L10.9934 15.3045L9.81504 16.4829L3.33337 10.0012L9.81504 3.51953L10.9934 4.69786L6.52337 9.16786Z"
                    fill="#262626"
                  />
                </svg>
              </div>
              <div className={styles.all_sites}>All sites</div>
            </div>
            <div className={styles.frame_2608579}>
              <div className={styles.frame_2608576}>
                <div className={styles.sidemenu_item}>
                  <div className={styles.frame_100}>
                    <svg
                      className={styles.line_02_up}
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M3.33333 2.5C3.79357 2.5 4.16667 2.8731 4.16667 3.33333V14.1667C4.16667 15.0871 4.91286 15.8333 5.83333 15.8333H16.6667C17.1269 15.8333 17.5 16.2064 17.5 16.6667C17.5 17.1269 17.1269 17.5 16.6667 17.5H5.83333C3.99238 17.5 2.5 16.0076 2.5 14.1667V3.33333C2.5 2.8731 2.8731 2.5 3.33333 2.5Z"
                        fill="#262626"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M16.9302 2.54299C17.3668 2.68853 17.6028 3.16046 17.4573 3.59708L15.81 8.53875C15.2223 10.3018 12.9847 10.8301 11.6706 9.51594L10.4843 8.32969C10.0463 7.89164 9.30038 8.06772 9.10448 8.65542L7.45726 13.5971C7.31172 14.0337 6.83979 14.2697 6.40317 14.1241C5.96655 13.9786 5.73058 13.5067 5.87612 13.07L7.52334 8.12837C8.11104 6.36528 10.3487 5.83705 11.6628 7.15118L12.8491 8.33743C13.2871 8.77547 14.033 8.59939 14.2289 8.0117L15.8761 3.07004C16.0217 2.63342 16.4936 2.39745 16.9302 2.54299Z"
                        fill="#262626"
                      />
                    </svg>

                    <div className={styles.title}>Analytics</div>
                  </div>
                  <div className={styles.frame_121}>
                    <div className={styles.pro_plan}>PRO plan</div>
                  </div>
                </div>
                <div className={styles.sidemenu_item2}>
                  <div className={styles.frame_100}>
                    <svg
                      className={styles.folder_user}
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M12.0002 12.332C12.314 11.9141 12.5 11.3948 12.5 10.832C12.5 9.45132 11.3807 8.33203 9.99996 8.33203C8.61925 8.33203 7.49996 9.45132 7.49996 10.832C7.49996 11.3948 7.68591 11.9141 7.99973 12.332C7.19023 12.9401 6.66663 13.9083 6.66663 14.9987V15.832H8.33329V14.9987C8.33329 14.0782 9.07948 13.332 9.99996 13.332C10.9204 13.332 11.6666 14.0782 11.6666 14.9987V15.832H13.3333V14.9987C13.3333 13.9083 12.8097 12.9401 12.0002 12.332ZM10.8333 10.832C10.8333 11.2923 10.4602 11.6654 9.99996 11.6654C9.53972 11.6654 9.16663 11.2923 9.16663 10.832C9.16663 10.3718 9.53972 9.9987 9.99996 9.9987C10.4602 9.9987 10.8333 10.3718 10.8333 10.832Z"
                        fill="#262626"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M8.52017 5.0448C8.35066 5.00411 8.16091 4.99875 7.50977 4.99875H6.49996C5.78614 4.99875 5.3009 4.9994 4.92582 5.03004C4.56048 5.05989 4.37364 5.114 4.24331 5.18041C3.92971 5.3402 3.67474 5.59516 3.51495 5.90877C3.44854 6.0391 3.39444 6.22594 3.36459 6.59128C3.33394 6.96636 3.33329 7.4516 3.33329 8.16542V11.8321C3.33329 12.5459 3.33394 13.0311 3.36459 13.4062C3.39444 13.7716 3.44854 13.9584 3.51495 14.0887C3.67474 14.4023 3.92971 14.6573 4.24331 14.8171C4.37364 14.8835 4.56048 14.9376 4.92582 14.9675C5.3009 14.9981 5.78614 14.9987 6.49996 14.9987H13.5C14.2138 14.9987 14.699 14.9981 15.0741 14.9675C15.4394 14.9376 15.6263 14.8835 15.7566 14.8171C16.0702 14.6573 16.3252 14.4023 16.485 14.0887C16.5514 13.9584 16.6055 13.7716 16.6353 13.4062C16.666 13.0311 16.6666 12.5459 16.6666 11.8321V9.83208C16.6666 9.11827 16.666 8.63302 16.6353 8.25795C16.6055 7.8926 16.5514 7.70577 16.485 7.57543C16.3252 7.26183 16.0702 7.00686 15.7566 6.84707C15.6263 6.78066 15.4394 6.72656 15.0741 6.69671C14.699 6.66606 14.2138 6.66542 13.5 6.66542H10.8333C10.6123 6.66542 10.4003 6.57762 10.244 6.42134L9.74894 5.92625C9.28852 5.46582 9.15056 5.33543 9.00192 5.24435C8.8528 5.15297 8.69023 5.08563 8.52017 5.0448ZM7.59467 3.33206C8.12384 3.33181 8.52367 3.33161 8.90924 3.42418C9.24936 3.50584 9.57451 3.64052 9.87276 3.82328C10.2109 4.03047 10.4934 4.31333 10.8674 4.68768C10.8872 4.70744 10.9072 4.72746 10.9275 4.74773L11.1785 4.99875L13.5344 4.99875C14.2052 4.99874 14.7588 4.99873 15.2098 5.03558C15.6782 5.07385 16.1088 5.15599 16.5133 5.36206C17.1405 5.68164 17.6504 6.19158 17.97 6.81878C18.1761 7.22323 18.2582 7.65381 18.2965 8.12223C18.3333 8.57322 18.3333 9.12685 18.3333 9.79765V11.8665C18.3333 12.5373 18.3333 13.0909 18.2965 13.5419C18.2582 14.0104 18.1761 14.4409 17.97 14.8454C17.6504 15.4726 17.1405 15.9825 16.5133 16.3021C16.1088 16.5082 15.6782 16.5903 15.2098 16.6286C14.7588 16.6654 14.2052 16.6654 13.5344 16.6654H6.46556C5.79475 16.6654 5.24111 16.6654 4.79011 16.6286C4.32169 16.5903 3.8911 16.5082 3.48666 16.3021C2.85945 15.9825 2.34952 15.4726 2.02994 14.8454C1.82386 14.4409 1.74173 14.0104 1.70345 13.5419C1.66661 13.0909 1.66662 12.5373 1.66663 11.8665V8.131C1.66662 7.46019 1.66661 6.90656 1.70345 6.45556C1.74173 5.98715 1.82386 5.55656 2.02994 5.15212C2.34952 4.52491 2.85945 4.01497 3.48666 3.6954C3.8911 3.48932 4.32169 3.40718 4.79011 3.36891C5.2411 3.33206 5.79474 3.33207 6.46554 3.33208L7.50977 3.33208C7.53844 3.33208 7.56674 3.33207 7.59467 3.33206Z"
                        fill="#262626"
                      />
                    </svg>

                    <div className={styles.title}>Leads</div>
                  </div>
                  <div className={styles.frame_121}>
                    <div className={styles.pro_plan}>PRO plan</div>
                  </div>
                </div>
                <div className={styles.sidemenu_item2}>
                  <div className={styles.frame_100}>
                    <svg
                      className={styles.megaphone}
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15.8334 9.58203C15.8334 8.89168 16.393 8.33203 17.0834 8.33203C17.7737 8.33203 18.3334 8.89168 18.3334 9.58203C18.3334 10.2724 17.7737 10.832 17.0834 10.832C16.393 10.832 15.8334 10.2724 15.8334 9.58203Z"
                        fill="#262626"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M4.98379 11.5039L5.59625 14.5662C5.64677 14.8188 5.86858 15.0007 6.1262 15.0007C6.42467 15.0007 6.66664 14.7587 6.66664 14.4602V11.6673H8.3333V14.4602C8.3333 15.6792 7.34515 16.6673 6.1262 16.6673C5.07411 16.6673 4.16828 15.9247 3.96195 14.8931L3.34949 11.8308L4.98379 11.5039Z"
                        fill="#262626"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M17.5 6.25701C17.5 4.00432 15.0549 2.60199 13.1105 3.7395L9.86193 5.63998C8.713 6.31213 7.40587 6.66639 6.07476 6.66639H4.58329C2.97246 6.66639 1.66663 7.97223 1.66663 9.58306C1.66663 11.1939 2.97246 12.4997 4.58329 12.4997H6.07136C7.40441 12.4997 8.71336 12.855 9.86345 13.529L13.1086 15.4308C15.053 16.5703 17.5 15.1681 17.5 12.9144V6.25701ZM13.9521 5.17808C14.7854 4.69057 15.8333 5.29157 15.8333 6.25701V12.9144C15.8333 13.8803 14.7846 14.4812 13.9513 13.9929L10.7061 12.0911C10.2144 11.8029 9.69886 11.5624 9.16663 11.3714V7.79589C9.69789 7.60554 10.2125 7.3658 10.7035 7.07855L13.9521 5.17808ZM7.49996 8.22159C7.03022 8.29553 6.55376 8.33306 6.07476 8.33306H4.58329C3.89294 8.33306 3.33329 8.8927 3.33329 9.58306C3.33329 10.2734 3.89294 10.8331 4.58329 10.8331H6.07136C6.55153 10.8331 7.02913 10.8708 7.49996 10.9451V8.22159Z"
                        fill="#262626"
                      />
                    </svg>

                    <div className={styles.title}>SEO</div>
                  </div>
                  <div className={styles.frame_121}>
                    <div className={styles.pro_plan}>PRO plan</div>
                  </div>
                </div>
                <div className={styles.sidemenu_item2}>
                  <div className={styles.frame_100}>
                    <svg
                      className={styles.bank_card}
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5 12.5013C5 12.0411 5.3731 11.668 5.83333 11.668H9.16667C9.6269 11.668 10 12.0411 10 12.5013C10 12.9615 9.6269 13.3346 9.16667 13.3346H5.83333C5.3731 13.3346 5 12.9615 5 12.5013Z"
                        fill="#262626"
                      />
                      <path
                        d="M1.66663 7.5H18.3333V9.16667H1.66663V7.5Z"
                        fill="#262626"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M6.46554 3.33203H13.5344C14.2052 3.33202 14.7588 3.33201 15.2098 3.36886C15.6782 3.40713 16.1088 3.48927 16.5133 3.69534C17.1405 4.01492 17.6504 4.52486 17.97 5.15206C18.1761 5.55651 18.2582 5.9871 18.2965 6.45551C18.3333 6.9065 18.3333 7.46013 18.3333 8.13093V11.8665C18.3333 12.5373 18.3333 13.0909 18.2965 13.5419C18.2582 14.0103 18.1761 14.4409 17.97 14.8453C17.6504 15.4725 17.1405 15.9825 16.5133 16.3021C16.1088 16.5081 15.6782 16.5903 15.2098 16.6285C14.7588 16.6654 14.2052 16.6654 13.5344 16.6654H6.46556C5.79475 16.6654 5.24111 16.6654 4.79011 16.6285C4.32169 16.5903 3.8911 16.5081 3.48666 16.3021C2.85945 15.9825 2.34952 15.4725 2.02994 14.8453C1.82386 14.4409 1.74173 14.0103 1.70345 13.5419C1.66661 13.0909 1.66662 12.5373 1.66663 11.8664V8.13095C1.66662 7.46014 1.66661 6.90651 1.70345 6.45551C1.74173 5.9871 1.82386 5.55651 2.02994 5.15206C2.34952 4.52486 2.85945 4.01492 3.48666 3.69534C3.8911 3.48927 4.32169 3.40713 4.79011 3.36886C5.2411 3.33201 5.79474 3.33202 6.46554 3.33203ZM4.92582 5.02999C4.56048 5.05984 4.37364 5.11395 4.24331 5.18035C3.92971 5.34014 3.67474 5.59511 3.51495 5.90871C3.44854 6.03905 3.39444 6.22588 3.36459 6.59123C3.33394 6.96631 3.33329 7.45155 3.33329 8.16537V11.832C3.33329 12.5458 3.33394 13.0311 3.36459 13.4062C3.39444 13.7715 3.44854 13.9584 3.51495 14.0887C3.67474 14.4023 3.92971 14.6573 4.24331 14.817C4.37364 14.8835 4.56048 14.9376 4.92582 14.9674C5.3009 14.9981 5.78614 14.9987 6.49996 14.9987H13.5C14.2138 14.9987 14.699 14.9981 15.0741 14.9674C15.4394 14.9376 15.6263 14.8835 15.7566 14.817C16.0702 14.6573 16.3252 14.4023 16.485 14.0887C16.5514 13.9584 16.6055 13.7715 16.6353 13.4062C16.666 13.0311 16.6666 12.5458 16.6666 11.832V8.16537C16.6666 7.45155 16.666 6.9663 16.6353 6.59123C16.6055 6.22588 16.5514 6.03905 16.485 5.90871C16.3252 5.59511 16.0702 5.34014 15.7566 5.18035C15.6263 5.11395 15.4394 5.05984 15.0741 5.02999C14.699 4.99935 14.2138 4.9987 13.5 4.9987H6.49996C5.78614 4.9987 5.3009 4.99935 4.92582 5.02999Z"
                        fill="#262626"
                      />
                    </svg>

                    <div className={styles.title}>Billing</div>
                  </div>
                </div>
                <div className={styles.frame_2608578}>
                  <div className={styles.sidemenu_item2}>
                    <div className={styles.frame_100}>
                      <svg
                        className={styles.line_03_up}
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M14.0339 7.57031L12.8089 10.0204C13.3915 10.0921 13.9121 10.3644 14.2995 10.766L15.5245 8.31591C14.9419 8.24413 14.4213 7.97189 14.0339 7.57031ZM11.4222 10.2451C10.9074 10.4915 10.4901 10.9088 10.2437 11.4236L8.57791 9.75783C9.09271 9.51147 9.51006 9.09412 9.75642 8.57932L11.4222 10.2451ZM5.70061 9.23698L4.47559 11.687C5.05821 11.7588 5.57878 12.0311 5.96618 12.4326L7.1912 9.98258C6.60857 9.91079 6.088 9.63855 5.70061 9.23698Z"
                          fill="#262626"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M16.6666 5.83203C16.6666 6.29227 16.2935 6.66536 15.8333 6.66536C15.3731 6.66536 15 6.29227 15 5.83203C15 5.37179 15.3731 4.9987 15.8333 4.9987C16.2935 4.9987 16.6666 5.37179 16.6666 5.83203ZM18.3333 5.83203C18.3333 7.21274 17.214 8.33203 15.8333 8.33203C14.4526 8.33203 13.3333 7.21274 13.3333 5.83203C13.3333 4.45132 14.4526 3.33203 15.8333 3.33203C17.214 3.33203 18.3333 4.45132 18.3333 5.83203ZM8.33329 7.4987C8.33329 7.95894 7.9602 8.33203 7.49996 8.33203C7.03972 8.33203 6.66663 7.95894 6.66663 7.4987C6.66663 7.03846 7.03972 6.66536 7.49996 6.66536C7.9602 6.66536 8.33329 7.03846 8.33329 7.4987ZM9.99996 7.4987C9.99996 8.87941 8.88067 9.9987 7.49996 9.9987C6.11925 9.9987 4.99996 8.87941 4.99996 7.4987C4.99996 6.11799 6.11925 4.9987 7.49996 4.9987C8.88067 4.9987 9.99996 6.11799 9.99996 7.4987ZM4.99996 14.1654C4.99996 14.6256 4.62686 14.9987 4.16663 14.9987C3.70639 14.9987 3.33329 14.6256 3.33329 14.1654C3.33329 13.7051 3.70639 13.332 4.16663 13.332C4.62686 13.332 4.99996 13.7051 4.99996 14.1654ZM6.66663 14.1654C6.66663 15.5461 5.54734 16.6654 4.16663 16.6654C2.78591 16.6654 1.66663 15.5461 1.66663 14.1654C1.66663 12.7847 2.78591 11.6654 4.16663 11.6654C5.54734 11.6654 6.66663 12.7847 6.66663 14.1654ZM12.5 13.332C12.9602 13.332 13.3333 12.9589 13.3333 12.4987C13.3333 12.0385 12.9602 11.6654 12.5 11.6654C12.0397 11.6654 11.6666 12.0385 11.6666 12.4987C11.6666 12.9589 12.0397 13.332 12.5 13.332ZM12.5 14.9987C13.8807 14.9987 15 13.8794 15 12.4987C15 11.118 13.8807 9.9987 12.5 9.9987C11.1192 9.9987 9.99996 11.118 9.99996 12.4987C9.99996 13.8794 11.1192 14.9987 12.5 14.9987Z"
                          fill="#262626"
                        />
                      </svg>

                      <div className={styles.title}>Integrations</div>
                    </div>
                    <div className={styles.frame_121}>
                      <div className={styles.pro_plan}>PRO plan</div>
                    </div>
                  </div>
                  <div className={styles.frame_2608577}>
                    <div className={styles.sidemenu_item3}>
                      <div className={styles.frame_100}>
                        <svg
                          className={styles.plus}
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M10 2.5C10.4602 2.5 10.8333 2.8731 10.8333 3.33333V9.16667H16.6667C17.1269 9.16667 17.5 9.53976 17.5 10C17.5 10.4602 17.1269 10.8333 16.6667 10.8333H10.8333V16.6667C10.8333 17.1269 10.4602 17.5 10 17.5C9.53976 17.5 9.16667 17.1269 9.16667 16.6667V10.8333H3.33333C2.8731 10.8333 2.5 10.4602 2.5 10C2.5 9.53976 2.8731 9.16667 3.33333 9.16667H9.16667V3.33333C9.16667 2.8731 9.53976 2.5 10 2.5Z"
                            fill="#262626"
                          />
                        </svg>

                        <div className={styles.title}>Webhooks</div>
                      </div>
                    </div>
                    <div className={styles.sidemenu_item3}>
                      <div className={styles.frame_100}>
                        <svg
                          className={styles.plus2}
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M10 2.5C10.4602 2.5 10.8333 2.8731 10.8333 3.33333V9.16667H16.6667C17.1269 9.16667 17.5 9.53976 17.5 10C17.5 10.4602 17.1269 10.8333 16.6667 10.8333H10.8333V16.6667C10.8333 17.1269 10.4602 17.5 10 17.5C9.53976 17.5 9.16667 17.1269 9.16667 16.6667V10.8333H3.33333C2.8731 10.8333 2.5 10.4602 2.5 10C2.5 9.53976 2.8731 9.16667 3.33333 9.16667H9.16667V3.33333C9.16667 2.8731 9.53976 2.5 10 2.5Z"
                            fill="#262626"
                          />
                        </svg>

                        <div className={styles.title}>Google Sheets</div>
                      </div>
                    </div>
                    <div className={styles.sidemenu_item3}>
                      <div className={styles.frame_100}>
                        <svg
                          className={styles.plus3}
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M10 2.5C10.4602 2.5 10.8333 2.8731 10.8333 3.33333V9.16667H16.6667C17.1269 9.16667 17.5 9.53976 17.5 10C17.5 10.4602 17.1269 10.8333 16.6667 10.8333H10.8333V16.6667C10.8333 17.1269 10.4602 17.5 10 17.5C9.53976 17.5 9.16667 17.1269 9.16667 16.6667V10.8333H3.33333C2.8731 10.8333 2.5 10.4602 2.5 10C2.5 9.53976 2.8731 9.16667 3.33333 9.16667H9.16667V3.33333C9.16667 2.8731 9.53976 2.5 10 2.5Z"
                            fill="#262626"
                          />
                        </svg>

                        <div className={styles.title}>Google Analytics</div>
                      </div>
                    </div>
                    <div className={styles.sidemenu_item3}>
                      <div className={styles.frame_100}>
                        <svg
                          className={styles.plus4}
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M10 2.5C10.4602 2.5 10.8333 2.8731 10.8333 3.33333V9.16667H16.6667C17.1269 9.16667 17.5 9.53976 17.5 10C17.5 10.4602 17.1269 10.8333 16.6667 10.8333H10.8333V16.6667C10.8333 17.1269 10.4602 17.5 10 17.5C9.53976 17.5 9.16667 17.1269 9.16667 16.6667V10.8333H3.33333C2.8731 10.8333 2.5 10.4602 2.5 10C2.5 9.53976 2.8731 9.16667 3.33333 9.16667H9.16667V3.33333C9.16667 2.8731 9.53976 2.5 10 2.5Z"
                            fill="#262626"
                          />
                        </svg>

                        <div className={styles.title}>Google Adwords</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.sidemenu_item2}>
                <div className={styles.frame_100}>
                  <svg
                    className={styles.map}
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M6.92319 3.37406C7.34776 3.29905 7.78451 3.33512 8.19102 3.47876L12.3642 4.95331C12.4997 5.00119 12.6452 5.01321 12.7868 4.98821L15.3983 4.52681C16.9293 4.25632 18.3333 5.43398 18.3333 6.98868V13.6037C18.3333 14.8166 17.4627 15.8546 16.2682 16.0656L13.0767 16.6295C12.6522 16.7045 12.2154 16.6684 11.8089 16.5248L7.63575 15.0503C7.50025 15.0024 7.35467 14.9904 7.21315 15.0154L4.60154 15.4767C3.07056 15.7472 1.66663 14.5695 1.66663 13.0148V6.39977C1.66663 5.18685 2.53727 4.14891 3.73169 3.9379L6.92319 3.37406ZM4.02165 5.57915L6.66663 5.11187V13.4194L4.3116 13.8355C3.80127 13.9256 3.33329 13.5331 3.33329 13.0148V6.39977C3.33329 5.99546 3.62351 5.64949 4.02165 5.57915ZM11.6666 14.7069L8.33329 13.5291V5.29668L11.6666 6.47449V14.7069ZM13.3333 14.8917L15.9783 14.4243C16.3764 14.354 16.6666 14.008 16.6666 13.6037V6.98868C16.6666 6.47045 16.1986 6.07789 15.6883 6.16805L13.3333 6.58413V14.8917Z"
                      fill="#262626"
                    />
                  </svg>

                  <div className={styles.title}>Plans</div>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.frame_2608580}>
            <div className={styles.upgrade_message}>
              <div className={styles.frame_227}>
                <div className={styles.txt}>
                  <div className={styles.txt2}>
                    <svg
                      className={styles.lightning}
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M12.2251 12.9989L11.7287 17.6452L16.9468 10.9989H11.7747L12.2703 6.36508L7.0627 12.9989H12.2251ZM14.6295 3.11328C14.7363 2.11449 13.4689 1.59934 12.8486 2.38946L4.21979 13.3815C3.70467 14.0377 4.17215 14.9989 5.00638 14.9989H10.0001L9.37005 20.8961C9.26335 21.8948 10.5307 22.4098 11.1509 21.6198L19.7899 10.6165C20.3051 9.9603 19.8376 8.99895 19.0034 8.99895H14.0001L14.6295 3.11328Z"
                        fill="#9176ED"
                      />
                    </svg>

                    <div className={styles.upgrade_your_plan}>Upgrade your plan</div>
                  </div>
                  <div className={styles.get_more_benefits_for_your_projects}>
                    Get more benefits for your projects
                  </div>
                </div>
              </div>
              <div className={styles.action}>
                <div className={styles.dismiss}>Dismiss</div>
                <div className={styles.upgrade}>Upgrade</div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.frame_292}>
          <div className={styles.frame_110}>
            <div className={styles.frame_109}>
              <div className={styles.karate_school}>Karate School</div>
              <div className={styles.remix_icons_line_system_arrow_right_up_line}>
                <svg
                  className={styles.group2}
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.0039 9.414L7.39691 18.021L5.98291 16.607L14.5889 8H7.00391V6H18.0039V17H16.0039V9.414Z"
                    fill="#262626"
                  />
                </svg>
              </div>
            </div>
            <div className={styles.frame_168}>
              <div className={styles.button}>
                <svg
                  className={styles.share}
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.8333 3.67988L12.7441 5.59062C13.0695 5.91606 13.5972 5.91606 13.9226 5.59062C14.248 5.26518 14.248 4.73755 13.9226 4.41211C13.3371 3.84115 11.4866 2.171 10.5518 1.33026C10.2369 1.04703 9.76218 1.046 9.44631 1.32816C8.51922 2.15633 6.69381 3.79572 6.07741 4.41211C5.75197 4.73755 5.75197 5.26518 6.07741 5.59062C6.40285 5.91606 6.93049 5.91606 7.25592 5.59062L9.16667 3.67988V12.5014C9.16667 12.9616 9.53976 13.3347 10 13.3347C10.4602 13.3347 10.8333 12.9616 10.8333 12.5014V3.67988Z"
                    fill="#262626"
                  />
                  <path
                    d="M4.16667 10.0014C4.16667 9.54113 3.79357 9.16803 3.33333 9.16803C2.8731 9.16803 2.5 9.54113 2.5 10.0014V16.668C2.5 17.3311 2.76339 17.967 3.23223 18.4358C3.70107 18.9046 4.33696 19.168 5 19.168H15C15.663 19.168 16.2989 18.9046 16.7678 18.4358C17.2366 17.967 17.5 17.3311 17.5 16.668V10.0014C17.5 9.54113 17.1269 9.16803 16.6667 9.16803C16.2064 9.16803 15.8333 9.54113 15.8333 10.0014V16.668C15.8333 16.889 15.7455 17.101 15.5893 17.2573C15.433 17.4136 15.221 17.5014 15 17.5014H5C4.77899 17.5014 4.56702 17.4136 4.41074 17.2573C4.25446 17.101 4.16667 16.889 4.16667 16.668V10.0014Z"
                    fill="#262626"
                  />
                </svg>

                <div className={styles.accept_all_cockies}>Share</div>
              </div>
              <div className={styles.button}>
                <svg
                  className={styles.edit}
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3.33325 17.5013C3.33325 17.0411 3.70635 16.668 4.16659 16.668H15.8333C16.2935 16.668 16.6666 17.0411 16.6666 17.5013C16.6666 17.9615 16.2935 18.3346 15.8333 18.3346H4.16659C3.70635 18.3346 3.33325 17.9615 3.33325 17.5013Z"
                    fill="#262626"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10.343 2.64427C11.6448 1.34253 13.7553 1.34254 15.0571 2.64428L15.6882 3.27541C16.9899 4.57716 16.9899 6.68771 15.6882 7.98946L9.93311 13.7445C9.70192 13.9757 9.40783 14.1338 9.08746 14.1991L5.33447 14.964C4.16401 15.2026 3.12999 14.1686 3.36852 12.9981L4.13336 9.24502C4.19865 8.92463 4.35674 8.63052 4.58795 8.39931L10.343 2.64427ZM13.8785 3.82279C13.2277 3.17192 12.1724 3.17192 11.5215 3.82279L11.1785 4.16582L14.1666 7.15398L14.5097 6.81095C15.1606 6.16007 15.1606 5.10479 14.5097 4.45392L13.8785 3.82279ZM7.01181 8.33248L9.99998 5.34433L12.9881 8.33248L9.99997 11.3206L7.01181 8.33248ZM5.8333 9.51099L5.76646 9.57783L5.00162 13.3309L8.7546 12.566L8.82145 12.4991L5.8333 9.51099Z"
                    fill="#262626"
                  />
                </svg>

                <div className={styles.accept_all_cockies}>Edit</div>
              </div>
              <div className={styles.button2}>
                <svg
                  className={styles.rocket_launch}
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <mask
                    id="mask0_856_14339"
                    style={{maskType: 'alpha'}}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="20"
                    height="20"
                  >
                    <rect width="20" height="20" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_856_14339)">
                    <path
                      d="M5.02083 8.60564L6.64583 9.14731C6.85417 8.75842 7.06944 8.37995 7.29167 8.01189C7.51389 7.64384 7.75 7.27925 8 6.91814L6.85417 6.77231L5.02083 8.60564ZM7.89583 9.95981L10.0208 12.0848C10.6875 11.7376 11.3194 11.3591 11.9167 10.9494C12.5139 10.5397 13.0764 10.0709 13.6042 9.54314C14.4375 8.70981 15.1285 7.7862 15.6771 6.77231C16.2257 5.75842 16.5 4.66814 16.5 3.50148C15.3194 3.50148 14.2222 3.77231 13.2083 4.31398C12.1944 4.85564 11.2708 5.54314 10.4375 6.37648C9.90972 6.90425 9.4375 7.46675 9.02083 8.06398C8.60417 8.6612 8.22917 9.29314 7.89583 9.95981ZM11.4375 8.56398C11.1458 8.27231 11 7.91814 11 7.50148C11 7.08481 11.1458 6.73064 11.4375 6.43898C11.7292 6.14731 12.0833 6.00148 12.5 6.00148C12.9167 6.00148 13.2708 6.14731 13.5625 6.43898C13.8542 6.73064 14 7.08481 14 7.50148C14 7.91814 13.8542 8.27231 13.5625 8.56398C13.2708 8.85564 12.9167 9.00148 12.5 9.00148C12.0833 9.00148 11.7292 8.85564 11.4375 8.56398ZM11.3958 14.9806L13.2292 13.1473L13.0833 12.0015C12.7222 12.2515 12.3576 12.4876 11.9896 12.7098C11.6215 12.932 11.2431 13.1473 10.8542 13.3556L11.3958 14.9806ZM17.7917 2.18898C18.1528 3.60564 18.0243 5.06398 17.4062 6.56398C16.7882 8.06398 15.9167 9.37648 14.7917 10.5015L14.4583 10.8556L14.7083 12.9598C14.7361 13.1959 14.7118 13.4216 14.6354 13.6369C14.559 13.8522 14.4375 14.0431 14.2708 14.2098L10.7292 17.7515L9.3125 13.5223L6.5 10.689L2.25 9.27231L5.79167 5.70981C5.95833 5.54314 6.14931 5.42161 6.36458 5.34523C6.57986 5.26884 6.80556 5.24453 7.04167 5.27231L9.14583 5.54314L9.54167 5.16814C10.6667 4.04314 11.9688 3.17161 13.4479 2.55356C14.9271 1.9355 16.375 1.81398 17.7917 2.18898ZM3.70833 13.1056C4.15278 12.689 4.67708 12.4841 5.28125 12.4911C5.88542 12.498 6.40972 12.7237 6.85417 13.1681C7.27083 13.5848 7.48264 14.0883 7.48958 14.6786C7.49653 15.2688 7.30556 15.7862 6.91667 16.2306C6.31944 16.9112 5.57292 17.3383 4.67708 17.5119C3.78125 17.6855 2.88889 17.8487 2 18.0015C2.15278 17.1265 2.3125 16.248 2.47917 15.3661C2.64583 14.4841 3.05556 13.7306 3.70833 13.1056ZM4.64583 14.2931C4.40972 14.5293 4.25347 14.807 4.17708 15.1265C4.10069 15.4459 4.01389 15.7654 3.91667 16.0848C4.23611 16.0015 4.55208 15.9181 4.86458 15.8348C5.17708 15.7515 5.44444 15.5918 5.66667 15.3556C5.81944 15.189 5.91319 14.9945 5.94792 14.7723C5.98264 14.5501 5.92361 14.3626 5.77083 14.2098C5.61806 14.057 5.43403 13.9945 5.21875 14.0223C5.00347 14.0501 4.8125 14.1404 4.64583 14.2931Z"
                      fill="white"
                    />
                  </g>
                </svg>

                <div className={styles.accept_all_cockies2}>Publish</div>
                <svg
                  className={styles.chevron_down2}
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M12.6726 8.16205C12.3472 7.83661 11.8195 7.83661 11.4941 8.16205L9.58333 10.0728L7.67259 8.16205C7.34715 7.83661 6.81951 7.83661 6.49408 8.16205C6.16864 8.48748 6.16864 9.01512 6.49408 9.34056L8.99408 11.8406C9.31951 12.166 9.84715 12.166 10.1726 11.8406L12.6726 9.34056C12.998 9.01512 12.998 8.48748 12.6726 8.16205Z"
                    fill="white"
                  />
                </svg>
              </div>
            </div>
          </div>
          <div className={styles.frame_291}>
            <div className={styles.cintent}>
              <div className={styles.stats}>
                <div className={styles.frame_147}>
                  <div className={styles.users}>Users</div>
                  <div className={styles.last_7_days}>Last 7 days</div>
                </div>
                <svg
                  className={styles.vector_3}
                  width="290"
                  height="48"
                  viewBox="0 0 290 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2 46C14.3468 46 18.4803 45.1631 28.1241 38.9001C33.5899 35.3505 34.2329 30.2225 41.771 30.2225C46.8768 30.2225 59.8427 27.9899 64.2883 31.099C67.2999 33.2053 75.7327 35.3945 77.4479 37.3224C87.0681 48.1357 93.1684 33.7239 98.5031 28.6448C102.523 24.8176 107.17 23.9115 113.515 23.9115C129.07 23.9115 130.623 5.84655 144.903 3.40081C152.176 2.15507 157.735 0.268341 163.813 5.32917C168.054 8.85975 176.241 16.8291 181.944 17.5129C193.527 18.9016 217.871 -7.39626 228.344 6.20569C231.124 9.81766 236.041 16.0228 241.503 16.0228C247.52 16.0228 251.433 15.5412 255.54 20.0548C258.369 23.1647 261.096 29.609 265.19 31.4497C272.445 34.7116 280.693 27.067 288 27.067"
                    stroke="#5CC79A"
                    stroke-width="3"
                    stroke-linecap="round"
                  />
                </svg>

                <div className={styles.frame_267}>
                  <div className={styles.view_all_activity}>View all activity</div>
                  <svg
                    className={styles.arrow_forward}
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_856_14361"
                      style={{maskType: 'alpha'}}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="20"
                      height="20"
                    >
                      <rect width="20" height="20" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_856_14361)">
                      <path
                        d="M13.125 10.75H4V9.25H13.125L8.9375 5.0625L10 4L16 10L10 16L8.9375 14.9375L13.125 10.75Z"
                        fill="#262626"
                      />
                    </g>
                  </svg>
                </div>
              </div>
              <div className={styles.stats}>
                <div className={styles.frame_147}>
                  <div className={styles.users}>Sessions</div>
                  <div className={styles.last_7_days}>Last 7 days</div>
                </div>
                <svg
                  className={styles.vector_32}
                  width="290"
                  height="48"
                  viewBox="0 0 290 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2 46C14.3468 46 18.4803 45.1631 28.1241 38.9001C33.5899 35.3505 34.2329 30.2225 41.771 30.2225C46.8768 30.2225 59.8427 27.9899 64.2883 31.099C67.2999 33.2053 75.7327 35.3945 77.4479 37.3224C87.0681 48.1357 93.1684 33.7239 98.5031 28.6448C102.523 24.8176 107.17 23.9115 113.515 23.9115C129.07 23.9115 130.623 5.84655 144.903 3.40081C152.176 2.15507 157.735 0.268341 163.813 5.32917C168.054 8.85975 176.241 16.8291 181.944 17.5129C193.527 18.9016 217.871 -7.39626 228.344 6.20569C231.124 9.81766 236.041 16.0228 241.503 16.0228C247.52 16.0228 251.433 15.5412 255.54 20.0548C258.369 23.1647 261.096 29.609 265.19 31.4497C272.445 34.7116 280.693 27.067 288 27.067"
                    stroke="#5CC79A"
                    stroke-width="3"
                    stroke-linecap="round"
                  />
                </svg>

                <div className={styles.frame_267}>
                  <div className={styles.view_all_activity}>View all activity</div>
                  <svg
                    className={styles.arrow_forward3}
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_856_13720"
                      style={{maskType: 'alpha'}}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="20"
                      height="20"
                    >
                      <rect width="20" height="20" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_856_13720)">
                      <path
                        d="M13.125 10.75H4V9.25H13.125L8.9375 5.0625L10 4L16 10L10 16L8.9375 14.9375L13.125 10.75Z"
                        fill="#262626"
                      />
                    </g>
                  </svg>
                </div>
              </div>
              <div className={styles.stats}>
                <div className={styles.frame_147}>
                  <div className={styles.users}>Session duration</div>
                  <div className={styles.last_7_days}>Last 7 days</div>
                </div>
                <svg
                  className={styles.vector_33}
                  width="290"
                  height="48"
                  viewBox="0 0 290 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2 46C14.3468 46 18.4803 45.1631 28.1241 38.9001C33.5899 35.3505 34.2329 30.2225 41.771 30.2225C46.8768 30.2225 59.8427 27.9899 64.2883 31.099C67.2999 33.2053 75.7327 35.3945 77.4479 37.3224C87.0681 48.1357 93.1684 33.7239 98.5031 28.6448C102.523 24.8176 107.17 23.9115 113.515 23.9115C129.07 23.9115 130.623 5.84655 144.903 3.40081C152.176 2.15507 157.735 0.268341 163.813 5.32917C168.054 8.85975 176.241 16.8291 181.944 17.5129C193.527 18.9016 217.871 -7.39626 228.344 6.20569C231.124 9.81766 236.041 16.0228 241.503 16.0228C247.52 16.0228 251.433 15.5412 255.54 20.0548C258.369 23.1647 261.096 29.609 265.19 31.4497C272.445 34.7116 280.693 27.067 288 27.067"
                    stroke="#5CC79A"
                    stroke-width="3"
                    stroke-linecap="round"
                  />
                </svg>

                <div className={styles.frame_267}>
                  <div className={styles.view_all_activity}>View all activity</div>
                  <svg
                    className={styles.arrow_forward5}
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_856_14447"
                      style={{maskType: 'alpha'}}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="20"
                      height="20"
                    >
                      <rect width="20" height="20" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_856_14447)">
                      <path
                        d="M13.125 10.75H4V9.25H13.125L8.9375 5.0625L10 4L16 10L10 16L8.9375 14.9375L13.125 10.75Z"
                        fill="#262626"
                      />
                    </g>
                  </svg>
                </div>
              </div>
            </div>
            <div className={styles.frame_134}>
              <div className={styles.frame_143}>
                <div className={styles.frame_144}>
                  <div className={styles.frame_289}>
                    <div className={styles.world_visitors}>World visitors</div>
                    <div className={styles.button3}>
                      <svg
                        className={styles.plus5}
                        width="20"
                        height="21"
                        viewBox="0 0 20 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M10 2.63672C10.4602 2.63672 10.8333 3.00981 10.8333 3.47005V9.30339H16.6667C17.1269 9.30339 17.5 9.67648 17.5 10.1367C17.5 10.597 17.1269 10.9701 16.6667 10.9701H10.8333V16.8034C10.8333 17.2636 10.4602 17.6367 10 17.6367C9.53976 17.6367 9.16667 17.2636 9.16667 16.8034V10.9701H3.33333C2.8731 10.9701 2.5 10.597 2.5 10.1367C2.5 9.67648 2.8731 9.30339 3.33333 9.30339H9.16667V3.47005C9.16667 3.00981 9.53976 2.63672 10 2.63672Z"
                          fill="#262626"
                        />
                      </svg>

                      <div className={styles.accept_all_cockies}>Select dates</div>
                    </div>
                  </div>
                  <div className={styles.frame_167}>
                    <div className={styles.button3}>
                      <svg
                        className={styles.share2}
                        width="20"
                        height="21"
                        viewBox="0 0 20 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10.8333 3.81659L12.7441 5.72734C13.0695 6.05278 13.5972 6.05278 13.9226 5.72734C14.248 5.4019 14.248 4.87426 13.9226 4.54883C13.3371 3.97787 11.4866 2.30772 10.5518 1.46698C10.2369 1.18375 9.76218 1.18272 9.44631 1.46488C8.51922 2.29305 6.69381 3.93244 6.07741 4.54883C5.75197 4.87426 5.75197 5.4019 6.07741 5.72734C6.40285 6.05278 6.93049 6.05278 7.25592 5.72734L9.16667 3.81659V12.6381C9.16667 13.0983 9.53976 13.4714 10 13.4714C10.4602 13.4714 10.8333 13.0983 10.8333 12.6381V3.81659Z"
                          fill="#262626"
                        />
                        <path
                          d="M4.16667 10.1381C4.16667 9.67784 3.79357 9.30475 3.33333 9.30475C2.8731 9.30475 2.5 9.67784 2.5 10.1381V16.8047C2.5 17.4678 2.76339 18.1037 3.23223 18.5725C3.70107 19.0414 4.33696 19.3047 5 19.3047H15C15.663 19.3047 16.2989 19.0414 16.7678 18.5725C17.2366 18.1037 17.5 17.4678 17.5 16.8047V10.1381C17.5 9.67784 17.1269 9.30475 16.6667 9.30475C16.2064 9.30475 15.8333 9.67784 15.8333 10.1381V16.8047C15.8333 17.0258 15.7455 17.2377 15.5893 17.394C15.433 17.5503 15.221 17.6381 15 17.6381H5C4.77899 17.6381 4.56702 17.5503 4.41074 17.394C4.25446 17.2377 4.16667 17.0258 4.16667 16.8047V10.1381Z"
                          fill="#262626"
                        />
                      </svg>

                      <div className={styles.accept_all_cockies}>Share</div>
                    </div>
                    <div className={styles.button2}>
                      <svg
                        className={styles.file_download_in_lc}
                        width="20"
                        height="21"
                        viewBox="0 0 20 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9.99992 8.47135C10.4602 8.47135 10.8333 8.84445 10.8333 9.30469V12.2928L11.0773 12.0488C11.4028 11.7233 11.9304 11.7233 12.2558 12.0488C12.5813 12.3742 12.5813 12.9018 12.2558 13.2273L10.5892 14.8939C10.2637 15.2194 9.7361 15.2194 9.41066 14.8939L7.744 13.2273C7.41856 12.9018 7.41856 12.3742 7.744 12.0488C8.06943 11.7233 8.59707 11.7233 8.92251 12.0488L9.16659 12.2928V9.30469C9.16659 8.84445 9.53968 8.47135 9.99992 8.47135Z"
                          fill="white"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M10.928 1.80471C11.4571 1.80446 11.857 1.80427 12.2425 1.89684C12.5827 1.9785 12.9078 2.11318 13.206 2.29594C13.5441 2.50313 13.8267 2.78598 14.2007 3.16034L15.311 4.2706C15.6853 4.64459 15.9682 4.92718 16.1754 5.26528C16.3581 5.56352 16.4928 5.88867 16.5745 6.22879C16.6671 6.61436 16.6669 7.0142 16.6666 7.54336L16.6666 13.6725C16.6666 14.3433 16.6666 14.8969 16.6298 15.3479C16.5915 15.8163 16.5094 16.2469 16.3033 16.6514C15.9837 17.2786 15.4738 17.7885 14.8466 18.1081C14.4421 18.3142 14.0115 18.3963 13.5431 18.4346C13.0921 18.4714 12.5385 18.4714 11.8677 18.4714H8.13215C7.46135 18.4714 6.90772 18.4714 6.45673 18.4346C5.98832 18.3963 5.55773 18.3142 5.15329 18.1081C4.52608 17.7885 4.01614 17.2786 3.69656 16.6514C3.49049 16.2469 3.40835 15.8163 3.37008 15.3479C3.33323 14.8969 3.33324 14.3433 3.33325 13.6725V6.60364C3.33324 5.93285 3.33323 5.37921 3.37008 4.92822C3.40835 4.4598 3.49049 4.02922 3.69656 3.62477C4.01614 2.99756 4.52608 2.48763 5.15329 2.16805C5.55773 1.96198 5.98832 1.87984 6.45673 1.84157C6.90773 1.80472 7.46136 1.80473 8.13217 1.80474L10.928 1.80471ZM8.16659 3.47141H10.8333V5.13807C10.8333 6.51878 11.9525 7.63807 13.3333 7.63807H14.9999V13.6381C14.9999 14.3519 14.9993 14.8371 14.9686 15.2122C14.9388 15.5776 14.8847 15.7644 14.8183 15.8947C14.6585 16.2083 14.4035 16.4633 14.0899 16.6231C13.9596 16.6895 13.7727 16.7436 13.4074 16.7734C13.0323 16.8041 12.5471 16.8047 11.8333 16.8047H8.16659C7.45277 16.8047 6.96753 16.8041 6.59245 16.7734C6.22711 16.7436 6.04027 16.6895 5.90994 16.6231C5.59633 16.4633 5.34136 16.2083 5.18158 15.8947C5.11517 15.7644 5.06106 15.5776 5.03121 15.2122C5.00057 14.8371 4.99992 14.3519 4.99992 13.6381V6.63807C4.99992 5.92426 5.00057 5.43901 5.03121 5.06394C5.06106 4.69859 5.11517 4.51176 5.18158 4.38142C5.34136 4.06782 5.59633 3.81285 5.90994 3.65306C6.04027 3.58665 6.22711 3.53255 6.59245 3.5027C6.96753 3.47205 7.45277 3.47141 8.16659 3.47141ZM14.0724 5.38909C14.3732 5.68982 14.5331 5.85298 14.6332 5.97141H13.3333C12.873 5.97141 12.4999 5.59831 12.4999 5.13807V3.83809C12.6183 3.93824 12.7815 4.09817 13.0822 4.3989L14.0724 5.38909Z"
                          fill="white"
                        />
                      </svg>

                      <div className={styles.accept_all_cockies2}>Download report</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.frame_142}>
                <div className={styles.frame_135}>
                  <svg
                    className={styles.g_10}
                    width="596"
                    height="336"
                    viewBox="0 0 596 336"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M179.497 333.199C179.497 334.269 178.629 335.137 177.559 335.137C176.489 335.137 175.622 334.269 175.622 333.199C175.622 332.129 176.489 331.262 177.559 331.262C178.629 331.262 179.497 332.129 179.497 333.199Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M174.774 333.199C174.774 334.269 173.906 335.137 172.836 335.137C171.766 335.137 170.899 334.269 170.899 333.199C170.899 332.129 171.766 331.262 172.836 331.262C173.906 331.262 174.774 332.129 174.774 333.199Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M174.774 328.476C174.774 329.546 173.906 330.414 172.836 330.414C171.766 330.414 170.899 329.546 170.899 328.476C170.899 327.406 171.766 326.539 172.836 326.539C173.906 326.539 174.774 327.406 174.774 328.476Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M188.943 323.754C188.943 324.824 188.076 325.691 187.006 325.691C185.936 325.691 185.068 324.824 185.068 323.754C185.068 322.684 185.936 321.816 187.006 321.816C188.076 321.816 188.943 322.684 188.943 323.754Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M170.051 328.476C170.051 329.546 169.183 330.414 168.113 330.414C167.043 330.414 166.176 329.546 166.176 328.476C166.176 327.406 167.043 326.539 168.113 326.539C169.183 326.539 170.051 327.406 170.051 328.476Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M170.051 323.754C170.051 324.824 169.183 325.691 168.113 325.691C167.043 325.691 166.176 324.824 166.176 323.754C166.176 322.684 167.043 321.816 168.113 321.816C169.183 321.816 170.051 322.684 170.051 323.754Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M165.328 323.754C165.328 324.824 164.46 325.691 163.39 325.691C162.32 325.691 161.452 324.824 161.452 323.754C161.452 322.684 162.32 321.816 163.39 321.816C164.46 321.816 165.328 322.684 165.328 323.754Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M165.328 319.031C165.328 320.101 164.46 320.969 163.39 320.969C162.32 320.969 161.452 320.101 161.452 319.031C161.452 317.961 162.32 317.094 163.39 317.094C164.46 317.094 165.328 317.961 165.328 319.031Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M170.051 319.031C170.051 320.101 169.183 320.969 168.113 320.969C167.043 320.969 166.176 320.101 166.176 319.031C166.176 317.961 167.043 317.094 168.113 317.094C169.183 317.094 170.051 317.961 170.051 319.031Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M170.051 314.305C170.051 315.375 169.183 316.242 168.113 316.242C167.043 316.242 166.176 315.375 166.176 314.305C166.176 313.235 167.043 312.367 168.113 312.367C169.183 312.367 170.051 313.235 170.051 314.305Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M174.774 314.305C174.774 315.375 173.906 316.242 172.836 316.242C171.766 316.242 170.899 315.375 170.899 314.305C170.899 313.235 171.766 312.367 172.836 312.367C173.906 312.367 174.774 313.235 174.774 314.305Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M165.328 314.305C165.328 315.375 164.46 316.242 163.39 316.242C162.32 316.242 161.452 315.375 161.452 314.305C161.452 313.235 162.32 312.367 163.39 312.367C164.46 312.367 165.328 313.235 165.328 314.305Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M165.328 309.582C165.328 310.652 164.46 311.52 163.39 311.52C162.32 311.52 161.452 310.652 161.452 309.582C161.452 308.512 162.32 307.644 163.39 307.644C164.46 307.644 165.328 308.512 165.328 309.582Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M165.328 304.859C165.328 305.929 164.46 306.797 163.39 306.797C162.32 306.797 161.452 305.929 161.452 304.859C161.452 303.789 162.32 302.922 163.39 302.922C164.46 302.922 165.328 303.789 165.328 304.859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M165.328 300.137C165.328 301.207 164.46 302.074 163.39 302.074C162.32 302.074 161.452 301.207 161.452 300.137C161.452 299.067 162.32 298.199 163.39 298.199C164.46 298.199 165.328 299.067 165.328 300.137Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M165.328 295.414C165.328 296.484 164.46 297.352 163.39 297.352C162.32 297.352 161.452 296.484 161.452 295.414C161.452 294.344 162.32 293.476 163.39 293.476C164.46 293.476 165.328 294.344 165.328 295.414Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M165.328 290.691C165.328 291.761 164.46 292.629 163.39 292.629C162.32 292.629 161.452 291.761 161.452 290.691C161.452 289.621 162.32 288.754 163.39 288.754C164.46 288.754 165.328 289.621 165.328 290.691Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M160.604 290.691C160.604 291.761 159.737 292.629 158.667 292.629C157.597 292.629 156.729 291.761 156.729 290.691C156.729 289.621 157.597 288.754 158.667 288.754C159.737 288.754 160.604 289.621 160.604 290.691Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M165.328 285.969C165.328 287.039 164.46 287.906 163.39 287.906C162.32 287.906 161.452 287.039 161.452 285.969C161.452 284.899 162.32 284.031 163.39 284.031C164.46 284.031 165.328 284.899 165.328 285.969Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M165.328 281.246C165.328 282.316 164.46 283.184 163.39 283.184C162.32 283.184 161.452 282.316 161.452 281.246C161.452 280.176 162.32 279.308 163.39 279.308C164.46 279.308 165.328 280.176 165.328 281.246Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M165.328 276.519C165.328 277.589 164.46 278.457 163.39 278.457C162.32 278.457 161.452 277.589 161.452 276.519C161.452 275.449 162.32 274.582 163.39 274.582C164.46 274.582 165.328 275.449 165.328 276.519Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M165.327 271.797C165.327 272.867 164.46 273.734 163.39 273.734C162.32 273.734 161.452 272.867 161.452 271.797C161.452 270.727 162.32 269.859 163.39 269.859C164.46 269.859 165.327 270.727 165.327 271.797Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M165.327 267.074C165.327 268.144 164.46 269.012 163.39 269.012C162.32 269.012 161.452 268.144 161.452 267.074C161.452 266.004 162.32 265.137 163.39 265.137C164.46 265.137 165.327 266.004 165.327 267.074Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M165.328 262.351C165.328 263.421 164.46 264.289 163.39 264.289C162.32 264.289 161.452 263.421 161.452 262.351C161.452 261.281 162.32 260.414 163.39 260.414C164.46 260.414 165.328 261.281 165.328 262.351Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M170.051 262.351C170.051 263.421 169.183 264.289 168.113 264.289C167.043 264.289 166.176 263.421 166.176 262.351C166.176 261.281 167.043 260.414 168.113 260.414C169.183 260.414 170.051 261.281 170.051 262.351Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M174.774 262.351C174.774 263.421 173.906 264.289 172.836 264.289C171.766 264.289 170.899 263.421 170.899 262.351C170.899 261.281 171.766 260.414 172.836 260.414C173.906 260.414 174.774 261.281 174.774 262.351Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M179.497 262.351C179.497 263.421 178.629 264.289 177.559 264.289C176.489 264.289 175.622 263.421 175.622 262.351C175.622 261.281 176.489 260.414 177.559 260.414C178.629 260.414 179.497 261.281 179.497 262.351Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M184.22 262.351C184.22 263.421 183.353 264.289 182.283 264.289C181.213 264.289 180.345 263.421 180.345 262.351C180.345 261.281 181.213 260.414 182.283 260.414C183.353 260.414 184.22 261.281 184.22 262.351Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M188.943 262.351C188.943 263.421 188.076 264.289 187.006 264.289C185.936 264.289 185.068 263.421 185.068 262.351C185.068 261.281 185.936 260.414 187.006 260.414C188.076 260.414 188.943 261.281 188.943 262.351Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M193.666 262.351C193.666 263.421 192.799 264.289 191.729 264.289C190.659 264.289 189.791 263.421 189.791 262.351C189.791 261.281 190.659 260.414 191.729 260.414C192.799 260.414 193.666 261.281 193.666 262.351Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M198.39 262.351C198.39 263.421 197.522 264.289 196.452 264.289C195.382 264.289 194.514 263.421 194.514 262.351C194.514 261.281 195.382 260.414 196.452 260.414C197.522 260.414 198.39 261.281 198.39 262.351Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M203.113 262.351C203.113 263.421 202.245 264.289 201.175 264.289C200.105 264.289 199.238 263.421 199.238 262.351C199.238 261.281 200.105 260.414 201.175 260.414C202.245 260.414 203.113 261.281 203.113 262.351Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M203.113 257.629C203.113 258.699 202.245 259.566 201.175 259.566C200.105 259.566 199.238 258.699 199.238 257.629C199.238 256.559 200.105 255.691 201.175 255.691C202.245 255.691 203.113 256.559 203.113 257.629Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M198.39 257.629C198.39 258.699 197.522 259.566 196.452 259.566C195.382 259.566 194.514 258.699 194.514 257.629C194.514 256.559 195.382 255.691 196.452 255.691C197.522 255.691 198.39 256.559 198.39 257.629Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M193.666 257.629C193.666 258.699 192.799 259.566 191.729 259.566C190.659 259.566 189.791 258.699 189.791 257.629C189.791 256.559 190.659 255.691 191.729 255.691C192.799 255.691 193.666 256.559 193.666 257.629Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M188.943 257.629C188.943 258.699 188.076 259.566 187.006 259.566C185.936 259.566 185.068 258.699 185.068 257.629C185.068 256.559 185.936 255.691 187.006 255.691C188.076 255.691 188.943 256.559 188.943 257.629Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M184.22 257.629C184.22 258.699 183.353 259.566 182.283 259.566C181.213 259.566 180.345 258.699 180.345 257.629C180.345 256.559 181.213 255.691 182.283 255.691C183.353 255.691 184.22 256.559 184.22 257.629Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M179.497 257.629C179.497 258.699 178.629 259.566 177.559 259.566C176.489 259.566 175.622 258.699 175.622 257.629C175.622 256.559 176.489 255.691 177.559 255.691C178.629 255.691 179.497 256.559 179.497 257.629Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M174.774 257.629C174.774 258.699 173.906 259.566 172.836 259.566C171.766 259.566 170.899 258.699 170.899 257.629C170.899 256.559 171.766 255.691 172.836 255.691C173.906 255.691 174.774 256.559 174.774 257.629Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M170.051 257.629C170.051 258.699 169.183 259.566 168.113 259.566C167.043 259.566 166.176 258.699 166.176 257.629C166.176 256.559 167.043 255.691 168.113 255.691C169.183 255.691 170.051 256.559 170.051 257.629Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M165.328 257.629C165.328 258.699 164.46 259.566 163.39 259.566C162.32 259.566 161.452 258.699 161.452 257.629C161.452 256.559 162.32 255.691 163.39 255.691C164.46 255.691 165.328 256.559 165.328 257.629Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M165.328 252.906C165.328 253.976 164.46 254.844 163.39 254.844C162.32 254.844 161.452 253.976 161.452 252.906C161.452 251.836 162.32 250.969 163.39 250.969C164.46 250.969 165.328 251.836 165.328 252.906Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M160.604 252.906C160.604 253.976 159.737 254.844 158.667 254.844C157.597 254.844 156.729 253.976 156.729 252.906C156.729 251.836 157.597 250.969 158.667 250.969C159.737 250.969 160.604 251.836 160.604 252.906Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M165.328 248.184C165.328 249.253 164.46 250.121 163.39 250.121C162.32 250.121 161.452 249.253 161.452 248.184C161.452 247.114 162.32 246.246 163.39 246.246C164.46 246.246 165.328 247.114 165.328 248.184Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M160.604 248.184C160.604 249.253 159.737 250.121 158.667 250.121C157.597 250.121 156.729 249.253 156.729 248.184C156.729 247.114 157.597 246.246 158.667 246.246C159.737 246.246 160.604 247.114 160.604 248.184Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M155.881 248.184C155.881 249.253 155.013 250.121 153.943 250.121C152.873 250.121 152.006 249.253 152.006 248.184C152.006 247.114 152.873 246.246 153.943 246.246C155.013 246.246 155.881 247.114 155.881 248.184Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M155.881 243.461C155.881 244.531 155.013 245.398 153.943 245.398C152.873 245.398 152.006 244.531 152.006 243.461C152.006 242.391 152.873 241.523 153.943 241.523C155.013 241.523 155.881 242.391 155.881 243.461Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M151.158 243.461C151.158 244.531 150.29 245.398 149.22 245.398C148.15 245.398 147.283 244.531 147.283 243.461C147.283 242.391 148.15 241.523 149.22 241.523C150.29 241.523 151.158 242.391 151.158 243.461Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M151.158 238.734C151.158 239.804 150.29 240.672 149.22 240.672C148.15 240.672 147.283 239.804 147.283 238.734C147.283 237.664 148.15 236.797 149.22 236.797C150.29 236.797 151.158 237.664 151.158 238.734Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M151.158 234.012C151.158 235.082 150.29 235.949 149.22 235.949C148.15 235.949 147.283 235.082 147.283 234.012C147.283 232.942 148.15 232.074 149.22 232.074C150.29 232.074 151.158 232.942 151.158 234.012Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M146.435 234.012C146.435 235.082 145.567 235.949 144.497 235.949C143.427 235.949 142.56 235.082 142.56 234.012C142.56 232.942 143.427 232.074 144.497 232.074C145.567 232.074 146.435 232.942 146.435 234.012Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M146.435 229.289C146.435 230.359 145.567 231.227 144.497 231.227C143.427 231.227 142.56 230.359 142.56 229.289C142.56 228.219 143.427 227.351 144.497 227.351C145.567 227.351 146.435 228.219 146.435 229.289Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M151.158 229.289C151.158 230.359 150.29 231.227 149.22 231.227C148.15 231.227 147.283 230.359 147.283 229.289C147.283 228.219 148.15 227.351 149.22 227.351C150.29 227.351 151.158 228.219 151.158 229.289Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M155.881 229.289C155.881 230.359 155.013 231.227 153.943 231.227C152.873 231.227 152.006 230.359 152.006 229.289C152.006 228.219 152.873 227.351 153.943 227.351C155.013 227.351 155.881 228.219 155.881 229.289Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M155.881 234.012C155.881 235.082 155.013 235.949 153.943 235.949C152.873 235.949 152.006 235.082 152.006 234.012C152.006 232.942 152.873 232.074 153.943 232.074C155.013 232.074 155.881 232.942 155.881 234.012Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M155.881 238.734C155.881 239.804 155.013 240.672 153.943 240.672C152.873 240.672 152.006 239.804 152.006 238.734C152.006 237.664 152.873 236.797 153.943 236.797C155.013 236.797 155.881 237.664 155.881 238.734Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M160.604 238.734C160.604 239.804 159.737 240.672 158.667 240.672C157.597 240.672 156.729 239.804 156.729 238.734C156.729 237.664 157.597 236.797 158.667 236.797C159.737 236.797 160.604 237.664 160.604 238.734Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M160.604 243.461C160.604 244.531 159.737 245.398 158.667 245.398C157.597 245.398 156.729 244.531 156.729 243.461C156.729 242.391 157.597 241.523 158.667 241.523C159.737 241.523 160.604 242.391 160.604 243.461Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M165.328 243.461C165.328 244.531 164.46 245.398 163.39 245.398C162.32 245.398 161.452 244.531 161.452 243.461C161.452 242.391 162.32 241.523 163.39 241.523C164.46 241.523 165.328 242.391 165.328 243.461Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M170.051 243.461C170.051 244.531 169.183 245.398 168.113 245.398C167.043 245.398 166.176 244.531 166.176 243.461C166.176 242.391 167.043 241.523 168.113 241.523C169.183 241.523 170.051 242.391 170.051 243.461Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M170.051 238.734C170.051 239.804 169.183 240.672 168.113 240.672C167.043 240.672 166.176 239.804 166.176 238.734C166.176 237.664 167.043 236.797 168.113 236.797C169.183 236.797 170.051 237.664 170.051 238.734Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M170.051 234.012C170.051 235.082 169.183 235.949 168.113 235.949C167.043 235.949 166.176 235.082 166.176 234.012C166.176 232.942 167.043 232.074 168.113 232.074C169.183 232.074 170.051 232.942 170.051 234.012Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M170.051 229.289C170.051 230.359 169.183 231.227 168.113 231.227C167.043 231.227 166.176 230.359 166.176 229.289C166.176 228.219 167.043 227.351 168.113 227.351C169.183 227.351 170.051 228.219 170.051 229.289Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M170.051 224.566C170.051 225.636 169.183 226.504 168.113 226.504C167.043 226.504 166.176 225.636 166.176 224.566C166.176 223.496 167.043 222.629 168.113 222.629C169.183 222.629 170.051 223.496 170.051 224.566Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M170.051 219.844C170.051 220.914 169.183 221.781 168.113 221.781C167.043 221.781 166.176 220.914 166.176 219.844C166.176 218.774 167.043 217.906 168.113 217.906C169.183 217.906 170.051 218.774 170.051 219.844Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M165.328 219.844C165.328 220.914 164.46 221.781 163.39 221.781C162.32 221.781 161.452 220.914 161.452 219.844C161.452 218.774 162.32 217.906 163.39 217.906C164.46 217.906 165.328 218.774 165.328 219.844Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M165.328 215.121C165.328 216.191 164.46 217.059 163.39 217.059C162.32 217.059 161.452 216.191 161.452 215.121C161.452 214.051 162.32 213.183 163.39 213.183C164.46 213.183 165.328 214.051 165.328 215.121Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M160.604 215.121C160.604 216.191 159.737 217.059 158.667 217.059C157.597 217.059 156.729 216.191 156.729 215.121C156.729 214.051 157.597 213.183 158.667 213.183C159.737 213.183 160.604 214.051 160.604 215.121Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M155.881 215.121C155.881 216.191 155.013 217.059 153.943 217.059C152.873 217.059 152.006 216.191 152.006 215.121C152.006 214.051 152.873 213.183 153.943 213.183C155.013 213.183 155.881 214.051 155.881 215.121Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M151.158 215.121C151.158 216.191 150.29 217.059 149.22 217.059C148.15 217.059 147.283 216.191 147.283 215.121C147.283 214.051 148.15 213.183 149.22 213.183C150.29 213.183 151.158 214.051 151.158 215.121Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M151.158 219.844C151.158 220.914 150.29 221.781 149.22 221.781C148.15 221.781 147.283 220.914 147.283 219.844C147.283 218.774 148.15 217.906 149.22 217.906C150.29 217.906 151.158 218.774 151.158 219.844Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M155.881 219.844C155.881 220.914 155.013 221.781 153.943 221.781C152.873 221.781 152.006 220.914 152.006 219.844C152.006 218.774 152.873 217.906 153.943 217.906C155.013 217.906 155.881 218.774 155.881 219.844Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M160.604 219.844C160.604 220.914 159.737 221.781 158.667 221.781C157.597 221.781 156.729 220.914 156.729 219.844C156.729 218.774 157.597 217.906 158.667 217.906C159.737 217.906 160.604 218.774 160.604 219.844Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M160.604 224.566C160.604 225.636 159.737 226.504 158.667 226.504C157.597 226.504 156.729 225.636 156.729 224.566C156.729 223.496 157.597 222.629 158.667 222.629C159.737 222.629 160.604 223.496 160.604 224.566Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M165.328 224.566C165.328 225.636 164.46 226.504 163.39 226.504C162.32 226.504 161.452 225.636 161.452 224.566C161.452 223.496 162.32 222.629 163.39 222.629C164.46 222.629 165.328 223.496 165.328 224.566Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M165.328 229.289C165.328 230.359 164.46 231.227 163.39 231.227C162.32 231.227 161.452 230.359 161.452 229.289C161.452 228.219 162.32 227.351 163.39 227.351C164.46 227.351 165.328 228.219 165.328 229.289Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M160.604 229.289C160.604 230.359 159.737 231.227 158.667 231.227C157.597 231.227 156.729 230.359 156.729 229.289C156.729 228.219 157.597 227.351 158.667 227.351C159.737 227.351 160.604 228.219 160.604 229.289Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M160.604 234.012C160.604 235.082 159.737 235.949 158.667 235.949C157.597 235.949 156.729 235.082 156.729 234.012C156.729 232.942 157.597 232.074 158.667 232.074C159.737 232.074 160.604 232.942 160.604 234.012Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M165.328 234.012C165.328 235.082 164.46 235.949 163.39 235.949C162.32 235.949 161.452 235.082 161.452 234.012C161.452 232.942 162.32 232.074 163.39 232.074C164.46 232.074 165.328 232.942 165.328 234.012Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M165.328 238.734C165.328 239.804 164.46 240.672 163.39 240.672C162.32 240.672 161.452 239.804 161.452 238.734C161.452 237.664 162.32 236.797 163.39 236.797C164.46 236.797 165.328 237.664 165.328 238.734Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M155.881 224.566C155.881 225.636 155.013 226.504 153.943 226.504C152.873 226.504 152.006 225.636 152.006 224.566C152.006 223.496 152.873 222.629 153.943 222.629C155.013 222.629 155.881 223.496 155.881 224.566Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M151.158 224.566C151.158 225.636 150.29 226.504 149.22 226.504C148.15 226.504 147.283 225.636 147.283 224.566C147.283 223.496 148.15 222.629 149.22 222.629C150.29 222.629 151.158 223.496 151.158 224.566Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M146.435 219.844C146.435 220.914 145.567 221.781 144.497 221.781C143.427 221.781 142.56 220.914 142.56 219.844C142.56 218.774 143.427 217.906 144.497 217.906C145.567 217.906 146.435 218.774 146.435 219.844Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M170.051 248.184C170.051 249.253 169.183 250.121 168.113 250.121C167.043 250.121 166.176 249.253 166.176 248.184C166.176 247.114 167.043 246.246 168.113 246.246C169.183 246.246 170.051 247.114 170.051 248.184Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M170.051 252.906C170.051 253.976 169.183 254.844 168.113 254.844C167.043 254.844 166.176 253.976 166.176 252.906C166.176 251.836 167.043 250.969 168.113 250.969C169.183 250.969 170.051 251.836 170.051 252.906Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M174.774 252.906C174.774 253.976 173.906 254.844 172.836 254.844C171.766 254.844 170.899 253.976 170.899 252.906C170.899 251.836 171.766 250.969 172.836 250.969C173.906 250.969 174.774 251.836 174.774 252.906Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M179.497 252.906C179.497 253.976 178.629 254.844 177.559 254.844C176.489 254.844 175.622 253.976 175.622 252.906C175.622 251.836 176.489 250.969 177.559 250.969C178.629 250.969 179.497 251.836 179.497 252.906Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M184.22 252.906C184.22 253.976 183.353 254.844 182.283 254.844C181.213 254.844 180.345 253.976 180.345 252.906C180.345 251.836 181.213 250.969 182.283 250.969C183.353 250.969 184.22 251.836 184.22 252.906Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M188.943 252.906C188.943 253.976 188.076 254.844 187.006 254.844C185.936 254.844 185.068 253.976 185.068 252.906C185.068 251.836 185.936 250.969 187.006 250.969C188.076 250.969 188.943 251.836 188.943 252.906Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M193.666 252.906C193.666 253.976 192.799 254.844 191.729 254.844C190.659 254.844 189.791 253.976 189.791 252.906C189.791 251.836 190.659 250.969 191.729 250.969C192.799 250.969 193.666 251.836 193.666 252.906Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M198.39 252.906C198.39 253.976 197.522 254.844 196.452 254.844C195.382 254.844 194.514 253.976 194.514 252.906C194.514 251.836 195.382 250.969 196.452 250.969C197.522 250.969 198.39 251.836 198.39 252.906Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M203.113 252.906C203.113 253.976 202.245 254.844 201.175 254.844C200.105 254.844 199.238 253.976 199.238 252.906C199.238 251.836 200.105 250.969 201.175 250.969C202.245 250.969 203.113 251.836 203.113 252.906Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M207.836 252.906C207.836 253.976 206.968 254.844 205.898 254.844C204.828 254.844 203.961 253.976 203.961 252.906C203.961 251.836 204.828 250.969 205.898 250.969C206.968 250.969 207.836 251.836 207.836 252.906Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M207.836 248.184C207.836 249.253 206.968 250.121 205.898 250.121C204.828 250.121 203.961 249.253 203.961 248.184C203.961 247.114 204.828 246.246 205.898 246.246C206.968 246.246 207.836 247.114 207.836 248.184Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M207.836 243.461C207.836 244.531 206.968 245.398 205.898 245.398C204.828 245.398 203.961 244.531 203.961 243.461C203.961 242.391 204.828 241.523 205.898 241.523C206.968 241.523 207.836 242.391 207.836 243.461Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M207.836 238.734C207.836 239.804 206.968 240.672 205.898 240.672C204.828 240.672 203.961 239.804 203.961 238.734C203.961 237.664 204.828 236.797 205.898 236.797C206.968 236.797 207.836 237.664 207.836 238.734Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M207.836 234.012C207.836 235.082 206.968 235.949 205.898 235.949C204.828 235.949 203.961 235.082 203.961 234.012C203.961 232.942 204.828 232.074 205.898 232.074C206.968 232.074 207.836 232.942 207.836 234.012Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M212.559 234.012C212.559 235.082 211.691 235.949 210.621 235.949C209.551 235.949 208.684 235.082 208.684 234.012C208.684 232.942 209.551 232.074 210.621 232.074C211.691 232.074 212.559 232.942 212.559 234.012Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M212.559 229.289C212.559 230.359 211.691 231.227 210.621 231.227C209.551 231.227 208.684 230.359 208.684 229.289C208.684 228.219 209.551 227.351 210.621 227.351C211.691 227.351 212.559 228.219 212.559 229.289Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M207.836 229.289C207.836 230.359 206.968 231.227 205.898 231.227C204.828 231.227 203.961 230.359 203.961 229.289C203.961 228.219 204.828 227.351 205.898 227.351C206.968 227.351 207.836 228.219 207.836 229.289Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M203.113 229.289C203.113 230.359 202.245 231.227 201.175 231.227C200.105 231.227 199.238 230.359 199.238 229.289C199.238 228.219 200.105 227.351 201.175 227.351C202.245 227.351 203.113 228.219 203.113 229.289Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M203.113 224.566C203.113 225.636 202.245 226.504 201.175 226.504C200.105 226.504 199.238 225.636 199.238 224.566C199.238 223.496 200.105 222.629 201.175 222.629C202.245 222.629 203.113 223.496 203.113 224.566Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M198.39 224.566C198.39 225.636 197.522 226.504 196.452 226.504C195.382 226.504 194.514 225.636 194.514 224.566C194.514 223.496 195.382 222.629 196.452 222.629C197.522 222.629 198.39 223.496 198.39 224.566Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M193.666 224.566C193.666 225.636 192.799 226.504 191.729 226.504C190.659 226.504 189.791 225.636 189.791 224.566C189.791 223.496 190.659 222.629 191.729 222.629C192.799 222.629 193.666 223.496 193.666 224.566Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M193.666 219.844C193.666 220.914 192.799 221.781 191.729 221.781C190.659 221.781 189.791 220.914 189.791 219.844C189.791 218.774 190.659 217.906 191.729 217.906C192.799 217.906 193.666 218.774 193.666 219.844Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M193.666 215.121C193.666 216.191 192.799 217.059 191.729 217.059C190.659 217.059 189.791 216.191 189.791 215.121C189.791 214.051 190.659 213.183 191.729 213.183C192.799 213.183 193.666 214.051 193.666 215.121Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M188.943 215.121C188.943 216.191 188.076 217.059 187.006 217.059C185.936 217.059 185.068 216.191 185.068 215.121C185.068 214.051 185.936 213.183 187.006 213.183C188.076 213.183 188.943 214.051 188.943 215.121Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M184.22 215.121C184.22 216.191 183.353 217.059 182.283 217.059C181.213 217.059 180.345 216.191 180.345 215.121C180.345 214.051 181.213 213.183 182.283 213.183C183.353 213.183 184.22 214.051 184.22 215.121Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M179.497 215.121C179.497 216.191 178.629 217.059 177.559 217.059C176.489 217.059 175.622 216.191 175.622 215.121C175.622 214.051 176.489 213.183 177.559 213.183C178.629 213.183 179.497 214.051 179.497 215.121Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M179.497 210.398C179.497 211.468 178.629 212.336 177.559 212.336C176.489 212.336 175.622 211.468 175.622 210.398C175.622 209.328 176.489 208.461 177.559 208.461C178.629 208.461 179.497 209.328 179.497 210.398Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M174.774 210.398C174.774 211.468 173.906 212.336 172.836 212.336C171.766 212.336 170.899 211.468 170.899 210.398C170.899 209.328 171.766 208.461 172.836 208.461C173.906 208.461 174.774 209.328 174.774 210.398Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M174.774 205.672C174.774 206.742 173.906 207.609 172.836 207.609C171.766 207.609 170.899 206.742 170.899 205.672C170.899 204.602 171.766 203.734 172.836 203.734C173.906 203.734 174.774 204.602 174.774 205.672Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M170.051 205.672C170.051 206.742 169.183 207.609 168.113 207.609C167.043 207.609 166.176 206.742 166.176 205.672C166.176 204.602 167.043 203.734 168.113 203.734C169.183 203.734 170.051 204.602 170.051 205.672Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M165.328 205.672C165.328 206.742 164.46 207.609 163.39 207.609C162.32 207.609 161.452 206.742 161.452 205.672C161.452 204.602 162.32 203.734 163.39 203.734C164.46 203.734 165.328 204.602 165.328 205.672Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M160.604 205.672C160.604 206.742 159.737 207.609 158.667 207.609C157.597 207.609 156.729 206.742 156.729 205.672C156.729 204.602 157.597 203.734 158.667 203.734C159.737 203.734 160.604 204.602 160.604 205.672Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M155.881 205.672C155.881 206.742 155.013 207.609 153.943 207.609C152.873 207.609 152.006 206.742 152.006 205.672C152.006 204.602 152.873 203.734 153.943 203.734C155.013 203.734 155.881 204.602 155.881 205.672Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M151.158 205.672C151.158 206.742 150.29 207.609 149.22 207.609C148.15 207.609 147.283 206.742 147.283 205.672C147.283 204.602 148.15 203.734 149.22 203.734C150.29 203.734 151.158 204.602 151.158 205.672Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M146.435 205.672C146.435 206.742 145.567 207.609 144.497 207.609C143.427 207.609 142.56 206.742 142.56 205.672C142.56 204.602 143.427 203.734 144.497 203.734C145.567 203.734 146.435 204.602 146.435 205.672Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M141.712 205.672C141.712 206.742 140.844 207.609 139.774 207.609C138.704 207.609 137.836 206.742 137.836 205.672C137.836 204.602 138.704 203.734 139.774 203.734C140.844 203.734 141.712 204.602 141.712 205.672Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M136.988 200.949C136.988 202.019 136.121 202.887 135.051 202.887C133.981 202.887 133.113 202.019 133.113 200.949C133.113 199.879 133.981 199.012 135.051 199.012C136.121 199.012 136.988 199.879 136.988 200.949Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M136.988 196.226C136.988 197.296 136.121 198.164 135.051 198.164C133.981 198.164 133.113 197.296 133.113 196.226C133.113 195.156 133.981 194.289 135.051 194.289C136.121 194.289 136.988 195.156 136.988 196.226Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M132.265 196.226C132.265 197.296 131.398 198.164 130.328 198.164C129.258 198.164 128.39 197.296 128.39 196.226C128.39 195.156 129.258 194.289 130.328 194.289C131.398 194.289 132.265 195.156 132.265 196.226Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M127.542 196.226C127.542 197.296 126.675 198.164 125.605 198.164C124.535 198.164 123.667 197.296 123.667 196.226C123.667 195.156 124.535 194.289 125.605 194.289C126.675 194.289 127.542 195.156 127.542 196.226Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M127.542 191.504C127.542 192.574 126.675 193.441 125.605 193.441C124.535 193.441 123.667 192.574 123.667 191.504C123.667 190.434 124.535 189.566 125.605 189.566C126.675 189.566 127.542 190.434 127.542 191.504Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M122.819 191.504C122.819 192.574 121.951 193.441 120.881 193.441C119.811 193.441 118.944 192.574 118.944 191.504C118.944 190.434 119.811 189.566 120.881 189.566C121.951 189.566 122.819 190.434 122.819 191.504Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M118.096 191.504C118.096 192.574 117.228 193.441 116.158 193.441C115.088 193.441 114.221 192.574 114.221 191.504C114.221 190.434 115.088 189.566 116.158 189.566C117.228 189.566 118.096 190.434 118.096 191.504Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M113.373 186.781C113.373 187.851 112.505 188.719 111.435 188.719C110.365 188.719 109.498 187.851 109.498 186.781C109.498 185.711 110.365 184.844 111.435 184.844C112.505 184.844 113.373 185.711 113.373 186.781Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M113.373 191.504C113.373 192.574 112.505 193.441 111.435 193.441C110.365 193.441 109.498 192.574 109.498 191.504C109.498 190.434 110.365 189.566 111.435 189.566C112.505 189.566 113.373 190.434 113.373 191.504Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M108.65 186.781C108.65 187.851 107.782 188.719 106.712 188.719C105.642 188.719 104.774 187.851 104.774 186.781C104.774 185.711 105.642 184.844 106.712 184.844C107.782 184.844 108.65 185.711 108.65 186.781Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M103.926 186.781C103.926 187.851 103.059 188.719 101.989 188.719C100.919 188.719 100.051 187.851 100.051 186.781C100.051 185.711 100.919 184.844 101.989 184.844C103.059 184.844 103.926 185.711 103.926 186.781Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M103.926 182.059C103.926 183.128 103.059 183.996 101.989 183.996C100.919 183.996 100.051 183.128 100.051 182.059C100.051 180.989 100.919 180.121 101.989 180.121C103.059 180.121 103.926 180.989 103.926 182.059Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M103.926 177.336C103.926 178.406 103.059 179.273 101.989 179.273C100.919 179.273 100.051 178.406 100.051 177.336C100.051 176.266 100.919 175.398 101.989 175.398C103.059 175.398 103.926 176.266 103.926 177.336Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M108.65 177.336C108.65 178.406 107.782 179.273 106.712 179.273C105.642 179.273 104.774 178.406 104.774 177.336C104.774 176.266 105.642 175.398 106.712 175.398C107.782 175.398 108.65 176.266 108.65 177.336Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M108.65 172.613C108.65 173.683 107.782 174.551 106.712 174.551C105.642 174.551 104.774 173.683 104.774 172.613C104.774 171.543 105.642 170.676 106.712 170.676C107.782 170.676 108.65 171.543 108.65 172.613Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M108.65 167.887C108.65 168.957 107.782 169.824 106.712 169.824C105.642 169.824 104.774 168.957 104.774 167.887C104.774 166.817 105.642 165.949 106.712 165.949C107.782 165.949 108.65 166.817 108.65 167.887Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M108.65 163.164C108.65 164.234 107.782 165.102 106.712 165.102C105.642 165.102 104.774 164.234 104.774 163.164C104.774 162.094 105.642 161.226 106.712 161.226C107.782 161.226 108.65 162.094 108.65 163.164Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M103.926 163.164C103.926 164.234 103.059 165.102 101.989 165.102C100.919 165.102 100.051 164.234 100.051 163.164C100.051 162.094 100.919 161.226 101.989 161.226C103.059 161.226 103.926 162.094 103.926 163.164Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M103.926 167.887C103.926 168.957 103.059 169.824 101.989 169.824C100.919 169.824 100.051 168.957 100.051 167.887C100.051 166.817 100.919 165.949 101.989 165.949C103.059 165.949 103.926 166.817 103.926 167.887Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M103.926 172.613C103.926 173.683 103.059 174.551 101.989 174.551C100.919 174.551 100.051 173.683 100.051 172.613C100.051 171.543 100.919 170.676 101.989 170.676C103.059 170.676 103.926 171.543 103.926 172.613Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M99.2033 172.613C99.2033 173.683 98.3357 174.551 97.2657 174.551C96.1957 174.551 95.3281 173.683 95.3281 172.613C95.3281 171.543 96.1957 170.676 97.2657 170.676C98.3357 170.676 99.2033 171.543 99.2033 172.613Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M99.2033 167.887C99.2033 168.957 98.3357 169.824 97.2657 169.824C96.1957 169.824 95.3281 168.957 95.3281 167.887C95.3281 166.817 96.1957 165.949 97.2657 165.949C98.3357 165.949 99.2033 166.817 99.2033 167.887Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M99.2033 163.164C99.2033 164.234 98.3357 165.102 97.2657 165.102C96.1957 165.102 95.3281 164.234 95.3281 163.164C95.3281 162.094 96.1957 161.226 97.2657 161.226C98.3357 161.226 99.2033 162.094 99.2033 163.164Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M94.4799 163.164C94.4799 164.234 93.6123 165.102 92.5423 165.102C91.4723 165.102 90.6047 164.234 90.6047 163.164C90.6047 162.094 91.4723 161.226 92.5423 161.226C93.6123 161.226 94.4799 162.094 94.4799 163.164Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M94.4799 158.441C94.4799 159.511 93.6123 160.379 92.5423 160.379C91.4723 160.379 90.6047 159.511 90.6047 158.441C90.6047 157.371 91.4723 156.504 92.5423 156.504C93.6123 156.504 94.4799 157.371 94.4799 158.441Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M99.2033 158.441C99.2033 159.511 98.3357 160.379 97.2657 160.379C96.1957 160.379 95.3281 159.511 95.3281 158.441C95.3281 157.371 96.1957 156.504 97.2657 156.504C98.3357 156.504 99.2033 157.371 99.2033 158.441Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M103.926 158.441C103.926 159.511 103.059 160.379 101.989 160.379C100.919 160.379 100.051 159.511 100.051 158.441C100.051 157.371 100.919 156.504 101.989 156.504C103.059 156.504 103.926 157.371 103.926 158.441Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M108.65 158.441C108.65 159.511 107.782 160.379 106.712 160.379C105.642 160.379 104.774 159.511 104.774 158.441C104.774 157.371 105.642 156.504 106.712 156.504C107.782 156.504 108.65 157.371 108.65 158.441Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M113.373 158.441C113.373 159.511 112.505 160.379 111.435 160.379C110.365 160.379 109.498 159.511 109.498 158.441C109.498 157.371 110.365 156.504 111.435 156.504C112.505 156.504 113.373 157.371 113.373 158.441Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M118.096 158.441C118.096 159.511 117.228 160.379 116.158 160.379C115.088 160.379 114.221 159.511 114.221 158.441C114.221 157.371 115.088 156.504 116.158 156.504C117.228 156.504 118.096 157.371 118.096 158.441Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M122.819 158.441C122.819 159.511 121.951 160.379 120.881 160.379C119.811 160.379 118.944 159.511 118.944 158.441C118.944 157.371 119.811 156.504 120.881 156.504C121.951 156.504 122.819 157.371 122.819 158.441Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M127.542 158.441C127.542 159.511 126.675 160.379 125.605 160.379C124.535 160.379 123.667 159.511 123.667 158.441C123.667 157.371 124.535 156.504 125.605 156.504C126.675 156.504 127.542 157.371 127.542 158.441Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M132.265 158.441C132.265 159.511 131.398 160.379 130.328 160.379C129.258 160.379 128.39 159.511 128.39 158.441C128.39 157.371 129.258 156.504 130.328 156.504C131.398 156.504 132.265 157.371 132.265 158.441Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M136.988 158.441C136.988 159.511 136.121 160.379 135.051 160.379C133.981 160.379 133.113 159.511 133.113 158.441C133.113 157.371 133.981 156.504 135.051 156.504C136.121 156.504 136.988 157.371 136.988 158.441Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M141.712 158.441C141.712 159.511 140.844 160.379 139.774 160.379C138.704 160.379 137.836 159.511 137.836 158.441C137.836 157.371 138.704 156.504 139.774 156.504C140.844 156.504 141.712 157.371 141.712 158.441Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M146.435 158.441C146.435 159.511 145.567 160.379 144.497 160.379C143.427 160.379 142.56 159.511 142.56 158.441C142.56 157.371 143.427 156.504 144.497 156.504C145.567 156.504 146.435 157.371 146.435 158.441Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M146.435 153.719C146.435 154.789 145.567 155.656 144.497 155.656C143.427 155.656 142.56 154.789 142.56 153.719C142.56 152.649 143.427 151.781 144.497 151.781C145.567 151.781 146.435 152.649 146.435 153.719Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M146.435 148.996C146.435 150.066 145.567 150.934 144.497 150.934C143.427 150.934 142.56 150.066 142.56 148.996C142.56 147.926 143.427 147.058 144.497 147.058C145.567 147.058 146.435 147.926 146.435 148.996Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M146.435 144.273C146.435 145.343 145.567 146.211 144.497 146.211C143.427 146.211 142.56 145.343 142.56 144.273C142.56 143.203 143.427 142.336 144.497 142.336C145.567 142.336 146.435 143.203 146.435 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M151.158 144.273C151.158 145.343 150.29 146.211 149.22 146.211C148.15 146.211 147.283 145.343 147.283 144.273C147.283 143.203 148.15 142.336 149.22 142.336C150.29 142.336 151.158 143.203 151.158 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M151.158 139.551C151.158 140.621 150.29 141.488 149.22 141.488C148.15 141.488 147.283 140.621 147.283 139.551C147.283 138.481 148.15 137.613 149.22 137.613C150.29 137.613 151.158 138.481 151.158 139.551Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M151.158 153.719C151.158 154.789 150.29 155.656 149.22 155.656C148.15 155.656 147.283 154.789 147.283 153.719C147.283 152.649 148.15 151.781 149.22 151.781C150.29 151.781 151.158 152.649 151.158 153.719Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M151.158 148.996C151.158 150.066 150.29 150.934 149.22 150.934C148.15 150.934 147.283 150.066 147.283 148.996C147.283 147.926 148.15 147.058 149.22 147.058C150.29 147.058 151.158 147.926 151.158 148.996Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M155.881 148.996C155.881 150.066 155.013 150.934 153.943 150.934C152.873 150.934 152.006 150.066 152.006 148.996C152.006 147.926 152.873 147.058 153.943 147.058C155.013 147.058 155.881 147.926 155.881 148.996Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M155.881 144.273C155.881 145.343 155.013 146.211 153.943 146.211C152.873 146.211 152.006 145.343 152.006 144.273C152.006 143.203 152.873 142.336 153.943 142.336C155.013 142.336 155.881 143.203 155.881 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M155.881 139.551C155.881 140.621 155.013 141.488 153.943 141.488C152.873 141.488 152.006 140.621 152.006 139.551C152.006 138.481 152.873 137.613 153.943 137.613C155.013 137.613 155.881 138.481 155.881 139.551Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M160.604 144.273C160.604 145.343 159.737 146.211 158.667 146.211C157.597 146.211 156.729 145.343 156.729 144.273C156.729 143.203 157.597 142.336 158.667 142.336C159.737 142.336 160.604 143.203 160.604 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M160.604 139.551C160.604 140.621 159.737 141.488 158.667 141.488C157.597 141.488 156.729 140.621 156.729 139.551C156.729 138.481 157.597 137.613 158.667 137.613C159.737 137.613 160.604 138.481 160.604 139.551Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M160.604 134.828C160.604 135.898 159.737 136.766 158.667 136.766C157.597 136.766 156.729 135.898 156.729 134.828C156.729 133.758 157.597 132.89 158.667 132.89C159.737 132.89 160.604 133.758 160.604 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M165.328 134.828C165.328 135.898 164.46 136.766 163.39 136.766C162.32 136.766 161.452 135.898 161.452 134.828C161.452 133.758 162.32 132.89 163.39 132.89C164.46 132.89 165.328 133.758 165.328 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M165.328 130.101C165.328 131.171 164.46 132.039 163.39 132.039C162.32 132.039 161.452 131.171 161.452 130.101C161.452 129.031 162.32 128.164 163.39 128.164C164.46 128.164 165.328 129.031 165.328 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M165.328 125.379C165.328 126.449 164.46 127.316 163.39 127.316C162.32 127.316 161.452 126.449 161.452 125.379C161.452 124.309 162.32 123.441 163.39 123.441C164.46 123.441 165.328 124.309 165.328 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M160.604 125.379C160.604 126.449 159.737 127.316 158.667 127.316C157.597 127.316 156.729 126.449 156.729 125.379C156.729 124.309 157.597 123.441 158.667 123.441C159.737 123.441 160.604 124.309 160.604 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M160.604 120.656C160.604 121.726 159.737 122.594 158.667 122.594C157.597 122.594 156.729 121.726 156.729 120.656C156.729 119.586 157.597 118.719 158.667 118.719C159.737 118.719 160.604 119.586 160.604 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M160.604 115.934C160.604 117.003 159.737 117.871 158.667 117.871C157.597 117.871 156.729 117.003 156.729 115.934C156.729 114.864 157.597 113.996 158.667 113.996C159.737 113.996 160.604 114.864 160.604 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M160.604 111.211C160.604 112.281 159.737 113.148 158.667 113.148C157.597 113.148 156.729 112.281 156.729 111.211C156.729 110.141 157.597 109.273 158.667 109.273C159.737 109.273 160.604 110.141 160.604 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M165.328 111.211C165.328 112.281 164.46 113.148 163.39 113.148C162.32 113.148 161.452 112.281 161.452 111.211C161.452 110.141 162.32 109.273 163.39 109.273C164.46 109.273 165.328 110.141 165.328 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M165.328 106.488C165.328 107.558 164.46 108.426 163.39 108.426C162.32 108.426 161.452 107.558 161.452 106.488C161.452 105.418 162.32 104.551 163.39 104.551C164.46 104.551 165.328 105.418 165.328 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M170.051 106.488C170.051 107.558 169.183 108.426 168.113 108.426C167.043 108.426 166.176 107.558 166.176 106.488C166.176 105.418 167.043 104.551 168.113 104.551C169.183 104.551 170.051 105.418 170.051 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M174.774 106.488C174.774 107.558 173.906 108.426 172.836 108.426C171.766 108.426 170.899 107.558 170.899 106.488C170.899 105.418 171.766 104.551 172.836 104.551C173.906 104.551 174.774 105.418 174.774 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M179.497 106.488C179.497 107.558 178.629 108.426 177.559 108.426C176.489 108.426 175.622 107.558 175.622 106.488C175.622 105.418 176.489 104.551 177.559 104.551C178.629 104.551 179.497 105.418 179.497 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M179.497 111.211C179.497 112.281 178.629 113.148 177.559 113.148C176.489 113.148 175.622 112.281 175.622 111.211C175.622 110.141 176.489 109.273 177.559 109.273C178.629 109.273 179.497 110.141 179.497 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M174.774 111.211C174.774 112.281 173.906 113.148 172.836 113.148C171.766 113.148 170.899 112.281 170.899 111.211C170.899 110.141 171.766 109.273 172.836 109.273C173.906 109.273 174.774 110.141 174.774 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M170.051 111.211C170.051 112.281 169.183 113.148 168.113 113.148C167.043 113.148 166.176 112.281 166.176 111.211C166.176 110.141 167.043 109.273 168.113 109.273C169.183 109.273 170.051 110.141 170.051 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M170.051 115.934C170.051 117.003 169.183 117.871 168.113 117.871C167.043 117.871 166.176 117.003 166.176 115.934C166.176 114.864 167.043 113.996 168.113 113.996C169.183 113.996 170.051 114.864 170.051 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M165.328 115.934C165.328 117.003 164.46 117.871 163.39 117.871C162.32 117.871 161.452 117.003 161.452 115.934C161.452 114.864 162.32 113.996 163.39 113.996C164.46 113.996 165.328 114.864 165.328 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M165.328 120.656C165.328 121.726 164.46 122.594 163.39 122.594C162.32 122.594 161.452 121.726 161.452 120.656C161.452 119.586 162.32 118.719 163.39 118.719C164.46 118.719 165.328 119.586 165.328 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M170.051 120.656C170.051 121.726 169.183 122.594 168.113 122.594C167.043 122.594 166.176 121.726 166.176 120.656C166.176 119.586 167.043 118.719 168.113 118.719C169.183 118.719 170.051 119.586 170.051 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M174.774 120.656C174.774 121.726 173.906 122.594 172.836 122.594C171.766 122.594 170.899 121.726 170.899 120.656C170.899 119.586 171.766 118.719 172.836 118.719C173.906 118.719 174.774 119.586 174.774 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M174.774 115.934C174.774 117.003 173.906 117.871 172.836 117.871C171.766 117.871 170.899 117.003 170.899 115.934C170.899 114.864 171.766 113.996 172.836 113.996C173.906 113.996 174.774 114.864 174.774 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M179.497 115.934C179.497 117.003 178.629 117.871 177.559 117.871C176.489 117.871 175.622 117.003 175.622 115.934C175.622 114.864 176.489 113.996 177.559 113.996C178.629 113.996 179.497 114.864 179.497 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M184.22 115.934C184.22 117.003 183.353 117.871 182.283 117.871C181.213 117.871 180.345 117.003 180.345 115.934C180.345 114.864 181.213 113.996 182.283 113.996C183.353 113.996 184.22 114.864 184.22 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M188.943 115.934C188.943 117.003 188.076 117.871 187.006 117.871C185.936 117.871 185.068 117.003 185.068 115.934C185.068 114.864 185.936 113.996 187.006 113.996C188.076 113.996 188.943 114.864 188.943 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M193.666 115.934C193.666 117.003 192.799 117.871 191.729 117.871C190.659 117.871 189.791 117.003 189.791 115.934C189.791 114.864 190.659 113.996 191.729 113.996C192.799 113.996 193.666 114.864 193.666 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M188.943 125.379C188.943 126.449 188.076 127.316 187.006 127.316C185.936 127.316 185.068 126.449 185.068 125.379C185.068 124.309 185.936 123.441 187.006 123.441C188.076 123.441 188.943 124.309 188.943 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M193.666 125.379C193.666 126.449 192.799 127.316 191.729 127.316C190.659 127.316 189.791 126.449 189.791 125.379C189.791 124.309 190.659 123.441 191.729 123.441C192.799 123.441 193.666 124.309 193.666 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M170.051 101.766C170.051 102.836 169.183 103.703 168.113 103.703C167.043 103.703 166.176 102.836 166.176 101.766C166.176 100.696 167.043 99.828 168.113 99.828C169.183 99.828 170.051 100.696 170.051 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M170.051 97.0429C170.051 98.1129 169.183 98.9805 168.113 98.9805C167.043 98.9805 166.176 98.1129 166.176 97.0429C166.176 95.9729 167.043 95.1053 168.113 95.1053C169.183 95.1053 170.051 95.9729 170.051 97.0429Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M170.051 92.3163C170.051 93.3863 169.183 94.2539 168.113 94.2539C167.043 94.2539 166.176 93.3863 166.176 92.3163C166.176 91.2463 167.043 90.3787 168.113 90.3787C169.183 90.3787 170.051 91.2463 170.051 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M174.774 92.3163C174.774 93.3863 173.906 94.2539 172.836 94.2539C171.766 94.2539 170.899 93.3863 170.899 92.3163C170.899 91.2463 171.766 90.3787 172.836 90.3787C173.906 90.3787 174.774 91.2463 174.774 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M174.774 97.0429C174.774 98.1129 173.906 98.9805 172.836 98.9805C171.766 98.9805 170.899 98.1129 170.899 97.0429C170.899 95.9729 171.766 95.1053 172.836 95.1053C173.906 95.1053 174.774 95.9729 174.774 97.0429Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M174.774 101.766C174.774 102.836 173.906 103.703 172.836 103.703C171.766 103.703 170.899 102.836 170.899 101.766C170.899 100.696 171.766 99.828 172.836 99.828C173.906 99.828 174.774 100.696 174.774 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M179.497 101.766C179.497 102.836 178.629 103.703 177.559 103.703C176.489 103.703 175.622 102.836 175.622 101.766C175.622 100.696 176.489 99.828 177.559 99.828C178.629 99.828 179.497 100.696 179.497 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M184.22 101.766C184.22 102.836 183.353 103.703 182.283 103.703C181.213 103.703 180.345 102.836 180.345 101.766C180.345 100.696 181.213 99.828 182.283 99.828C183.353 99.828 184.22 100.696 184.22 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M184.22 106.488C184.22 107.558 183.353 108.426 182.283 108.426C181.213 108.426 180.345 107.558 180.345 106.488C180.345 105.418 181.213 104.551 182.283 104.551C183.353 104.551 184.22 105.418 184.22 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M184.22 111.211C184.22 112.281 183.353 113.148 182.283 113.148C181.213 113.148 180.345 112.281 180.345 111.211C180.345 110.141 181.213 109.273 182.283 109.273C183.353 109.273 184.22 110.141 184.22 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M188.943 111.211C188.943 112.281 188.076 113.148 187.006 113.148C185.936 113.148 185.068 112.281 185.068 111.211C185.068 110.141 185.936 109.273 187.006 109.273C188.076 109.273 188.943 110.141 188.943 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M184.22 97.0429C184.22 98.1129 183.353 98.9805 182.283 98.9805C181.213 98.9805 180.345 98.1129 180.345 97.0429C180.345 95.9729 181.213 95.1053 182.283 95.1053C183.353 95.1053 184.22 95.9729 184.22 97.0429Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M170.051 87.5937C170.051 88.6636 169.183 89.5312 168.113 89.5312C167.043 89.5312 166.176 88.6636 166.176 87.5937C166.176 86.5237 167.043 85.6561 168.113 85.6561C169.183 85.6561 170.051 86.5237 170.051 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M160.604 82.871C160.604 83.941 159.737 84.8086 158.667 84.8086C157.597 84.8086 156.729 83.941 156.729 82.871C156.729 81.801 157.597 80.9334 158.667 80.9334C159.737 80.9334 160.604 81.801 160.604 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M165.328 97.0429C165.328 98.1129 164.46 98.9805 163.39 98.9805C162.32 98.9805 161.452 98.1129 161.452 97.0429C161.452 95.9729 162.32 95.1053 163.39 95.1053C164.46 95.1053 165.328 95.9729 165.328 97.0429Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M165.328 101.766C165.328 102.836 164.46 103.703 163.39 103.703C162.32 103.703 161.452 102.836 161.452 101.766C161.452 100.696 162.32 99.828 163.39 99.828C164.46 99.828 165.328 100.696 165.328 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M155.881 120.656C155.881 121.726 155.013 122.594 153.943 122.594C152.873 122.594 152.006 121.726 152.006 120.656C152.006 119.586 152.873 118.719 153.943 118.719C155.013 118.719 155.881 119.586 155.881 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M160.604 130.101C160.604 131.171 159.737 132.039 158.667 132.039C157.597 132.039 156.729 131.171 156.729 130.101C156.729 129.031 157.597 128.164 158.667 128.164C159.737 128.164 160.604 129.031 160.604 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M155.881 130.101C155.881 131.171 155.013 132.039 153.943 132.039C152.873 132.039 152.006 131.171 152.006 130.101C152.006 129.031 152.873 128.164 153.943 128.164C155.013 128.164 155.881 129.031 155.881 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M155.881 125.379C155.881 126.449 155.013 127.316 153.943 127.316C152.873 127.316 152.006 126.449 152.006 125.379C152.006 124.309 152.873 123.441 153.943 123.441C155.013 123.441 155.881 124.309 155.881 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M151.158 125.379C151.158 126.449 150.29 127.316 149.22 127.316C148.15 127.316 147.283 126.449 147.283 125.379C147.283 124.309 148.15 123.441 149.22 123.441C150.29 123.441 151.158 124.309 151.158 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M146.435 125.379C146.435 126.449 145.567 127.316 144.497 127.316C143.427 127.316 142.56 126.449 142.56 125.379C142.56 124.309 143.427 123.441 144.497 123.441C145.567 123.441 146.435 124.309 146.435 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M146.435 120.656C146.435 121.726 145.567 122.594 144.497 122.594C143.427 122.594 142.56 121.726 142.56 120.656C142.56 119.586 143.427 118.719 144.497 118.719C145.567 118.719 146.435 119.586 146.435 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M141.712 120.656C141.712 121.726 140.844 122.594 139.774 122.594C138.704 122.594 137.836 121.726 137.836 120.656C137.836 119.586 138.704 118.719 139.774 118.719C140.844 118.719 141.712 119.586 141.712 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M151.158 120.656C151.158 121.726 150.29 122.594 149.22 122.594C148.15 122.594 147.283 121.726 147.283 120.656C147.283 119.586 148.15 118.719 149.22 118.719C150.29 118.719 151.158 119.586 151.158 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M151.158 115.934C151.158 117.003 150.29 117.871 149.22 117.871C148.15 117.871 147.283 117.003 147.283 115.934C147.283 114.864 148.15 113.996 149.22 113.996C150.29 113.996 151.158 114.864 151.158 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M146.435 115.934C146.435 117.003 145.567 117.871 144.497 117.871C143.427 117.871 142.56 117.003 142.56 115.934C142.56 114.864 143.427 113.996 144.497 113.996C145.567 113.996 146.435 114.864 146.435 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M146.435 111.211C146.435 112.281 145.567 113.148 144.497 113.148C143.427 113.148 142.56 112.281 142.56 111.211C142.56 110.141 143.427 109.273 144.497 109.273C145.567 109.273 146.435 110.141 146.435 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M141.712 111.211C141.712 112.281 140.844 113.148 139.774 113.148C138.704 113.148 137.836 112.281 137.836 111.211C137.836 110.141 138.704 109.273 139.774 109.273C140.844 109.273 141.712 110.141 141.712 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M136.988 111.211C136.988 112.281 136.121 113.148 135.051 113.148C133.981 113.148 133.113 112.281 133.113 111.211C133.113 110.141 133.981 109.273 135.051 109.273C136.121 109.273 136.988 110.141 136.988 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M132.265 111.211C132.265 112.281 131.398 113.148 130.328 113.148C129.258 113.148 128.39 112.281 128.39 111.211C128.39 110.141 129.258 109.273 130.328 109.273C131.398 109.273 132.265 110.141 132.265 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M132.265 115.934C132.265 117.003 131.398 117.871 130.328 117.871C129.258 117.871 128.39 117.003 128.39 115.934C128.39 114.864 129.258 113.996 130.328 113.996C131.398 113.996 132.265 114.864 132.265 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M151.158 111.211C151.158 112.281 150.29 113.148 149.22 113.148C148.15 113.148 147.283 112.281 147.283 111.211C147.283 110.141 148.15 109.273 149.22 109.273C150.29 109.273 151.158 110.141 151.158 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M151.158 106.488C151.158 107.558 150.29 108.426 149.22 108.426C148.15 108.426 147.283 107.558 147.283 106.488C147.283 105.418 148.15 104.551 149.22 104.551C150.29 104.551 151.158 105.418 151.158 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M146.435 106.488C146.435 107.558 145.567 108.426 144.497 108.426C143.427 108.426 142.56 107.558 142.56 106.488C142.56 105.418 143.427 104.551 144.497 104.551C145.567 104.551 146.435 105.418 146.435 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M141.712 106.488C141.712 107.558 140.844 108.426 139.774 108.426C138.704 108.426 137.836 107.558 137.836 106.488C137.836 105.418 138.704 104.551 139.774 104.551C140.844 104.551 141.712 105.418 141.712 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M141.712 101.766C141.712 102.836 140.844 103.703 139.774 103.703C138.704 103.703 137.836 102.836 137.836 101.766C137.836 100.696 138.704 99.828 139.774 99.828C140.844 99.828 141.712 100.696 141.712 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M136.988 101.766C136.988 102.836 136.121 103.703 135.051 103.703C133.981 103.703 133.113 102.836 133.113 101.766C133.113 100.696 133.981 99.828 135.051 99.828C136.121 99.828 136.988 100.696 136.988 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M132.265 101.766C132.265 102.836 131.398 103.703 130.328 103.703C129.258 103.703 128.39 102.836 128.39 101.766C128.39 100.696 129.258 99.828 130.328 99.828C131.398 99.828 132.265 100.696 132.265 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M132.265 106.488C132.265 107.558 131.398 108.426 130.328 108.426C129.258 108.426 128.39 107.558 128.39 106.488C128.39 105.418 129.258 104.551 130.328 104.551C131.398 104.551 132.265 105.418 132.265 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M127.542 101.766C127.542 102.836 126.675 103.703 125.605 103.703C124.535 103.703 123.667 102.836 123.667 101.766C123.667 100.696 124.535 99.828 125.605 99.828C126.675 99.828 127.542 100.696 127.542 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M122.819 101.766C122.819 102.836 121.951 103.703 120.881 103.703C119.811 103.703 118.944 102.836 118.944 101.766C118.944 100.696 119.811 99.828 120.881 99.828C121.951 99.828 122.819 100.696 122.819 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M136.988 97.0429C136.988 98.1129 136.121 98.9805 135.051 98.9805C133.981 98.9805 133.113 98.1129 133.113 97.0429C133.113 95.9729 133.981 95.1053 135.051 95.1053C136.121 95.1053 136.988 95.9729 136.988 97.0429Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M127.542 97.0429C127.542 98.1129 126.675 98.9805 125.605 98.9805C124.535 98.9805 123.667 98.1129 123.667 97.0429C123.667 95.9729 124.535 95.1053 125.605 95.1053C126.675 95.1053 127.542 95.9729 127.542 97.0429Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M136.988 92.3163C136.988 93.3863 136.121 94.2539 135.051 94.2539C133.981 94.2539 133.113 93.3863 133.113 92.3163C133.113 91.2463 133.981 90.3787 135.051 90.3787C136.121 90.3787 136.988 91.2463 136.988 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M132.265 92.3163C132.265 93.3863 131.398 94.2539 130.328 94.2539C129.258 94.2539 128.39 93.3863 128.39 92.3163C128.39 91.2463 129.258 90.3787 130.328 90.3787C131.398 90.3787 132.265 91.2463 132.265 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M136.988 87.5937C136.988 88.6636 136.121 89.5312 135.051 89.5312C133.981 89.5312 133.113 88.6636 133.113 87.5937C133.113 86.5237 133.981 85.6561 135.051 85.6561C136.121 85.6561 136.988 86.5237 136.988 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M136.988 82.871C136.988 83.941 136.121 84.8086 135.051 84.8086C133.981 84.8086 133.113 83.941 133.113 82.871C133.113 81.801 133.981 80.9334 135.051 80.9334C136.121 80.9334 136.988 81.801 136.988 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M132.265 82.871C132.265 83.941 131.398 84.8086 130.328 84.8086C129.258 84.8086 128.39 83.941 128.39 82.871C128.39 81.801 129.258 80.9334 130.328 80.9334C131.398 80.9334 132.265 81.801 132.265 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M170.051 130.101C170.051 131.171 169.183 132.039 168.113 132.039C167.043 132.039 166.176 131.171 166.176 130.101C166.176 129.031 167.043 128.164 168.113 128.164C169.183 128.164 170.051 129.031 170.051 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M174.774 130.101C174.774 131.171 173.906 132.039 172.836 132.039C171.766 132.039 170.899 131.171 170.899 130.101C170.899 129.031 171.766 128.164 172.836 128.164C173.906 128.164 174.774 129.031 174.774 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M174.774 125.379C174.774 126.449 173.906 127.316 172.836 127.316C171.766 127.316 170.899 126.449 170.899 125.379C170.899 124.309 171.766 123.441 172.836 123.441C173.906 123.441 174.774 124.309 174.774 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M179.497 134.828C179.497 135.898 178.629 136.766 177.559 136.766C176.489 136.766 175.622 135.898 175.622 134.828C175.622 133.758 176.489 132.89 177.559 132.89C178.629 132.89 179.497 133.758 179.497 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M184.22 130.101C184.22 131.171 183.353 132.039 182.283 132.039C181.213 132.039 180.345 131.171 180.345 130.101C180.345 129.031 181.213 128.164 182.283 128.164C183.353 128.164 184.22 129.031 184.22 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M89.7569 158.441C89.7569 159.511 88.8893 160.379 87.8193 160.379C86.7493 160.379 85.8817 159.511 85.8817 158.441C85.8817 157.371 86.7493 156.504 87.8193 156.504C88.8893 156.504 89.7569 157.371 89.7569 158.441Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M89.7569 153.719C89.7569 154.789 88.8893 155.656 87.8193 155.656C86.7493 155.656 85.8817 154.789 85.8817 153.719C85.8817 152.649 86.7493 151.781 87.8193 151.781C88.8893 151.781 89.7569 152.649 89.7569 153.719Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M85.0337 153.719C85.0337 154.789 84.1661 155.656 83.0962 155.656C82.0262 155.656 81.1586 154.789 81.1586 153.719C81.1586 152.649 82.0262 151.781 83.0962 151.781C84.1661 151.781 85.0337 152.649 85.0337 153.719Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M85.0337 158.441C85.0337 159.511 84.1661 160.379 83.0962 160.379C82.0262 160.379 81.1586 159.511 81.1586 158.441C81.1586 157.371 82.0262 156.504 83.0962 156.504C84.1661 156.504 85.0337 157.371 85.0337 158.441Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M85.0337 163.164C85.0337 164.234 84.1661 165.102 83.0962 165.102C82.0262 165.102 81.1586 164.234 81.1586 163.164C81.1586 162.094 82.0262 161.226 83.0962 161.226C84.1661 161.226 85.0337 162.094 85.0337 163.164Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M85.0337 167.887C85.0337 168.957 84.1661 169.824 83.0962 169.824C82.0262 169.824 81.1586 168.957 81.1586 167.887C81.1586 166.817 82.0262 165.949 83.0962 165.949C84.1661 165.949 85.0337 166.817 85.0337 167.887Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M14.1862 182.059C14.1862 183.128 13.3186 183.996 12.2486 183.996C11.1786 183.996 10.311 183.128 10.311 182.059C10.311 180.989 11.1786 180.121 12.2486 180.121C13.3186 180.121 14.1862 180.989 14.1862 182.059Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M9.46306 177.336C9.46306 178.406 8.59546 179.273 7.52548 179.273C6.4555 179.273 5.58789 178.406 5.58789 177.336C5.58789 176.266 6.4555 175.398 7.52548 175.398C8.59546 175.398 9.46306 176.266 9.46306 177.336Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M89.7569 167.887C89.7569 168.957 88.8893 169.824 87.8193 169.824C86.7493 169.824 85.8817 168.957 85.8817 167.887C85.8817 166.817 86.7493 165.949 87.8193 165.949C88.8893 165.949 89.7569 166.817 89.7569 167.887Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M89.7569 172.613C89.7569 173.683 88.8893 174.551 87.8193 174.551C86.7493 174.551 85.8817 173.683 85.8817 172.613C85.8817 171.543 86.7493 170.676 87.8193 170.676C88.8893 170.676 89.7569 171.543 89.7569 172.613Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M94.4799 177.336C94.4799 178.406 93.6123 179.273 92.5423 179.273C91.4723 179.273 90.6047 178.406 90.6047 177.336C90.6047 176.266 91.4723 175.398 92.5423 175.398C93.6123 175.398 94.4799 176.266 94.4799 177.336Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M85.0339 148.996C85.0339 150.066 84.1663 150.934 83.0963 150.934C82.0263 150.934 81.1587 150.066 81.1587 148.996C81.1587 147.926 82.0263 147.058 83.0963 147.058C84.1663 147.058 85.0339 147.926 85.0339 148.996Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M80.3107 148.996C80.3107 150.066 79.4431 150.934 78.3731 150.934C77.3032 150.934 76.4355 150.066 76.4355 148.996C76.4355 147.926 77.3032 147.058 78.3731 147.058C79.4431 147.058 80.3107 147.926 80.3107 148.996Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M80.3107 144.273C80.3107 145.343 79.4431 146.211 78.3731 146.211C77.3032 146.211 76.4355 145.343 76.4355 144.273C76.4355 143.203 77.3032 142.336 78.3731 142.336C79.4431 142.336 80.3107 143.203 80.3107 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M80.3107 139.551C80.3107 140.621 79.4431 141.488 78.3731 141.488C77.3032 141.488 76.4355 140.621 76.4355 139.551C76.4355 138.481 77.3032 137.613 78.3731 137.613C79.4431 137.613 80.3107 138.481 80.3107 139.551Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M80.3105 134.828C80.3105 135.898 79.4429 136.766 78.3729 136.766C77.3029 136.766 76.4353 135.898 76.4353 134.828C76.4353 133.758 77.3029 132.89 78.3729 132.89C79.4429 132.89 80.3105 133.758 80.3105 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M80.3105 130.101C80.3105 131.171 79.4429 132.039 78.3729 132.039C77.3029 132.039 76.4353 131.171 76.4353 130.101C76.4353 129.031 77.3029 128.164 78.3729 128.164C79.4429 128.164 80.3105 129.031 80.3105 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M85.0337 130.101C85.0337 131.171 84.1661 132.039 83.0962 132.039C82.0262 132.039 81.1586 131.171 81.1586 130.101C81.1586 129.031 82.0262 128.164 83.0962 128.164C84.1661 128.164 85.0337 129.031 85.0337 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M85.0337 125.379C85.0337 126.449 84.1661 127.316 83.0962 127.316C82.0262 127.316 81.1586 126.449 81.1586 125.379C81.1586 124.309 82.0262 123.441 83.0962 123.441C84.1661 123.441 85.0337 124.309 85.0337 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M80.3105 125.379C80.3105 126.449 79.4429 127.316 78.3729 127.316C77.3029 127.316 76.4353 126.449 76.4353 125.379C76.4353 124.309 77.3029 123.441 78.3729 123.441C79.4429 123.441 80.3105 124.309 80.3105 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M89.7569 125.379C89.7569 126.449 88.8893 127.316 87.8193 127.316C86.7493 127.316 85.8817 126.449 85.8817 125.379C85.8817 124.309 86.7493 123.441 87.8193 123.441C88.8893 123.441 89.7569 124.309 89.7569 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M94.4799 125.379C94.4799 126.449 93.6123 127.316 92.5423 127.316C91.4723 127.316 90.6047 126.449 90.6047 125.379C90.6047 124.309 91.4723 123.441 92.5423 123.441C93.6123 123.441 94.4799 124.309 94.4799 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M99.2033 125.379C99.2033 126.449 98.3357 127.316 97.2657 127.316C96.1957 127.316 95.3281 126.449 95.3281 125.379C95.3281 124.309 96.1957 123.441 97.2657 123.441C98.3357 123.441 99.2033 124.309 99.2033 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M103.926 125.379C103.926 126.449 103.059 127.316 101.989 127.316C100.919 127.316 100.051 126.449 100.051 125.379C100.051 124.309 100.919 123.441 101.989 123.441C103.059 123.441 103.926 124.309 103.926 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M108.65 125.379C108.65 126.449 107.782 127.316 106.712 127.316C105.642 127.316 104.774 126.449 104.774 125.379C104.774 124.309 105.642 123.441 106.712 123.441C107.782 123.441 108.65 124.309 108.65 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M113.373 125.379C113.373 126.449 112.505 127.316 111.435 127.316C110.365 127.316 109.498 126.449 109.498 125.379C109.498 124.309 110.365 123.441 111.435 123.441C112.505 123.441 113.373 124.309 113.373 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M118.096 125.379C118.096 126.449 117.228 127.316 116.158 127.316C115.088 127.316 114.221 126.449 114.221 125.379C114.221 124.309 115.088 123.441 116.158 123.441C117.228 123.441 118.096 124.309 118.096 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M122.819 125.379C122.819 126.449 121.951 127.316 120.881 127.316C119.811 127.316 118.944 126.449 118.944 125.379C118.944 124.309 119.811 123.441 120.881 123.441C121.951 123.441 122.819 124.309 122.819 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M127.542 125.379C127.542 126.449 126.675 127.316 125.605 127.316C124.535 127.316 123.667 126.449 123.667 125.379C123.667 124.309 124.535 123.441 125.605 123.441C126.675 123.441 127.542 124.309 127.542 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M132.265 125.379C132.265 126.449 131.398 127.316 130.328 127.316C129.258 127.316 128.39 126.449 128.39 125.379C128.39 124.309 129.258 123.441 130.328 123.441C131.398 123.441 132.265 124.309 132.265 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M132.265 120.656C132.265 121.726 131.398 122.594 130.328 122.594C129.258 122.594 128.39 121.726 128.39 120.656C128.39 119.586 129.258 118.719 130.328 118.719C131.398 118.719 132.265 119.586 132.265 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M136.988 120.656C136.988 121.726 136.121 122.594 135.051 122.594C133.981 122.594 133.113 121.726 133.113 120.656C133.113 119.586 133.981 118.719 135.051 118.719C136.121 118.719 136.988 119.586 136.988 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M127.542 120.656C127.542 121.726 126.675 122.594 125.605 122.594C124.535 122.594 123.667 121.726 123.667 120.656C123.667 119.586 124.535 118.719 125.605 118.719C126.675 118.719 127.542 119.586 127.542 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M122.819 120.656C122.819 121.726 121.951 122.594 120.881 122.594C119.811 122.594 118.944 121.726 118.944 120.656C118.944 119.586 119.811 118.719 120.881 118.719C121.951 118.719 122.819 119.586 122.819 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M118.096 120.656C118.096 121.726 117.228 122.594 116.158 122.594C115.088 122.594 114.221 121.726 114.221 120.656C114.221 119.586 115.088 118.719 116.158 118.719C117.228 118.719 118.096 119.586 118.096 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M113.373 120.656C113.373 121.726 112.505 122.594 111.435 122.594C110.365 122.594 109.498 121.726 109.498 120.656C109.498 119.586 110.365 118.719 111.435 118.719C112.505 118.719 113.373 119.586 113.373 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M108.65 120.656C108.65 121.726 107.782 122.594 106.712 122.594C105.642 122.594 104.774 121.726 104.774 120.656C104.774 119.586 105.642 118.719 106.712 118.719C107.782 118.719 108.65 119.586 108.65 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M103.926 120.656C103.926 121.726 103.059 122.594 101.989 122.594C100.919 122.594 100.051 121.726 100.051 120.656C100.051 119.586 100.919 118.719 101.989 118.719C103.059 118.719 103.926 119.586 103.926 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M99.2033 120.656C99.2033 121.726 98.3357 122.594 97.2657 122.594C96.1957 122.594 95.3281 121.726 95.3281 120.656C95.3281 119.586 96.1957 118.719 97.2657 118.719C98.3357 118.719 99.2033 119.586 99.2033 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M94.4799 120.656C94.4799 121.726 93.6123 122.594 92.5423 122.594C91.4723 122.594 90.6047 121.726 90.6047 120.656C90.6047 119.586 91.4723 118.719 92.5423 118.719C93.6123 118.719 94.4799 119.586 94.4799 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M89.7569 120.656C89.7569 121.726 88.8893 122.594 87.8193 122.594C86.7493 122.594 85.8817 121.726 85.8817 120.656C85.8817 119.586 86.7493 118.719 87.8193 118.719C88.8893 118.719 89.7569 119.586 89.7569 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M85.0337 120.656C85.0337 121.726 84.1661 122.594 83.0962 122.594C82.0262 122.594 81.1586 121.726 81.1586 120.656C81.1586 119.586 82.0262 118.719 83.0962 118.719C84.1661 118.719 85.0337 119.586 85.0337 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M85.0337 115.934C85.0337 117.003 84.1661 117.871 83.0962 117.871C82.0262 117.871 81.1586 117.003 81.1586 115.934C81.1586 114.864 82.0262 113.996 83.0962 113.996C84.1661 113.996 85.0337 114.864 85.0337 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M85.0337 111.211C85.0337 112.281 84.1661 113.148 83.0962 113.148C82.0262 113.148 81.1586 112.281 81.1586 111.211C81.1586 110.141 82.0262 109.273 83.0962 109.273C84.1661 109.273 85.0337 110.141 85.0337 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M85.0337 106.488C85.0337 107.558 84.1661 108.426 83.0962 108.426C82.0262 108.426 81.1586 107.558 81.1586 106.488C81.1586 105.418 82.0262 104.551 83.0962 104.551C84.1661 104.551 85.0337 105.418 85.0337 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M80.3105 106.488C80.3105 107.558 79.4429 108.426 78.3729 108.426C77.3029 108.426 76.4353 107.558 76.4353 106.488C76.4353 105.418 77.3029 104.551 78.3729 104.551C79.4429 104.551 80.3105 105.418 80.3105 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M80.3105 101.766C80.3105 102.836 79.4429 103.703 78.3729 103.703C77.3029 103.703 76.4353 102.836 76.4353 101.766C76.4353 100.696 77.3029 99.828 78.3729 99.828C79.4429 99.828 80.3105 100.696 80.3105 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M80.3105 97.0429C80.3105 98.1129 79.4429 98.9805 78.3729 98.9805C77.3029 98.9805 76.4353 98.1129 76.4353 97.0429C76.4353 95.9729 77.3029 95.1053 78.3729 95.1053C79.4429 95.1053 80.3105 95.9729 80.3105 97.0429Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M80.3105 92.3163C80.3105 93.3863 79.4429 94.2539 78.3729 94.2539C77.3029 94.2539 76.4353 93.3863 76.4353 92.3163C76.4353 91.2463 77.3029 90.3787 78.3729 90.3787C79.4429 90.3787 80.3105 91.2463 80.3105 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M75.5873 92.3163C75.5873 93.3863 74.7197 94.2539 73.6497 94.2539C72.5798 94.2539 71.7122 93.3863 71.7122 92.3163C71.7122 91.2463 72.5798 90.3787 73.6497 90.3787C74.7197 90.3787 75.5873 91.2463 75.5873 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M75.5873 87.5937C75.5873 88.6636 74.7197 89.5312 73.6497 89.5312C72.5798 89.5312 71.7122 88.6636 71.7122 87.5937C71.7122 86.5237 72.5798 85.6561 73.6497 85.6561C74.7197 85.6561 75.5873 86.5237 75.5873 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M75.5873 82.871C75.5873 83.941 74.7197 84.8086 73.6497 84.8086C72.5798 84.8086 71.7122 83.941 71.7122 82.871C71.7122 81.801 72.5798 80.9334 73.6497 80.9334C74.7197 80.9334 75.5873 81.801 75.5873 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M75.5873 78.1484C75.5873 79.2183 74.7197 80.0859 73.6497 80.0859C72.5798 80.0859 71.7122 79.2183 71.7122 78.1484C71.7122 77.0784 72.5798 76.2108 73.6497 76.2108C74.7197 76.2108 75.5873 77.0784 75.5873 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M70.8642 78.1484C70.8642 79.2183 69.9966 80.0859 68.9266 80.0859C67.8566 80.0859 66.989 79.2183 66.989 78.1484C66.989 77.0784 67.8566 76.2108 68.9266 76.2108C69.9966 76.2108 70.8642 77.0784 70.8642 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M70.8642 73.4257C70.8642 74.4957 69.9966 75.3633 68.9266 75.3633C67.8566 75.3633 66.989 74.4957 66.989 73.4257C66.989 72.3557 67.8566 71.4881 68.9266 71.4881C69.9966 71.4881 70.8642 72.3557 70.8642 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M66.141 73.4257C66.141 74.4957 65.2734 75.3633 64.2035 75.3633C63.1335 75.3633 62.2659 74.4957 62.2659 73.4257C62.2659 72.3557 63.1335 71.4881 64.2035 71.4881C65.2734 71.4881 66.141 72.3557 66.141 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M66.141 68.703C66.141 69.773 65.2734 70.6406 64.2035 70.6406C63.1335 70.6406 62.2659 69.773 62.2659 68.703C62.2659 67.6331 63.1335 66.7655 64.2035 66.7655C65.2734 66.7655 66.141 67.6331 66.141 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M61.4179 68.703C61.4179 69.773 60.5503 70.6406 59.4803 70.6406C58.4103 70.6406 57.5427 69.773 57.5427 68.703C57.5427 67.6331 58.4103 66.7655 59.4803 66.7655C60.5503 66.7655 61.4179 67.6331 61.4179 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M61.4179 63.9804C61.4179 65.0504 60.5503 65.918 59.4803 65.918C58.4103 65.918 57.5427 65.0504 57.5427 63.9804C57.5427 62.9104 58.4103 62.0428 59.4803 62.0428C60.5503 62.0428 61.4179 62.9104 61.4179 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M56.6948 63.9804C56.6948 65.0504 55.8271 65.918 54.7572 65.918C53.6872 65.918 52.8196 65.0504 52.8196 63.9804C52.8196 62.9104 53.6872 62.0428 54.7572 62.0428C55.8271 62.0428 56.6948 62.9104 56.6948 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M56.6948 68.703C56.6948 69.773 55.8271 70.6406 54.7572 70.6406C53.6872 70.6406 52.8196 69.773 52.8196 68.703C52.8196 67.6331 53.6872 66.7655 54.7572 66.7655C55.8271 66.7655 56.6948 67.6331 56.6948 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M56.6948 73.4257C56.6948 74.4957 55.8271 75.3633 54.7572 75.3633C53.6872 75.3633 52.8196 74.4957 52.8196 73.4257C52.8196 72.3557 53.6872 71.4881 54.7572 71.4881C55.8271 71.4881 56.6948 72.3557 56.6948 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M51.9716 73.4257C51.9716 74.4957 51.104 75.3633 50.034 75.3633C48.964 75.3633 48.0964 74.4957 48.0964 73.4257C48.0964 72.3557 48.964 71.4881 50.034 71.4881C51.104 71.4881 51.9716 72.3557 51.9716 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M51.9716 68.703C51.9716 69.773 51.104 70.6406 50.034 70.6406C48.964 70.6406 48.0964 69.773 48.0964 68.703C48.0964 67.6331 48.964 66.7655 50.034 66.7655C51.104 66.7655 51.9716 67.6331 51.9716 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M51.9716 63.9804C51.9716 65.0504 51.104 65.918 50.034 65.918C48.964 65.918 48.0964 65.0504 48.0964 63.9804C48.0964 62.9104 48.964 62.0428 50.034 62.0428C51.104 62.0428 51.9716 62.9104 51.9716 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M47.2483 63.9804C47.2483 65.0504 46.3807 65.918 45.3108 65.918C44.2408 65.918 43.3732 65.0504 43.3732 63.9804C43.3732 62.9104 44.2408 62.0428 45.3108 62.0428C46.3807 62.0428 47.2483 62.9104 47.2483 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M47.2483 68.703C47.2483 69.773 46.3807 70.6406 45.3108 70.6406C44.2408 70.6406 43.3732 69.773 43.3732 68.703C43.3732 67.6331 44.2408 66.7655 45.3108 66.7655C46.3807 66.7655 47.2483 67.6331 47.2483 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M47.2483 73.4257C47.2483 74.4957 46.3807 75.3633 45.3108 75.3633C44.2408 75.3633 43.3732 74.4957 43.3732 73.4257C43.3732 72.3557 44.2408 71.4881 45.3108 71.4881C46.3807 71.4881 47.2483 72.3557 47.2483 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M42.5252 73.4257C42.5252 74.4957 41.6576 75.3633 40.5876 75.3633C39.5176 75.3633 38.65 74.4957 38.65 73.4257C38.65 72.3557 39.5176 71.4881 40.5876 71.4881C41.6576 71.4881 42.5252 72.3557 42.5252 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M37.8021 73.4257C37.8021 74.4957 36.9344 75.3633 35.8645 75.3633C34.7945 75.3633 33.9269 74.4957 33.9269 73.4257C33.9269 72.3557 34.7945 71.4881 35.8645 71.4881C36.9344 71.4881 37.8021 72.3557 37.8021 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M37.8021 68.703C37.8021 69.773 36.9344 70.6406 35.8645 70.6406C34.7945 70.6406 33.9269 69.773 33.9269 68.703C33.9269 67.6331 34.7945 66.7655 35.8645 66.7655C36.9344 66.7655 37.8021 67.6331 37.8021 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M37.8021 63.9804C37.8021 65.0504 36.9344 65.918 35.8645 65.918C34.7945 65.918 33.9269 65.0504 33.9269 63.9804C33.9269 62.9104 34.7945 62.0428 35.8645 62.0428C36.9344 62.0428 37.8021 62.9104 37.8021 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M42.5252 63.9804C42.5252 65.0504 41.6576 65.918 40.5876 65.918C39.5176 65.918 38.65 65.0504 38.65 63.9804C38.65 62.9104 39.5176 62.0428 40.5876 62.0428C41.6576 62.0428 42.5252 62.9104 42.5252 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M42.5252 59.2538C42.5252 60.3238 41.6576 61.1914 40.5876 61.1914C39.5176 61.1914 38.65 60.3238 38.65 59.2538C38.65 58.1838 39.5176 57.3162 40.5876 57.3162C41.6576 57.3162 42.5252 58.1838 42.5252 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M47.2483 59.2538C47.2483 60.3238 46.3807 61.1914 45.3108 61.1914C44.2408 61.1914 43.3732 60.3238 43.3732 59.2538C43.3732 58.1838 44.2408 57.3162 45.3108 57.3162C46.3807 57.3162 47.2483 58.1838 47.2483 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M51.9716 59.2538C51.9716 60.3238 51.104 61.1914 50.034 61.1914C48.964 61.1914 48.0964 60.3238 48.0964 59.2538C48.0964 58.1838 48.964 57.3162 50.034 57.3162C51.104 57.3162 51.9716 58.1838 51.9716 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M51.9716 54.5312C51.9716 55.6011 51.104 56.4688 50.034 56.4688C48.964 56.4688 48.0964 55.6011 48.0964 54.5312C48.0964 53.4612 48.964 52.5936 50.034 52.5936C51.104 52.5936 51.9716 53.4612 51.9716 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M51.9716 49.8085C51.9716 50.8785 51.104 51.7461 50.034 51.7461C48.964 51.7461 48.0964 50.8785 48.0964 49.8085C48.0964 48.7385 48.964 47.8709 50.034 47.8709C51.104 47.8709 51.9716 48.7385 51.9716 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M56.6948 49.8085C56.6948 50.8785 55.8271 51.7461 54.7572 51.7461C53.6872 51.7461 52.8196 50.8785 52.8196 49.8085C52.8196 48.7385 53.6872 47.8709 54.7572 47.8709C55.8271 47.8709 56.6948 48.7385 56.6948 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M56.6948 45.0859C56.6948 46.1558 55.8271 47.0234 54.7572 47.0234C53.6872 47.0234 52.8196 46.1558 52.8196 45.0859C52.8196 44.0159 53.6872 43.1483 54.7572 43.1483C55.8271 43.1483 56.6948 44.0159 56.6948 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M56.6948 40.3632C56.6948 41.4332 55.8271 42.3008 54.7572 42.3008C53.6872 42.3008 52.8196 41.4332 52.8196 40.3632C52.8196 39.2932 53.6872 38.4256 54.7572 38.4256C55.8271 38.4256 56.6948 39.2932 56.6948 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M51.9716 40.3632C51.9716 41.4332 51.104 42.3008 50.034 42.3008C48.964 42.3008 48.0964 41.4332 48.0964 40.3632C48.0964 39.2932 48.964 38.4256 50.034 38.4256C51.104 38.4256 51.9716 39.2932 51.9716 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M51.9716 35.6405C51.9716 36.7105 51.104 37.5781 50.034 37.5781C48.964 37.5781 48.0964 36.7105 48.0964 35.6405C48.0964 34.5706 48.964 33.703 50.034 33.703C51.104 33.703 51.9716 34.5706 51.9716 35.6405Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M56.6948 35.6405C56.6948 36.7105 55.8271 37.5781 54.7572 37.5781C53.6872 37.5781 52.8196 36.7105 52.8196 35.6405C52.8196 34.5706 53.6872 33.703 54.7572 33.703C55.8271 33.703 56.6948 34.5706 56.6948 35.6405Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M61.4179 35.6405C61.4179 36.7105 60.5503 37.5781 59.4803 37.5781C58.4103 37.5781 57.5427 36.7105 57.5427 35.6405C57.5427 34.5706 58.4103 33.703 59.4803 33.703C60.5503 33.703 61.4179 34.5706 61.4179 35.6405Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M66.141 35.6405C66.141 36.7105 65.2734 37.5781 64.2035 37.5781C63.1335 37.5781 62.2659 36.7105 62.2659 35.6405C62.2659 34.5706 63.1335 33.703 64.2035 33.703C65.2734 33.703 66.141 34.5706 66.141 35.6405Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M66.1408 30.9179C66.1408 31.9879 65.2732 32.8555 64.2032 32.8555C63.1332 32.8555 62.2656 31.9879 62.2656 30.9179C62.2656 29.8479 63.1332 28.9803 64.2032 28.9803C65.2732 28.9803 66.1408 29.8479 66.1408 30.9179Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M70.8644 30.9179C70.8644 31.9879 69.9968 32.8555 68.9268 32.8555C67.8569 32.8555 66.9893 31.9879 66.9893 30.9179C66.9893 29.8479 67.8569 28.9803 68.9268 28.9803C69.9968 28.9803 70.8644 29.8479 70.8644 30.9179Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M70.8642 35.6405C70.8642 36.7105 69.9966 37.5781 68.9266 37.5781C67.8566 37.5781 66.989 36.7105 66.989 35.6405C66.989 34.5706 67.8566 33.703 68.9266 33.703C69.9966 33.703 70.8642 34.5706 70.8642 35.6405Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M75.5873 35.6405C75.5873 36.7105 74.7197 37.5781 73.6497 37.5781C72.5798 37.5781 71.7122 36.7105 71.7122 35.6405C71.7122 34.5706 72.5798 33.703 73.6497 33.703C74.7197 33.703 75.5873 34.5706 75.5873 35.6405Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M75.5873 40.3632C75.5873 41.4332 74.7197 42.3008 73.6497 42.3008C72.5798 42.3008 71.7122 41.4332 71.7122 40.3632C71.7122 39.2932 72.5798 38.4256 73.6497 38.4256C74.7197 38.4256 75.5873 39.2932 75.5873 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M80.3105 40.3632C80.3105 41.4332 79.4429 42.3008 78.3729 42.3008C77.3029 42.3008 76.4353 41.4332 76.4353 40.3632C76.4353 39.2932 77.3029 38.4256 78.3729 38.4256C79.4429 38.4256 80.3105 39.2932 80.3105 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M85.0337 40.3632C85.0337 41.4332 84.1661 42.3008 83.0962 42.3008C82.0262 42.3008 81.1586 41.4332 81.1586 40.3632C81.1586 39.2932 82.0262 38.4256 83.0962 38.4256C84.1661 38.4256 85.0337 39.2932 85.0337 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M85.0337 45.0859C85.0337 46.1558 84.1661 47.0234 83.0962 47.0234C82.0262 47.0234 81.1586 46.1558 81.1586 45.0859C81.1586 44.0159 82.0262 43.1483 83.0962 43.1483C84.1661 43.1483 85.0337 44.0159 85.0337 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M89.7569 45.0859C89.7569 46.1558 88.8893 47.0234 87.8193 47.0234C86.7493 47.0234 85.8817 46.1558 85.8817 45.0859C85.8817 44.0159 86.7493 43.1483 87.8193 43.1483C88.8893 43.1483 89.7569 44.0159 89.7569 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M89.7569 49.8085C89.7569 50.8785 88.8893 51.7461 87.8193 51.7461C86.7493 51.7461 85.8817 50.8785 85.8817 49.8085C85.8817 48.7385 86.7493 47.8709 87.8193 47.8709C88.8893 47.8709 89.7569 48.7385 89.7569 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M85.0337 49.8085C85.0337 50.8785 84.1661 51.7461 83.0962 51.7461C82.0262 51.7461 81.1586 50.8785 81.1586 49.8085C81.1586 48.7385 82.0262 47.8709 83.0962 47.8709C84.1661 47.8709 85.0337 48.7385 85.0337 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M80.3105 49.8085C80.3105 50.8785 79.4429 51.7461 78.3729 51.7461C77.3029 51.7461 76.4353 50.8785 76.4353 49.8085C76.4353 48.7385 77.3029 47.8709 78.3729 47.8709C79.4429 47.8709 80.3105 48.7385 80.3105 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M80.3105 45.0859C80.3105 46.1558 79.4429 47.0234 78.3729 47.0234C77.3029 47.0234 76.4353 46.1558 76.4353 45.0859C76.4353 44.0159 77.3029 43.1483 78.3729 43.1483C79.4429 43.1483 80.3105 44.0159 80.3105 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M75.5873 45.0859C75.5873 46.1558 74.7197 47.0234 73.6497 47.0234C72.5798 47.0234 71.7122 46.1558 71.7122 45.0859C71.7122 44.0159 72.5798 43.1483 73.6497 43.1483C74.7197 43.1483 75.5873 44.0159 75.5873 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M70.8642 45.0859C70.8642 46.1558 69.9966 47.0234 68.9266 47.0234C67.8566 47.0234 66.989 46.1558 66.989 45.0859C66.989 44.0159 67.8566 43.1483 68.9266 43.1483C69.9966 43.1483 70.8642 44.0159 70.8642 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M70.8642 40.3632C70.8642 41.4332 69.9966 42.3008 68.9266 42.3008C67.8566 42.3008 66.989 41.4332 66.989 40.3632C66.989 39.2932 67.8566 38.4256 68.9266 38.4256C69.9966 38.4256 70.8642 39.2932 70.8642 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M66.141 40.3632C66.141 41.4332 65.2734 42.3008 64.2035 42.3008C63.1335 42.3008 62.2659 41.4332 62.2659 40.3632C62.2659 39.2932 63.1335 38.4256 64.2035 38.4256C65.2734 38.4256 66.141 39.2932 66.141 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M61.4179 40.3632C61.4179 41.4332 60.5503 42.3008 59.4803 42.3008C58.4103 42.3008 57.5427 41.4332 57.5427 40.3632C57.5427 39.2932 58.4103 38.4256 59.4803 38.4256C60.5503 38.4256 61.4179 39.2932 61.4179 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M61.4179 45.0859C61.4179 46.1558 60.5503 47.0234 59.4803 47.0234C58.4103 47.0234 57.5427 46.1558 57.5427 45.0859C57.5427 44.0159 58.4103 43.1483 59.4803 43.1483C60.5503 43.1483 61.4179 44.0159 61.4179 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M66.141 45.0859C66.141 46.1558 65.2734 47.0234 64.2035 47.0234C63.1335 47.0234 62.2659 46.1558 62.2659 45.0859C62.2659 44.0159 63.1335 43.1483 64.2035 43.1483C65.2734 43.1483 66.141 44.0159 66.141 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M66.141 49.8085C66.141 50.8785 65.2734 51.7461 64.2035 51.7461C63.1335 51.7461 62.2659 50.8785 62.2659 49.8085C62.2659 48.7385 63.1335 47.8709 64.2035 47.8709C65.2734 47.8709 66.141 48.7385 66.141 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M61.4179 49.8085C61.4179 50.8785 60.5503 51.7461 59.4803 51.7461C58.4103 51.7461 57.5427 50.8785 57.5427 49.8085C57.5427 48.7385 58.4103 47.8709 59.4803 47.8709C60.5503 47.8709 61.4179 48.7385 61.4179 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M61.4179 54.5312C61.4179 55.6011 60.5503 56.4688 59.4803 56.4688C58.4103 56.4688 57.5427 55.6011 57.5427 54.5312C57.5427 53.4612 58.4103 52.5936 59.4803 52.5936C60.5503 52.5936 61.4179 53.4612 61.4179 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M66.141 54.5312C66.141 55.6011 65.2734 56.4688 64.2035 56.4688C63.1335 56.4688 62.2659 55.6011 62.2659 54.5312C62.2659 53.4612 63.1335 52.5936 64.2035 52.5936C65.2734 52.5936 66.141 53.4612 66.141 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M70.8642 54.5312C70.8642 55.6011 69.9966 56.4688 68.9266 56.4688C67.8566 56.4688 66.989 55.6011 66.989 54.5312C66.989 53.4612 67.8566 52.5936 68.9266 52.5936C69.9966 52.5936 70.8642 53.4612 70.8642 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M70.8642 49.8085C70.8642 50.8785 69.9966 51.7461 68.9266 51.7461C67.8566 51.7461 66.989 50.8785 66.989 49.8085C66.989 48.7385 67.8566 47.8709 68.9266 47.8709C69.9966 47.8709 70.8642 48.7385 70.8642 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M75.5873 49.8085C75.5873 50.8785 74.7197 51.7461 73.6497 51.7461C72.5798 51.7461 71.7122 50.8785 71.7122 49.8085C71.7122 48.7385 72.5798 47.8709 73.6497 47.8709C74.7197 47.8709 75.5873 48.7385 75.5873 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M75.5873 54.5312C75.5873 55.6011 74.7197 56.4688 73.6497 56.4688C72.5798 56.4688 71.7122 55.6011 71.7122 54.5312C71.7122 53.4612 72.5798 52.5936 73.6497 52.5936C74.7197 52.5936 75.5873 53.4612 75.5873 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M80.3105 54.5312C80.3105 55.6011 79.4429 56.4688 78.3729 56.4688C77.3029 56.4688 76.4353 55.6011 76.4353 54.5312C76.4353 53.4612 77.3029 52.5936 78.3729 52.5936C79.4429 52.5936 80.3105 53.4612 80.3105 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M85.0337 54.5312C85.0337 55.6011 84.1661 56.4688 83.0962 56.4688C82.0262 56.4688 81.1586 55.6011 81.1586 54.5312C81.1586 53.4612 82.0262 52.5936 83.0962 52.5936C84.1661 52.5936 85.0337 53.4612 85.0337 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M89.7569 54.5312C89.7569 55.6011 88.8893 56.4688 87.8193 56.4688C86.7493 56.4688 85.8817 55.6011 85.8817 54.5312C85.8817 53.4612 86.7493 52.5936 87.8193 52.5936C88.8893 52.5936 89.7569 53.4612 89.7569 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M94.4799 54.5312C94.4799 55.6011 93.6123 56.4688 92.5423 56.4688C91.4723 56.4688 90.6047 55.6011 90.6047 54.5312C90.6047 53.4612 91.4723 52.5936 92.5423 52.5936C93.6123 52.5936 94.4799 53.4612 94.4799 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M99.2033 54.5312C99.2033 55.6011 98.3357 56.4688 97.2657 56.4688C96.1957 56.4688 95.3281 55.6011 95.3281 54.5312C95.3281 53.4612 96.1957 52.5936 97.2657 52.5936C98.3357 52.5936 99.2033 53.4612 99.2033 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M99.2033 49.8085C99.2033 50.8785 98.3357 51.7461 97.2657 51.7461C96.1957 51.7461 95.3281 50.8785 95.3281 49.8085C95.3281 48.7385 96.1957 47.8709 97.2657 47.8709C98.3357 47.8709 99.2033 48.7385 99.2033 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M103.926 49.8085C103.926 50.8785 103.059 51.7461 101.989 51.7461C100.919 51.7461 100.051 50.8785 100.051 49.8085C100.051 48.7385 100.919 47.8709 101.989 47.8709C103.059 47.8709 103.926 48.7385 103.926 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M108.65 45.0859C108.65 46.1558 107.782 47.0234 106.712 47.0234C105.642 47.0234 104.774 46.1558 104.774 45.0859C104.774 44.0159 105.642 43.1483 106.712 43.1483C107.782 43.1483 108.65 44.0159 108.65 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M103.926 45.0859C103.926 46.1558 103.059 47.0234 101.989 47.0234C100.919 47.0234 100.051 46.1558 100.051 45.0859C100.051 44.0159 100.919 43.1483 101.989 43.1483C103.059 43.1483 103.926 44.0159 103.926 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M108.65 49.8085C108.65 50.8785 107.782 51.7461 106.712 51.7461C105.642 51.7461 104.774 50.8785 104.774 49.8085C104.774 48.7385 105.642 47.8709 106.712 47.8709C107.782 47.8709 108.65 48.7385 108.65 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M103.926 54.5312C103.926 55.6011 103.059 56.4688 101.989 56.4688C100.919 56.4688 100.051 55.6011 100.051 54.5312C100.051 53.4612 100.919 52.5936 101.989 52.5936C103.059 52.5936 103.926 53.4612 103.926 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M108.65 54.5312C108.65 55.6011 107.782 56.4688 106.712 56.4688C105.642 56.4688 104.774 55.6011 104.774 54.5312C104.774 53.4612 105.642 52.5936 106.712 52.5936C107.782 52.5936 108.65 53.4612 108.65 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M108.65 59.2538C108.65 60.3238 107.782 61.1914 106.712 61.1914C105.642 61.1914 104.774 60.3238 104.774 59.2538C104.774 58.1838 105.642 57.3162 106.712 57.3162C107.782 57.3162 108.65 58.1838 108.65 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M113.373 54.5312C113.373 55.6011 112.505 56.4688 111.435 56.4688C110.365 56.4688 109.498 55.6011 109.498 54.5312C109.498 53.4612 110.365 52.5936 111.435 52.5936C112.505 52.5936 113.373 53.4612 113.373 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M113.373 59.2538C113.373 60.3238 112.505 61.1914 111.435 61.1914C110.365 61.1914 109.498 60.3238 109.498 59.2538C109.498 58.1838 110.365 57.3162 111.435 57.3162C112.505 57.3162 113.373 58.1838 113.373 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M118.096 54.5312C118.096 55.6011 117.228 56.4688 116.158 56.4688C115.088 56.4688 114.221 55.6011 114.221 54.5312C114.221 53.4612 115.088 52.5936 116.158 52.5936C117.228 52.5936 118.096 53.4612 118.096 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M127.542 54.5312C127.542 55.6011 126.675 56.4688 125.605 56.4688C124.535 56.4688 123.667 55.6011 123.667 54.5312C123.667 53.4612 124.535 52.5936 125.605 52.5936C126.675 52.5936 127.542 53.4612 127.542 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M127.542 49.8085C127.542 50.8785 126.675 51.7461 125.605 51.7461C124.535 51.7461 123.667 50.8785 123.667 49.8085C123.667 48.7385 124.535 47.8709 125.605 47.8709C126.675 47.8709 127.542 48.7385 127.542 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M122.819 49.8085C122.819 50.8785 121.951 51.7461 120.881 51.7461C119.811 51.7461 118.944 50.8785 118.944 49.8085C118.944 48.7385 119.811 47.8709 120.881 47.8709C121.951 47.8709 122.819 48.7385 122.819 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M132.265 54.5312C132.265 55.6011 131.398 56.4688 130.328 56.4688C129.258 56.4688 128.39 55.6011 128.39 54.5312C128.39 53.4612 129.258 52.5936 130.328 52.5936C131.398 52.5936 132.265 53.4612 132.265 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M132.265 49.8085C132.265 50.8785 131.398 51.7461 130.328 51.7461C129.258 51.7461 128.39 50.8785 128.39 49.8085C128.39 48.7385 129.258 47.8709 130.328 47.8709C131.398 47.8709 132.265 48.7385 132.265 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M136.988 49.8085C136.988 50.8785 136.121 51.7461 135.051 51.7461C133.981 51.7461 133.113 50.8785 133.113 49.8085C133.113 48.7385 133.981 47.8709 135.051 47.8709C136.121 47.8709 136.988 48.7385 136.988 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M141.712 54.5312C141.712 55.6011 140.844 56.4688 139.774 56.4688C138.704 56.4688 137.836 55.6011 137.836 54.5312C137.836 53.4612 138.704 52.5936 139.774 52.5936C140.844 52.5936 141.712 53.4612 141.712 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M141.712 45.0859C141.712 46.1558 140.844 47.0234 139.774 47.0234C138.704 47.0234 137.836 46.1558 137.836 45.0859C137.836 44.0159 138.704 43.1483 139.774 43.1483C140.844 43.1483 141.712 44.0159 141.712 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M146.435 40.3632C146.435 41.4332 145.567 42.3008 144.497 42.3008C143.427 42.3008 142.56 41.4332 142.56 40.3632C142.56 39.2932 143.427 38.4256 144.497 38.4256C145.567 38.4256 146.435 39.2932 146.435 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M141.712 26.1952C141.712 27.2652 140.844 28.1328 139.774 28.1328C138.704 28.1328 137.836 27.2652 137.836 26.1952C137.836 25.1252 138.704 24.2576 139.774 24.2576C140.844 24.2576 141.712 25.1252 141.712 26.1952Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M141.712 30.9179C141.712 31.9879 140.844 32.8555 139.774 32.8555C138.704 32.8555 137.836 31.9879 137.836 30.9179C137.836 29.8479 138.704 28.9803 139.774 28.9803C140.844 28.9803 141.712 29.8479 141.712 30.9179Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M141.712 16.746C141.712 17.816 140.844 18.6836 139.774 18.6836C138.704 18.6836 137.836 17.816 137.836 16.746C137.836 15.676 138.704 14.8084 139.774 14.8084C140.844 14.8084 141.712 15.676 141.712 16.746Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M151.158 16.746C151.158 17.816 150.29 18.6836 149.22 18.6836C148.15 18.6836 147.283 17.816 147.283 16.746C147.283 15.676 148.15 14.8084 149.22 14.8084C150.29 14.8084 151.158 15.676 151.158 16.746Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M155.881 12.0234C155.881 13.0933 155.013 13.9609 153.943 13.9609C152.873 13.9609 152.006 13.0933 152.006 12.0234C152.006 10.9534 152.873 10.0858 153.943 10.0858C155.013 10.0858 155.881 10.9534 155.881 12.0234Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M165.327 12.0234C165.327 13.0933 164.46 13.9609 163.39 13.9609C162.32 13.9609 161.452 13.0933 161.452 12.0234C161.452 10.9534 162.32 10.0858 163.39 10.0858C164.46 10.0858 165.327 10.9534 165.327 12.0234Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M165.327 16.746C165.327 17.816 164.46 18.6836 163.39 18.6836C162.32 18.6836 161.452 17.816 161.452 16.746C161.452 15.676 162.32 14.8084 163.39 14.8084C164.46 14.8084 165.327 15.676 165.327 16.746Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M170.05 21.4687C170.05 22.5386 169.183 23.4062 168.113 23.4062C167.043 23.4062 166.175 22.5386 166.175 21.4687C166.175 20.3987 167.043 19.5311 168.113 19.5311C169.183 19.5311 170.05 20.3987 170.05 21.4687Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M179.497 16.746C179.497 17.816 178.629 18.6836 177.559 18.6836C176.489 18.6836 175.622 17.816 175.622 16.746C175.622 15.676 176.489 14.8084 177.559 14.8084C178.629 14.8084 179.497 15.676 179.497 16.746Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M179.497 12.0234C179.497 13.0933 178.629 13.9609 177.559 13.9609C176.489 13.9609 175.622 13.0933 175.622 12.0234C175.622 10.9534 176.489 10.0858 177.559 10.0858C178.629 10.0858 179.497 10.9534 179.497 12.0234Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M184.22 12.0234C184.22 13.0933 183.352 13.9609 182.282 13.9609C181.212 13.9609 180.345 13.0933 180.345 12.0234C180.345 10.9534 181.212 10.0858 182.282 10.0858C183.352 10.0858 184.22 10.9534 184.22 12.0234Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M184.22 7.30069C184.22 8.37067 183.353 9.23828 182.283 9.23828C181.213 9.23828 180.345 8.37067 180.345 7.30069C180.345 6.23072 181.213 5.36311 182.283 5.36311C183.353 5.36311 184.22 6.23072 184.22 7.30069Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M188.943 7.30069C188.943 8.37067 188.076 9.23828 187.006 9.23828C185.936 9.23828 185.068 8.37067 185.068 7.30069C185.068 6.23072 185.936 5.36311 187.006 5.36311C188.076 5.36311 188.943 6.23072 188.943 7.30069Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M193.666 7.30069C193.666 8.37067 192.799 9.23828 191.729 9.23828C190.659 9.23828 189.791 8.37067 189.791 7.30069C189.791 6.23072 190.659 5.36311 191.729 5.36311C192.799 5.36311 193.666 6.23072 193.666 7.30069Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M193.666 2.57804C193.666 3.64802 192.799 4.51562 191.729 4.51562C190.659 4.51562 189.791 3.64802 189.791 2.57804C189.791 1.50806 190.659 0.640451 191.729 0.640451C192.799 0.640451 193.666 1.50806 193.666 2.57804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M198.39 2.57804C198.39 3.64802 197.522 4.51562 196.452 4.51562C195.382 4.51562 194.514 3.64802 194.514 2.57804C194.514 1.50806 195.382 0.640451 196.452 0.640451C197.522 0.640451 198.39 1.50806 198.39 2.57804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M198.39 7.30069C198.39 8.37067 197.522 9.23828 196.452 9.23828C195.382 9.23828 194.514 8.37067 194.514 7.30069C194.514 6.23072 195.382 5.36311 196.452 5.36311C197.522 5.36311 198.39 6.23072 198.39 7.30069Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M203.113 7.30069C203.113 8.37067 202.245 9.23828 201.175 9.23828C200.105 9.23828 199.238 8.37067 199.238 7.30069C199.238 6.23072 200.105 5.36311 201.175 5.36311C202.245 5.36311 203.113 6.23072 203.113 7.30069Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M203.113 2.57804C203.113 3.64802 202.245 4.51562 201.175 4.51562C200.105 4.51562 199.238 3.64802 199.238 2.57804C199.238 1.50806 200.105 0.640451 201.175 0.640451C202.245 0.640451 203.113 1.50806 203.113 2.57804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M207.836 2.57804C207.836 3.64802 206.968 4.51562 205.898 4.51562C204.828 4.51562 203.961 3.64802 203.961 2.57804C203.961 1.50806 204.828 0.640451 205.898 0.640451C206.968 0.640451 207.836 1.50806 207.836 2.57804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M212.559 2.57804C212.559 3.64802 211.691 4.51562 210.621 4.51562C209.551 4.51562 208.684 3.64802 208.684 2.57804C208.684 1.50806 209.551 0.640451 210.621 0.640451C211.691 0.640451 212.559 1.50806 212.559 2.57804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M212.559 7.30069C212.559 8.37067 211.691 9.23828 210.621 9.23828C209.551 9.23828 208.684 8.37067 208.684 7.30069C208.684 6.23072 209.551 5.36311 210.621 5.36311C211.691 5.36311 212.559 6.23072 212.559 7.30069Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M217.282 7.30069C217.282 8.37067 216.415 9.23828 215.345 9.23828C214.275 9.23828 213.407 8.37067 213.407 7.30069C213.407 6.23072 214.275 5.36311 215.345 5.36311C216.415 5.36311 217.282 6.23072 217.282 7.30069Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M217.282 16.746C217.282 17.816 216.415 18.6836 215.345 18.6836C214.275 18.6836 213.407 17.816 213.407 16.746C213.407 15.676 214.275 14.8084 215.345 14.8084C216.415 14.8084 217.282 15.676 217.282 16.746Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M212.559 16.746C212.559 17.816 211.692 18.6836 210.622 18.6836C209.552 18.6836 208.684 17.816 208.684 16.746C208.684 15.676 209.552 14.8084 210.622 14.8084C211.692 14.8084 212.559 15.676 212.559 16.746Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M212.559 21.4687C212.559 22.5386 211.692 23.4062 210.622 23.4062C209.552 23.4062 208.684 22.5386 208.684 21.4687C208.684 20.3987 209.552 19.5311 210.622 19.5311C211.692 19.5311 212.559 20.3987 212.559 21.4687Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M212.559 26.1952C212.559 27.2652 211.692 28.1328 210.622 28.1328C209.552 28.1328 208.684 27.2652 208.684 26.1952C208.684 25.1252 209.552 24.2576 210.622 24.2576C211.692 24.2576 212.559 25.1252 212.559 26.1952Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M207.836 26.1952C207.836 27.2652 206.969 28.1328 205.899 28.1328C204.829 28.1328 203.961 27.2652 203.961 26.1952C203.961 25.1252 204.829 24.2576 205.899 24.2576C206.969 24.2576 207.836 25.1252 207.836 26.1952Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M203.113 26.1952C203.113 27.2652 202.245 28.1328 201.175 28.1328C200.105 28.1328 199.238 27.2652 199.238 26.1952C199.238 25.1252 200.105 24.2576 201.175 24.2576C202.245 24.2576 203.113 25.1252 203.113 26.1952Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M203.113 30.9179C203.113 31.9879 202.245 32.8555 201.175 32.8555C200.105 32.8555 199.238 31.9879 199.238 30.9179C199.238 29.8479 200.105 28.9803 201.175 28.9803C202.245 28.9803 203.113 29.8479 203.113 30.9179Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M207.836 30.9179C207.836 31.9879 206.969 32.8555 205.899 32.8555C204.829 32.8555 203.961 31.9879 203.961 30.9179C203.961 29.8479 204.829 28.9803 205.899 28.9803C206.969 28.9803 207.836 29.8479 207.836 30.9179Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M207.836 35.6405C207.836 36.7105 206.968 37.5781 205.898 37.5781C204.828 37.5781 203.961 36.7105 203.961 35.6405C203.961 34.5706 204.828 33.703 205.898 33.703C206.968 33.703 207.836 34.5706 207.836 35.6405Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M212.559 35.6405C212.559 36.7105 211.691 37.5781 210.621 37.5781C209.551 37.5781 208.684 36.7105 208.684 35.6405C208.684 34.5706 209.551 33.703 210.621 33.703C211.691 33.703 212.559 34.5706 212.559 35.6405Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M212.559 40.3632C212.559 41.4332 211.691 42.3008 210.621 42.3008C209.551 42.3008 208.684 41.4332 208.684 40.3632C208.684 39.2932 209.551 38.4256 210.621 38.4256C211.691 38.4256 212.559 39.2932 212.559 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M212.559 45.0859C212.559 46.1558 211.691 47.0234 210.621 47.0234C209.551 47.0234 208.684 46.1558 208.684 45.0859C208.684 44.0159 209.551 43.1483 210.621 43.1483C211.691 43.1483 212.559 44.0159 212.559 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M212.559 49.8085C212.559 50.8785 211.691 51.7461 210.621 51.7461C209.551 51.7461 208.684 50.8785 208.684 49.8085C208.684 48.7385 209.551 47.8709 210.621 47.8709C211.691 47.8709 212.559 48.7385 212.559 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M212.559 54.5312C212.559 55.6011 211.691 56.4688 210.621 56.4688C209.551 56.4688 208.684 55.6011 208.684 54.5312C208.684 53.4612 209.551 52.5936 210.621 52.5936C211.691 52.5936 212.559 53.4612 212.559 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M212.559 59.2538C212.559 60.3238 211.691 61.1914 210.621 61.1914C209.551 61.1914 208.684 60.3238 208.684 59.2538C208.684 58.1838 209.551 57.3162 210.621 57.3162C211.691 57.3162 212.559 58.1838 212.559 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M212.559 63.9804C212.559 65.0504 211.691 65.918 210.621 65.918C209.551 65.918 208.684 65.0504 208.684 63.9804C208.684 62.9104 209.551 62.0428 210.621 62.0428C211.691 62.0428 212.559 62.9104 212.559 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M217.282 63.9804C217.282 65.0504 216.415 65.918 215.345 65.918C214.275 65.918 213.407 65.0504 213.407 63.9804C213.407 62.9104 214.275 62.0428 215.345 62.0428C216.415 62.0428 217.282 62.9104 217.282 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M217.282 68.703C217.282 69.773 216.415 70.6406 215.345 70.6406C214.275 70.6406 213.407 69.773 213.407 68.703C213.407 67.6331 214.275 66.7655 215.345 66.7655C216.415 66.7655 217.282 67.6331 217.282 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M217.282 73.4257C217.282 74.4957 216.415 75.3633 215.345 75.3633C214.275 75.3633 213.407 74.4957 213.407 73.4257C213.407 72.3557 214.275 71.4881 215.345 71.4881C216.415 71.4881 217.282 72.3557 217.282 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M212.559 73.4257C212.559 74.4957 211.691 75.3633 210.621 75.3633C209.551 75.3633 208.684 74.4957 208.684 73.4257C208.684 72.3557 209.551 71.4881 210.621 71.4881C211.691 71.4881 212.559 72.3557 212.559 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M212.559 78.1484C212.559 79.2183 211.691 80.0859 210.621 80.0859C209.551 80.0859 208.684 79.2183 208.684 78.1484C208.684 77.0784 209.551 76.2108 210.621 76.2108C211.691 76.2108 212.559 77.0784 212.559 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M212.559 82.871C212.559 83.941 211.691 84.8086 210.621 84.8086C209.551 84.8086 208.684 83.941 208.684 82.871C208.684 81.801 209.551 80.9334 210.621 80.9334C211.691 80.9334 212.559 81.801 212.559 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M212.559 87.5937C212.559 88.6636 211.691 89.5312 210.621 89.5312C209.551 89.5312 208.684 88.6636 208.684 87.5937C208.684 86.5237 209.551 85.6561 210.621 85.6561C211.691 85.6561 212.559 86.5237 212.559 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M212.559 92.3163C212.559 93.3863 211.691 94.2539 210.621 94.2539C209.551 94.2539 208.684 93.3863 208.684 92.3163C208.684 91.2463 209.551 90.3787 210.621 90.3787C211.691 90.3787 212.559 91.2463 212.559 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M217.282 92.3163C217.282 93.3863 216.415 94.2539 215.345 94.2539C214.275 94.2539 213.407 93.3863 213.407 92.3163C213.407 91.2463 214.275 90.3787 215.345 90.3787C216.415 90.3787 217.282 91.2463 217.282 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M217.282 87.5937C217.282 88.6636 216.415 89.5312 215.345 89.5312C214.275 89.5312 213.407 88.6636 213.407 87.5937C213.407 86.5237 214.275 85.6561 215.345 85.6561C216.415 85.6561 217.282 86.5237 217.282 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M217.282 82.871C217.282 83.941 216.415 84.8086 215.345 84.8086C214.275 84.8086 213.407 83.941 213.407 82.871C213.407 81.801 214.275 80.9334 215.345 80.9334C216.415 80.9334 217.282 81.801 217.282 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M222.005 82.871C222.005 83.941 221.138 84.8086 220.068 84.8086C218.998 84.8086 218.13 83.941 218.13 82.871C218.13 81.801 218.998 80.9334 220.068 80.9334C221.138 80.9334 222.005 81.801 222.005 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M222.005 78.1484C222.005 79.2183 221.138 80.0859 220.068 80.0859C218.998 80.0859 218.13 79.2183 218.13 78.1484C218.13 77.0784 218.998 76.2108 220.068 76.2108C221.138 76.2108 222.005 77.0784 222.005 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M226.729 78.1484C226.729 79.2183 225.861 80.0859 224.791 80.0859C223.721 80.0859 222.854 79.2183 222.854 78.1484C222.854 77.0784 223.721 76.2108 224.791 76.2108C225.861 76.2108 226.729 77.0784 226.729 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M231.452 78.1484C231.452 79.2183 230.584 80.0859 229.514 80.0859C228.444 80.0859 227.577 79.2183 227.577 78.1484C227.577 77.0784 228.444 76.2108 229.514 76.2108C230.584 76.2108 231.452 77.0784 231.452 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M231.452 73.4257C231.452 74.4957 230.584 75.3633 229.514 75.3633C228.444 75.3633 227.577 74.4957 227.577 73.4257C227.577 72.3557 228.444 71.4881 229.514 71.4881C230.584 71.4881 231.452 72.3557 231.452 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M236.175 73.4257C236.175 74.4957 235.307 75.3633 234.237 75.3633C233.167 75.3633 232.3 74.4957 232.3 73.4257C232.3 72.3557 233.167 71.4881 234.237 71.4881C235.307 71.4881 236.175 72.3557 236.175 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M236.175 68.703C236.175 69.773 235.307 70.6406 234.237 70.6406C233.167 70.6406 232.3 69.773 232.3 68.703C232.3 67.6331 233.167 66.7655 234.237 66.7655C235.307 66.7655 236.175 67.6331 236.175 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M240.898 68.703C240.898 69.773 240.031 70.6406 238.961 70.6406C237.891 70.6406 237.023 69.773 237.023 68.703C237.023 67.6331 237.891 66.7655 238.961 66.7655C240.031 66.7655 240.898 67.6331 240.898 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M240.898 63.9804C240.898 65.0504 240.031 65.918 238.961 65.918C237.891 65.918 237.023 65.0504 237.023 63.9804C237.023 62.9104 237.891 62.0428 238.961 62.0428C240.031 62.0428 240.898 62.9104 240.898 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M240.898 59.2538C240.898 60.3238 240.031 61.1914 238.961 61.1914C237.891 61.1914 237.023 60.3238 237.023 59.2538C237.023 58.1838 237.891 57.3162 238.961 57.3162C240.031 57.3162 240.898 58.1838 240.898 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M245.621 59.2538C245.621 60.3238 244.754 61.1914 243.684 61.1914C242.614 61.1914 241.746 60.3238 241.746 59.2538C241.746 58.1838 242.614 57.3162 243.684 57.3162C244.754 57.3162 245.621 58.1838 245.621 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M250.344 63.9804C250.344 65.0504 249.477 65.918 248.407 65.918C247.337 65.918 246.469 65.0504 246.469 63.9804C246.469 62.9104 247.337 62.0428 248.407 62.0428C249.477 62.0428 250.344 62.9104 250.344 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M245.621 54.5312C245.621 55.6011 244.754 56.4688 243.684 56.4688C242.614 56.4688 241.746 55.6011 241.746 54.5312C241.746 53.4612 242.614 52.5936 243.684 52.5936C244.754 52.5936 245.621 53.4612 245.621 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M245.621 49.8085C245.621 50.8785 244.754 51.7461 243.684 51.7461C242.614 51.7461 241.746 50.8785 241.746 49.8085C241.746 48.7385 242.614 47.8709 243.684 47.8709C244.754 47.8709 245.621 48.7385 245.621 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M250.344 49.8085C250.344 50.8785 249.477 51.7461 248.407 51.7461C247.337 51.7461 246.469 50.8785 246.469 49.8085C246.469 48.7385 247.337 47.8709 248.407 47.8709C249.477 47.8709 250.344 48.7385 250.344 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M250.344 45.0859C250.344 46.1558 249.477 47.0234 248.407 47.0234C247.337 47.0234 246.469 46.1558 246.469 45.0859C246.469 44.0159 247.337 43.1483 248.407 43.1483C249.477 43.1483 250.344 44.0159 250.344 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M250.344 40.3632C250.344 41.4332 249.477 42.3008 248.407 42.3008C247.337 42.3008 246.469 41.4332 246.469 40.3632C246.469 39.2932 247.337 38.4256 248.407 38.4256C249.477 38.4256 250.344 39.2932 250.344 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M255.068 40.3632C255.068 41.4332 254.2 42.3008 253.13 42.3008C252.06 42.3008 251.192 41.4332 251.192 40.3632C251.192 39.2932 252.06 38.4256 253.13 38.4256C254.2 38.4256 255.068 39.2932 255.068 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M255.068 35.6405C255.068 36.7105 254.2 37.5781 253.13 37.5781C252.06 37.5781 251.192 36.7105 251.192 35.6405C251.192 34.5706 252.06 33.703 253.13 33.703C254.2 33.703 255.068 34.5706 255.068 35.6405Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M255.068 30.9179C255.068 31.9879 254.2 32.8555 253.13 32.8555C252.06 32.8555 251.192 31.9879 251.192 30.9179C251.192 29.8479 252.06 28.9803 253.13 28.9803C254.2 28.9803 255.068 29.8479 255.068 30.9179Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M259.791 30.9179C259.791 31.9879 258.923 32.8555 257.853 32.8555C256.783 32.8555 255.916 31.9879 255.916 30.9179C255.916 29.8479 256.783 28.9803 257.853 28.9803C258.923 28.9803 259.791 29.8479 259.791 30.9179Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M250.344 30.9179C250.344 31.9879 249.477 32.8555 248.407 32.8555C247.337 32.8555 246.469 31.9879 246.469 30.9179C246.469 29.8479 247.337 28.9803 248.407 28.9803C249.477 28.9803 250.344 29.8479 250.344 30.9179Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M250.344 26.1952C250.344 27.2652 249.477 28.1328 248.407 28.1328C247.337 28.1328 246.469 27.2652 246.469 26.1952C246.469 25.1252 247.337 24.2576 248.407 24.2576C249.477 24.2576 250.344 25.1252 250.344 26.1952Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M245.621 26.1952C245.621 27.2652 244.754 28.1328 243.684 28.1328C242.614 28.1328 241.746 27.2652 241.746 26.1952C241.746 25.1252 242.614 24.2576 243.684 24.2576C244.754 24.2576 245.621 25.1252 245.621 26.1952Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M240.898 26.1952C240.898 27.2652 240.031 28.1328 238.961 28.1328C237.891 28.1328 237.023 27.2652 237.023 26.1952C237.023 25.1252 237.891 24.2576 238.961 24.2576C240.031 24.2576 240.898 25.1252 240.898 26.1952Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M240.898 21.4687C240.898 22.5386 240.031 23.4062 238.961 23.4062C237.891 23.4062 237.023 22.5386 237.023 21.4687C237.023 20.3987 237.891 19.5311 238.961 19.5311C240.031 19.5311 240.898 20.3987 240.898 21.4687Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M236.175 21.4687C236.175 22.5386 235.307 23.4062 234.237 23.4062C233.167 23.4062 232.3 22.5386 232.3 21.4687C232.3 20.3987 233.167 19.5311 234.237 19.5311C235.307 19.5311 236.175 20.3987 236.175 21.4687Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M231.452 21.4687C231.452 22.5386 230.584 23.4062 229.514 23.4062C228.444 23.4062 227.577 22.5386 227.577 21.4687C227.577 20.3987 228.444 19.5311 229.514 19.5311C230.584 19.5311 231.452 20.3987 231.452 21.4687Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M226.729 21.4687C226.729 22.5386 225.861 23.4062 224.791 23.4062C223.721 23.4062 222.854 22.5386 222.854 21.4687C222.854 20.3987 223.721 19.5311 224.791 19.5311C225.861 19.5311 226.729 20.3987 226.729 21.4687Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M226.729 26.1952C226.729 27.2652 225.861 28.1328 224.791 28.1328C223.721 28.1328 222.854 27.2652 222.854 26.1952C222.854 25.1252 223.721 24.2576 224.791 24.2576C225.861 24.2576 226.729 25.1252 226.729 26.1952Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M222.006 26.1952C222.006 27.2652 221.138 28.1328 220.068 28.1328C218.998 28.1328 218.13 27.2652 218.13 26.1952C218.13 25.1252 218.998 24.2576 220.068 24.2576C221.138 24.2576 222.006 25.1252 222.006 26.1952Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M222.006 30.9179C222.006 31.9879 221.138 32.8555 220.068 32.8555C218.998 32.8555 218.13 31.9879 218.13 30.9179C218.13 29.8479 218.998 28.9803 220.068 28.9803C221.138 28.9803 222.006 29.8479 222.006 30.9179Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M222.005 35.6405C222.005 36.7105 221.138 37.5781 220.068 37.5781C218.998 37.5781 218.13 36.7105 218.13 35.6405C218.13 34.5706 218.998 33.703 220.068 33.703C221.138 33.703 222.005 34.5706 222.005 35.6405Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M217.282 35.6405C217.282 36.7105 216.415 37.5781 215.345 37.5781C214.275 37.5781 213.407 36.7105 213.407 35.6405C213.407 34.5706 214.275 33.703 215.345 33.703C216.415 33.703 217.282 34.5706 217.282 35.6405Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M217.282 40.3632C217.282 41.4332 216.415 42.3008 215.345 42.3008C214.275 42.3008 213.407 41.4332 213.407 40.3632C213.407 39.2932 214.275 38.4256 215.345 38.4256C216.415 38.4256 217.282 39.2932 217.282 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M217.282 45.0859C217.282 46.1558 216.415 47.0234 215.345 47.0234C214.275 47.0234 213.407 46.1558 213.407 45.0859C213.407 44.0159 214.275 43.1483 215.345 43.1483C216.415 43.1483 217.282 44.0159 217.282 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M217.282 49.8085C217.282 50.8785 216.415 51.7461 215.345 51.7461C214.275 51.7461 213.407 50.8785 213.407 49.8085C213.407 48.7385 214.275 47.8709 215.345 47.8709C216.415 47.8709 217.282 48.7385 217.282 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M217.282 54.5312C217.282 55.6011 216.415 56.4688 215.345 56.4688C214.275 56.4688 213.407 55.6011 213.407 54.5312C213.407 53.4612 214.275 52.5936 215.345 52.5936C216.415 52.5936 217.282 53.4612 217.282 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M217.282 59.2538C217.282 60.3238 216.415 61.1914 215.345 61.1914C214.275 61.1914 213.407 60.3238 213.407 59.2538C213.407 58.1838 214.275 57.3162 215.345 57.3162C216.415 57.3162 217.282 58.1838 217.282 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M222.005 59.2538C222.005 60.3238 221.138 61.1914 220.068 61.1914C218.998 61.1914 218.13 60.3238 218.13 59.2538C218.13 58.1838 218.998 57.3162 220.068 57.3162C221.138 57.3162 222.005 58.1838 222.005 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M222.005 63.9804C222.005 65.0504 221.138 65.918 220.068 65.918C218.998 65.918 218.13 65.0504 218.13 63.9804C218.13 62.9104 218.998 62.0428 220.068 62.0428C221.138 62.0428 222.005 62.9104 222.005 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M222.005 68.703C222.005 69.773 221.138 70.6406 220.068 70.6406C218.998 70.6406 218.13 69.773 218.13 68.703C218.13 67.6331 218.998 66.7655 220.068 66.7655C221.138 66.7655 222.005 67.6331 222.005 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M222.005 73.4257C222.005 74.4957 221.138 75.3633 220.068 75.3633C218.998 75.3633 218.13 74.4957 218.13 73.4257C218.13 72.3557 218.998 71.4881 220.068 71.4881C221.138 71.4881 222.005 72.3557 222.005 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M226.729 73.4257C226.729 74.4957 225.861 75.3633 224.791 75.3633C223.721 75.3633 222.854 74.4957 222.854 73.4257C222.854 72.3557 223.721 71.4881 224.791 71.4881C225.861 71.4881 226.729 72.3557 226.729 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M226.729 68.703C226.729 69.773 225.861 70.6406 224.791 70.6406C223.721 70.6406 222.854 69.773 222.854 68.703C222.854 67.6331 223.721 66.7655 224.791 66.7655C225.861 66.7655 226.729 67.6331 226.729 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M231.452 68.703C231.452 69.773 230.584 70.6406 229.514 70.6406C228.444 70.6406 227.577 69.773 227.577 68.703C227.577 67.6331 228.444 66.7655 229.514 66.7655C230.584 66.7655 231.452 67.6331 231.452 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M231.452 63.9804C231.452 65.0504 230.584 65.918 229.514 65.918C228.444 65.918 227.577 65.0504 227.577 63.9804C227.577 62.9104 228.444 62.0428 229.514 62.0428C230.584 62.0428 231.452 62.9104 231.452 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M236.175 63.9804C236.175 65.0504 235.307 65.918 234.237 65.918C233.167 65.918 232.3 65.0504 232.3 63.9804C232.3 62.9104 233.167 62.0428 234.237 62.0428C235.307 62.0428 236.175 62.9104 236.175 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M236.175 59.2538C236.175 60.3238 235.307 61.1914 234.237 61.1914C233.167 61.1914 232.3 60.3238 232.3 59.2538C232.3 58.1838 233.167 57.3162 234.237 57.3162C235.307 57.3162 236.175 58.1838 236.175 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M236.175 54.5312C236.175 55.6011 235.307 56.4688 234.237 56.4688C233.167 56.4688 232.3 55.6011 232.3 54.5312C232.3 53.4612 233.167 52.5936 234.237 52.5936C235.307 52.5936 236.175 53.4612 236.175 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M236.175 49.8085C236.175 50.8785 235.307 51.7461 234.237 51.7461C233.167 51.7461 232.3 50.8785 232.3 49.8085C232.3 48.7385 233.167 47.8709 234.237 47.8709C235.307 47.8709 236.175 48.7385 236.175 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M240.898 49.8085C240.898 50.8785 240.031 51.7461 238.961 51.7461C237.891 51.7461 237.023 50.8785 237.023 49.8085C237.023 48.7385 237.891 47.8709 238.961 47.8709C240.031 47.8709 240.898 48.7385 240.898 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M240.898 45.0859C240.898 46.1558 240.031 47.0234 238.961 47.0234C237.891 47.0234 237.023 46.1558 237.023 45.0859C237.023 44.0159 237.891 43.1483 238.961 43.1483C240.031 43.1483 240.898 44.0159 240.898 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M245.621 45.0859C245.621 46.1558 244.754 47.0234 243.684 47.0234C242.614 47.0234 241.746 46.1558 241.746 45.0859C241.746 44.0159 242.614 43.1483 243.684 43.1483C244.754 43.1483 245.621 44.0159 245.621 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M245.621 40.3632C245.621 41.4332 244.754 42.3008 243.684 42.3008C242.614 42.3008 241.746 41.4332 241.746 40.3632C241.746 39.2932 242.614 38.4256 243.684 38.4256C244.754 38.4256 245.621 39.2932 245.621 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M245.621 35.6405C245.621 36.7105 244.754 37.5781 243.684 37.5781C242.614 37.5781 241.746 36.7105 241.746 35.6405C241.746 34.5706 242.614 33.703 243.684 33.703C244.754 33.703 245.621 34.5706 245.621 35.6405Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M245.621 30.9179C245.621 31.9879 244.754 32.8555 243.684 32.8555C242.614 32.8555 241.746 31.9879 241.746 30.9179C241.746 29.8479 242.614 28.9803 243.684 28.9803C244.754 28.9803 245.621 29.8479 245.621 30.9179Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M240.898 30.9179C240.898 31.9879 240.031 32.8555 238.961 32.8555C237.891 32.8555 237.023 31.9879 237.023 30.9179C237.023 29.8479 237.891 28.9803 238.961 28.9803C240.031 28.9803 240.898 29.8479 240.898 30.9179Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M236.175 30.9179C236.175 31.9879 235.307 32.8555 234.237 32.8555C233.167 32.8555 232.3 31.9879 232.3 30.9179C232.3 29.8479 233.167 28.9803 234.237 28.9803C235.307 28.9803 236.175 29.8479 236.175 30.9179Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M236.175 26.1952C236.175 27.2652 235.307 28.1328 234.237 28.1328C233.167 28.1328 232.3 27.2652 232.3 26.1952C232.3 25.1252 233.167 24.2576 234.237 24.2576C235.307 24.2576 236.175 25.1252 236.175 26.1952Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M231.452 26.1952C231.452 27.2652 230.584 28.1328 229.514 28.1328C228.444 28.1328 227.577 27.2652 227.577 26.1952C227.577 25.1252 228.444 24.2576 229.514 24.2576C230.584 24.2576 231.452 25.1252 231.452 26.1952Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M231.452 30.9179C231.452 31.9879 230.584 32.8555 229.514 32.8555C228.444 32.8555 227.577 31.9879 227.577 30.9179C227.577 29.8479 228.444 28.9803 229.514 28.9803C230.584 28.9803 231.452 29.8479 231.452 30.9179Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M226.729 30.9179C226.729 31.9879 225.861 32.8555 224.791 32.8555C223.721 32.8555 222.854 31.9879 222.854 30.9179C222.854 29.8479 223.721 28.9803 224.791 28.9803C225.861 28.9803 226.729 29.8479 226.729 30.9179Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M226.729 35.6405C226.729 36.7105 225.861 37.5781 224.791 37.5781C223.721 37.5781 222.854 36.7105 222.854 35.6405C222.854 34.5706 223.721 33.703 224.791 33.703C225.861 33.703 226.729 34.5706 226.729 35.6405Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M226.729 40.3632C226.729 41.4332 225.861 42.3008 224.791 42.3008C223.721 42.3008 222.854 41.4332 222.854 40.3632C222.854 39.2932 223.721 38.4256 224.791 38.4256C225.861 38.4256 226.729 39.2932 226.729 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M222.005 40.3632C222.005 41.4332 221.138 42.3008 220.068 42.3008C218.998 42.3008 218.13 41.4332 218.13 40.3632C218.13 39.2932 218.998 38.4256 220.068 38.4256C221.138 38.4256 222.005 39.2932 222.005 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M222.005 45.0859C222.005 46.1558 221.138 47.0234 220.068 47.0234C218.998 47.0234 218.13 46.1558 218.13 45.0859C218.13 44.0159 218.998 43.1483 220.068 43.1483C221.138 43.1483 222.005 44.0159 222.005 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M222.005 49.8085C222.005 50.8785 221.138 51.7461 220.068 51.7461C218.998 51.7461 218.13 50.8785 218.13 49.8085C218.13 48.7385 218.998 47.8709 220.068 47.8709C221.138 47.8709 222.005 48.7385 222.005 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M222.005 54.5312C222.005 55.6011 221.138 56.4688 220.068 56.4688C218.998 56.4688 218.13 55.6011 218.13 54.5312C218.13 53.4612 218.998 52.5936 220.068 52.5936C221.138 52.5936 222.005 53.4612 222.005 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M226.729 54.5312C226.729 55.6011 225.861 56.4688 224.791 56.4688C223.721 56.4688 222.854 55.6011 222.854 54.5312C222.854 53.4612 223.721 52.5936 224.791 52.5936C225.861 52.5936 226.729 53.4612 226.729 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M226.729 59.2538C226.729 60.3238 225.861 61.1914 224.791 61.1914C223.721 61.1914 222.854 60.3238 222.854 59.2538C222.854 58.1838 223.721 57.3162 224.791 57.3162C225.861 57.3162 226.729 58.1838 226.729 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M231.452 59.2538C231.452 60.3238 230.584 61.1914 229.514 61.1914C228.444 61.1914 227.577 60.3238 227.577 59.2538C227.577 58.1838 228.444 57.3162 229.514 57.3162C230.584 57.3162 231.452 58.1838 231.452 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M231.452 54.5312C231.452 55.6011 230.584 56.4688 229.514 56.4688C228.444 56.4688 227.577 55.6011 227.577 54.5312C227.577 53.4612 228.444 52.5936 229.514 52.5936C230.584 52.5936 231.452 53.4612 231.452 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M231.452 49.8085C231.452 50.8785 230.584 51.7461 229.514 51.7461C228.444 51.7461 227.577 50.8785 227.577 49.8085C227.577 48.7385 228.444 47.8709 229.514 47.8709C230.584 47.8709 231.452 48.7385 231.452 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M231.452 45.0859C231.452 46.1558 230.584 47.0234 229.514 47.0234C228.444 47.0234 227.577 46.1558 227.577 45.0859C227.577 44.0159 228.444 43.1483 229.514 43.1483C230.584 43.1483 231.452 44.0159 231.452 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M236.175 45.0859C236.175 46.1558 235.307 47.0234 234.237 47.0234C233.167 47.0234 232.3 46.1558 232.3 45.0859C232.3 44.0159 233.167 43.1483 234.237 43.1483C235.307 43.1483 236.175 44.0159 236.175 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M236.175 40.3632C236.175 41.4332 235.307 42.3008 234.237 42.3008C233.167 42.3008 232.3 41.4332 232.3 40.3632C232.3 39.2932 233.167 38.4256 234.237 38.4256C235.307 38.4256 236.175 39.2932 236.175 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M240.898 40.3632C240.898 41.4332 240.031 42.3008 238.961 42.3008C237.891 42.3008 237.023 41.4332 237.023 40.3632C237.023 39.2932 237.891 38.4256 238.961 38.4256C240.031 38.4256 240.898 39.2932 240.898 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M240.898 35.6405C240.898 36.7105 240.031 37.5781 238.961 37.5781C237.891 37.5781 237.023 36.7105 237.023 35.6405C237.023 34.5706 237.891 33.703 238.961 33.703C240.031 33.703 240.898 34.5706 240.898 35.6405Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M236.175 35.6405C236.175 36.7105 235.307 37.5781 234.237 37.5781C233.167 37.5781 232.3 36.7105 232.3 35.6405C232.3 34.5706 233.167 33.703 234.237 33.703C235.307 33.703 236.175 34.5706 236.175 35.6405Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M231.452 35.6405C231.452 36.7105 230.584 37.5781 229.514 37.5781C228.444 37.5781 227.577 36.7105 227.577 35.6405C227.577 34.5706 228.444 33.703 229.514 33.703C230.584 33.703 231.452 34.5706 231.452 35.6405Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M231.452 40.3632C231.452 41.4332 230.584 42.3008 229.514 42.3008C228.444 42.3008 227.577 41.4332 227.577 40.3632C227.577 39.2932 228.444 38.4256 229.514 38.4256C230.584 38.4256 231.452 39.2932 231.452 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M226.729 45.0859C226.729 46.1558 225.861 47.0234 224.791 47.0234C223.721 47.0234 222.854 46.1558 222.854 45.0859C222.854 44.0159 223.721 43.1483 224.791 43.1483C225.861 43.1483 226.729 44.0159 226.729 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M226.729 49.8085C226.729 50.8785 225.861 51.7461 224.791 51.7461C223.721 51.7461 222.854 50.8785 222.854 49.8085C222.854 48.7385 223.721 47.8709 224.791 47.8709C225.861 47.8709 226.729 48.7385 226.729 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M226.729 63.9804C226.729 65.0504 225.861 65.918 224.791 65.918C223.721 65.918 222.854 65.0504 222.854 63.9804C222.854 62.9104 223.721 62.0428 224.791 62.0428C225.861 62.0428 226.729 62.9104 226.729 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M250.344 35.6405C250.344 36.7105 249.477 37.5781 248.407 37.5781C247.337 37.5781 246.469 36.7105 246.469 35.6405C246.469 34.5706 247.337 33.703 248.407 33.703C249.477 33.703 250.344 34.5706 250.344 35.6405Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M240.898 54.5312C240.898 55.6011 240.031 56.4688 238.961 56.4688C237.891 56.4688 237.023 55.6011 237.023 54.5312C237.023 53.4612 237.891 52.5936 238.961 52.5936C240.031 52.5936 240.898 53.4612 240.898 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M255.068 26.1952C255.068 27.2652 254.2 28.1328 253.13 28.1328C252.06 28.1328 251.192 27.2652 251.192 26.1952C251.192 25.1252 252.06 24.2576 253.13 24.2576C254.2 24.2576 255.068 25.1252 255.068 26.1952Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M259.791 26.1952C259.791 27.2652 258.923 28.1328 257.853 28.1328C256.783 28.1328 255.916 27.2652 255.916 26.1952C255.916 25.1252 256.783 24.2576 257.853 24.2576C258.923 24.2576 259.791 25.1252 259.791 26.1952Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M255.068 49.8085C255.068 50.8785 254.2 51.7461 253.13 51.7461C252.06 51.7461 251.192 50.8785 251.192 49.8085C251.192 48.7385 252.06 47.8709 253.13 47.8709C254.2 47.8709 255.068 48.7385 255.068 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M245.621 68.703C245.621 69.773 244.754 70.6406 243.684 70.6406C242.614 70.6406 241.746 69.773 241.746 68.703C241.746 67.6331 242.614 66.7655 243.684 66.7655C244.754 66.7655 245.621 67.6331 245.621 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M250.344 82.871C250.344 83.941 249.477 84.8086 248.407 84.8086C247.337 84.8086 246.469 83.941 246.469 82.871C246.469 81.801 247.337 80.9334 248.407 80.9334C249.477 80.9334 250.344 81.801 250.344 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M255.068 87.5937C255.068 88.6636 254.2 89.5312 253.13 89.5312C252.06 89.5312 251.192 88.6636 251.192 87.5937C251.192 86.5237 252.06 85.6561 253.13 85.6561C254.2 85.6561 255.068 86.5237 255.068 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M259.791 82.871C259.791 83.941 258.923 84.8086 257.853 84.8086C256.783 84.8086 255.916 83.941 255.916 82.871C255.916 81.801 256.783 80.9334 257.853 80.9334C258.923 80.9334 259.791 81.801 259.791 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M269.237 115.934C269.237 117.003 268.369 117.871 267.299 117.871C266.229 117.871 265.362 117.003 265.362 115.934C265.362 114.864 266.229 113.996 267.299 113.996C268.369 113.996 269.237 114.864 269.237 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M278.683 115.934C278.683 117.003 277.816 117.871 276.746 117.871C275.676 117.871 274.808 117.003 274.808 115.934C274.808 114.864 275.676 113.996 276.746 113.996C277.816 113.996 278.683 114.864 278.683 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M278.683 111.211C278.683 112.281 277.816 113.148 276.746 113.148C275.676 113.148 274.808 112.281 274.808 111.211C274.808 110.141 275.676 109.273 276.746 109.273C277.816 109.273 278.683 110.141 278.683 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M273.96 106.488C273.96 107.558 273.093 108.426 272.023 108.426C270.953 108.426 270.085 107.558 270.085 106.488C270.085 105.418 270.953 104.551 272.023 104.551C273.093 104.551 273.96 105.418 273.96 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M278.683 120.656C278.683 121.726 277.816 122.594 276.746 122.594C275.676 122.594 274.808 121.726 274.808 120.656C274.808 119.586 275.676 118.719 276.746 118.719C277.816 118.719 278.683 119.586 278.683 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M283.406 120.656C283.406 121.726 282.539 122.594 281.469 122.594C280.399 122.594 279.531 121.726 279.531 120.656C279.531 119.586 280.399 118.719 281.469 118.719C282.539 118.719 283.406 119.586 283.406 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M283.406 130.101C283.406 131.171 282.539 132.039 281.469 132.039C280.399 132.039 279.531 131.171 279.531 130.101C279.531 129.031 280.399 128.164 281.469 128.164C282.539 128.164 283.406 129.031 283.406 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M278.683 130.101C278.683 131.171 277.816 132.039 276.746 132.039C275.676 132.039 274.808 131.171 274.808 130.101C274.808 129.031 275.676 128.164 276.746 128.164C277.816 128.164 278.683 129.031 278.683 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M278.683 139.551C278.683 140.621 277.816 141.488 276.746 141.488C275.676 141.488 274.808 140.621 274.808 139.551C274.808 138.481 275.676 137.613 276.746 137.613C277.816 137.613 278.683 138.481 278.683 139.551Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M273.96 139.551C273.96 140.621 273.093 141.488 272.023 141.488C270.953 141.488 270.085 140.621 270.085 139.551C270.085 138.481 270.953 137.613 272.023 137.613C273.093 137.613 273.96 138.481 273.96 139.551Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M273.96 144.273C273.96 145.343 273.093 146.211 272.023 146.211C270.953 146.211 270.085 145.343 270.085 144.273C270.085 143.203 270.953 142.336 272.023 142.336C273.093 142.336 273.96 143.203 273.96 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M269.237 144.273C269.237 145.343 268.369 146.211 267.299 146.211C266.229 146.211 265.362 145.343 265.362 144.273C265.362 143.203 266.229 142.336 267.299 142.336C268.369 142.336 269.237 143.203 269.237 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M269.237 148.996C269.237 150.066 268.369 150.934 267.299 150.934C266.229 150.934 265.362 150.066 265.362 148.996C265.362 147.926 266.229 147.058 267.299 147.058C268.369 147.058 269.237 147.926 269.237 148.996Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M273.96 148.996C273.96 150.066 273.093 150.934 272.023 150.934C270.953 150.934 270.085 150.066 270.085 148.996C270.085 147.926 270.953 147.058 272.023 147.058C273.093 147.058 273.96 147.926 273.96 148.996Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M273.96 153.719C273.96 154.789 273.093 155.656 272.023 155.656C270.953 155.656 270.085 154.789 270.085 153.719C270.085 152.649 270.953 151.781 272.023 151.781C273.093 151.781 273.96 152.649 273.96 153.719Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M278.683 148.996C278.683 150.066 277.816 150.934 276.746 150.934C275.676 150.934 274.808 150.066 274.808 148.996C274.808 147.926 275.676 147.058 276.746 147.058C277.816 147.058 278.683 147.926 278.683 148.996Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M278.683 144.273C278.683 145.343 277.816 146.211 276.746 146.211C275.676 146.211 274.808 145.343 274.808 144.273C274.808 143.203 275.676 142.336 276.746 142.336C277.816 142.336 278.683 143.203 278.683 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M283.406 144.273C283.406 145.343 282.539 146.211 281.469 146.211C280.399 146.211 279.531 145.343 279.531 144.273C279.531 143.203 280.399 142.336 281.469 142.336C282.539 142.336 283.406 143.203 283.406 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M283.406 139.551C283.406 140.621 282.539 141.488 281.469 141.488C280.399 141.488 279.531 140.621 279.531 139.551C279.531 138.481 280.399 137.613 281.469 137.613C282.539 137.613 283.406 138.481 283.406 139.551Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M288.13 134.828C288.13 135.898 287.262 136.766 286.192 136.766C285.122 136.766 284.255 135.898 284.255 134.828C284.255 133.758 285.122 132.89 286.192 132.89C287.262 132.89 288.13 133.758 288.13 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M292.853 134.828C292.853 135.898 291.985 136.766 290.915 136.766C289.845 136.766 288.978 135.898 288.978 134.828C288.978 133.758 289.845 132.89 290.915 132.89C291.985 132.89 292.853 133.758 292.853 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M292.853 130.101C292.853 131.171 291.985 132.039 290.915 132.039C289.845 132.039 288.978 131.171 288.978 130.101C288.978 129.031 289.845 128.164 290.915 128.164C291.985 128.164 292.853 129.031 292.853 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M288.13 130.101C288.13 131.171 287.262 132.039 286.192 132.039C285.122 132.039 284.255 131.171 284.255 130.101C284.255 129.031 285.122 128.164 286.192 128.164C287.262 128.164 288.13 129.031 288.13 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M288.13 125.379C288.13 126.449 287.262 127.316 286.192 127.316C285.122 127.316 284.255 126.449 284.255 125.379C284.255 124.309 285.122 123.441 286.192 123.441C287.262 123.441 288.13 124.309 288.13 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M292.853 125.379C292.853 126.449 291.985 127.316 290.915 127.316C289.845 127.316 288.978 126.449 288.978 125.379C288.978 124.309 289.845 123.441 290.915 123.441C291.985 123.441 292.853 124.309 292.853 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M292.853 120.656C292.853 121.726 291.985 122.594 290.915 122.594C289.845 122.594 288.978 121.726 288.978 120.656C288.978 119.586 289.845 118.719 290.915 118.719C291.985 118.719 292.853 119.586 292.853 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M297.576 120.656C297.576 121.726 296.709 122.594 295.639 122.594C294.569 122.594 293.701 121.726 293.701 120.656C293.701 119.586 294.569 118.719 295.639 118.719C296.709 118.719 297.576 119.586 297.576 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M302.299 120.656C302.299 121.726 301.432 122.594 300.362 122.594C299.292 122.594 298.424 121.726 298.424 120.656C298.424 119.586 299.292 118.719 300.362 118.719C301.432 118.719 302.299 119.586 302.299 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M302.299 115.934C302.299 117.003 301.432 117.871 300.362 117.871C299.292 117.871 298.424 117.003 298.424 115.934C298.424 114.864 299.292 113.996 300.362 113.996C301.432 113.996 302.299 114.864 302.299 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M307.022 115.934C307.022 117.003 306.155 117.871 305.085 117.871C304.015 117.871 303.147 117.003 303.147 115.934C303.147 114.864 304.015 113.996 305.085 113.996C306.155 113.996 307.022 114.864 307.022 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M307.022 120.656C307.022 121.726 306.155 122.594 305.085 122.594C304.015 122.594 303.147 121.726 303.147 120.656C303.147 119.586 304.015 118.719 305.085 118.719C306.155 118.719 307.022 119.586 307.022 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M307.022 125.379C307.022 126.449 306.155 127.316 305.085 127.316C304.015 127.316 303.147 126.449 303.147 125.379C303.147 124.309 304.015 123.441 305.085 123.441C306.155 123.441 307.022 124.309 307.022 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M302.299 125.379C302.299 126.449 301.432 127.316 300.362 127.316C299.292 127.316 298.424 126.449 298.424 125.379C298.424 124.309 299.292 123.441 300.362 123.441C301.432 123.441 302.299 124.309 302.299 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M307.022 130.101C307.022 131.171 306.155 132.039 305.085 132.039C304.015 132.039 303.147 131.171 303.147 130.101C303.147 129.031 304.015 128.164 305.085 128.164C306.155 128.164 307.022 129.031 307.022 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M311.745 134.828C311.745 135.898 310.878 136.766 309.808 136.766C308.738 136.766 307.87 135.898 307.87 134.828C307.87 133.758 308.738 132.89 309.808 132.89C310.878 132.89 311.745 133.758 311.745 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M311.745 130.101C311.745 131.171 310.878 132.039 309.808 132.039C308.738 132.039 307.87 131.171 307.87 130.101C307.87 129.031 308.738 128.164 309.808 128.164C310.878 128.164 311.745 129.031 311.745 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M311.745 125.379C311.745 126.449 310.878 127.316 309.808 127.316C308.738 127.316 307.87 126.449 307.87 125.379C307.87 124.309 308.738 123.441 309.808 123.441C310.878 123.441 311.745 124.309 311.745 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M311.745 120.656C311.745 121.726 310.878 122.594 309.808 122.594C308.738 122.594 307.87 121.726 307.87 120.656C307.87 119.586 308.738 118.719 309.808 118.719C310.878 118.719 311.745 119.586 311.745 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M316.469 120.656C316.469 121.726 315.602 122.594 314.532 122.594C313.462 122.594 312.594 121.726 312.594 120.656C312.594 119.586 313.462 118.719 314.532 118.719C315.602 118.719 316.469 119.586 316.469 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M316.469 115.934C316.469 117.003 315.602 117.871 314.532 117.871C313.462 117.871 312.594 117.003 312.594 115.934C312.594 114.864 313.462 113.996 314.532 113.996C315.602 113.996 316.469 114.864 316.469 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M316.469 111.211C316.469 112.281 315.602 113.148 314.532 113.148C313.462 113.148 312.594 112.281 312.594 111.211C312.594 110.141 313.462 109.273 314.532 109.273C315.602 109.273 316.469 110.141 316.469 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M316.469 106.488C316.469 107.558 315.602 108.426 314.532 108.426C313.462 108.426 312.594 107.558 312.594 106.488C312.594 105.418 313.462 104.551 314.532 104.551C315.602 104.551 316.469 105.418 316.469 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M321.192 106.488C321.192 107.558 320.325 108.426 319.255 108.426C318.185 108.426 317.317 107.558 317.317 106.488C317.317 105.418 318.185 104.551 319.255 104.551C320.325 104.551 321.192 105.418 321.192 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M321.192 111.211C321.192 112.281 320.325 113.148 319.255 113.148C318.185 113.148 317.317 112.281 317.317 111.211C317.317 110.141 318.185 109.273 319.255 109.273C320.325 109.273 321.192 110.141 321.192 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M321.192 115.934C321.192 117.003 320.325 117.871 319.255 117.871C318.185 117.871 317.317 117.003 317.317 115.934C317.317 114.864 318.185 113.996 319.255 113.996C320.325 113.996 321.192 114.864 321.192 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M321.192 120.656C321.192 121.726 320.325 122.594 319.255 122.594C318.185 122.594 317.317 121.726 317.317 120.656C317.317 119.586 318.185 118.719 319.255 118.719C320.325 118.719 321.192 119.586 321.192 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M321.192 125.379C321.192 126.449 320.325 127.316 319.255 127.316C318.185 127.316 317.317 126.449 317.317 125.379C317.317 124.309 318.185 123.441 319.255 123.441C320.325 123.441 321.192 124.309 321.192 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M316.469 125.379C316.469 126.449 315.602 127.316 314.532 127.316C313.462 127.316 312.594 126.449 312.594 125.379C312.594 124.309 313.462 123.441 314.532 123.441C315.602 123.441 316.469 124.309 316.469 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M316.469 130.101C316.469 131.171 315.602 132.039 314.532 132.039C313.462 132.039 312.594 131.171 312.594 130.101C312.594 129.031 313.462 128.164 314.532 128.164C315.602 128.164 316.469 129.031 316.469 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M316.469 134.828C316.469 135.898 315.602 136.766 314.532 136.766C313.462 136.766 312.594 135.898 312.594 134.828C312.594 133.758 313.462 132.89 314.532 132.89C315.602 132.89 316.469 133.758 316.469 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M321.192 134.828C321.192 135.898 320.325 136.766 319.255 136.766C318.185 136.766 317.317 135.898 317.317 134.828C317.317 133.758 318.185 132.89 319.255 132.89C320.325 132.89 321.192 133.758 321.192 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M321.192 130.101C321.192 131.171 320.325 132.039 319.255 132.039C318.185 132.039 317.317 131.171 317.317 130.101C317.317 129.031 318.185 128.164 319.255 128.164C320.325 128.164 321.192 129.031 321.192 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M325.915 130.101C325.915 131.171 325.048 132.039 323.978 132.039C322.908 132.039 322.04 131.171 322.04 130.101C322.04 129.031 322.908 128.164 323.978 128.164C325.048 128.164 325.915 129.031 325.915 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M325.915 134.828C325.915 135.898 325.048 136.766 323.978 136.766C322.908 136.766 322.04 135.898 322.04 134.828C322.04 133.758 322.908 132.89 323.978 132.89C325.048 132.89 325.915 133.758 325.915 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M330.638 130.101C330.638 131.171 329.771 132.039 328.701 132.039C327.631 132.039 326.763 131.171 326.763 130.101C326.763 129.031 327.631 128.164 328.701 128.164C329.771 128.164 330.638 129.031 330.638 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M330.638 125.379C330.638 126.449 329.771 127.316 328.701 127.316C327.631 127.316 326.763 126.449 326.763 125.379C326.763 124.309 327.631 123.441 328.701 123.441C329.771 123.441 330.638 124.309 330.638 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M325.915 125.379C325.915 126.449 325.048 127.316 323.978 127.316C322.908 127.316 322.04 126.449 322.04 125.379C322.04 124.309 322.908 123.441 323.978 123.441C325.048 123.441 325.915 124.309 325.915 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M325.915 120.656C325.915 121.726 325.048 122.594 323.978 122.594C322.908 122.594 322.04 121.726 322.04 120.656C322.04 119.586 322.908 118.719 323.978 118.719C325.048 118.719 325.915 119.586 325.915 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M325.915 115.934C325.915 117.003 325.048 117.871 323.978 117.871C322.908 117.871 322.04 117.003 322.04 115.934C322.04 114.864 322.908 113.996 323.978 113.996C325.048 113.996 325.915 114.864 325.915 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M325.915 111.211C325.915 112.281 325.048 113.148 323.978 113.148C322.908 113.148 322.04 112.281 322.04 111.211C322.04 110.141 322.908 109.273 323.978 109.273C325.048 109.273 325.915 110.141 325.915 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M325.915 106.488C325.915 107.558 325.048 108.426 323.978 108.426C322.908 108.426 322.04 107.558 322.04 106.488C322.04 105.418 322.908 104.551 323.978 104.551C325.048 104.551 325.915 105.418 325.915 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M330.638 106.488C330.638 107.558 329.771 108.426 328.701 108.426C327.631 108.426 326.763 107.558 326.763 106.488C326.763 105.418 327.631 104.551 328.701 104.551C329.771 104.551 330.638 105.418 330.638 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M335.361 106.488C335.361 107.558 334.494 108.426 333.424 108.426C332.354 108.426 331.486 107.558 331.486 106.488C331.486 105.418 332.354 104.551 333.424 104.551C334.494 104.551 335.361 105.418 335.361 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M340.084 106.488C340.084 107.558 339.217 108.426 338.147 108.426C337.077 108.426 336.209 107.558 336.209 106.488C336.209 105.418 337.077 104.551 338.147 104.551C339.217 104.551 340.084 105.418 340.084 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M340.084 111.211C340.084 112.281 339.217 113.148 338.147 113.148C337.077 113.148 336.209 112.281 336.209 111.211C336.209 110.141 337.077 109.273 338.147 109.273C339.217 109.273 340.084 110.141 340.084 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M335.361 111.211C335.361 112.281 334.494 113.148 333.424 113.148C332.354 113.148 331.486 112.281 331.486 111.211C331.486 110.141 332.354 109.273 333.424 109.273C334.494 109.273 335.361 110.141 335.361 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M330.638 111.211C330.638 112.281 329.771 113.148 328.701 113.148C327.631 113.148 326.763 112.281 326.763 111.211C326.763 110.141 327.631 109.273 328.701 109.273C329.771 109.273 330.638 110.141 330.638 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M330.638 115.934C330.638 117.003 329.771 117.871 328.701 117.871C327.631 117.871 326.763 117.003 326.763 115.934C326.763 114.864 327.631 113.996 328.701 113.996C329.771 113.996 330.638 114.864 330.638 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M335.361 115.934C335.361 117.003 334.494 117.871 333.424 117.871C332.354 117.871 331.486 117.003 331.486 115.934C331.486 114.864 332.354 113.996 333.424 113.996C334.494 113.996 335.361 114.864 335.361 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M335.361 120.656C335.361 121.726 334.494 122.594 333.424 122.594C332.354 122.594 331.486 121.726 331.486 120.656C331.486 119.586 332.354 118.719 333.424 118.719C334.494 118.719 335.361 119.586 335.361 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M330.638 120.656C330.638 121.726 329.771 122.594 328.701 122.594C327.631 122.594 326.763 121.726 326.763 120.656C326.763 119.586 327.631 118.719 328.701 118.719C329.771 118.719 330.638 119.586 330.638 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M335.361 125.379C335.361 126.449 334.494 127.316 333.424 127.316C332.354 127.316 331.486 126.449 331.486 125.379C331.486 124.309 332.354 123.441 333.424 123.441C334.494 123.441 335.361 124.309 335.361 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M340.084 130.101C340.084 131.171 339.217 132.039 338.147 132.039C337.077 132.039 336.209 131.171 336.209 130.101C336.209 129.031 337.077 128.164 338.147 128.164C339.217 128.164 340.084 129.031 340.084 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M340.084 125.379C340.084 126.449 339.217 127.316 338.147 127.316C337.077 127.316 336.209 126.449 336.209 125.379C336.209 124.309 337.077 123.441 338.147 123.441C339.217 123.441 340.084 124.309 340.084 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M340.084 120.656C340.084 121.726 339.217 122.594 338.147 122.594C337.077 122.594 336.209 121.726 336.209 120.656C336.209 119.586 337.077 118.719 338.147 118.719C339.217 118.719 340.084 119.586 340.084 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M340.084 115.934C340.084 117.003 339.217 117.871 338.147 117.871C337.077 117.871 336.209 117.003 336.209 115.934C336.209 114.864 337.077 113.996 338.147 113.996C339.217 113.996 340.084 114.864 340.084 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M344.808 115.934C344.808 117.003 343.941 117.871 342.871 117.871C341.801 117.871 340.933 117.003 340.933 115.934C340.933 114.864 341.801 113.996 342.871 113.996C343.941 113.996 344.808 114.864 344.808 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M344.808 111.211C344.808 112.281 343.941 113.148 342.871 113.148C341.801 113.148 340.933 112.281 340.933 111.211C340.933 110.141 341.801 109.273 342.871 109.273C343.941 109.273 344.808 110.141 344.808 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M344.808 106.488C344.808 107.558 343.941 108.426 342.871 108.426C341.801 108.426 340.933 107.558 340.933 106.488C340.933 105.418 341.801 104.551 342.871 104.551C343.941 104.551 344.808 105.418 344.808 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M344.808 101.766C344.808 102.836 343.941 103.703 342.871 103.703C341.801 103.703 340.933 102.836 340.933 101.766C340.933 100.696 341.801 99.828 342.871 99.828C343.941 99.828 344.808 100.696 344.808 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M344.808 97.0429C344.808 98.1129 343.941 98.9805 342.871 98.9805C341.801 98.9805 340.933 98.1129 340.933 97.0429C340.933 95.9729 341.801 95.1053 342.871 95.1053C343.941 95.1053 344.808 95.9729 344.808 97.0429Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M340.084 97.0429C340.084 98.1129 339.217 98.9805 338.147 98.9805C337.077 98.9805 336.209 98.1129 336.209 97.0429C336.209 95.9729 337.077 95.1053 338.147 95.1053C339.217 95.1053 340.084 95.9729 340.084 97.0429Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M340.084 92.3163C340.084 93.3863 339.217 94.2539 338.147 94.2539C337.077 94.2539 336.209 93.3863 336.209 92.3163C336.209 91.2463 337.077 90.3787 338.147 90.3787C339.217 90.3787 340.084 91.2463 340.084 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M340.084 87.5937C340.084 88.6636 339.217 89.5312 338.147 89.5312C337.077 89.5312 336.209 88.6636 336.209 87.5937C336.209 86.5237 337.077 85.6561 338.147 85.6561C339.217 85.6561 340.084 86.5237 340.084 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M344.808 87.5937C344.808 88.6636 343.941 89.5312 342.871 89.5312C341.801 89.5312 340.933 88.6636 340.933 87.5937C340.933 86.5237 341.801 85.6561 342.871 85.6561C343.941 85.6561 344.808 86.5237 344.808 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M344.808 92.3163C344.808 93.3863 343.941 94.2539 342.871 94.2539C341.801 94.2539 340.933 93.3863 340.933 92.3163C340.933 91.2463 341.801 90.3787 342.871 90.3787C343.941 90.3787 344.808 91.2463 344.808 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M349.531 92.3163C349.531 93.3863 348.664 94.2539 347.594 94.2539C346.524 94.2539 345.656 93.3863 345.656 92.3163C345.656 91.2463 346.524 90.3787 347.594 90.3787C348.664 90.3787 349.531 91.2463 349.531 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M349.531 97.0429C349.531 98.1129 348.664 98.9805 347.594 98.9805C346.524 98.9805 345.656 98.1129 345.656 97.0429C345.656 95.9729 346.524 95.1053 347.594 95.1053C348.664 95.1053 349.531 95.9729 349.531 97.0429Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M349.531 101.766C349.531 102.836 348.664 103.703 347.594 103.703C346.524 103.703 345.656 102.836 345.656 101.766C345.656 100.696 346.524 99.828 347.594 99.828C348.664 99.828 349.531 100.696 349.531 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M349.531 106.488C349.531 107.558 348.664 108.426 347.594 108.426C346.524 108.426 345.656 107.558 345.656 106.488C345.656 105.418 346.524 104.551 347.594 104.551C348.664 104.551 349.531 105.418 349.531 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M349.531 111.211C349.531 112.281 348.664 113.148 347.594 113.148C346.524 113.148 345.656 112.281 345.656 111.211C345.656 110.141 346.524 109.273 347.594 109.273C348.664 109.273 349.531 110.141 349.531 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M349.531 115.934C349.531 117.003 348.664 117.871 347.594 117.871C346.524 117.871 345.656 117.003 345.656 115.934C345.656 114.864 346.524 113.996 347.594 113.996C348.664 113.996 349.531 114.864 349.531 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M349.531 120.656C349.531 121.726 348.664 122.594 347.594 122.594C346.524 122.594 345.656 121.726 345.656 120.656C345.656 119.586 346.524 118.719 347.594 118.719C348.664 118.719 349.531 119.586 349.531 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M344.808 120.656C344.808 121.726 343.941 122.594 342.871 122.594C341.801 122.594 340.933 121.726 340.933 120.656C340.933 119.586 341.801 118.719 342.871 118.719C343.941 118.719 344.808 119.586 344.808 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M344.808 125.379C344.808 126.449 343.941 127.316 342.871 127.316C341.801 127.316 340.933 126.449 340.933 125.379C340.933 124.309 341.801 123.441 342.871 123.441C343.941 123.441 344.808 124.309 344.808 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M349.531 125.379C349.531 126.449 348.664 127.316 347.594 127.316C346.524 127.316 345.656 126.449 345.656 125.379C345.656 124.309 346.524 123.441 347.594 123.441C348.664 123.441 349.531 124.309 349.531 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M349.531 130.101C349.531 131.171 348.664 132.039 347.594 132.039C346.524 132.039 345.656 131.171 345.656 130.101C345.656 129.031 346.524 128.164 347.594 128.164C348.664 128.164 349.531 129.031 349.531 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M349.531 134.828C349.531 135.898 348.664 136.766 347.594 136.766C346.524 136.766 345.656 135.898 345.656 134.828C345.656 133.758 346.524 132.89 347.594 132.89C348.664 132.89 349.531 133.758 349.531 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M344.808 134.828C344.808 135.898 343.941 136.766 342.871 136.766C341.801 136.766 340.933 135.898 340.933 134.828C340.933 133.758 341.801 132.89 342.871 132.89C343.941 132.89 344.808 133.758 344.808 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M340.084 134.828C340.084 135.898 339.217 136.766 338.147 136.766C337.077 136.766 336.209 135.898 336.209 134.828C336.209 133.758 337.077 132.89 338.147 132.89C339.217 132.89 340.084 133.758 340.084 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M354.254 139.551C354.254 140.621 353.387 141.488 352.317 141.488C351.247 141.488 350.379 140.621 350.379 139.551C350.379 138.481 351.247 137.613 352.317 137.613C353.387 137.613 354.254 138.481 354.254 139.551Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M354.254 144.273C354.254 145.343 353.387 146.211 352.317 146.211C351.247 146.211 350.379 145.343 350.379 144.273C350.379 143.203 351.247 142.336 352.317 142.336C353.387 142.336 354.254 143.203 354.254 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M354.254 148.996C354.254 150.066 353.387 150.934 352.317 150.934C351.247 150.934 350.379 150.066 350.379 148.996C350.379 147.926 351.247 147.058 352.317 147.058C353.387 147.058 354.254 147.926 354.254 148.996Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M349.531 148.996C349.531 150.066 348.664 150.934 347.594 150.934C346.524 150.934 345.656 150.066 345.656 148.996C345.656 147.926 346.524 147.058 347.594 147.058C348.664 147.058 349.531 147.926 349.531 148.996Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M344.808 144.273C344.808 145.343 343.941 146.211 342.871 146.211C341.801 146.211 340.933 145.343 340.933 144.273C340.933 143.203 341.801 142.336 342.871 142.336C343.941 142.336 344.808 143.203 344.808 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M340.085 144.273C340.085 145.343 339.217 146.211 338.147 146.211C337.077 146.211 336.209 145.343 336.209 144.273C336.209 143.203 337.077 142.336 338.147 142.336C339.217 142.336 340.085 143.203 340.085 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M335.362 144.273C335.362 145.343 334.494 146.211 333.424 146.211C332.354 146.211 331.486 145.343 331.486 144.273C331.486 143.203 332.354 142.336 333.424 142.336C334.494 142.336 335.362 143.203 335.362 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M335.362 148.996C335.362 150.066 334.494 150.934 333.424 150.934C332.354 150.934 331.486 150.066 331.486 148.996C331.486 147.926 332.354 147.058 333.424 147.058C334.494 147.058 335.362 147.926 335.362 148.996Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M340.085 148.996C340.085 150.066 339.217 150.934 338.147 150.934C337.077 150.934 336.209 150.066 336.209 148.996C336.209 147.926 337.077 147.058 338.147 147.058C339.217 147.058 340.085 147.926 340.085 148.996Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M344.808 148.996C344.808 150.066 343.941 150.934 342.871 150.934C341.801 150.934 340.933 150.066 340.933 148.996C340.933 147.926 341.801 147.058 342.871 147.058C343.941 147.058 344.808 147.926 344.808 148.996Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M344.808 153.719C344.808 154.789 343.941 155.656 342.871 155.656C341.801 155.656 340.933 154.789 340.933 153.719C340.933 152.649 341.801 151.781 342.871 151.781C343.941 151.781 344.808 152.649 344.808 153.719Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M340.084 158.441C340.084 159.511 339.217 160.379 338.147 160.379C337.077 160.379 336.209 159.511 336.209 158.441C336.209 157.371 337.077 156.504 338.147 156.504C339.217 156.504 340.084 157.371 340.084 158.441Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M344.808 158.441C344.808 159.511 343.941 160.379 342.871 160.379C341.801 160.379 340.933 159.511 340.933 158.441C340.933 157.371 341.801 156.504 342.871 156.504C343.941 156.504 344.808 157.371 344.808 158.441Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M344.808 163.164C344.808 164.234 343.941 165.102 342.871 165.102C341.801 165.102 340.933 164.234 340.933 163.164C340.933 162.094 341.801 161.226 342.871 161.226C343.941 161.226 344.808 162.094 344.808 163.164Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M340.084 167.887C340.084 168.957 339.217 169.824 338.147 169.824C337.077 169.824 336.209 168.957 336.209 167.887C336.209 166.817 337.077 165.949 338.147 165.949C339.217 165.949 340.084 166.817 340.084 167.887Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M335.361 167.887C335.361 168.957 334.494 169.824 333.424 169.824C332.354 169.824 331.486 168.957 331.486 167.887C331.486 166.817 332.354 165.949 333.424 165.949C334.494 165.949 335.361 166.817 335.361 167.887Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M330.638 167.887C330.638 168.957 329.771 169.824 328.701 169.824C327.631 169.824 326.763 168.957 326.763 167.887C326.763 166.817 327.631 165.949 328.701 165.949C329.771 165.949 330.638 166.817 330.638 167.887Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M325.915 167.887C325.915 168.957 325.048 169.824 323.978 169.824C322.908 169.824 322.04 168.957 322.04 167.887C322.04 166.817 322.908 165.949 323.978 165.949C325.048 165.949 325.915 166.817 325.915 167.887Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M321.192 167.887C321.192 168.957 320.325 169.824 319.255 169.824C318.185 169.824 317.317 168.957 317.317 167.887C317.317 166.817 318.185 165.949 319.255 165.949C320.325 165.949 321.192 166.817 321.192 167.887Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M321.192 163.164C321.192 164.234 320.325 165.102 319.255 165.102C318.185 165.102 317.317 164.234 317.317 163.164C317.317 162.094 318.185 161.226 319.255 161.226C320.325 161.226 321.192 162.094 321.192 163.164Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M316.469 167.891C316.469 168.961 315.602 169.828 314.532 169.828C313.462 169.828 312.594 168.961 312.594 167.891C312.594 166.821 313.462 165.953 314.532 165.953C315.602 165.953 316.469 166.821 316.469 167.891Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M311.745 167.891C311.745 168.961 310.878 169.828 309.808 169.828C308.738 169.828 307.87 168.961 307.87 167.891C307.87 166.821 308.738 165.953 309.808 165.953C310.878 165.953 311.745 166.821 311.745 167.891Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M307.022 167.887C307.022 168.957 306.155 169.824 305.085 169.824C304.015 169.824 303.147 168.957 303.147 167.887C303.147 166.817 304.015 165.949 305.085 165.949C306.155 165.949 307.022 166.817 307.022 167.887Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M307.022 163.164C307.022 164.234 306.155 165.102 305.085 165.102C304.015 165.102 303.147 164.234 303.147 163.164C303.147 162.094 304.015 161.226 305.085 161.226C306.155 161.226 307.022 162.094 307.022 163.164Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M302.299 163.164C302.299 164.234 301.432 165.102 300.362 165.102C299.292 165.102 298.424 164.234 298.424 163.164C298.424 162.094 299.292 161.226 300.362 161.226C301.432 161.226 302.299 162.094 302.299 163.164Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M297.576 163.164C297.576 164.234 296.709 165.102 295.639 165.102C294.569 165.102 293.701 164.234 293.701 163.164C293.701 162.094 294.569 161.226 295.639 161.226C296.709 161.226 297.576 162.094 297.576 163.164Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M297.576 158.441C297.576 159.511 296.709 160.379 295.639 160.379C294.569 160.379 293.701 159.511 293.701 158.441C293.701 157.371 294.569 156.504 295.639 156.504C296.709 156.504 297.576 157.371 297.576 158.441Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M292.853 158.441C292.853 159.511 291.986 160.379 290.916 160.379C289.846 160.379 288.978 159.511 288.978 158.441C288.978 157.371 289.846 156.504 290.916 156.504C291.986 156.504 292.853 157.371 292.853 158.441Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M292.853 153.719C292.853 154.789 291.986 155.656 290.916 155.656C289.846 155.656 288.978 154.789 288.978 153.719C288.978 152.649 289.846 151.781 290.916 151.781C291.986 151.781 292.853 152.649 292.853 153.719Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M288.13 158.441C288.13 159.511 287.263 160.379 286.193 160.379C285.123 160.379 284.255 159.511 284.255 158.441C284.255 157.371 285.123 156.504 286.193 156.504C287.263 156.504 288.13 157.371 288.13 158.441Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M283.406 158.441C283.406 159.511 282.539 160.379 281.469 160.379C280.399 160.379 279.531 159.511 279.531 158.441C279.531 157.371 280.399 156.504 281.469 156.504C282.539 156.504 283.406 157.371 283.406 158.441Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M278.683 158.441C278.683 159.511 277.816 160.379 276.746 160.379C275.676 160.379 274.808 159.511 274.808 158.441C274.808 157.371 275.676 156.504 276.746 156.504C277.816 156.504 278.683 157.371 278.683 158.441Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M273.96 158.441C273.96 159.511 273.093 160.379 272.023 160.379C270.953 160.379 270.085 159.511 270.085 158.441C270.085 157.371 270.953 156.504 272.023 156.504C273.093 156.504 273.96 157.371 273.96 158.441Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M273.96 163.164C273.96 164.234 273.093 165.102 272.023 165.102C270.953 165.102 270.085 164.234 270.085 163.164C270.085 162.094 270.953 161.226 272.023 161.226C273.093 161.226 273.96 162.094 273.96 163.164Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M269.237 163.164C269.237 164.234 268.37 165.102 267.3 165.102C266.23 165.102 265.362 164.234 265.362 163.164C265.362 162.094 266.23 161.226 267.3 161.226C268.37 161.226 269.237 162.094 269.237 163.164Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M269.237 167.887C269.237 168.957 268.37 169.824 267.3 169.824C266.23 169.824 265.362 168.957 265.362 167.887C265.362 166.817 266.23 165.949 267.3 165.949C268.37 165.949 269.237 166.817 269.237 167.887Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M269.237 172.613C269.237 173.683 268.37 174.551 267.3 174.551C266.23 174.551 265.362 173.683 265.362 172.613C265.362 171.543 266.23 170.676 267.3 170.676C268.37 170.676 269.237 171.543 269.237 172.613Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M264.514 172.613C264.514 173.683 263.647 174.551 262.577 174.551C261.507 174.551 260.639 173.683 260.639 172.613C260.639 171.543 261.507 170.676 262.577 170.676C263.647 170.676 264.514 171.543 264.514 172.613Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M264.514 177.336C264.514 178.406 263.647 179.273 262.577 179.273C261.507 179.273 260.639 178.406 260.639 177.336C260.639 176.266 261.507 175.398 262.577 175.398C263.647 175.398 264.514 176.266 264.514 177.336Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M259.791 177.336C259.791 178.406 258.923 179.273 257.853 179.273C256.783 179.273 255.916 178.406 255.916 177.336C255.916 176.266 256.783 175.398 257.853 175.398C258.923 175.398 259.791 176.266 259.791 177.336Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M259.791 182.059C259.791 183.128 258.923 183.996 257.853 183.996C256.783 183.996 255.916 183.128 255.916 182.059C255.916 180.989 256.783 180.121 257.853 180.121C258.923 180.121 259.791 180.989 259.791 182.059Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M255.068 182.059C255.068 183.128 254.2 183.996 253.13 183.996C252.06 183.996 251.192 183.128 251.192 182.059C251.192 180.989 252.06 180.121 253.13 180.121C254.2 180.121 255.068 180.989 255.068 182.059Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M259.791 186.781C259.791 187.851 258.923 188.719 257.853 188.719C256.783 188.719 255.916 187.851 255.916 186.781C255.916 185.711 256.783 184.844 257.853 184.844C258.923 184.844 259.791 185.711 259.791 186.781Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M255.068 186.781C255.068 187.851 254.2 188.719 253.13 188.719C252.06 188.719 251.192 187.851 251.192 186.781C251.192 185.711 252.06 184.844 253.13 184.844C254.2 184.844 255.068 185.711 255.068 186.781Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M259.791 191.504C259.791 192.574 258.923 193.441 257.853 193.441C256.783 193.441 255.916 192.574 255.916 191.504C255.916 190.434 256.783 189.566 257.853 189.566C258.923 189.566 259.791 190.434 259.791 191.504Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M255.068 196.226C255.068 197.296 254.2 198.164 253.13 198.164C252.06 198.164 251.192 197.296 251.192 196.226C251.192 195.156 252.06 194.289 253.13 194.289C254.2 194.289 255.068 195.156 255.068 196.226Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M259.791 196.226C259.791 197.296 258.923 198.164 257.853 198.164C256.783 198.164 255.916 197.296 255.916 196.226C255.916 195.156 256.783 194.289 257.853 194.289C258.923 194.289 259.791 195.156 259.791 196.226Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M259.791 200.949C259.791 202.019 258.923 202.887 257.853 202.887C256.783 202.887 255.916 202.019 255.916 200.949C255.916 199.879 256.783 199.012 257.853 199.012C258.923 199.012 259.791 199.879 259.791 200.949Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M264.514 200.949C264.514 202.019 263.647 202.887 262.577 202.887C261.507 202.887 260.639 202.019 260.639 200.949C260.639 199.879 261.507 199.012 262.577 199.012C263.647 199.012 264.514 199.879 264.514 200.949Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M264.514 205.672C264.514 206.742 263.647 207.609 262.577 207.609C261.507 207.609 260.639 206.742 260.639 205.672C260.639 204.602 261.507 203.734 262.577 203.734C263.647 203.734 264.514 204.602 264.514 205.672Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M269.237 205.672C269.237 206.742 268.37 207.609 267.3 207.609C266.23 207.609 265.362 206.742 265.362 205.672C265.362 204.602 266.23 203.734 267.3 203.734C268.37 203.734 269.237 204.602 269.237 205.672Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M269.237 210.398C269.237 211.468 268.37 212.336 267.3 212.336C266.23 212.336 265.362 211.468 265.362 210.398C265.362 209.328 266.23 208.461 267.3 208.461C268.37 208.461 269.237 209.328 269.237 210.398Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M273.96 205.672C273.96 206.742 273.093 207.609 272.023 207.609C270.953 207.609 270.085 206.742 270.085 205.672C270.085 204.602 270.953 203.734 272.023 203.734C273.093 203.734 273.96 204.602 273.96 205.672Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M273.96 210.398C273.96 211.468 273.093 212.336 272.023 212.336C270.953 212.336 270.085 211.468 270.085 210.398C270.085 209.328 270.953 208.461 272.023 208.461C273.093 208.461 273.96 209.328 273.96 210.398Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M278.683 205.672C278.683 206.742 277.816 207.609 276.746 207.609C275.676 207.609 274.808 206.742 274.808 205.672C274.808 204.602 275.676 203.734 276.746 203.734C277.816 203.734 278.683 204.602 278.683 205.672Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M278.683 210.398C278.683 211.468 277.816 212.336 276.746 212.336C275.676 212.336 274.808 211.468 274.808 210.398C274.808 209.328 275.676 208.461 276.746 208.461C277.816 208.461 278.683 209.328 278.683 210.398Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M283.406 205.672C283.406 206.742 282.539 207.609 281.469 207.609C280.399 207.609 279.531 206.742 279.531 205.672C279.531 204.602 280.399 203.734 281.469 203.734C282.539 203.734 283.406 204.602 283.406 205.672Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M288.13 205.672C288.13 206.742 287.263 207.609 286.193 207.609C285.123 207.609 284.255 206.742 284.255 205.672C284.255 204.602 285.123 203.734 286.193 203.734C287.263 203.734 288.13 204.602 288.13 205.672Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M292.853 205.672C292.853 206.742 291.986 207.609 290.916 207.609C289.846 207.609 288.978 206.742 288.978 205.672C288.978 204.602 289.846 203.734 290.916 203.734C291.986 203.734 292.853 204.602 292.853 205.672Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M297.576 205.672C297.576 206.742 296.709 207.609 295.639 207.609C294.569 207.609 293.701 206.742 293.701 205.672C293.701 204.602 294.569 203.734 295.639 203.734C296.709 203.734 297.576 204.602 297.576 205.672Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M297.576 210.398C297.576 211.468 296.709 212.336 295.639 212.336C294.569 212.336 293.701 211.468 293.701 210.398C293.701 209.328 294.569 208.461 295.639 208.461C296.709 208.461 297.576 209.328 297.576 210.398Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M302.299 210.398C302.299 211.468 301.432 212.336 300.362 212.336C299.292 212.336 298.424 211.468 298.424 210.398C298.424 209.328 299.292 208.461 300.362 208.461C301.432 208.461 302.299 209.328 302.299 210.398Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M302.299 215.121C302.299 216.191 301.432 217.059 300.362 217.059C299.292 217.059 298.424 216.191 298.424 215.121C298.424 214.051 299.292 213.183 300.362 213.183C301.432 213.183 302.299 214.051 302.299 215.121Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M302.299 219.844C302.299 220.914 301.432 221.781 300.362 221.781C299.292 221.781 298.424 220.914 298.424 219.844C298.424 218.774 299.292 217.906 300.362 217.906C301.432 217.906 302.299 218.774 302.299 219.844Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M302.299 224.566C302.299 225.636 301.432 226.504 300.362 226.504C299.292 226.504 298.424 225.636 298.424 224.566C298.424 223.496 299.292 222.629 300.362 222.629C301.432 222.629 302.299 223.496 302.299 224.566Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M307.022 224.566C307.022 225.636 306.155 226.504 305.085 226.504C304.015 226.504 303.147 225.636 303.147 224.566C303.147 223.496 304.015 222.629 305.085 222.629C306.155 222.629 307.022 223.496 307.022 224.566Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M307.022 229.289C307.022 230.359 306.155 231.227 305.085 231.227C304.015 231.227 303.147 230.359 303.147 229.289C303.147 228.219 304.015 227.351 305.085 227.351C306.155 227.351 307.022 228.219 307.022 229.289Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M311.745 229.289C311.745 230.359 310.878 231.227 309.808 231.227C308.738 231.227 307.87 230.359 307.87 229.289C307.87 228.219 308.738 227.351 309.808 227.351C310.878 227.351 311.745 228.219 311.745 229.289Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M311.745 234.012C311.745 235.082 310.878 235.949 309.808 235.949C308.738 235.949 307.87 235.082 307.87 234.012C307.87 232.942 308.738 232.074 309.808 232.074C310.878 232.074 311.745 232.942 311.745 234.012Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M307.022 234.012C307.022 235.082 306.155 235.949 305.085 235.949C304.015 235.949 303.147 235.082 303.147 234.012C303.147 232.942 304.015 232.074 305.085 232.074C306.155 232.074 307.022 232.942 307.022 234.012Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M311.745 238.734C311.745 239.804 310.878 240.672 309.808 240.672C308.738 240.672 307.87 239.804 307.87 238.734C307.87 237.664 308.738 236.797 309.808 236.797C310.878 236.797 311.745 237.664 311.745 238.734Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M307.022 238.734C307.022 239.804 306.155 240.672 305.085 240.672C304.015 240.672 303.147 239.804 303.147 238.734C303.147 237.664 304.015 236.797 305.085 236.797C306.155 236.797 307.022 237.664 307.022 238.734Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M311.745 243.461C311.745 244.531 310.878 245.398 309.808 245.398C308.738 245.398 307.87 244.531 307.87 243.461C307.87 242.391 308.738 241.523 309.808 241.523C310.878 241.523 311.745 242.391 311.745 243.461Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M311.745 248.184C311.745 249.253 310.878 250.121 309.808 250.121C308.738 250.121 307.87 249.253 307.87 248.184C307.87 247.114 308.738 246.246 309.808 246.246C310.878 246.246 311.745 247.114 311.745 248.184Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M307.022 248.184C307.022 249.253 306.155 250.121 305.085 250.121C304.015 250.121 303.147 249.253 303.147 248.184C303.147 247.114 304.015 246.246 305.085 246.246C306.155 246.246 307.022 247.114 307.022 248.184Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M307.022 252.906C307.022 253.976 306.155 254.844 305.085 254.844C304.015 254.844 303.147 253.976 303.147 252.906C303.147 251.836 304.015 250.969 305.085 250.969C306.155 250.969 307.022 251.836 307.022 252.906Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M311.745 252.906C311.745 253.976 310.878 254.844 309.808 254.844C308.738 254.844 307.87 253.976 307.87 252.906C307.87 251.836 308.738 250.969 309.808 250.969C310.878 250.969 311.745 251.836 311.745 252.906Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M311.745 257.629C311.745 258.699 310.878 259.566 309.808 259.566C308.738 259.566 307.87 258.699 307.87 257.629C307.87 256.559 308.738 255.691 309.808 255.691C310.878 255.691 311.745 256.559 311.745 257.629Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M307.022 257.629C307.022 258.699 306.155 259.566 305.085 259.566C304.015 259.566 303.147 258.699 303.147 257.629C303.147 256.559 304.015 255.691 305.085 255.691C306.155 255.691 307.022 256.559 307.022 257.629Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M311.745 262.351C311.745 263.421 310.878 264.289 309.808 264.289C308.738 264.289 307.87 263.421 307.87 262.351C307.87 261.281 308.738 260.414 309.808 260.414C310.878 260.414 311.745 261.281 311.745 262.351Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M311.745 267.074C311.745 268.144 310.878 269.012 309.808 269.012C308.738 269.012 307.87 268.144 307.87 267.074C307.87 266.004 308.738 265.137 309.808 265.137C310.878 265.137 311.745 266.004 311.745 267.074Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M316.469 271.797C316.469 272.867 315.602 273.734 314.532 273.734C313.462 273.734 312.594 272.867 312.594 271.797C312.594 270.727 313.462 269.859 314.532 269.859C315.602 269.859 316.469 270.727 316.469 271.797Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M311.745 271.797C311.745 272.867 310.878 273.734 309.808 273.734C308.738 273.734 307.87 272.867 307.87 271.797C307.87 270.727 308.738 269.859 309.808 269.859C310.878 269.859 311.745 270.727 311.745 271.797Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M316.469 276.523C316.469 277.593 315.602 278.461 314.532 278.461C313.462 278.461 312.594 277.593 312.594 276.523C312.594 275.453 313.462 274.586 314.532 274.586C315.602 274.586 316.469 275.453 316.469 276.523Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M316.469 281.246C316.469 282.316 315.602 283.184 314.532 283.184C313.462 283.184 312.594 282.316 312.594 281.246C312.594 280.176 313.462 279.308 314.532 279.308C315.602 279.308 316.469 280.176 316.469 281.246Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M321.192 281.246C321.192 282.316 320.325 283.184 319.255 283.184C318.185 283.184 317.317 282.316 317.317 281.246C317.317 280.176 318.185 279.308 319.255 279.308C320.325 279.308 321.192 280.176 321.192 281.246Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M321.192 276.519C321.192 277.589 320.325 278.457 319.255 278.457C318.185 278.457 317.317 277.589 317.317 276.519C317.317 275.449 318.185 274.582 319.255 274.582C320.325 274.582 321.192 275.449 321.192 276.519Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M325.915 276.519C325.915 277.589 325.048 278.457 323.978 278.457C322.908 278.457 322.04 277.589 322.04 276.519C322.04 275.449 322.908 274.582 323.978 274.582C325.048 274.582 325.915 275.449 325.915 276.519Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M325.915 281.246C325.915 282.316 325.048 283.184 323.978 283.184C322.908 283.184 322.04 282.316 322.04 281.246C322.04 280.176 322.908 279.308 323.978 279.308C325.048 279.308 325.915 280.176 325.915 281.246Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M330.638 276.519C330.638 277.589 329.771 278.457 328.701 278.457C327.631 278.457 326.763 277.589 326.763 276.519C326.763 275.449 327.631 274.582 328.701 274.582C329.771 274.582 330.638 275.449 330.638 276.519Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M330.638 271.797C330.638 272.867 329.771 273.734 328.701 273.734C327.631 273.734 326.763 272.867 326.763 271.797C326.763 270.727 327.631 269.859 328.701 269.859C329.771 269.859 330.638 270.727 330.638 271.797Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M335.362 271.797C335.362 272.867 334.494 273.734 333.424 273.734C332.354 273.734 331.486 272.867 331.486 271.797C331.486 270.727 332.354 269.859 333.424 269.859C334.494 269.859 335.362 270.727 335.362 271.797Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M335.362 267.074C335.362 268.144 334.494 269.012 333.424 269.012C332.354 269.012 331.486 268.144 331.486 267.074C331.486 266.004 332.354 265.137 333.424 265.137C334.494 265.137 335.362 266.004 335.362 267.074Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M335.361 262.351C335.361 263.421 334.494 264.289 333.424 264.289C332.354 264.289 331.486 263.421 331.486 262.351C331.486 261.281 332.354 260.414 333.424 260.414C334.494 260.414 335.361 261.281 335.361 262.351Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M340.084 262.351C340.084 263.421 339.217 264.289 338.147 264.289C337.077 264.289 336.209 263.421 336.209 262.351C336.209 261.281 337.077 260.414 338.147 260.414C339.217 260.414 340.084 261.281 340.084 262.351Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M340.084 257.629C340.084 258.699 339.217 259.566 338.147 259.566C337.077 259.566 336.209 258.699 336.209 257.629C336.209 256.559 337.077 255.691 338.147 255.691C339.217 255.691 340.084 256.559 340.084 257.629Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M340.084 252.906C340.084 253.976 339.217 254.844 338.147 254.844C337.077 254.844 336.209 253.976 336.209 252.906C336.209 251.836 337.077 250.969 338.147 250.969C339.217 250.969 340.084 251.836 340.084 252.906Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M344.808 252.906C344.808 253.976 343.941 254.844 342.871 254.844C341.801 254.844 340.933 253.976 340.933 252.906C340.933 251.836 341.801 250.969 342.871 250.969C343.941 250.969 344.808 251.836 344.808 252.906Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M363.7 252.906C363.7 253.976 362.833 254.844 361.763 254.844C360.693 254.844 359.825 253.976 359.825 252.906C359.825 251.836 360.693 250.969 361.763 250.969C362.833 250.969 363.7 251.836 363.7 252.906Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M368.424 252.906C368.424 253.976 367.556 254.844 366.486 254.844C365.416 254.844 364.548 253.976 364.548 252.906C364.548 251.836 365.416 250.969 366.486 250.969C367.556 250.969 368.424 251.836 368.424 252.906Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M368.424 248.184C368.424 249.253 367.556 250.121 366.486 250.121C365.416 250.121 364.548 249.253 364.548 248.184C364.548 247.114 365.416 246.246 366.486 246.246C367.556 246.246 368.424 247.114 368.424 248.184Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M363.7 257.629C363.7 258.699 362.833 259.566 361.763 259.566C360.693 259.566 359.825 258.699 359.825 257.629C359.825 256.559 360.693 255.691 361.763 255.691C362.833 255.691 363.7 256.559 363.7 257.629Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M363.7 262.351C363.7 263.421 362.833 264.289 361.763 264.289C360.693 264.289 359.825 263.421 359.825 262.351C359.825 261.281 360.693 260.414 361.763 260.414C362.833 260.414 363.7 261.281 363.7 262.351Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M358.977 262.351C358.977 263.421 358.11 264.289 357.04 264.289C355.97 264.289 355.102 263.421 355.102 262.351C355.102 261.281 355.97 260.414 357.04 260.414C358.11 260.414 358.977 261.281 358.977 262.351Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M344.808 248.184C344.808 249.253 343.941 250.121 342.871 250.121C341.801 250.121 340.933 249.253 340.933 248.184C340.933 247.114 341.801 246.246 342.871 246.246C343.941 246.246 344.808 247.114 344.808 248.184Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M349.531 248.184C349.531 249.253 348.664 250.121 347.594 250.121C346.524 250.121 345.656 249.253 345.656 248.184C345.656 247.114 346.524 246.246 347.594 246.246C348.664 246.246 349.531 247.114 349.531 248.184Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M349.531 243.461C349.531 244.531 348.664 245.398 347.594 245.398C346.524 245.398 345.656 244.531 345.656 243.461C345.656 242.391 346.524 241.523 347.594 241.523C348.664 241.523 349.531 242.391 349.531 243.461Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M349.531 238.734C349.531 239.804 348.664 240.672 347.594 240.672C346.524 240.672 345.656 239.804 345.656 238.734C345.656 237.664 346.524 236.797 347.594 236.797C348.664 236.797 349.531 237.664 349.531 238.734Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M344.808 238.734C344.808 239.804 343.941 240.672 342.871 240.672C341.801 240.672 340.933 239.804 340.933 238.734C340.933 237.664 341.801 236.797 342.871 236.797C343.941 236.797 344.808 237.664 344.808 238.734Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M349.531 234.012C349.531 235.082 348.664 235.949 347.594 235.949C346.524 235.949 345.656 235.082 345.656 234.012C345.656 232.942 346.524 232.074 347.594 232.074C348.664 232.074 349.531 232.942 349.531 234.012Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M349.531 229.289C349.531 230.359 348.664 231.227 347.594 231.227C346.524 231.227 345.656 230.359 345.656 229.289C345.656 228.219 346.524 227.351 347.594 227.351C348.664 227.351 349.531 228.219 349.531 229.289Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M349.531 224.566C349.531 225.636 348.664 226.504 347.594 226.504C346.524 226.504 345.656 225.636 345.656 224.566C345.656 223.496 346.524 222.629 347.594 222.629C348.664 222.629 349.531 223.496 349.531 224.566Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M349.531 219.844C349.531 220.914 348.664 221.781 347.594 221.781C346.524 221.781 345.656 220.914 345.656 219.844C345.656 218.774 346.524 217.906 347.594 217.906C348.664 217.906 349.531 218.774 349.531 219.844Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M354.254 219.844C354.254 220.914 353.387 221.781 352.317 221.781C351.247 221.781 350.379 220.914 350.379 219.844C350.379 218.774 351.247 217.906 352.317 217.906C353.387 217.906 354.254 218.774 354.254 219.844Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M354.254 215.121C354.254 216.191 353.387 217.059 352.317 217.059C351.247 217.059 350.379 216.191 350.379 215.121C350.379 214.051 351.247 213.183 352.317 213.183C353.387 213.183 354.254 214.051 354.254 215.121Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M358.977 215.121C358.977 216.191 358.11 217.059 357.04 217.059C355.97 217.059 355.102 216.191 355.102 215.121C355.102 214.051 355.97 213.183 357.04 213.183C358.11 213.183 358.977 214.051 358.977 215.121Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M358.977 210.398C358.977 211.468 358.11 212.336 357.04 212.336C355.97 212.336 355.102 211.468 355.102 210.398C355.102 209.328 355.97 208.461 357.04 208.461C358.11 208.461 358.977 209.328 358.977 210.398Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M363.7 210.398C363.7 211.468 362.833 212.336 361.763 212.336C360.693 212.336 359.825 211.468 359.825 210.398C359.825 209.328 360.693 208.461 361.763 208.461C362.833 208.461 363.7 209.328 363.7 210.398Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M363.7 205.672C363.7 206.742 362.833 207.609 361.763 207.609C360.693 207.609 359.825 206.742 359.825 205.672C359.825 204.602 360.693 203.734 361.763 203.734C362.833 203.734 363.7 204.602 363.7 205.672Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M358.977 205.672C358.977 206.742 358.11 207.609 357.04 207.609C355.97 207.609 355.102 206.742 355.102 205.672C355.102 204.602 355.97 203.734 357.04 203.734C358.11 203.734 358.977 204.602 358.977 205.672Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M354.254 205.672C354.254 206.742 353.387 207.609 352.317 207.609C351.247 207.609 350.379 206.742 350.379 205.672C350.379 204.602 351.247 203.734 352.317 203.734C353.387 203.734 354.254 204.602 354.254 205.672Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M354.254 200.949C354.254 202.019 353.387 202.887 352.317 202.887C351.247 202.887 350.379 202.019 350.379 200.949C350.379 199.879 351.247 199.012 352.317 199.012C353.387 199.012 354.254 199.879 354.254 200.949Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M358.977 196.226C358.977 197.296 358.11 198.164 357.04 198.164C355.97 198.164 355.102 197.296 355.102 196.226C355.102 195.156 355.97 194.289 357.04 194.289C358.11 194.289 358.977 195.156 358.977 196.226Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M363.7 191.504C363.7 192.574 362.833 193.441 361.763 193.441C360.693 193.441 359.825 192.574 359.825 191.504C359.825 190.434 360.693 189.566 361.763 189.566C362.833 189.566 363.7 190.434 363.7 191.504Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M368.424 191.504C368.424 192.574 367.556 193.441 366.486 193.441C365.416 193.441 364.548 192.574 364.548 191.504C364.548 190.434 365.416 189.566 366.486 189.566C367.556 189.566 368.424 190.434 368.424 191.504Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M373.147 191.504C373.147 192.574 372.279 193.441 371.209 193.441C370.139 193.441 369.271 192.574 369.271 191.504C369.271 190.434 370.139 189.566 371.209 189.566C372.279 189.566 373.147 190.434 373.147 191.504Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M373.147 186.781C373.147 187.851 372.279 188.719 371.209 188.719C370.139 188.719 369.271 187.851 369.271 186.781C369.271 185.711 370.139 184.844 371.209 184.844C372.279 184.844 373.147 185.711 373.147 186.781Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M377.87 186.781C377.87 187.851 377.003 188.719 375.933 188.719C374.863 188.719 373.995 187.851 373.995 186.781C373.995 185.711 374.863 184.844 375.933 184.844C377.003 184.844 377.87 185.711 377.87 186.781Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M377.87 182.059C377.87 183.128 377.003 183.996 375.933 183.996C374.863 183.996 373.995 183.128 373.995 182.059C373.995 180.989 374.863 180.121 375.933 180.121C377.003 180.121 377.87 180.989 377.87 182.059Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M377.87 177.336C377.87 178.406 377.003 179.273 375.933 179.273C374.863 179.273 373.995 178.406 373.995 177.336C373.995 176.266 374.863 175.398 375.933 175.398C377.003 175.398 377.87 176.266 377.87 177.336Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M373.147 182.059C373.147 183.128 372.279 183.996 371.209 183.996C370.139 183.996 369.271 183.128 369.271 182.059C369.271 180.989 370.139 180.121 371.209 180.121C372.279 180.121 373.147 180.989 373.147 182.059Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M368.424 182.059C368.424 183.128 367.556 183.996 366.486 183.996C365.416 183.996 364.548 183.128 364.548 182.059C364.548 180.989 365.416 180.121 366.486 180.121C367.556 180.121 368.424 180.989 368.424 182.059Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M368.424 177.336C368.424 178.406 367.556 179.273 366.486 179.273C365.416 179.273 364.548 178.406 364.548 177.336C364.548 176.266 365.416 175.398 366.486 175.398C367.556 175.398 368.424 176.266 368.424 177.336Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M363.7 177.336C363.7 178.406 362.833 179.273 361.763 179.273C360.693 179.273 359.825 178.406 359.825 177.336C359.825 176.266 360.693 175.398 361.763 175.398C362.833 175.398 363.7 176.266 363.7 177.336Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M363.7 172.613C363.7 173.683 362.833 174.551 361.763 174.551C360.693 174.551 359.825 173.683 359.825 172.613C359.825 171.543 360.693 170.676 361.763 170.676C362.833 170.676 363.7 171.543 363.7 172.613Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M363.7 167.887C363.7 168.957 362.833 169.824 361.763 169.824C360.693 169.824 359.825 168.957 359.825 167.887C359.825 166.817 360.693 165.949 361.763 165.949C362.833 165.949 363.7 166.817 363.7 167.887Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M358.977 167.887C358.977 168.957 358.11 169.824 357.04 169.824C355.97 169.824 355.102 168.957 355.102 167.887C355.102 166.817 355.97 165.949 357.04 165.949C358.11 165.949 358.977 166.817 358.977 167.887Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M358.977 163.164C358.977 164.234 358.11 165.102 357.04 165.102C355.97 165.102 355.102 164.234 355.102 163.164C355.102 162.094 355.97 161.226 357.04 161.226C358.11 161.226 358.977 162.094 358.977 163.164Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M354.254 163.164C354.254 164.234 353.387 165.102 352.317 165.102C351.247 165.102 350.379 164.234 350.379 163.164C350.379 162.094 351.247 161.226 352.317 161.226C353.387 161.226 354.254 162.094 354.254 163.164Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M354.254 167.887C354.254 168.957 353.387 169.824 352.317 169.824C351.247 169.824 350.379 168.957 350.379 167.887C350.379 166.817 351.247 165.949 352.317 165.949C353.387 165.949 354.254 166.817 354.254 167.887Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M349.531 167.887C349.531 168.957 348.664 169.824 347.594 169.824C346.524 169.824 345.656 168.957 345.656 167.887C345.656 166.817 346.524 165.949 347.594 165.949C348.664 165.949 349.531 166.817 349.531 167.887Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M344.808 167.887C344.808 168.957 343.941 169.824 342.871 169.824C341.801 169.824 340.933 168.957 340.933 167.887C340.933 166.817 341.801 165.949 342.871 165.949C343.941 165.949 344.808 166.817 344.808 167.887Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M349.531 172.613C349.531 173.683 348.664 174.551 347.594 174.551C346.524 174.551 345.656 173.683 345.656 172.613C345.656 171.543 346.524 170.676 347.594 170.676C348.664 170.676 349.531 171.543 349.531 172.613Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M354.254 172.613C354.254 173.683 353.387 174.551 352.317 174.551C351.247 174.551 350.379 173.683 350.379 172.613C350.379 171.543 351.247 170.676 352.317 170.676C353.387 170.676 354.254 171.543 354.254 172.613Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M354.254 177.336C354.254 178.406 353.387 179.273 352.317 179.273C351.247 179.273 350.379 178.406 350.379 177.336C350.379 176.266 351.247 175.398 352.317 175.398C353.387 175.398 354.254 176.266 354.254 177.336Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M358.977 177.336C358.977 178.406 358.11 179.273 357.04 179.273C355.97 179.273 355.102 178.406 355.102 177.336C355.102 176.266 355.97 175.398 357.04 175.398C358.11 175.398 358.977 176.266 358.977 177.336Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M358.977 172.613C358.977 173.683 358.11 174.551 357.04 174.551C355.97 174.551 355.102 173.683 355.102 172.613C355.102 171.543 355.97 170.676 357.04 170.676C358.11 170.676 358.977 171.543 358.977 172.613Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M354.254 182.059C354.254 183.128 353.387 183.996 352.317 183.996C351.247 183.996 350.379 183.128 350.379 182.059C350.379 180.989 351.247 180.121 352.317 180.121C353.387 180.121 354.254 180.989 354.254 182.059Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M358.977 182.059C358.977 183.128 358.11 183.996 357.04 183.996C355.97 183.996 355.102 183.128 355.102 182.059C355.102 180.989 355.97 180.121 357.04 180.121C358.11 180.121 358.977 180.989 358.977 182.059Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M358.977 186.781C358.977 187.851 358.11 188.719 357.04 188.719C355.97 188.719 355.102 187.851 355.102 186.781C355.102 185.711 355.97 184.844 357.04 184.844C358.11 184.844 358.977 185.711 358.977 186.781Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M363.7 186.781C363.7 187.851 362.833 188.719 361.763 188.719C360.693 188.719 359.825 187.851 359.825 186.781C359.825 185.711 360.693 184.844 361.763 184.844C362.833 184.844 363.7 185.711 363.7 186.781Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M363.7 182.059C363.7 183.128 362.833 183.996 361.763 183.996C360.693 183.996 359.825 183.128 359.825 182.059C359.825 180.989 360.693 180.121 361.763 180.121C362.833 180.121 363.7 180.989 363.7 182.059Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M368.424 186.781C368.424 187.851 367.556 188.719 366.486 188.719C365.416 188.719 364.548 187.851 364.548 186.781C364.548 185.711 365.416 184.844 366.486 184.844C367.556 184.844 368.424 185.711 368.424 186.781Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M382.593 182.059C382.593 183.128 381.726 183.996 380.656 183.996C379.586 183.996 378.718 183.128 378.718 182.059C378.718 180.989 379.586 180.121 380.656 180.121C381.726 180.121 382.593 180.989 382.593 182.059Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M349.531 200.949C349.531 202.019 348.664 202.887 347.594 202.887C346.524 202.887 345.656 202.019 345.656 200.949C345.656 199.879 346.524 199.012 347.594 199.012C348.664 199.012 349.531 199.879 349.531 200.949Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M349.531 196.226C349.531 197.296 348.664 198.164 347.594 198.164C346.524 198.164 345.656 197.296 345.656 196.226C345.656 195.156 346.524 194.289 347.594 194.289C348.664 194.289 349.531 195.156 349.531 196.226Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M349.531 191.504C349.531 192.574 348.664 193.441 347.594 193.441C346.524 193.441 345.656 192.574 345.656 191.504C345.656 190.434 346.524 189.566 347.594 189.566C348.664 189.566 349.531 190.434 349.531 191.504Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M344.808 196.226C344.808 197.296 343.941 198.164 342.871 198.164C341.801 198.164 340.933 197.296 340.933 196.226C340.933 195.156 341.801 194.289 342.871 194.289C343.941 194.289 344.808 195.156 344.808 196.226Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M344.808 191.504C344.808 192.574 343.941 193.441 342.871 193.441C341.801 193.441 340.933 192.574 340.933 191.504C340.933 190.434 341.801 189.566 342.871 189.566C343.941 189.566 344.808 190.434 344.808 191.504Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M344.808 186.781C344.808 187.851 343.941 188.719 342.871 188.719C341.801 188.719 340.933 187.851 340.933 186.781C340.933 185.711 341.801 184.844 342.871 184.844C343.941 184.844 344.808 185.711 344.808 186.781Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M344.808 182.059C344.808 183.128 343.941 183.996 342.871 183.996C341.801 183.996 340.933 183.128 340.933 182.059C340.933 180.989 341.801 180.121 342.871 180.121C343.941 180.121 344.808 180.989 344.808 182.059Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M340.084 182.059C340.084 183.128 339.217 183.996 338.147 183.996C337.077 183.996 336.209 183.128 336.209 182.059C336.209 180.989 337.077 180.121 338.147 180.121C339.217 180.121 340.084 180.989 340.084 182.059Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M340.084 177.336C340.084 178.406 339.217 179.273 338.147 179.273C337.077 179.273 336.209 178.406 336.209 177.336C336.209 176.266 337.077 175.398 338.147 175.398C339.217 175.398 340.084 176.266 340.084 177.336Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M340.084 172.613C340.084 173.683 339.217 174.551 338.147 174.551C337.077 174.551 336.209 173.683 336.209 172.613C336.209 171.543 337.077 170.676 338.147 170.676C339.217 170.676 340.084 171.543 340.084 172.613Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M335.361 172.613C335.361 173.683 334.494 174.551 333.424 174.551C332.354 174.551 331.486 173.683 331.486 172.613C331.486 171.543 332.354 170.676 333.424 170.676C334.494 170.676 335.361 171.543 335.361 172.613Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M330.638 172.613C330.638 173.683 329.771 174.551 328.701 174.551C327.631 174.551 326.763 173.683 326.763 172.613C326.763 171.543 327.631 170.676 328.701 170.676C329.771 170.676 330.638 171.543 330.638 172.613Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M325.915 172.613C325.915 173.683 325.048 174.551 323.978 174.551C322.908 174.551 322.04 173.683 322.04 172.613C322.04 171.543 322.908 170.676 323.978 170.676C325.048 170.676 325.915 171.543 325.915 172.613Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M321.192 172.613C321.192 173.683 320.325 174.551 319.255 174.551C318.185 174.551 317.317 173.683 317.317 172.613C317.317 171.543 318.185 170.676 319.255 170.676C320.325 170.676 321.192 171.543 321.192 172.613Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M316.469 172.613C316.469 173.683 315.602 174.551 314.532 174.551C313.462 174.551 312.594 173.683 312.594 172.613C312.594 171.543 313.462 170.676 314.532 170.676C315.602 170.676 316.469 171.543 316.469 172.613Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M311.745 172.613C311.745 173.683 310.878 174.551 309.808 174.551C308.738 174.551 307.87 173.683 307.87 172.613C307.87 171.543 308.738 170.676 309.808 170.676C310.878 170.676 311.745 171.543 311.745 172.613Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M307.022 172.613C307.022 173.683 306.155 174.551 305.085 174.551C304.015 174.551 303.147 173.683 303.147 172.613C303.147 171.543 304.015 170.676 305.085 170.676C306.155 170.676 307.022 171.543 307.022 172.613Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M302.299 172.613C302.299 173.683 301.432 174.551 300.362 174.551C299.292 174.551 298.424 173.683 298.424 172.613C298.424 171.543 299.292 170.676 300.362 170.676C301.432 170.676 302.299 171.543 302.299 172.613Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M302.299 167.887C302.299 168.957 301.432 169.824 300.362 169.824C299.292 169.824 298.424 168.957 298.424 167.887C298.424 166.817 299.292 165.949 300.362 165.949C301.432 165.949 302.299 166.817 302.299 167.887Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M297.576 167.887C297.576 168.957 296.709 169.824 295.639 169.824C294.569 169.824 293.701 168.957 293.701 167.887C293.701 166.817 294.569 165.949 295.639 165.949C296.709 165.949 297.576 166.817 297.576 167.887Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M292.853 167.887C292.853 168.957 291.986 169.824 290.916 169.824C289.846 169.824 288.978 168.957 288.978 167.887C288.978 166.817 289.846 165.949 290.916 165.949C291.986 165.949 292.853 166.817 292.853 167.887Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M292.853 163.164C292.853 164.234 291.986 165.102 290.916 165.102C289.846 165.102 288.978 164.234 288.978 163.164C288.978 162.094 289.846 161.226 290.916 161.226C291.986 161.226 292.853 162.094 292.853 163.164Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M288.13 163.164C288.13 164.234 287.263 165.102 286.193 165.102C285.123 165.102 284.255 164.234 284.255 163.164C284.255 162.094 285.123 161.226 286.193 161.226C287.263 161.226 288.13 162.094 288.13 163.164Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M283.406 163.164C283.406 164.234 282.539 165.102 281.469 165.102C280.399 165.102 279.531 164.234 279.531 163.164C279.531 162.094 280.399 161.226 281.469 161.226C282.539 161.226 283.406 162.094 283.406 163.164Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M278.683 163.164C278.683 164.234 277.816 165.102 276.746 165.102C275.676 165.102 274.808 164.234 274.808 163.164C274.808 162.094 275.676 161.226 276.746 161.226C277.816 161.226 278.683 162.094 278.683 163.164Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M278.683 167.887C278.683 168.957 277.816 169.824 276.746 169.824C275.676 169.824 274.808 168.957 274.808 167.887C274.808 166.817 275.676 165.949 276.746 165.949C277.816 165.949 278.683 166.817 278.683 167.887Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M273.96 167.887C273.96 168.957 273.093 169.824 272.023 169.824C270.953 169.824 270.085 168.957 270.085 167.887C270.085 166.817 270.953 165.949 272.023 165.949C273.093 165.949 273.96 166.817 273.96 167.887Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M273.96 172.613C273.96 173.683 273.093 174.551 272.023 174.551C270.953 174.551 270.085 173.683 270.085 172.613C270.085 171.543 270.953 170.676 272.023 170.676C273.093 170.676 273.96 171.543 273.96 172.613Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M273.96 177.336C273.96 178.406 273.093 179.273 272.023 179.273C270.953 179.273 270.085 178.406 270.085 177.336C270.085 176.266 270.953 175.398 272.023 175.398C273.093 175.398 273.96 176.266 273.96 177.336Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M269.237 177.336C269.237 178.406 268.37 179.273 267.3 179.273C266.23 179.273 265.362 178.406 265.362 177.336C265.362 176.266 266.23 175.398 267.3 175.398C268.37 175.398 269.237 176.266 269.237 177.336Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M269.237 182.059C269.237 183.128 268.37 183.996 267.3 183.996C266.23 183.996 265.362 183.128 265.362 182.059C265.362 180.989 266.23 180.121 267.3 180.121C268.37 180.121 269.237 180.989 269.237 182.059Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M264.514 182.059C264.514 183.128 263.647 183.996 262.577 183.996C261.507 183.996 260.639 183.128 260.639 182.059C260.639 180.989 261.507 180.121 262.577 180.121C263.647 180.121 264.514 180.989 264.514 182.059Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M264.514 186.781C264.514 187.851 263.647 188.719 262.577 188.719C261.507 188.719 260.639 187.851 260.639 186.781C260.639 185.711 261.507 184.844 262.577 184.844C263.647 184.844 264.514 185.711 264.514 186.781Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M264.514 191.504C264.514 192.574 263.647 193.441 262.577 193.441C261.507 193.441 260.639 192.574 260.639 191.504C260.639 190.434 261.507 189.566 262.577 189.566C263.647 189.566 264.514 190.434 264.514 191.504Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M264.514 196.226C264.514 197.296 263.647 198.164 262.577 198.164C261.507 198.164 260.639 197.296 260.639 196.226C260.639 195.156 261.507 194.289 262.577 194.289C263.647 194.289 264.514 195.156 264.514 196.226Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M269.237 196.226C269.237 197.296 268.37 198.164 267.3 198.164C266.23 198.164 265.362 197.296 265.362 196.226C265.362 195.156 266.23 194.289 267.3 194.289C268.37 194.289 269.237 195.156 269.237 196.226Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M273.96 196.226C273.96 197.296 273.093 198.164 272.023 198.164C270.953 198.164 270.085 197.296 270.085 196.226C270.085 195.156 270.953 194.289 272.023 194.289C273.093 194.289 273.96 195.156 273.96 196.226Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M278.683 196.226C278.683 197.296 277.816 198.164 276.746 198.164C275.676 198.164 274.808 197.296 274.808 196.226C274.808 195.156 275.676 194.289 276.746 194.289C277.816 194.289 278.683 195.156 278.683 196.226Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M283.406 196.226C283.406 197.296 282.539 198.164 281.469 198.164C280.399 198.164 279.531 197.296 279.531 196.226C279.531 195.156 280.399 194.289 281.469 194.289C282.539 194.289 283.406 195.156 283.406 196.226Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M288.13 196.226C288.13 197.296 287.263 198.164 286.193 198.164C285.123 198.164 284.255 197.296 284.255 196.226C284.255 195.156 285.123 194.289 286.193 194.289C287.263 194.289 288.13 195.156 288.13 196.226Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M288.13 200.949C288.13 202.019 287.263 202.887 286.193 202.887C285.123 202.887 284.255 202.019 284.255 200.949C284.255 199.879 285.123 199.012 286.193 199.012C287.263 199.012 288.13 199.879 288.13 200.949Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M292.853 200.949C292.853 202.019 291.986 202.887 290.916 202.887C289.846 202.887 288.978 202.019 288.978 200.949C288.978 199.879 289.846 199.012 290.916 199.012C291.986 199.012 292.853 199.879 292.853 200.949Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M297.576 200.949C297.576 202.019 296.709 202.887 295.639 202.887C294.569 202.887 293.701 202.019 293.701 200.949C293.701 199.879 294.569 199.012 295.639 199.012C296.709 199.012 297.576 199.879 297.576 200.949Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M302.299 200.949C302.299 202.019 301.432 202.887 300.362 202.887C299.292 202.887 298.424 202.019 298.424 200.949C298.424 199.879 299.292 199.012 300.362 199.012C301.432 199.012 302.299 199.879 302.299 200.949Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M302.299 205.672C302.299 206.742 301.432 207.609 300.362 207.609C299.292 207.609 298.424 206.742 298.424 205.672C298.424 204.602 299.292 203.734 300.362 203.734C301.432 203.734 302.299 204.602 302.299 205.672Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M307.022 205.672C307.022 206.742 306.155 207.609 305.085 207.609C304.015 207.609 303.147 206.742 303.147 205.672C303.147 204.602 304.015 203.734 305.085 203.734C306.155 203.734 307.022 204.602 307.022 205.672Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M307.022 210.398C307.022 211.468 306.155 212.336 305.085 212.336C304.015 212.336 303.147 211.468 303.147 210.398C303.147 209.328 304.015 208.461 305.085 208.461C306.155 208.461 307.022 209.328 307.022 210.398Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M307.022 215.121C307.022 216.191 306.155 217.059 305.085 217.059C304.015 217.059 303.147 216.191 303.147 215.121C303.147 214.051 304.015 213.183 305.085 213.183C306.155 213.183 307.022 214.051 307.022 215.121Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M307.022 219.844C307.022 220.914 306.155 221.781 305.085 221.781C304.015 221.781 303.147 220.914 303.147 219.844C303.147 218.774 304.015 217.906 305.085 217.906C306.155 217.906 307.022 218.774 307.022 219.844Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M311.745 219.844C311.745 220.914 310.878 221.781 309.808 221.781C308.738 221.781 307.87 220.914 307.87 219.844C307.87 218.774 308.738 217.906 309.808 217.906C310.878 217.906 311.745 218.774 311.745 219.844Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M311.745 224.566C311.745 225.636 310.878 226.504 309.808 226.504C308.738 226.504 307.87 225.636 307.87 224.566C307.87 223.496 308.738 222.629 309.808 222.629C310.878 222.629 311.745 223.496 311.745 224.566Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M316.469 224.566C316.469 225.636 315.602 226.504 314.532 226.504C313.462 226.504 312.594 225.636 312.594 224.566C312.594 223.496 313.462 222.629 314.532 222.629C315.602 222.629 316.469 223.496 316.469 224.566Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M316.469 229.289C316.469 230.359 315.602 231.227 314.532 231.227C313.462 231.227 312.594 230.359 312.594 229.289C312.594 228.219 313.462 227.351 314.532 227.351C315.602 227.351 316.469 228.219 316.469 229.289Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M316.469 234.012C316.469 235.082 315.602 235.949 314.532 235.949C313.462 235.949 312.594 235.082 312.594 234.012C312.594 232.942 313.462 232.074 314.532 232.074C315.602 232.074 316.469 232.942 316.469 234.012Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M316.469 238.734C316.469 239.804 315.602 240.672 314.532 240.672C313.462 240.672 312.594 239.804 312.594 238.734C312.594 237.664 313.462 236.797 314.532 236.797C315.602 236.797 316.469 237.664 316.469 238.734Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M316.469 243.461C316.469 244.531 315.602 245.398 314.532 245.398C313.462 245.398 312.594 244.531 312.594 243.461C312.594 242.391 313.462 241.523 314.532 241.523C315.602 241.523 316.469 242.391 316.469 243.461Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M316.469 248.184C316.469 249.253 315.602 250.121 314.532 250.121C313.462 250.121 312.594 249.253 312.594 248.184C312.594 247.114 313.462 246.246 314.532 246.246C315.602 246.246 316.469 247.114 316.469 248.184Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M316.469 252.906C316.469 253.976 315.602 254.844 314.532 254.844C313.462 254.844 312.594 253.976 312.594 252.906C312.594 251.836 313.462 250.969 314.532 250.969C315.602 250.969 316.469 251.836 316.469 252.906Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M316.469 257.629C316.469 258.699 315.602 259.566 314.532 259.566C313.462 259.566 312.594 258.699 312.594 257.629C312.594 256.559 313.462 255.691 314.532 255.691C315.602 255.691 316.469 256.559 316.469 257.629Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M316.469 262.351C316.469 263.421 315.602 264.289 314.532 264.289C313.462 264.289 312.594 263.421 312.594 262.351C312.594 261.281 313.462 260.414 314.532 260.414C315.602 260.414 316.469 261.281 316.469 262.351Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M316.469 267.074C316.469 268.144 315.602 269.012 314.532 269.012C313.462 269.012 312.594 268.144 312.594 267.074C312.594 266.004 313.462 265.137 314.532 265.137C315.602 265.137 316.469 266.004 316.469 267.074Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M321.192 267.074C321.192 268.144 320.325 269.012 319.255 269.012C318.185 269.012 317.317 268.144 317.317 267.074C317.317 266.004 318.185 265.137 319.255 265.137C320.325 265.137 321.192 266.004 321.192 267.074Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M321.192 271.797C321.192 272.867 320.325 273.734 319.255 273.734C318.185 273.734 317.317 272.867 317.317 271.797C317.317 270.727 318.185 269.859 319.255 269.859C320.325 269.859 321.192 270.727 321.192 271.797Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M325.915 271.797C325.915 272.867 325.048 273.734 323.978 273.734C322.908 273.734 322.04 272.867 322.04 271.797C322.04 270.727 322.908 269.859 323.978 269.859C325.048 269.859 325.915 270.727 325.915 271.797Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M325.915 267.074C325.915 268.144 325.048 269.012 323.978 269.012C322.908 269.012 322.04 268.144 322.04 267.074C322.04 266.004 322.908 265.137 323.978 265.137C325.048 265.137 325.915 266.004 325.915 267.074Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M330.638 267.074C330.638 268.144 329.771 269.012 328.701 269.012C327.631 269.012 326.763 268.144 326.763 267.074C326.763 266.004 327.631 265.137 328.701 265.137C329.771 265.137 330.638 266.004 330.638 267.074Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M330.638 262.351C330.638 263.421 329.771 264.289 328.701 264.289C327.631 264.289 326.763 263.421 326.763 262.351C326.763 261.281 327.631 260.414 328.701 260.414C329.771 260.414 330.638 261.281 330.638 262.351Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M330.638 257.629C330.638 258.699 329.771 259.566 328.701 259.566C327.631 259.566 326.763 258.699 326.763 257.629C326.763 256.559 327.631 255.691 328.701 255.691C329.771 255.691 330.638 256.559 330.638 257.629Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M335.361 257.629C335.361 258.699 334.494 259.566 333.424 259.566C332.354 259.566 331.486 258.699 331.486 257.629C331.486 256.559 332.354 255.691 333.424 255.691C334.494 255.691 335.361 256.559 335.361 257.629Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M335.361 252.906C335.361 253.976 334.494 254.844 333.424 254.844C332.354 254.844 331.486 253.976 331.486 252.906C331.486 251.836 332.354 250.969 333.424 250.969C334.494 250.969 335.361 251.836 335.361 252.906Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M335.361 248.184C335.361 249.253 334.494 250.121 333.424 250.121C332.354 250.121 331.486 249.253 331.486 248.184C331.486 247.114 332.354 246.246 333.424 246.246C334.494 246.246 335.361 247.114 335.361 248.184Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M340.084 248.184C340.084 249.253 339.217 250.121 338.147 250.121C337.077 250.121 336.209 249.253 336.209 248.184C336.209 247.114 337.077 246.246 338.147 246.246C339.217 246.246 340.084 247.114 340.084 248.184Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M340.084 243.461C340.084 244.531 339.217 245.398 338.147 245.398C337.077 245.398 336.209 244.531 336.209 243.461C336.209 242.391 337.077 241.523 338.147 241.523C339.217 241.523 340.084 242.391 340.084 243.461Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M340.084 238.734C340.084 239.804 339.217 240.672 338.147 240.672C337.077 240.672 336.209 239.804 336.209 238.734C336.209 237.664 337.077 236.797 338.147 236.797C339.217 236.797 340.084 237.664 340.084 238.734Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M340.084 234.012C340.084 235.082 339.217 235.949 338.147 235.949C337.077 235.949 336.209 235.082 336.209 234.012C336.209 232.942 337.077 232.074 338.147 232.074C339.217 232.074 340.084 232.942 340.084 234.012Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M344.808 234.012C344.808 235.082 343.941 235.949 342.871 235.949C341.801 235.949 340.933 235.082 340.933 234.012C340.933 232.942 341.801 232.074 342.871 232.074C343.941 232.074 344.808 232.942 344.808 234.012Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M344.808 229.289C344.808 230.359 343.941 231.227 342.871 231.227C341.801 231.227 340.933 230.359 340.933 229.289C340.933 228.219 341.801 227.351 342.871 227.351C343.941 227.351 344.808 228.219 344.808 229.289Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M340.084 229.289C340.084 230.359 339.217 231.227 338.147 231.227C337.077 231.227 336.209 230.359 336.209 229.289C336.209 228.219 337.077 227.351 338.147 227.351C339.217 227.351 340.084 228.219 340.084 229.289Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M344.808 224.566C344.808 225.636 343.941 226.504 342.871 226.504C341.801 226.504 340.933 225.636 340.933 224.566C340.933 223.496 341.801 222.629 342.871 222.629C343.941 222.629 344.808 223.496 344.808 224.566Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M344.808 219.844C344.808 220.914 343.941 221.781 342.871 221.781C341.801 221.781 340.933 220.914 340.933 219.844C340.933 218.774 341.801 217.906 342.871 217.906C343.941 217.906 344.808 218.774 344.808 219.844Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M344.808 215.121C344.808 216.191 343.941 217.059 342.871 217.059C341.801 217.059 340.933 216.191 340.933 215.121C340.933 214.051 341.801 213.183 342.871 213.183C343.941 213.183 344.808 214.051 344.808 215.121Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M349.531 215.121C349.531 216.191 348.664 217.059 347.594 217.059C346.524 217.059 345.656 216.191 345.656 215.121C345.656 214.051 346.524 213.183 347.594 213.183C348.664 213.183 349.531 214.051 349.531 215.121Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M349.531 210.398C349.531 211.468 348.664 212.336 347.594 212.336C346.524 212.336 345.656 211.468 345.656 210.398C345.656 209.328 346.524 208.461 347.594 208.461C348.664 208.461 349.531 209.328 349.531 210.398Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M354.254 210.398C354.254 211.468 353.387 212.336 352.317 212.336C351.247 212.336 350.379 211.468 350.379 210.398C350.379 209.328 351.247 208.461 352.317 208.461C353.387 208.461 354.254 209.328 354.254 210.398Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M349.531 205.672C349.531 206.742 348.664 207.609 347.594 207.609C346.524 207.609 345.656 206.742 345.656 205.672C345.656 204.602 346.524 203.734 347.594 203.734C348.664 203.734 349.531 204.602 349.531 205.672Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M344.808 205.672C344.808 206.742 343.941 207.609 342.871 207.609C341.801 207.609 340.933 206.742 340.933 205.672C340.933 204.602 341.801 203.734 342.871 203.734C343.941 203.734 344.808 204.602 344.808 205.672Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M344.808 210.398C344.808 211.468 343.941 212.336 342.871 212.336C341.801 212.336 340.933 211.468 340.933 210.398C340.933 209.328 341.801 208.461 342.871 208.461C343.941 208.461 344.808 209.328 344.808 210.398Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M340.084 210.398C340.084 211.468 339.217 212.336 338.147 212.336C337.077 212.336 336.209 211.468 336.209 210.398C336.209 209.328 337.077 208.461 338.147 208.461C339.217 208.461 340.084 209.328 340.084 210.398Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M340.084 205.672C340.084 206.742 339.217 207.609 338.147 207.609C337.077 207.609 336.209 206.742 336.209 205.672C336.209 204.602 337.077 203.734 338.147 203.734C339.217 203.734 340.084 204.602 340.084 205.672Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M340.084 200.949C340.084 202.019 339.217 202.887 338.147 202.887C337.077 202.887 336.209 202.019 336.209 200.949C336.209 199.879 337.077 199.012 338.147 199.012C339.217 199.012 340.084 199.879 340.084 200.949Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M344.808 200.949C344.808 202.019 343.941 202.887 342.871 202.887C341.801 202.887 340.933 202.019 340.933 200.949C340.933 199.879 341.801 199.012 342.871 199.012C343.941 199.012 344.808 199.879 344.808 200.949Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M340.084 196.226C340.084 197.296 339.217 198.164 338.147 198.164C337.077 198.164 336.209 197.296 336.209 196.226C336.209 195.156 337.077 194.289 338.147 194.289C339.217 194.289 340.084 195.156 340.084 196.226Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M340.084 191.504C340.084 192.574 339.217 193.441 338.147 193.441C337.077 193.441 336.209 192.574 336.209 191.504C336.209 190.434 337.077 189.566 338.147 189.566C339.217 189.566 340.084 190.434 340.084 191.504Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M340.084 186.781C340.084 187.851 339.217 188.719 338.147 188.719C337.077 188.719 336.209 187.851 336.209 186.781C336.209 185.711 337.077 184.844 338.147 184.844C339.217 184.844 340.084 185.711 340.084 186.781Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M335.361 186.781C335.361 187.851 334.494 188.719 333.424 188.719C332.354 188.719 331.486 187.851 331.486 186.781C331.486 185.711 332.354 184.844 333.424 184.844C334.494 184.844 335.361 185.711 335.361 186.781Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M335.361 182.059C335.361 183.128 334.494 183.996 333.424 183.996C332.354 183.996 331.486 183.128 331.486 182.059C331.486 180.989 332.354 180.121 333.424 180.121C334.494 180.121 335.361 180.989 335.361 182.059Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M335.361 177.336C335.361 178.406 334.494 179.273 333.424 179.273C332.354 179.273 331.486 178.406 331.486 177.336C331.486 176.266 332.354 175.398 333.424 175.398C334.494 175.398 335.361 176.266 335.361 177.336Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M330.638 177.336C330.638 178.406 329.771 179.273 328.701 179.273C327.631 179.273 326.763 178.406 326.763 177.336C326.763 176.266 327.631 175.398 328.701 175.398C329.771 175.398 330.638 176.266 330.638 177.336Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M325.915 177.336C325.915 178.406 325.048 179.273 323.978 179.273C322.908 179.273 322.04 178.406 322.04 177.336C322.04 176.266 322.908 175.398 323.978 175.398C325.048 175.398 325.915 176.266 325.915 177.336Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M321.192 177.336C321.192 178.406 320.325 179.273 319.255 179.273C318.185 179.273 317.317 178.406 317.317 177.336C317.317 176.266 318.185 175.398 319.255 175.398C320.325 175.398 321.192 176.266 321.192 177.336Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M316.469 177.336C316.469 178.406 315.602 179.273 314.532 179.273C313.462 179.273 312.594 178.406 312.594 177.336C312.594 176.266 313.462 175.398 314.532 175.398C315.602 175.398 316.469 176.266 316.469 177.336Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M311.745 177.336C311.745 178.406 310.878 179.273 309.808 179.273C308.738 179.273 307.87 178.406 307.87 177.336C307.87 176.266 308.738 175.398 309.808 175.398C310.878 175.398 311.745 176.266 311.745 177.336Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M307.022 177.336C307.022 178.406 306.155 179.273 305.085 179.273C304.015 179.273 303.147 178.406 303.147 177.336C303.147 176.266 304.015 175.398 305.085 175.398C306.155 175.398 307.022 176.266 307.022 177.336Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M302.299 177.336C302.299 178.406 301.432 179.273 300.362 179.273C299.292 179.273 298.424 178.406 298.424 177.336C298.424 176.266 299.292 175.398 300.362 175.398C301.432 175.398 302.299 176.266 302.299 177.336Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M297.576 177.336C297.576 178.406 296.709 179.273 295.639 179.273C294.569 179.273 293.701 178.406 293.701 177.336C293.701 176.266 294.569 175.398 295.639 175.398C296.709 175.398 297.576 176.266 297.576 177.336Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M297.576 172.613C297.576 173.683 296.709 174.551 295.639 174.551C294.569 174.551 293.701 173.683 293.701 172.613C293.701 171.543 294.569 170.676 295.639 170.676C296.709 170.676 297.576 171.543 297.576 172.613Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M292.853 172.613C292.853 173.683 291.986 174.551 290.916 174.551C289.846 174.551 288.978 173.683 288.978 172.613C288.978 171.543 289.846 170.676 290.916 170.676C291.986 170.676 292.853 171.543 292.853 172.613Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M288.13 172.613C288.13 173.683 287.263 174.551 286.193 174.551C285.123 174.551 284.255 173.683 284.255 172.613C284.255 171.543 285.123 170.676 286.193 170.676C287.263 170.676 288.13 171.543 288.13 172.613Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M288.13 167.887C288.13 168.957 287.263 169.824 286.193 169.824C285.123 169.824 284.255 168.957 284.255 167.887C284.255 166.817 285.123 165.949 286.193 165.949C287.263 165.949 288.13 166.817 288.13 167.887Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M283.406 167.887C283.406 168.957 282.539 169.824 281.469 169.824C280.399 169.824 279.531 168.957 279.531 167.887C279.531 166.817 280.399 165.949 281.469 165.949C282.539 165.949 283.406 166.817 283.406 167.887Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M283.406 172.613C283.406 173.683 282.539 174.551 281.469 174.551C280.399 174.551 279.531 173.683 279.531 172.613C279.531 171.543 280.399 170.676 281.469 170.676C282.539 170.676 283.406 171.543 283.406 172.613Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M278.683 172.613C278.683 173.683 277.816 174.551 276.746 174.551C275.676 174.551 274.808 173.683 274.808 172.613C274.808 171.543 275.676 170.676 276.746 170.676C277.816 170.676 278.683 171.543 278.683 172.613Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M278.683 177.336C278.683 178.406 277.816 179.273 276.746 179.273C275.676 179.273 274.808 178.406 274.808 177.336C274.808 176.266 275.676 175.398 276.746 175.398C277.816 175.398 278.683 176.266 278.683 177.336Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M278.683 182.059C278.683 183.128 277.816 183.996 276.746 183.996C275.676 183.996 274.808 183.128 274.808 182.059C274.808 180.989 275.676 180.121 276.746 180.121C277.816 180.121 278.683 180.989 278.683 182.059Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M273.96 182.059C273.96 183.128 273.093 183.996 272.023 183.996C270.953 183.996 270.085 183.128 270.085 182.059C270.085 180.989 270.953 180.121 272.023 180.121C273.093 180.121 273.96 180.989 273.96 182.059Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M273.96 186.781C273.96 187.851 273.093 188.719 272.023 188.719C270.953 188.719 270.085 187.851 270.085 186.781C270.085 185.711 270.953 184.844 272.023 184.844C273.093 184.844 273.96 185.711 273.96 186.781Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M269.237 186.781C269.237 187.851 268.37 188.719 267.3 188.719C266.23 188.719 265.362 187.851 265.362 186.781C265.362 185.711 266.23 184.844 267.3 184.844C268.37 184.844 269.237 185.711 269.237 186.781Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M269.237 191.504C269.237 192.574 268.37 193.441 267.3 193.441C266.23 193.441 265.362 192.574 265.362 191.504C265.362 190.434 266.23 189.566 267.3 189.566C268.37 189.566 269.237 190.434 269.237 191.504Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M273.96 191.504C273.96 192.574 273.093 193.441 272.023 193.441C270.953 193.441 270.085 192.574 270.085 191.504C270.085 190.434 270.953 189.566 272.023 189.566C273.093 189.566 273.96 190.434 273.96 191.504Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M278.683 191.504C278.683 192.574 277.816 193.441 276.746 193.441C275.676 193.441 274.808 192.574 274.808 191.504C274.808 190.434 275.676 189.566 276.746 189.566C277.816 189.566 278.683 190.434 278.683 191.504Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M283.406 191.504C283.406 192.574 282.539 193.441 281.469 193.441C280.399 193.441 279.531 192.574 279.531 191.504C279.531 190.434 280.399 189.566 281.469 189.566C282.539 189.566 283.406 190.434 283.406 191.504Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M288.13 191.504C288.13 192.574 287.263 193.441 286.193 193.441C285.123 193.441 284.255 192.574 284.255 191.504C284.255 190.434 285.123 189.566 286.193 189.566C287.263 189.566 288.13 190.434 288.13 191.504Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M292.853 191.504C292.853 192.574 291.986 193.441 290.916 193.441C289.846 193.441 288.978 192.574 288.978 191.504C288.978 190.434 289.846 189.566 290.916 189.566C291.986 189.566 292.853 190.434 292.853 191.504Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M297.576 191.504C297.576 192.574 296.709 193.441 295.639 193.441C294.569 193.441 293.701 192.574 293.701 191.504C293.701 190.434 294.569 189.566 295.639 189.566C296.709 189.566 297.576 190.434 297.576 191.504Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M292.853 196.226C292.853 197.296 291.986 198.164 290.916 198.164C289.846 198.164 288.978 197.296 288.978 196.226C288.978 195.156 289.846 194.289 290.916 194.289C291.986 194.289 292.853 195.156 292.853 196.226Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M297.576 196.226C297.576 197.296 296.709 198.164 295.639 198.164C294.569 198.164 293.701 197.296 293.701 196.226C293.701 195.156 294.569 194.289 295.639 194.289C296.709 194.289 297.576 195.156 297.576 196.226Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M302.299 196.226C302.299 197.296 301.432 198.164 300.362 198.164C299.292 198.164 298.424 197.296 298.424 196.226C298.424 195.156 299.292 194.289 300.362 194.289C301.432 194.289 302.299 195.156 302.299 196.226Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M307.022 196.226C307.022 197.296 306.155 198.164 305.085 198.164C304.015 198.164 303.147 197.296 303.147 196.226C303.147 195.156 304.015 194.289 305.085 194.289C306.155 194.289 307.022 195.156 307.022 196.226Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M307.022 200.949C307.022 202.019 306.155 202.887 305.085 202.887C304.015 202.887 303.147 202.019 303.147 200.949C303.147 199.879 304.015 199.012 305.085 199.012C306.155 199.012 307.022 199.879 307.022 200.949Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M311.745 200.949C311.745 202.019 310.878 202.887 309.808 202.887C308.738 202.887 307.87 202.019 307.87 200.949C307.87 199.879 308.738 199.012 309.808 199.012C310.878 199.012 311.745 199.879 311.745 200.949Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M311.745 205.672C311.745 206.742 310.878 207.609 309.808 207.609C308.738 207.609 307.87 206.742 307.87 205.672C307.87 204.602 308.738 203.734 309.808 203.734C310.878 203.734 311.745 204.602 311.745 205.672Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M311.745 210.398C311.745 211.468 310.878 212.336 309.808 212.336C308.738 212.336 307.87 211.468 307.87 210.398C307.87 209.328 308.738 208.461 309.808 208.461C310.878 208.461 311.745 209.328 311.745 210.398Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M311.745 215.121C311.745 216.191 310.878 217.059 309.808 217.059C308.738 217.059 307.87 216.191 307.87 215.121C307.87 214.051 308.738 213.183 309.808 213.183C310.878 213.183 311.745 214.051 311.745 215.121Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M316.469 215.121C316.469 216.191 315.602 217.059 314.532 217.059C313.462 217.059 312.594 216.191 312.594 215.121C312.594 214.051 313.462 213.183 314.532 213.183C315.602 213.183 316.469 214.051 316.469 215.121Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M316.469 219.844C316.469 220.914 315.602 221.781 314.532 221.781C313.462 221.781 312.594 220.914 312.594 219.844C312.594 218.774 313.462 217.906 314.532 217.906C315.602 217.906 316.469 218.774 316.469 219.844Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M321.192 219.844C321.192 220.914 320.325 221.781 319.255 221.781C318.185 221.781 317.317 220.914 317.317 219.844C317.317 218.774 318.185 217.906 319.255 217.906C320.325 217.906 321.192 218.774 321.192 219.844Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M321.192 224.566C321.192 225.636 320.325 226.504 319.255 226.504C318.185 226.504 317.317 225.636 317.317 224.566C317.317 223.496 318.185 222.629 319.255 222.629C320.325 222.629 321.192 223.496 321.192 224.566Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M321.192 229.289C321.192 230.359 320.325 231.227 319.255 231.227C318.185 231.227 317.317 230.359 317.317 229.289C317.317 228.219 318.185 227.351 319.255 227.351C320.325 227.351 321.192 228.219 321.192 229.289Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M321.192 234.012C321.192 235.082 320.325 235.949 319.255 235.949C318.185 235.949 317.317 235.082 317.317 234.012C317.317 232.942 318.185 232.074 319.255 232.074C320.325 232.074 321.192 232.942 321.192 234.012Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M321.192 238.734C321.192 239.804 320.325 240.672 319.255 240.672C318.185 240.672 317.317 239.804 317.317 238.734C317.317 237.664 318.185 236.797 319.255 236.797C320.325 236.797 321.192 237.664 321.192 238.734Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M321.192 243.461C321.192 244.531 320.325 245.398 319.255 245.398C318.185 245.398 317.317 244.531 317.317 243.461C317.317 242.391 318.185 241.523 319.255 241.523C320.325 241.523 321.192 242.391 321.192 243.461Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M321.192 248.184C321.192 249.253 320.325 250.121 319.255 250.121C318.185 250.121 317.317 249.253 317.317 248.184C317.317 247.114 318.185 246.246 319.255 246.246C320.325 246.246 321.192 247.114 321.192 248.184Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M321.192 252.906C321.192 253.976 320.325 254.844 319.255 254.844C318.185 254.844 317.317 253.976 317.317 252.906C317.317 251.836 318.185 250.969 319.255 250.969C320.325 250.969 321.192 251.836 321.192 252.906Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M321.192 257.629C321.192 258.699 320.325 259.566 319.255 259.566C318.185 259.566 317.317 258.699 317.317 257.629C317.317 256.559 318.185 255.691 319.255 255.691C320.325 255.691 321.192 256.559 321.192 257.629Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M321.192 262.351C321.192 263.421 320.325 264.289 319.255 264.289C318.185 264.289 317.317 263.421 317.317 262.351C317.317 261.281 318.185 260.414 319.255 260.414C320.325 260.414 321.192 261.281 321.192 262.351Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M325.915 262.351C325.915 263.421 325.048 264.289 323.978 264.289C322.908 264.289 322.04 263.421 322.04 262.351C322.04 261.281 322.908 260.414 323.978 260.414C325.048 260.414 325.915 261.281 325.915 262.351Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M325.915 257.629C325.915 258.699 325.048 259.566 323.978 259.566C322.908 259.566 322.04 258.699 322.04 257.629C322.04 256.559 322.908 255.691 323.978 255.691C325.048 255.691 325.915 256.559 325.915 257.629Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M325.915 252.906C325.915 253.976 325.048 254.844 323.978 254.844C322.908 254.844 322.04 253.976 322.04 252.906C322.04 251.836 322.908 250.969 323.978 250.969C325.048 250.969 325.915 251.836 325.915 252.906Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M330.638 252.906C330.638 253.976 329.771 254.844 328.701 254.844C327.631 254.844 326.763 253.976 326.763 252.906C326.763 251.836 327.631 250.969 328.701 250.969C329.771 250.969 330.638 251.836 330.638 252.906Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M325.915 248.184C325.915 249.253 325.048 250.121 323.978 250.121C322.908 250.121 322.04 249.253 322.04 248.184C322.04 247.114 322.908 246.246 323.978 246.246C325.048 246.246 325.915 247.114 325.915 248.184Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M325.915 243.461C325.915 244.531 325.048 245.398 323.978 245.398C322.908 245.398 322.04 244.531 322.04 243.461C322.04 242.391 322.908 241.523 323.978 241.523C325.048 241.523 325.915 242.391 325.915 243.461Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M325.915 238.734C325.915 239.804 325.048 240.672 323.978 240.672C322.908 240.672 322.04 239.804 322.04 238.734C322.04 237.664 322.908 236.797 323.978 236.797C325.048 236.797 325.915 237.664 325.915 238.734Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M325.915 234.012C325.915 235.082 325.048 235.949 323.978 235.949C322.908 235.949 322.04 235.082 322.04 234.012C322.04 232.942 322.908 232.074 323.978 232.074C325.048 232.074 325.915 232.942 325.915 234.012Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M325.915 229.289C325.915 230.359 325.048 231.227 323.978 231.227C322.908 231.227 322.04 230.359 322.04 229.289C322.04 228.219 322.908 227.351 323.978 227.351C325.048 227.351 325.915 228.219 325.915 229.289Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M325.915 224.566C325.915 225.636 325.048 226.504 323.978 226.504C322.908 226.504 322.04 225.636 322.04 224.566C322.04 223.496 322.908 222.629 323.978 222.629C325.048 222.629 325.915 223.496 325.915 224.566Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M325.915 219.844C325.915 220.914 325.048 221.781 323.978 221.781C322.908 221.781 322.04 220.914 322.04 219.844C322.04 218.774 322.908 217.906 323.978 217.906C325.048 217.906 325.915 218.774 325.915 219.844Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M330.638 219.844C330.638 220.914 329.771 221.781 328.701 221.781C327.631 221.781 326.763 220.914 326.763 219.844C326.763 218.774 327.631 217.906 328.701 217.906C329.771 217.906 330.638 218.774 330.638 219.844Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M330.638 215.121C330.638 216.191 329.771 217.059 328.701 217.059C327.631 217.059 326.763 216.191 326.763 215.121C326.763 214.051 327.631 213.183 328.701 213.183C329.771 213.183 330.638 214.051 330.638 215.121Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M330.638 210.398C330.638 211.468 329.771 212.336 328.701 212.336C327.631 212.336 326.763 211.468 326.763 210.398C326.763 209.328 327.631 208.461 328.701 208.461C329.771 208.461 330.638 209.328 330.638 210.398Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M330.638 205.672C330.638 206.742 329.771 207.609 328.701 207.609C327.631 207.609 326.763 206.742 326.763 205.672C326.763 204.602 327.631 203.734 328.701 203.734C329.771 203.734 330.638 204.602 330.638 205.672Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M335.361 205.672C335.361 206.742 334.494 207.609 333.424 207.609C332.354 207.609 331.486 206.742 331.486 205.672C331.486 204.602 332.354 203.734 333.424 203.734C334.494 203.734 335.361 204.602 335.361 205.672Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M335.361 200.949C335.361 202.019 334.494 202.887 333.424 202.887C332.354 202.887 331.486 202.019 331.486 200.949C331.486 199.879 332.354 199.012 333.424 199.012C334.494 199.012 335.361 199.879 335.361 200.949Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M335.361 196.226C335.361 197.296 334.494 198.164 333.424 198.164C332.354 198.164 331.486 197.296 331.486 196.226C331.486 195.156 332.354 194.289 333.424 194.289C334.494 194.289 335.361 195.156 335.361 196.226Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M335.361 191.504C335.361 192.574 334.494 193.441 333.424 193.441C332.354 193.441 331.486 192.574 331.486 191.504C331.486 190.434 332.354 189.566 333.424 189.566C334.494 189.566 335.361 190.434 335.361 191.504Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M330.638 191.504C330.638 192.574 329.771 193.441 328.701 193.441C327.631 193.441 326.763 192.574 326.763 191.504C326.763 190.434 327.631 189.566 328.701 189.566C329.771 189.566 330.638 190.434 330.638 191.504Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M330.638 186.781C330.638 187.851 329.771 188.719 328.701 188.719C327.631 188.719 326.763 187.851 326.763 186.781C326.763 185.711 327.631 184.844 328.701 184.844C329.771 184.844 330.638 185.711 330.638 186.781Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M330.638 182.059C330.638 183.128 329.771 183.996 328.701 183.996C327.631 183.996 326.763 183.128 326.763 182.059C326.763 180.989 327.631 180.121 328.701 180.121C329.771 180.121 330.638 180.989 330.638 182.059Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M325.915 182.059C325.915 183.128 325.048 183.996 323.978 183.996C322.908 183.996 322.04 183.128 322.04 182.059C322.04 180.989 322.908 180.121 323.978 180.121C325.048 180.121 325.915 180.989 325.915 182.059Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M321.192 182.059C321.192 183.128 320.325 183.996 319.255 183.996C318.185 183.996 317.317 183.128 317.317 182.059C317.317 180.989 318.185 180.121 319.255 180.121C320.325 180.121 321.192 180.989 321.192 182.059Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M316.469 182.059C316.469 183.128 315.602 183.996 314.532 183.996C313.462 183.996 312.594 183.128 312.594 182.059C312.594 180.989 313.462 180.121 314.532 180.121C315.602 180.121 316.469 180.989 316.469 182.059Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M311.745 182.059C311.745 183.128 310.878 183.996 309.808 183.996C308.738 183.996 307.87 183.128 307.87 182.059C307.87 180.989 308.738 180.121 309.808 180.121C310.878 180.121 311.745 180.989 311.745 182.059Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M307.022 182.059C307.022 183.128 306.155 183.996 305.085 183.996C304.015 183.996 303.147 183.128 303.147 182.059C303.147 180.989 304.015 180.121 305.085 180.121C306.155 180.121 307.022 180.989 307.022 182.059Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M302.299 182.059C302.299 183.128 301.432 183.996 300.362 183.996C299.292 183.996 298.424 183.128 298.424 182.059C298.424 180.989 299.292 180.121 300.362 180.121C301.432 180.121 302.299 180.989 302.299 182.059Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M297.576 182.059C297.576 183.128 296.709 183.996 295.639 183.996C294.569 183.996 293.701 183.128 293.701 182.059C293.701 180.989 294.569 180.121 295.639 180.121C296.709 180.121 297.576 180.989 297.576 182.059Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M292.853 182.059C292.853 183.128 291.986 183.996 290.916 183.996C289.846 183.996 288.978 183.128 288.978 182.059C288.978 180.989 289.846 180.121 290.916 180.121C291.986 180.121 292.853 180.989 292.853 182.059Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M292.853 177.336C292.853 178.406 291.986 179.273 290.916 179.273C289.846 179.273 288.978 178.406 288.978 177.336C288.978 176.266 289.846 175.398 290.916 175.398C291.986 175.398 292.853 176.266 292.853 177.336Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M288.13 177.336C288.13 178.406 287.263 179.273 286.193 179.273C285.123 179.273 284.255 178.406 284.255 177.336C284.255 176.266 285.123 175.398 286.193 175.398C287.263 175.398 288.13 176.266 288.13 177.336Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M283.406 177.336C283.406 178.406 282.539 179.273 281.469 179.273C280.399 179.273 279.531 178.406 279.531 177.336C279.531 176.266 280.399 175.398 281.469 175.398C282.539 175.398 283.406 176.266 283.406 177.336Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M283.406 182.059C283.406 183.128 282.539 183.996 281.469 183.996C280.399 183.996 279.531 183.128 279.531 182.059C279.531 180.989 280.399 180.121 281.469 180.121C282.539 180.121 283.406 180.989 283.406 182.059Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M288.13 182.059C288.13 183.128 287.263 183.996 286.193 183.996C285.123 183.996 284.255 183.128 284.255 182.059C284.255 180.989 285.123 180.121 286.193 180.121C287.263 180.121 288.13 180.989 288.13 182.059Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M278.683 186.781C278.683 187.851 277.816 188.719 276.746 188.719C275.676 188.719 274.808 187.851 274.808 186.781C274.808 185.711 275.676 184.844 276.746 184.844C277.816 184.844 278.683 185.711 278.683 186.781Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M283.406 186.781C283.406 187.851 282.539 188.719 281.469 188.719C280.399 188.719 279.531 187.851 279.531 186.781C279.531 185.711 280.399 184.844 281.469 184.844C282.539 184.844 283.406 185.711 283.406 186.781Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M288.13 186.781C288.13 187.851 287.263 188.719 286.193 188.719C285.123 188.719 284.255 187.851 284.255 186.781C284.255 185.711 285.123 184.844 286.193 184.844C287.263 184.844 288.13 185.711 288.13 186.781Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M292.853 186.781C292.853 187.851 291.986 188.719 290.916 188.719C289.846 188.719 288.978 187.851 288.978 186.781C288.978 185.711 289.846 184.844 290.916 184.844C291.986 184.844 292.853 185.711 292.853 186.781Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M297.576 186.781C297.576 187.851 296.709 188.719 295.639 188.719C294.569 188.719 293.701 187.851 293.701 186.781C293.701 185.711 294.569 184.844 295.639 184.844C296.709 184.844 297.576 185.711 297.576 186.781Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M302.299 186.781C302.299 187.851 301.432 188.719 300.362 188.719C299.292 188.719 298.424 187.851 298.424 186.781C298.424 185.711 299.292 184.844 300.362 184.844C301.432 184.844 302.299 185.711 302.299 186.781Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M307.022 186.781C307.022 187.851 306.155 188.719 305.085 188.719C304.015 188.719 303.147 187.851 303.147 186.781C303.147 185.711 304.015 184.844 305.085 184.844C306.155 184.844 307.022 185.711 307.022 186.781Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M311.745 186.781C311.745 187.851 310.878 188.719 309.808 188.719C308.738 188.719 307.87 187.851 307.87 186.781C307.87 185.711 308.738 184.844 309.808 184.844C310.878 184.844 311.745 185.711 311.745 186.781Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M316.469 186.781C316.469 187.851 315.602 188.719 314.532 188.719C313.462 188.719 312.594 187.851 312.594 186.781C312.594 185.711 313.462 184.844 314.532 184.844C315.602 184.844 316.469 185.711 316.469 186.781Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M321.192 186.781C321.192 187.851 320.325 188.719 319.255 188.719C318.185 188.719 317.317 187.851 317.317 186.781C317.317 185.711 318.185 184.844 319.255 184.844C320.325 184.844 321.192 185.711 321.192 186.781Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M325.915 186.781C325.915 187.851 325.048 188.719 323.978 188.719C322.908 188.719 322.04 187.851 322.04 186.781C322.04 185.711 322.908 184.844 323.978 184.844C325.048 184.844 325.915 185.711 325.915 186.781Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M325.915 191.504C325.915 192.574 325.048 193.441 323.978 193.441C322.908 193.441 322.04 192.574 322.04 191.504C322.04 190.434 322.908 189.566 323.978 189.566C325.048 189.566 325.915 190.434 325.915 191.504Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M325.915 196.226C325.915 197.296 325.048 198.164 323.978 198.164C322.908 198.164 322.04 197.296 322.04 196.226C322.04 195.156 322.908 194.289 323.978 194.289C325.048 194.289 325.915 195.156 325.915 196.226Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M325.915 200.949C325.915 202.019 325.048 202.887 323.978 202.887C322.908 202.887 322.04 202.019 322.04 200.949C322.04 199.879 322.908 199.012 323.978 199.012C325.048 199.012 325.915 199.879 325.915 200.949Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M330.638 200.949C330.638 202.019 329.771 202.887 328.701 202.887C327.631 202.887 326.763 202.019 326.763 200.949C326.763 199.879 327.631 199.012 328.701 199.012C329.771 199.012 330.638 199.879 330.638 200.949Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M330.638 196.226C330.638 197.296 329.771 198.164 328.701 198.164C327.631 198.164 326.763 197.296 326.763 196.226C326.763 195.156 327.631 194.289 328.701 194.289C329.771 194.289 330.638 195.156 330.638 196.226Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M325.915 205.672C325.915 206.742 325.048 207.609 323.978 207.609C322.908 207.609 322.04 206.742 322.04 205.672C322.04 204.602 322.908 203.734 323.978 203.734C325.048 203.734 325.915 204.602 325.915 205.672Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M325.915 210.398C325.915 211.468 325.048 212.336 323.978 212.336C322.908 212.336 322.04 211.468 322.04 210.398C322.04 209.328 322.908 208.461 323.978 208.461C325.048 208.461 325.915 209.328 325.915 210.398Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M325.915 215.121C325.915 216.191 325.048 217.059 323.978 217.059C322.908 217.059 322.04 216.191 322.04 215.121C322.04 214.051 322.908 213.183 323.978 213.183C325.048 213.183 325.915 214.051 325.915 215.121Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M321.192 215.121C321.192 216.191 320.325 217.059 319.255 217.059C318.185 217.059 317.317 216.191 317.317 215.121C317.317 214.051 318.185 213.183 319.255 213.183C320.325 213.183 321.192 214.051 321.192 215.121Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M321.192 210.398C321.192 211.468 320.325 212.336 319.255 212.336C318.185 212.336 317.317 211.468 317.317 210.398C317.317 209.328 318.185 208.461 319.255 208.461C320.325 208.461 321.192 209.328 321.192 210.398Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M316.469 210.398C316.469 211.468 315.602 212.336 314.532 212.336C313.462 212.336 312.594 211.468 312.594 210.398C312.594 209.328 313.462 208.461 314.532 208.461C315.602 208.461 316.469 209.328 316.469 210.398Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M316.469 205.672C316.469 206.742 315.602 207.609 314.532 207.609C313.462 207.609 312.594 206.742 312.594 205.672C312.594 204.602 313.462 203.734 314.532 203.734C315.602 203.734 316.469 204.602 316.469 205.672Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M321.192 205.672C321.192 206.742 320.325 207.609 319.255 207.609C318.185 207.609 317.317 206.742 317.317 205.672C317.317 204.602 318.185 203.734 319.255 203.734C320.325 203.734 321.192 204.602 321.192 205.672Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M321.192 200.949C321.192 202.019 320.325 202.887 319.255 202.887C318.185 202.887 317.317 202.019 317.317 200.949C317.317 199.879 318.185 199.012 319.255 199.012C320.325 199.012 321.192 199.879 321.192 200.949Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M316.469 200.949C316.469 202.019 315.602 202.887 314.532 202.887C313.462 202.887 312.594 202.019 312.594 200.949C312.594 199.879 313.462 199.012 314.532 199.012C315.602 199.012 316.469 199.879 316.469 200.949Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M316.469 196.226C316.469 197.296 315.602 198.164 314.532 198.164C313.462 198.164 312.594 197.296 312.594 196.226C312.594 195.156 313.462 194.289 314.532 194.289C315.602 194.289 316.469 195.156 316.469 196.226Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M321.192 196.226C321.192 197.296 320.325 198.164 319.255 198.164C318.185 198.164 317.317 197.296 317.317 196.226C317.317 195.156 318.185 194.289 319.255 194.289C320.325 194.289 321.192 195.156 321.192 196.226Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M321.192 191.504C321.192 192.574 320.325 193.441 319.255 193.441C318.185 193.441 317.317 192.574 317.317 191.504C317.317 190.434 318.185 189.566 319.255 189.566C320.325 189.566 321.192 190.434 321.192 191.504Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M316.469 191.504C316.469 192.574 315.602 193.441 314.532 193.441C313.462 193.441 312.594 192.574 312.594 191.504C312.594 190.434 313.462 189.566 314.532 189.566C315.602 189.566 316.469 190.434 316.469 191.504Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M311.745 191.504C311.745 192.574 310.878 193.441 309.808 193.441C308.738 193.441 307.87 192.574 307.87 191.504C307.87 190.434 308.738 189.566 309.808 189.566C310.878 189.566 311.745 190.434 311.745 191.504Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M311.745 196.226C311.745 197.296 310.878 198.164 309.808 198.164C308.738 198.164 307.87 197.296 307.87 196.226C307.87 195.156 308.738 194.289 309.808 194.289C310.878 194.289 311.745 195.156 311.745 196.226Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M307.022 191.504C307.022 192.574 306.155 193.441 305.085 193.441C304.015 193.441 303.147 192.574 303.147 191.504C303.147 190.434 304.015 189.566 305.085 189.566C306.155 189.566 307.022 190.434 307.022 191.504Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M302.299 191.504C302.299 192.574 301.432 193.441 300.362 193.441C299.292 193.441 298.424 192.574 298.424 191.504C298.424 190.434 299.292 189.566 300.362 189.566C301.432 189.566 302.299 190.434 302.299 191.504Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M330.638 248.184C330.638 249.253 329.771 250.121 328.701 250.121C327.631 250.121 326.763 249.253 326.763 248.184C326.763 247.114 327.631 246.246 328.701 246.246C329.771 246.246 330.638 247.114 330.638 248.184Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M330.638 243.461C330.638 244.531 329.771 245.398 328.701 245.398C327.631 245.398 326.763 244.531 326.763 243.461C326.763 242.391 327.631 241.523 328.701 241.523C329.771 241.523 330.638 242.391 330.638 243.461Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M335.361 243.461C335.361 244.531 334.494 245.398 333.424 245.398C332.354 245.398 331.486 244.531 331.486 243.461C331.486 242.391 332.354 241.523 333.424 241.523C334.494 241.523 335.361 242.391 335.361 243.461Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M335.361 238.734C335.361 239.804 334.494 240.672 333.424 240.672C332.354 240.672 331.486 239.804 331.486 238.734C331.486 237.664 332.354 236.797 333.424 236.797C334.494 236.797 335.361 237.664 335.361 238.734Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M330.638 238.734C330.638 239.804 329.771 240.672 328.701 240.672C327.631 240.672 326.763 239.804 326.763 238.734C326.763 237.664 327.631 236.797 328.701 236.797C329.771 236.797 330.638 237.664 330.638 238.734Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M330.638 234.012C330.638 235.082 329.771 235.949 328.701 235.949C327.631 235.949 326.763 235.082 326.763 234.012C326.763 232.942 327.631 232.074 328.701 232.074C329.771 232.074 330.638 232.942 330.638 234.012Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M330.638 229.289C330.638 230.359 329.771 231.227 328.701 231.227C327.631 231.227 326.763 230.359 326.763 229.289C326.763 228.219 327.631 227.351 328.701 227.351C329.771 227.351 330.638 228.219 330.638 229.289Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M335.361 224.566C335.361 225.636 334.494 226.504 333.424 226.504C332.354 226.504 331.486 225.636 331.486 224.566C331.486 223.496 332.354 222.629 333.424 222.629C334.494 222.629 335.361 223.496 335.361 224.566Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M335.361 219.844C335.361 220.914 334.494 221.781 333.424 221.781C332.354 221.781 331.486 220.914 331.486 219.844C331.486 218.774 332.354 217.906 333.424 217.906C334.494 217.906 335.361 218.774 335.361 219.844Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M335.361 215.121C335.361 216.191 334.494 217.059 333.424 217.059C332.354 217.059 331.486 216.191 331.486 215.121C331.486 214.051 332.354 213.183 333.424 213.183C334.494 213.183 335.361 214.051 335.361 215.121Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M340.084 215.121C340.084 216.191 339.217 217.059 338.147 217.059C337.077 217.059 336.209 216.191 336.209 215.121C336.209 214.051 337.077 213.183 338.147 213.183C339.217 213.183 340.084 214.051 340.084 215.121Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M335.361 210.398C335.361 211.468 334.494 212.336 333.424 212.336C332.354 212.336 331.486 211.468 331.486 210.398C331.486 209.328 332.354 208.461 333.424 208.461C334.494 208.461 335.361 209.328 335.361 210.398Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M269.237 200.949C269.237 202.019 268.37 202.887 267.3 202.887C266.23 202.887 265.362 202.019 265.362 200.949C265.362 199.879 266.23 199.012 267.3 199.012C268.37 199.012 269.237 199.879 269.237 200.949Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M368.424 205.672C368.424 206.742 367.556 207.609 366.486 207.609C365.416 207.609 364.548 206.742 364.548 205.672C364.548 204.602 365.416 203.734 366.486 203.734C367.556 203.734 368.424 204.602 368.424 205.672Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M373.147 200.949C373.147 202.019 372.279 202.887 371.209 202.887C370.139 202.887 369.271 202.019 369.271 200.949C369.271 199.879 370.139 199.012 371.209 199.012C372.279 199.012 373.147 199.879 373.147 200.949Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M292.853 210.398C292.853 211.468 291.986 212.336 290.916 212.336C289.846 212.336 288.978 211.468 288.978 210.398C288.978 209.328 289.846 208.461 290.916 208.461C291.986 208.461 292.853 209.328 292.853 210.398Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M283.406 200.949C283.406 202.019 282.539 202.887 281.469 202.887C280.399 202.887 279.531 202.019 279.531 200.949C279.531 199.879 280.399 199.012 281.469 199.012C282.539 199.012 283.406 199.879 283.406 200.949Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M278.683 200.949C278.683 202.019 277.816 202.887 276.746 202.887C275.676 202.887 274.808 202.019 274.808 200.949C274.808 199.879 275.676 199.012 276.746 199.012C277.816 199.012 278.683 199.879 278.683 200.949Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M273.96 200.949C273.96 202.019 273.093 202.887 272.023 202.887C270.953 202.887 270.085 202.019 270.085 200.949C270.085 199.879 270.953 199.012 272.023 199.012C273.093 199.012 273.96 199.879 273.96 200.949Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M297.576 153.719C297.576 154.789 296.709 155.656 295.639 155.656C294.569 155.656 293.701 154.789 293.701 153.719C293.701 152.649 294.569 151.781 295.639 151.781C296.709 151.781 297.576 152.649 297.576 153.719Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M349.531 153.719C349.531 154.789 348.664 155.656 347.594 155.656C346.524 155.656 345.656 154.789 345.656 153.719C345.656 152.649 346.524 151.781 347.594 151.781C348.664 151.781 349.531 152.649 349.531 153.719Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M354.254 153.719C354.254 154.789 353.387 155.656 352.317 155.656C351.247 155.656 350.379 154.789 350.379 153.719C350.379 152.649 351.247 151.781 352.317 151.781C353.387 151.781 354.254 152.649 354.254 153.719Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M358.977 153.719C358.977 154.789 358.11 155.656 357.04 155.656C355.97 155.656 355.102 154.789 355.102 153.719C355.102 152.649 355.97 151.781 357.04 151.781C358.11 151.781 358.977 152.649 358.977 153.719Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M358.977 148.996C358.977 150.066 358.11 150.934 357.04 150.934C355.97 150.934 355.102 150.066 355.102 148.996C355.102 147.926 355.97 147.058 357.04 147.058C358.11 147.058 358.977 147.926 358.977 148.996Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M358.977 144.273C358.977 145.343 358.11 146.211 357.04 146.211C355.97 146.211 355.102 145.343 355.102 144.273C355.102 143.203 355.97 142.336 357.04 142.336C358.11 142.336 358.977 143.203 358.977 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M363.7 144.273C363.7 145.343 362.833 146.211 361.763 146.211C360.693 146.211 359.825 145.343 359.825 144.273C359.825 143.203 360.693 142.336 361.763 142.336C362.833 142.336 363.7 143.203 363.7 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M358.977 139.551C358.977 140.621 358.11 141.488 357.04 141.488C355.97 141.488 355.102 140.621 355.102 139.551C355.102 138.481 355.97 137.613 357.04 137.613C358.11 137.613 358.977 138.481 358.977 139.551Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M354.254 134.828C354.254 135.898 353.387 136.766 352.317 136.766C351.247 136.766 350.379 135.898 350.379 134.828C350.379 133.758 351.247 132.89 352.317 132.89C353.387 132.89 354.254 133.758 354.254 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M354.254 130.101C354.254 131.171 353.387 132.039 352.317 132.039C351.247 132.039 350.379 131.171 350.379 130.101C350.379 129.031 351.247 128.164 352.317 128.164C353.387 128.164 354.254 129.031 354.254 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M358.977 130.101C358.977 131.171 358.11 132.039 357.04 132.039C355.97 132.039 355.102 131.171 355.102 130.101C355.102 129.031 355.97 128.164 357.04 128.164C358.11 128.164 358.977 129.031 358.977 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M358.977 125.379C358.977 126.449 358.11 127.316 357.04 127.316C355.97 127.316 355.102 126.449 355.102 125.379C355.102 124.309 355.97 123.441 357.04 123.441C358.11 123.441 358.977 124.309 358.977 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M363.7 125.379C363.7 126.449 362.833 127.316 361.763 127.316C360.693 127.316 359.825 126.449 359.825 125.379C359.825 124.309 360.693 123.441 361.763 123.441C362.833 123.441 363.7 124.309 363.7 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M368.424 125.379C368.424 126.449 367.556 127.316 366.486 127.316C365.416 127.316 364.548 126.449 364.548 125.379C364.548 124.309 365.416 123.441 366.486 123.441C367.556 123.441 368.424 124.309 368.424 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M373.147 125.379C373.147 126.449 372.279 127.316 371.209 127.316C370.139 127.316 369.271 126.449 369.271 125.379C369.271 124.309 370.139 123.441 371.209 123.441C372.279 123.441 373.147 124.309 373.147 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M373.147 130.101C373.147 131.171 372.279 132.039 371.209 132.039C370.139 132.039 369.271 131.171 369.271 130.101C369.271 129.031 370.139 128.164 371.209 128.164C372.279 128.164 373.147 129.031 373.147 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M373.147 134.828C373.147 135.898 372.279 136.766 371.209 136.766C370.139 136.766 369.271 135.898 369.271 134.828C369.271 133.758 370.139 132.89 371.209 132.89C372.279 132.89 373.147 133.758 373.147 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M368.424 134.828C368.424 135.898 367.556 136.766 366.486 136.766C365.416 136.766 364.548 135.898 364.548 134.828C364.548 133.758 365.416 132.89 366.486 132.89C367.556 132.89 368.424 133.758 368.424 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M373.147 139.551C373.147 140.621 372.279 141.488 371.209 141.488C370.139 141.488 369.271 140.621 369.271 139.551C369.271 138.481 370.139 137.613 371.209 137.613C372.279 137.613 373.147 138.481 373.147 139.551Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M373.147 144.273C373.147 145.343 372.279 146.211 371.209 146.211C370.139 146.211 369.271 145.343 369.271 144.273C369.271 143.203 370.139 142.336 371.209 142.336C372.279 142.336 373.147 143.203 373.147 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M377.87 144.273C377.87 145.343 377.003 146.211 375.933 146.211C374.863 146.211 373.995 145.343 373.995 144.273C373.995 143.203 374.863 142.336 375.933 142.336C377.003 142.336 377.87 143.203 377.87 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M377.87 148.996C377.87 150.066 377.003 150.934 375.933 150.934C374.863 150.934 373.995 150.066 373.995 148.996C373.995 147.926 374.863 147.058 375.933 147.058C377.003 147.058 377.87 147.926 377.87 148.996Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M377.87 153.719C377.87 154.789 377.003 155.656 375.933 155.656C374.863 155.656 373.995 154.789 373.995 153.719C373.995 152.649 374.863 151.781 375.933 151.781C377.003 151.781 377.87 152.649 377.87 153.719Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M377.87 158.441C377.87 159.511 377.003 160.379 375.933 160.379C374.863 160.379 373.995 159.511 373.995 158.441C373.995 157.371 374.863 156.504 375.933 156.504C377.003 156.504 377.87 157.371 377.87 158.441Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M373.147 158.441C373.147 159.511 372.279 160.379 371.209 160.379C370.139 160.379 369.271 159.511 369.271 158.441C369.271 157.371 370.139 156.504 371.209 156.504C372.279 156.504 373.147 157.371 373.147 158.441Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M373.147 153.719C373.147 154.789 372.279 155.656 371.209 155.656C370.139 155.656 369.271 154.789 369.271 153.719C369.271 152.649 370.139 151.781 371.209 151.781C372.279 151.781 373.147 152.649 373.147 153.719Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M368.424 153.719C368.424 154.789 367.556 155.656 366.486 155.656C365.416 155.656 364.548 154.789 364.548 153.719C364.548 152.649 365.416 151.781 366.486 151.781C367.556 151.781 368.424 152.649 368.424 153.719Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M363.7 153.719C363.7 154.789 362.833 155.656 361.763 155.656C360.693 155.656 359.825 154.789 359.825 153.719C359.825 152.649 360.693 151.781 361.763 151.781C362.833 151.781 363.7 152.649 363.7 153.719Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M363.7 158.441C363.7 159.511 362.833 160.379 361.763 160.379C360.693 160.379 359.825 159.511 359.825 158.441C359.825 157.371 360.693 156.504 361.763 156.504C362.833 156.504 363.7 157.371 363.7 158.441Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M368.424 158.441C368.424 159.511 367.556 160.379 366.486 160.379C365.416 160.379 364.548 159.511 364.548 158.441C364.548 157.371 365.416 156.504 366.486 156.504C367.556 156.504 368.424 157.371 368.424 158.441Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M368.424 163.164C368.424 164.234 367.556 165.102 366.486 165.102C365.416 165.102 364.548 164.234 364.548 163.164C364.548 162.094 365.416 161.226 366.486 161.226C367.556 161.226 368.424 162.094 368.424 163.164Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M363.7 163.164C363.7 164.234 362.833 165.102 361.763 165.102C360.693 165.102 359.825 164.234 359.825 163.164C359.825 162.094 360.693 161.226 361.763 161.226C362.833 161.226 363.7 162.094 363.7 163.164Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M373.147 163.164C373.147 164.234 372.279 165.102 371.209 165.102C370.139 165.102 369.271 164.234 369.271 163.164C369.271 162.094 370.139 161.226 371.209 161.226C372.279 161.226 373.147 162.094 373.147 163.164Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M373.147 167.887C373.147 168.957 372.279 169.824 371.209 169.824C370.139 169.824 369.271 168.957 369.271 167.887C369.271 166.817 370.139 165.949 371.209 165.949C372.279 165.949 373.147 166.817 373.147 167.887Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M377.87 167.887C377.87 168.957 377.003 169.824 375.933 169.824C374.863 169.824 373.995 168.957 373.995 167.887C373.995 166.817 374.863 165.949 375.933 165.949C377.003 165.949 377.87 166.817 377.87 167.887Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M377.87 163.164C377.87 164.234 377.003 165.102 375.933 165.102C374.863 165.102 373.995 164.234 373.995 163.164C373.995 162.094 374.863 161.226 375.933 161.226C377.003 161.226 377.87 162.094 377.87 163.164Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M382.593 163.164C382.593 164.234 381.726 165.102 380.656 165.102C379.586 165.102 378.718 164.234 378.718 163.164C378.718 162.094 379.586 161.226 380.656 161.226C381.726 161.226 382.593 162.094 382.593 163.164Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M382.593 167.887C382.593 168.957 381.726 169.824 380.656 169.824C379.586 169.824 378.718 168.957 378.718 167.887C378.718 166.817 379.586 165.949 380.656 165.949C381.726 165.949 382.593 166.817 382.593 167.887Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M387.316 167.887C387.316 168.957 386.449 169.824 385.379 169.824C384.309 169.824 383.441 168.957 383.441 167.887C383.441 166.817 384.309 165.949 385.379 165.949C386.449 165.949 387.316 166.817 387.316 167.887Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M387.316 172.613C387.316 173.683 386.449 174.551 385.379 174.551C384.309 174.551 383.441 173.683 383.441 172.613C383.441 171.543 384.309 170.676 385.379 170.676C386.449 170.676 387.316 171.543 387.316 172.613Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M392.039 172.613C392.039 173.683 391.172 174.551 390.102 174.551C389.032 174.551 388.164 173.683 388.164 172.613C388.164 171.543 389.032 170.676 390.102 170.676C391.172 170.676 392.039 171.543 392.039 172.613Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M396.762 172.613C396.762 173.683 395.895 174.551 394.825 174.551C393.755 174.551 392.887 173.683 392.887 172.613C392.887 171.543 393.755 170.676 394.825 170.676C395.895 170.676 396.762 171.543 396.762 172.613Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M401.486 172.613C401.486 173.683 400.618 174.551 399.548 174.551C398.478 174.551 397.61 173.683 397.61 172.613C397.61 171.543 398.478 170.676 399.548 170.676C400.618 170.676 401.486 171.543 401.486 172.613Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M406.209 172.613C406.209 173.683 405.341 174.551 404.271 174.551C403.201 174.551 402.333 173.683 402.333 172.613C402.333 171.543 403.201 170.676 404.271 170.676C405.341 170.676 406.209 171.543 406.209 172.613Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M406.209 177.336C406.209 178.406 405.341 179.273 404.271 179.273C403.201 179.273 402.333 178.406 402.333 177.336C402.333 176.266 403.201 175.398 404.271 175.398C405.341 175.398 406.209 176.266 406.209 177.336Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M401.486 177.336C401.486 178.406 400.618 179.273 399.548 179.273C398.478 179.273 397.61 178.406 397.61 177.336C397.61 176.266 398.478 175.398 399.548 175.398C400.618 175.398 401.486 176.266 401.486 177.336Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M406.209 182.059C406.209 183.128 405.341 183.996 404.271 183.996C403.201 183.996 402.333 183.128 402.333 182.059C402.333 180.989 403.201 180.121 404.271 180.121C405.341 180.121 406.209 180.989 406.209 182.059Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M410.932 177.336C410.932 178.406 410.065 179.273 408.995 179.273C407.925 179.273 407.057 178.406 407.057 177.336C407.057 176.266 407.925 175.398 408.995 175.398C410.065 175.398 410.932 176.266 410.932 177.336Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M415.655 177.336C415.655 178.406 414.788 179.273 413.718 179.273C412.648 179.273 411.78 178.406 411.78 177.336C411.78 176.266 412.648 175.398 413.718 175.398C414.788 175.398 415.655 176.266 415.655 177.336Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M415.655 182.059C415.655 183.128 414.788 183.996 413.718 183.996C412.648 183.996 411.78 183.128 411.78 182.059C411.78 180.989 412.648 180.121 413.718 180.121C414.788 180.121 415.655 180.989 415.655 182.059Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M410.932 182.059C410.932 183.128 410.065 183.996 408.995 183.996C407.925 183.996 407.057 183.128 407.057 182.059C407.057 180.989 407.925 180.121 408.995 180.121C410.065 180.121 410.932 180.989 410.932 182.059Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M415.655 186.781C415.655 187.851 414.788 188.719 413.718 188.719C412.648 188.719 411.78 187.851 411.78 186.781C411.78 185.711 412.648 184.844 413.718 184.844C414.788 184.844 415.655 185.711 415.655 186.781Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M410.932 186.781C410.932 187.851 410.065 188.719 408.995 188.719C407.925 188.719 407.057 187.851 407.057 186.781C407.057 185.711 407.925 184.844 408.995 184.844C410.065 184.844 410.932 185.711 410.932 186.781Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M415.655 191.504C415.655 192.574 414.788 193.441 413.718 193.441C412.648 193.441 411.78 192.574 411.78 191.504C411.78 190.434 412.648 189.566 413.718 189.566C414.788 189.566 415.655 190.434 415.655 191.504Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M415.655 196.226C415.655 197.296 414.788 198.164 413.718 198.164C412.648 198.164 411.78 197.296 411.78 196.226C411.78 195.156 412.648 194.289 413.718 194.289C414.788 194.289 415.655 195.156 415.655 196.226Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M420.378 196.226C420.378 197.296 419.511 198.164 418.441 198.164C417.371 198.164 416.503 197.296 416.503 196.226C416.503 195.156 417.371 194.289 418.441 194.289C419.511 194.289 420.378 195.156 420.378 196.226Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M420.378 191.504C420.378 192.574 419.511 193.441 418.441 193.441C417.371 193.441 416.503 192.574 416.503 191.504C416.503 190.434 417.371 189.566 418.441 189.566C419.511 189.566 420.378 190.434 420.378 191.504Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M420.378 186.781C420.378 187.851 419.511 188.719 418.441 188.719C417.371 188.719 416.503 187.851 416.503 186.781C416.503 185.711 417.371 184.844 418.441 184.844C419.511 184.844 420.378 185.711 420.378 186.781Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M425.101 186.781C425.101 187.851 424.234 188.719 423.164 188.719C422.094 188.719 421.226 187.851 421.226 186.781C421.226 185.711 422.094 184.844 423.164 184.844C424.234 184.844 425.101 185.711 425.101 186.781Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M425.101 182.059C425.101 183.128 424.234 183.996 423.164 183.996C422.094 183.996 421.226 183.128 421.226 182.059C421.226 180.989 422.094 180.121 423.164 180.121C424.234 180.121 425.101 180.989 425.101 182.059Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M429.825 182.059C429.825 183.128 428.957 183.996 427.887 183.996C426.817 183.996 425.949 183.128 425.949 182.059C425.949 180.989 426.817 180.121 427.887 180.121C428.957 180.121 429.825 180.989 429.825 182.059Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M429.825 177.336C429.825 178.406 428.957 179.273 427.887 179.273C426.817 179.273 425.949 178.406 425.949 177.336C425.949 176.266 426.817 175.398 427.887 175.398C428.957 175.398 429.825 176.266 429.825 177.336Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M434.548 177.336C434.548 178.406 433.681 179.273 432.611 179.273C431.541 179.273 430.673 178.406 430.673 177.336C430.673 176.266 431.541 175.398 432.611 175.398C433.681 175.398 434.548 176.266 434.548 177.336Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M439.271 177.336C439.271 178.406 438.403 179.273 437.333 179.273C436.263 179.273 435.396 178.406 435.396 177.336C435.396 176.266 436.263 175.398 437.333 175.398C438.403 175.398 439.271 176.266 439.271 177.336Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M443.994 177.336C443.994 178.406 443.127 179.273 442.057 179.273C440.987 179.273 440.119 178.406 440.119 177.336C440.119 176.266 440.987 175.398 442.057 175.398C443.127 175.398 443.994 176.266 443.994 177.336Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M448.717 177.336C448.717 178.406 447.85 179.273 446.78 179.273C445.71 179.273 444.842 178.406 444.842 177.336C444.842 176.266 445.71 175.398 446.78 175.398C447.85 175.398 448.717 176.266 448.717 177.336Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M448.717 182.059C448.717 183.128 447.85 183.996 446.78 183.996C445.71 183.996 444.842 183.128 444.842 182.059C444.842 180.989 445.71 180.121 446.78 180.121C447.85 180.121 448.717 180.989 448.717 182.059Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M448.717 186.781C448.717 187.851 447.85 188.719 446.78 188.719C445.71 188.719 444.842 187.851 444.842 186.781C444.842 185.711 445.71 184.844 446.78 184.844C447.85 184.844 448.717 185.711 448.717 186.781Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M453.44 186.781C453.44 187.851 452.573 188.719 451.503 188.719C450.433 188.719 449.565 187.851 449.565 186.781C449.565 185.711 450.433 184.844 451.503 184.844C452.573 184.844 453.44 185.711 453.44 186.781Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M458.164 186.781C458.164 187.851 457.296 188.719 456.226 188.719C455.156 188.719 454.288 187.851 454.288 186.781C454.288 185.711 455.156 184.844 456.226 184.844C457.296 184.844 458.164 185.711 458.164 186.781Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M458.164 191.504C458.164 192.574 457.296 193.441 456.226 193.441C455.156 193.441 454.288 192.574 454.288 191.504C454.288 190.434 455.156 189.566 456.226 189.566C457.296 189.566 458.164 190.434 458.164 191.504Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M458.164 200.949C458.164 202.019 457.296 202.887 456.226 202.887C455.156 202.887 454.288 202.019 454.288 200.949C454.288 199.879 455.156 199.012 456.226 199.012C457.296 199.012 458.164 199.879 458.164 200.949Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M458.164 205.672C458.164 206.742 457.296 207.609 456.226 207.609C455.156 207.609 454.288 206.742 454.288 205.672C454.288 204.602 455.156 203.734 456.226 203.734C457.296 203.734 458.164 204.602 458.164 205.672Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M462.887 210.398C462.887 211.468 462.019 212.336 460.949 212.336C459.879 212.336 459.011 211.468 459.011 210.398C459.011 209.328 459.879 208.461 460.949 208.461C462.019 208.461 462.887 209.328 462.887 210.398Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M462.887 215.121C462.887 216.191 462.019 217.059 460.949 217.059C459.879 217.059 459.011 216.191 459.011 215.121C459.011 214.051 459.879 213.183 460.949 213.183C462.019 213.183 462.887 214.051 462.887 215.121Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M462.887 219.844C462.887 220.914 462.019 221.781 460.949 221.781C459.879 221.781 459.011 220.914 459.011 219.844C459.011 218.774 459.879 217.906 460.949 217.906C462.019 217.906 462.887 218.774 462.887 219.844Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M462.887 224.566C462.887 225.636 462.019 226.504 460.949 226.504C459.879 226.504 459.011 225.636 459.011 224.566C459.011 223.496 459.879 222.629 460.949 222.629C462.019 222.629 462.887 223.496 462.887 224.566Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M467.61 224.566C467.61 225.636 466.743 226.504 465.673 226.504C464.603 226.504 463.735 225.636 463.735 224.566C463.735 223.496 464.603 222.629 465.673 222.629C466.743 222.629 467.61 223.496 467.61 224.566Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M477.056 224.566C477.056 225.636 476.189 226.504 475.119 226.504C474.049 226.504 473.181 225.636 473.181 224.566C473.181 223.496 474.049 222.629 475.119 222.629C476.189 222.629 477.056 223.496 477.056 224.566Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M477.056 219.844C477.056 220.914 476.189 221.781 475.119 221.781C474.049 221.781 473.181 220.914 473.181 219.844C473.181 218.774 474.049 217.906 475.119 217.906C476.189 217.906 477.056 218.774 477.056 219.844Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M481.779 219.844C481.779 220.914 480.912 221.781 479.842 221.781C478.772 221.781 477.904 220.914 477.904 219.844C477.904 218.774 478.772 217.906 479.842 217.906C480.912 217.906 481.779 218.774 481.779 219.844Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M486.503 219.844C486.503 220.914 485.635 221.781 484.565 221.781C483.495 221.781 482.627 220.914 482.627 219.844C482.627 218.774 483.495 217.906 484.565 217.906C485.635 217.906 486.503 218.774 486.503 219.844Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M486.503 215.121C486.503 216.191 485.635 217.059 484.565 217.059C483.495 217.059 482.627 216.191 482.627 215.121C482.627 214.051 483.495 213.183 484.565 213.183C485.635 213.183 486.503 214.051 486.503 215.121Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M491.226 210.398C491.226 211.468 490.359 212.336 489.289 212.336C488.219 212.336 487.351 211.468 487.351 210.398C487.351 209.328 488.219 208.461 489.289 208.461C490.359 208.461 491.226 209.328 491.226 210.398Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M486.503 224.566C486.503 225.636 485.635 226.504 484.565 226.504C483.495 226.504 482.627 225.636 482.627 224.566C482.627 223.496 483.495 222.629 484.565 222.629C485.635 222.629 486.503 223.496 486.503 224.566Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M495.949 224.566C495.949 225.636 495.082 226.504 494.012 226.504C492.942 226.504 492.074 225.636 492.074 224.566C492.074 223.496 492.942 222.629 494.012 222.629C495.082 222.629 495.949 223.496 495.949 224.566Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M500.672 219.844C500.672 220.914 499.805 221.781 498.735 221.781C497.665 221.781 496.797 220.914 496.797 219.844C496.797 218.774 497.665 217.906 498.735 217.906C499.805 217.906 500.672 218.774 500.672 219.844Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M510.118 219.844C510.118 220.914 509.251 221.781 508.181 221.781C507.111 221.781 506.243 220.914 506.243 219.844C506.243 218.774 507.111 217.906 508.181 217.906C509.251 217.906 510.118 218.774 510.118 219.844Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M514.841 224.566C514.841 225.636 513.974 226.504 512.904 226.504C511.834 226.504 510.966 225.636 510.966 224.566C510.966 223.496 511.834 222.629 512.904 222.629C513.974 222.629 514.841 223.496 514.841 224.566Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M519.565 224.566C519.565 225.636 518.697 226.504 517.627 226.504C516.557 226.504 515.689 225.636 515.689 224.566C515.689 223.496 516.557 222.629 517.627 222.629C518.697 222.629 519.565 223.496 519.565 224.566Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M519.565 229.289C519.565 230.359 518.697 231.227 517.627 231.227C516.557 231.227 515.689 230.359 515.689 229.289C515.689 228.219 516.557 227.351 517.627 227.351C518.697 227.351 519.565 228.219 519.565 229.289Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M524.288 229.289C524.288 230.359 523.421 231.227 522.351 231.227C521.281 231.227 520.413 230.359 520.413 229.289C520.413 228.219 521.281 227.351 522.351 227.351C523.421 227.351 524.288 228.219 524.288 229.289Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M524.288 224.566C524.288 225.636 523.421 226.504 522.351 226.504C521.281 226.504 520.413 225.636 520.413 224.566C520.413 223.496 521.281 222.629 522.351 222.629C523.421 222.629 524.288 223.496 524.288 224.566Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M529.011 229.289C529.011 230.359 528.144 231.227 527.074 231.227C526.004 231.227 525.136 230.359 525.136 229.289C525.136 228.219 526.004 227.351 527.074 227.351C528.144 227.351 529.011 228.219 529.011 229.289Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M533.734 229.289C533.734 230.359 532.867 231.227 531.797 231.227C530.727 231.227 529.859 230.359 529.859 229.289C529.859 228.219 530.727 227.351 531.797 227.351C532.867 227.351 533.734 228.219 533.734 229.289Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M533.734 234.012C533.734 235.082 532.867 235.949 531.797 235.949C530.727 235.949 529.859 235.082 529.859 234.012C529.859 232.942 530.727 232.074 531.797 232.074C532.867 232.074 533.734 232.942 533.734 234.012Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M533.734 243.461C533.734 244.531 532.867 245.398 531.797 245.398C530.727 245.398 529.859 244.531 529.859 243.461C529.859 242.391 530.727 241.523 531.797 241.523C532.867 241.523 533.734 242.391 533.734 243.461Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M533.734 248.184C533.734 249.253 532.867 250.121 531.797 250.121C530.727 250.121 529.859 249.253 529.859 248.184C529.859 247.114 530.727 246.246 531.797 246.246C532.867 246.246 533.734 247.114 533.734 248.184Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M533.734 252.906C533.734 253.976 532.867 254.844 531.797 254.844C530.727 254.844 529.859 253.976 529.859 252.906C529.859 251.836 530.727 250.969 531.797 250.969C532.867 250.969 533.734 251.836 533.734 252.906Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M533.734 257.629C533.734 258.699 532.867 259.566 531.797 259.566C530.727 259.566 529.859 258.699 529.859 257.629C529.859 256.559 530.727 255.691 531.797 255.691C532.867 255.691 533.734 256.559 533.734 257.629Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M533.734 262.351C533.734 263.421 532.867 264.289 531.797 264.289C530.727 264.289 529.859 263.421 529.859 262.351C529.859 261.281 530.727 260.414 531.797 260.414C532.867 260.414 533.734 261.281 533.734 262.351Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M538.457 262.351C538.457 263.421 537.59 264.289 536.52 264.289C535.45 264.289 534.582 263.421 534.582 262.351C534.582 261.281 535.45 260.414 536.52 260.414C537.59 260.414 538.457 261.281 538.457 262.351Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M538.457 257.629C538.457 258.699 537.59 259.566 536.52 259.566C535.45 259.566 534.582 258.699 534.582 257.629C534.582 256.559 535.45 255.691 536.52 255.691C537.59 255.691 538.457 256.559 538.457 257.629Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M538.457 267.074C538.457 268.144 537.59 269.012 536.52 269.012C535.45 269.012 534.582 268.144 534.582 267.074C534.582 266.004 535.45 265.137 536.52 265.137C537.59 265.137 538.457 266.004 538.457 267.074Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M543.18 267.074C543.18 268.144 542.313 269.012 541.243 269.012C540.173 269.012 539.305 268.144 539.305 267.074C539.305 266.004 540.173 265.137 541.243 265.137C542.313 265.137 543.18 266.004 543.18 267.074Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M543.18 271.797C543.18 272.867 542.313 273.734 541.243 273.734C540.173 273.734 539.305 272.867 539.305 271.797C539.305 270.727 540.173 269.859 541.243 269.859C542.313 269.859 543.18 270.727 543.18 271.797Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M547.903 271.797C547.903 272.867 547.036 273.734 545.966 273.734C544.896 273.734 544.028 272.867 544.028 271.797C544.028 270.727 544.896 269.859 545.966 269.859C547.036 269.859 547.903 270.727 547.903 271.797Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M543.18 276.519C543.18 277.589 542.313 278.457 541.243 278.457C540.173 278.457 539.305 277.589 539.305 276.519C539.305 275.449 540.173 274.582 541.243 274.582C542.313 274.582 543.18 275.449 543.18 276.519Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M547.903 276.519C547.903 277.589 547.036 278.457 545.966 278.457C544.896 278.457 544.028 277.589 544.028 276.519C544.028 275.449 544.896 274.582 545.966 274.582C547.036 274.582 547.903 275.449 547.903 276.519Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M543.18 281.246C543.18 282.316 542.313 283.184 541.243 283.184C540.173 283.184 539.305 282.316 539.305 281.246C539.305 280.176 540.173 279.308 541.243 279.308C542.313 279.308 543.18 280.176 543.18 281.246Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M543.18 285.969C543.18 287.039 542.313 287.906 541.243 287.906C540.173 287.906 539.305 287.039 539.305 285.969C539.305 284.899 540.173 284.031 541.243 284.031C542.313 284.031 543.18 284.899 543.18 285.969Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M538.457 285.969C538.457 287.039 537.59 287.906 536.52 287.906C535.45 287.906 534.582 287.039 534.582 285.969C534.582 284.899 535.45 284.031 536.52 284.031C537.59 284.031 538.457 284.899 538.457 285.969Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M538.457 290.691C538.457 291.761 537.59 292.629 536.52 292.629C535.45 292.629 534.582 291.761 534.582 290.691C534.582 289.621 535.45 288.754 536.52 288.754C537.59 288.754 538.457 289.621 538.457 290.691Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M533.734 290.691C533.734 291.761 532.867 292.629 531.797 292.629C530.727 292.629 529.859 291.761 529.859 290.691C529.859 289.621 530.727 288.754 531.797 288.754C532.867 288.754 533.734 289.621 533.734 290.691Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M533.734 295.414C533.734 296.484 532.867 297.352 531.797 297.352C530.727 297.352 529.859 296.484 529.859 295.414C529.859 294.344 530.727 293.476 531.797 293.476C532.867 293.476 533.734 294.344 533.734 295.414Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M538.457 295.414C538.457 296.484 537.59 297.352 536.52 297.352C535.45 297.352 534.582 296.484 534.582 295.414C534.582 294.344 535.45 293.476 536.52 293.476C537.59 293.476 538.457 294.344 538.457 295.414Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M533.734 300.137C533.734 301.207 532.867 302.074 531.797 302.074C530.727 302.074 529.859 301.207 529.859 300.137C529.859 299.067 530.727 298.199 531.797 298.199C532.867 298.199 533.734 299.067 533.734 300.137Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M529.011 300.137C529.011 301.207 528.144 302.074 527.074 302.074C526.004 302.074 525.136 301.207 525.136 300.137C525.136 299.067 526.004 298.199 527.074 298.199C528.144 298.199 529.011 299.067 529.011 300.137Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M529.011 309.582C529.011 310.652 528.144 311.52 527.074 311.52C526.004 311.52 525.136 310.652 525.136 309.582C525.136 308.512 526.004 307.644 527.074 307.644C528.144 307.644 529.011 308.512 529.011 309.582Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M529.011 314.305C529.011 315.375 528.144 316.242 527.074 316.242C526.004 316.242 525.136 315.375 525.136 314.305C525.136 313.235 526.004 312.367 527.074 312.367C528.144 312.367 529.011 313.235 529.011 314.305Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M562.073 328.476C562.073 329.546 561.206 330.414 560.136 330.414C559.066 330.414 558.198 329.546 558.198 328.476C558.198 327.406 559.066 326.539 560.136 326.539C561.206 326.539 562.073 327.406 562.073 328.476Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M562.073 323.754C562.073 324.824 561.206 325.691 560.136 325.691C559.066 325.691 558.198 324.824 558.198 323.754C558.198 322.684 559.066 321.816 560.136 321.816C561.206 321.816 562.073 322.684 562.073 323.754Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M566.796 323.754C566.796 324.824 565.929 325.691 564.859 325.691C563.789 325.691 562.921 324.824 562.921 323.754C562.921 322.684 563.789 321.816 564.859 321.816C565.929 321.816 566.796 322.684 566.796 323.754Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M571.52 319.031C571.52 320.101 570.652 320.969 569.582 320.969C568.513 320.969 567.645 320.101 567.645 319.031C567.645 317.961 568.513 317.094 569.582 317.094C570.652 317.094 571.52 317.961 571.52 319.031Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M576.242 314.305C576.242 315.375 575.375 316.242 574.305 316.242C573.235 316.242 572.367 315.375 572.367 314.305C572.367 313.235 573.235 312.367 574.305 312.367C575.375 312.367 576.242 313.235 576.242 314.305Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M580.966 309.582C580.966 310.652 580.099 311.52 579.029 311.52C577.959 311.52 577.091 310.652 577.091 309.582C577.091 308.512 577.959 307.644 579.029 307.644C580.099 307.644 580.966 308.512 580.966 309.582Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M580.966 304.859C580.966 305.929 580.099 306.797 579.029 306.797C577.959 306.797 577.091 305.929 577.091 304.859C577.091 303.789 577.959 302.922 579.029 302.922C580.099 302.922 580.966 303.789 580.966 304.859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M580.966 300.137C580.966 301.207 580.099 302.074 579.029 302.074C577.959 302.074 577.091 301.207 577.091 300.137C577.091 299.067 577.959 298.199 579.029 298.199C580.099 298.199 580.966 299.067 580.966 300.137Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M529.011 295.414C529.011 296.484 528.144 297.352 527.074 297.352C526.004 297.352 525.136 296.484 525.136 295.414C525.136 294.344 526.004 293.476 527.074 293.476C528.144 293.476 529.011 294.344 529.011 295.414Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M524.288 295.414C524.288 296.484 523.421 297.352 522.351 297.352C521.281 297.352 520.413 296.484 520.413 295.414C520.413 294.344 521.281 293.476 522.351 293.476C523.421 293.476 524.288 294.344 524.288 295.414Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M524.288 300.137C524.288 301.207 523.421 302.074 522.351 302.074C521.281 302.074 520.413 301.207 520.413 300.137C520.413 299.067 521.281 298.199 522.351 298.199C523.421 298.199 524.288 299.067 524.288 300.137Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M524.288 290.691C524.288 291.761 523.421 292.629 522.351 292.629C521.281 292.629 520.413 291.761 520.413 290.691C520.413 289.621 521.281 288.754 522.351 288.754C523.421 288.754 524.288 289.621 524.288 290.691Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M519.565 290.691C519.565 291.761 518.697 292.629 517.627 292.629C516.557 292.629 515.689 291.761 515.689 290.691C515.689 289.621 516.557 288.754 517.627 288.754C518.697 288.754 519.565 289.621 519.565 290.691Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M519.565 285.969C519.565 287.039 518.697 287.906 517.627 287.906C516.557 287.906 515.689 287.039 515.689 285.969C515.689 284.899 516.557 284.031 517.627 284.031C518.697 284.031 519.565 284.899 519.565 285.969Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M514.841 285.969C514.841 287.039 513.974 287.906 512.904 287.906C511.834 287.906 510.966 287.039 510.966 285.969C510.966 284.899 511.834 284.031 512.904 284.031C513.974 284.031 514.841 284.899 514.841 285.969Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M514.841 281.246C514.841 282.316 513.974 283.184 512.904 283.184C511.834 283.184 510.966 282.316 510.966 281.246C510.966 280.176 511.834 279.308 512.904 279.308C513.974 279.308 514.841 280.176 514.841 281.246Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M510.118 281.246C510.118 282.316 509.251 283.184 508.181 283.184C507.111 283.184 506.243 282.316 506.243 281.246C506.243 280.176 507.111 279.308 508.181 279.308C509.251 279.308 510.118 280.176 510.118 281.246Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M505.395 281.246C505.395 282.316 504.528 283.184 503.458 283.184C502.388 283.184 501.52 282.316 501.52 281.246C501.52 280.176 502.388 279.308 503.458 279.308C504.528 279.308 505.395 280.176 505.395 281.246Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M500.672 281.246C500.672 282.316 499.805 283.184 498.735 283.184C497.665 283.184 496.797 282.316 496.797 281.246C496.797 280.176 497.665 279.308 498.735 279.308C499.805 279.308 500.672 280.176 500.672 281.246Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M495.949 281.246C495.949 282.316 495.082 283.184 494.012 283.184C492.942 283.184 492.074 282.316 492.074 281.246C492.074 280.176 492.942 279.308 494.012 279.308C495.082 279.308 495.949 280.176 495.949 281.246Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M491.226 281.246C491.226 282.316 490.359 283.184 489.289 283.184C488.219 283.184 487.351 282.316 487.351 281.246C487.351 280.176 488.219 279.308 489.289 279.308C490.359 279.308 491.226 280.176 491.226 281.246Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M491.226 285.969C491.226 287.039 490.359 287.906 489.289 287.906C488.219 287.906 487.351 287.039 487.351 285.969C487.351 284.899 488.219 284.031 489.289 284.031C490.359 284.031 491.226 284.899 491.226 285.969Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M486.503 285.969C486.503 287.039 485.635 287.906 484.565 287.906C483.495 287.906 482.627 287.039 482.627 285.969C482.627 284.899 483.495 284.031 484.565 284.031C485.635 284.031 486.503 284.899 486.503 285.969Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M481.779 285.969C481.779 287.039 480.912 287.906 479.842 287.906C478.772 287.906 477.904 287.039 477.904 285.969C477.904 284.899 478.772 284.031 479.842 284.031C480.912 284.031 481.779 284.899 481.779 285.969Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M481.779 281.246C481.779 282.316 480.912 283.184 479.842 283.184C478.772 283.184 477.904 282.316 477.904 281.246C477.904 280.176 478.772 279.308 479.842 279.308C480.912 279.308 481.779 280.176 481.779 281.246Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M481.779 276.519C481.779 277.589 480.912 278.457 479.842 278.457C478.772 278.457 477.904 277.589 477.904 276.519C477.904 275.449 478.772 274.582 479.842 274.582C480.912 274.582 481.779 275.449 481.779 276.519Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M481.779 271.797C481.779 272.867 480.912 273.734 479.842 273.734C478.772 273.734 477.904 272.867 477.904 271.797C477.904 270.727 478.772 269.859 479.842 269.859C480.912 269.859 481.779 270.727 481.779 271.797Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M481.779 267.074C481.779 268.144 480.912 269.012 479.842 269.012C478.772 269.012 477.904 268.144 477.904 267.074C477.904 266.004 478.772 265.137 479.842 265.137C480.912 265.137 481.779 266.004 481.779 267.074Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M486.503 262.351C486.503 263.421 485.635 264.289 484.565 264.289C483.495 264.289 482.627 263.421 482.627 262.351C482.627 261.281 483.495 260.414 484.565 260.414C485.635 260.414 486.503 261.281 486.503 262.351Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M491.226 262.351C491.226 263.421 490.359 264.289 489.289 264.289C488.219 264.289 487.351 263.421 487.351 262.351C487.351 261.281 488.219 260.414 489.289 260.414C490.359 260.414 491.226 261.281 491.226 262.351Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M495.949 262.351C495.949 263.421 495.082 264.289 494.012 264.289C492.942 264.289 492.074 263.421 492.074 262.351C492.074 261.281 492.942 260.414 494.012 260.414C495.082 260.414 495.949 261.281 495.949 262.351Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M495.949 257.629C495.949 258.699 495.082 259.566 494.012 259.566C492.942 259.566 492.074 258.699 492.074 257.629C492.074 256.559 492.942 255.691 494.012 255.691C495.082 255.691 495.949 256.559 495.949 257.629Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M500.672 257.629C500.672 258.699 499.805 259.566 498.735 259.566C497.665 259.566 496.797 258.699 496.797 257.629C496.797 256.559 497.665 255.691 498.735 255.691C499.805 255.691 500.672 256.559 500.672 257.629Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M505.395 257.629C505.395 258.699 504.528 259.566 503.458 259.566C502.388 259.566 501.52 258.699 501.52 257.629C501.52 256.559 502.388 255.691 503.458 255.691C504.528 255.691 505.395 256.559 505.395 257.629Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M505.395 252.906C505.395 253.976 504.528 254.844 503.458 254.844C502.388 254.844 501.52 253.976 501.52 252.906C501.52 251.836 502.388 250.969 503.458 250.969C504.528 250.969 505.395 251.836 505.395 252.906Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M500.672 252.906C500.672 253.976 499.805 254.844 498.735 254.844C497.665 254.844 496.797 253.976 496.797 252.906C496.797 251.836 497.665 250.969 498.735 250.969C499.805 250.969 500.672 251.836 500.672 252.906Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M505.395 248.184C505.395 249.253 504.528 250.121 503.458 250.121C502.388 250.121 501.52 249.253 501.52 248.184C501.52 247.114 502.388 246.246 503.458 246.246C504.528 246.246 505.395 247.114 505.395 248.184Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M510.118 252.906C510.118 253.976 509.251 254.844 508.181 254.844C507.111 254.844 506.243 253.976 506.243 252.906C506.243 251.836 507.111 250.969 508.181 250.969C509.251 250.969 510.118 251.836 510.118 252.906Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M514.841 252.906C514.841 253.976 513.974 254.844 512.904 254.844C511.834 254.844 510.966 253.976 510.966 252.906C510.966 251.836 511.834 250.969 512.904 250.969C513.974 250.969 514.841 251.836 514.841 252.906Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M514.841 248.184C514.841 249.253 513.974 250.121 512.904 250.121C511.834 250.121 510.966 249.253 510.966 248.184C510.966 247.114 511.834 246.246 512.904 246.246C513.974 246.246 514.841 247.114 514.841 248.184Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M514.841 243.461C514.841 244.531 513.974 245.398 512.904 245.398C511.834 245.398 510.966 244.531 510.966 243.461C510.966 242.391 511.834 241.523 512.904 241.523C513.974 241.523 514.841 242.391 514.841 243.461Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M519.565 243.461C519.565 244.531 518.697 245.398 517.627 245.398C516.557 245.398 515.689 244.531 515.689 243.461C515.689 242.391 516.557 241.523 517.627 241.523C518.697 241.523 519.565 242.391 519.565 243.461Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M519.565 248.184C519.565 249.253 518.697 250.121 517.627 250.121C516.557 250.121 515.689 249.253 515.689 248.184C515.689 247.114 516.557 246.246 517.627 246.246C518.697 246.246 519.565 247.114 519.565 248.184Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M519.565 252.906C519.565 253.976 518.697 254.844 517.627 254.844C516.557 254.844 515.689 253.976 515.689 252.906C515.689 251.836 516.557 250.969 517.627 250.969C518.697 250.969 519.565 251.836 519.565 252.906Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M524.288 252.906C524.288 253.976 523.421 254.844 522.351 254.844C521.281 254.844 520.413 253.976 520.413 252.906C520.413 251.836 521.281 250.969 522.351 250.969C523.421 250.969 524.288 251.836 524.288 252.906Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M524.288 257.629C524.288 258.699 523.421 259.566 522.351 259.566C521.281 259.566 520.413 258.699 520.413 257.629C520.413 256.559 521.281 255.691 522.351 255.691C523.421 255.691 524.288 256.559 524.288 257.629Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M529.011 257.629C529.011 258.699 528.144 259.566 527.074 259.566C526.004 259.566 525.136 258.699 525.136 257.629C525.136 256.559 526.004 255.691 527.074 255.691C528.144 255.691 529.011 256.559 529.011 257.629Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M529.011 262.351C529.011 263.421 528.144 264.289 527.074 264.289C526.004 264.289 525.136 263.421 525.136 262.351C525.136 261.281 526.004 260.414 527.074 260.414C528.144 260.414 529.011 261.281 529.011 262.351Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M529.011 267.074C529.011 268.144 528.144 269.012 527.074 269.012C526.004 269.012 525.136 268.144 525.136 267.074C525.136 266.004 526.004 265.137 527.074 265.137C528.144 265.137 529.011 266.004 529.011 267.074Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M533.734 267.074C533.734 268.144 532.867 269.012 531.797 269.012C530.727 269.012 529.859 268.144 529.859 267.074C529.859 266.004 530.727 265.137 531.797 265.137C532.867 265.137 533.734 266.004 533.734 267.074Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M533.734 271.797C533.734 272.867 532.867 273.734 531.797 273.734C530.727 273.734 529.859 272.867 529.859 271.797C529.859 270.727 530.727 269.859 531.797 269.859C532.867 269.859 533.734 270.727 533.734 271.797Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M538.457 271.797C538.457 272.867 537.59 273.734 536.52 273.734C535.45 273.734 534.582 272.867 534.582 271.797C534.582 270.727 535.45 269.859 536.52 269.859C537.59 269.859 538.457 270.727 538.457 271.797Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M538.457 276.519C538.457 277.589 537.59 278.457 536.52 278.457C535.45 278.457 534.582 277.589 534.582 276.519C534.582 275.449 535.45 274.582 536.52 274.582C537.59 274.582 538.457 275.449 538.457 276.519Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M538.457 281.246C538.457 282.316 537.59 283.184 536.52 283.184C535.45 283.184 534.582 282.316 534.582 281.246C534.582 280.176 535.45 279.308 536.52 279.308C537.59 279.308 538.457 280.176 538.457 281.246Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M533.734 281.246C533.734 282.316 532.867 283.184 531.797 283.184C530.727 283.184 529.859 282.316 529.859 281.246C529.859 280.176 530.727 279.308 531.797 279.308C532.867 279.308 533.734 280.176 533.734 281.246Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M533.734 285.969C533.734 287.039 532.867 287.906 531.797 287.906C530.727 287.906 529.859 287.039 529.859 285.969C529.859 284.899 530.727 284.031 531.797 284.031C532.867 284.031 533.734 284.899 533.734 285.969Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M529.011 285.969C529.011 287.039 528.144 287.906 527.074 287.906C526.004 287.906 525.136 287.039 525.136 285.969C525.136 284.899 526.004 284.031 527.074 284.031C528.144 284.031 529.011 284.899 529.011 285.969Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M529.011 290.691C529.011 291.761 528.144 292.629 527.074 292.629C526.004 292.629 525.136 291.761 525.136 290.691C525.136 289.621 526.004 288.754 527.074 288.754C528.144 288.754 529.011 289.621 529.011 290.691Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M524.288 285.969C524.288 287.039 523.421 287.906 522.351 287.906C521.281 287.906 520.413 287.039 520.413 285.969C520.413 284.899 521.281 284.031 522.351 284.031C523.421 284.031 524.288 284.899 524.288 285.969Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M524.288 281.246C524.288 282.316 523.421 283.184 522.351 283.184C521.281 283.184 520.413 282.316 520.413 281.246C520.413 280.176 521.281 279.308 522.351 279.308C523.421 279.308 524.288 280.176 524.288 281.246Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M529.011 281.246C529.011 282.316 528.144 283.184 527.074 283.184C526.004 283.184 525.136 282.316 525.136 281.246C525.136 280.176 526.004 279.308 527.074 279.308C528.144 279.308 529.011 280.176 529.011 281.246Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M529.011 276.519C529.011 277.589 528.144 278.457 527.074 278.457C526.004 278.457 525.136 277.589 525.136 276.519C525.136 275.449 526.004 274.582 527.074 274.582C528.144 274.582 529.011 275.449 529.011 276.519Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M533.734 276.519C533.734 277.589 532.867 278.457 531.797 278.457C530.727 278.457 529.859 277.589 529.859 276.519C529.859 275.449 530.727 274.582 531.797 274.582C532.867 274.582 533.734 275.449 533.734 276.519Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M529.011 271.797C529.011 272.867 528.144 273.734 527.074 273.734C526.004 273.734 525.136 272.867 525.136 271.797C525.136 270.727 526.004 269.859 527.074 269.859C528.144 269.859 529.011 270.727 529.011 271.797Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M524.288 271.797C524.288 272.867 523.421 273.734 522.351 273.734C521.281 273.734 520.413 272.867 520.413 271.797C520.413 270.727 521.281 269.859 522.351 269.859C523.421 269.859 524.288 270.727 524.288 271.797Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M524.288 267.074C524.288 268.144 523.421 269.012 522.351 269.012C521.281 269.012 520.413 268.144 520.413 267.074C520.413 266.004 521.281 265.137 522.351 265.137C523.421 265.137 524.288 266.004 524.288 267.074Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M524.288 262.351C524.288 263.421 523.421 264.289 522.351 264.289C521.281 264.289 520.413 263.421 520.413 262.351C520.413 261.281 521.281 260.414 522.351 260.414C523.421 260.414 524.288 261.281 524.288 262.351Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M519.565 262.351C519.565 263.421 518.697 264.289 517.627 264.289C516.557 264.289 515.689 263.421 515.689 262.351C515.689 261.281 516.557 260.414 517.627 260.414C518.697 260.414 519.565 261.281 519.565 262.351Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M514.841 262.351C514.841 263.421 513.974 264.289 512.904 264.289C511.834 264.289 510.966 263.421 510.966 262.351C510.966 261.281 511.834 260.414 512.904 260.414C513.974 260.414 514.841 261.281 514.841 262.351Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M519.565 257.629C519.565 258.699 518.697 259.566 517.627 259.566C516.557 259.566 515.689 258.699 515.689 257.629C515.689 256.559 516.557 255.691 517.627 255.691C518.697 255.691 519.565 256.559 519.565 257.629Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M514.841 257.629C514.841 258.699 513.974 259.566 512.904 259.566C511.834 259.566 510.966 258.699 510.966 257.629C510.966 256.559 511.834 255.691 512.904 255.691C513.974 255.691 514.841 256.559 514.841 257.629Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M510.118 257.629C510.118 258.699 509.251 259.566 508.181 259.566C507.111 259.566 506.243 258.699 506.243 257.629C506.243 256.559 507.111 255.691 508.181 255.691C509.251 255.691 510.118 256.559 510.118 257.629Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M510.118 262.351C510.118 263.421 509.251 264.289 508.181 264.289C507.111 264.289 506.243 263.421 506.243 262.351C506.243 261.281 507.111 260.414 508.181 260.414C509.251 260.414 510.118 261.281 510.118 262.351Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M505.395 262.351C505.395 263.421 504.528 264.289 503.458 264.289C502.388 264.289 501.52 263.421 501.52 262.351C501.52 261.281 502.388 260.414 503.458 260.414C504.528 260.414 505.395 261.281 505.395 262.351Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M500.672 262.351C500.672 263.421 499.805 264.289 498.735 264.289C497.665 264.289 496.797 263.421 496.797 262.351C496.797 261.281 497.665 260.414 498.735 260.414C499.805 260.414 500.672 261.281 500.672 262.351Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M500.672 267.074C500.672 268.144 499.805 269.012 498.735 269.012C497.665 269.012 496.797 268.144 496.797 267.074C496.797 266.004 497.665 265.137 498.735 265.137C499.805 265.137 500.672 266.004 500.672 267.074Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M495.949 267.074C495.949 268.144 495.082 269.012 494.012 269.012C492.942 269.012 492.074 268.144 492.074 267.074C492.074 266.004 492.942 265.137 494.012 265.137C495.082 265.137 495.949 266.004 495.949 267.074Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M491.226 267.074C491.226 268.144 490.359 269.012 489.289 269.012C488.219 269.012 487.351 268.144 487.351 267.074C487.351 266.004 488.219 265.137 489.289 265.137C490.359 265.137 491.226 266.004 491.226 267.074Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M486.503 267.074C486.503 268.144 485.635 269.012 484.565 269.012C483.495 269.012 482.627 268.144 482.627 267.074C482.627 266.004 483.495 265.137 484.565 265.137C485.635 265.137 486.503 266.004 486.503 267.074Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M486.503 271.797C486.503 272.867 485.635 273.734 484.565 273.734C483.495 273.734 482.627 272.867 482.627 271.797C482.627 270.727 483.495 269.859 484.565 269.859C485.635 269.859 486.503 270.727 486.503 271.797Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M486.503 276.519C486.503 277.589 485.635 278.457 484.565 278.457C483.495 278.457 482.627 277.589 482.627 276.519C482.627 275.449 483.495 274.582 484.565 274.582C485.635 274.582 486.503 275.449 486.503 276.519Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M486.503 281.246C486.503 282.316 485.635 283.184 484.565 283.184C483.495 283.184 482.627 282.316 482.627 281.246C482.627 280.176 483.495 279.308 484.565 279.308C485.635 279.308 486.503 280.176 486.503 281.246Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M491.226 276.519C491.226 277.589 490.359 278.457 489.289 278.457C488.219 278.457 487.351 277.589 487.351 276.519C487.351 275.449 488.219 274.582 489.289 274.582C490.359 274.582 491.226 275.449 491.226 276.519Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M491.226 271.797C491.226 272.867 490.359 273.734 489.289 273.734C488.219 273.734 487.351 272.867 487.351 271.797C487.351 270.727 488.219 269.859 489.289 269.859C490.359 269.859 491.226 270.727 491.226 271.797Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M495.949 271.797C495.949 272.867 495.082 273.734 494.012 273.734C492.942 273.734 492.074 272.867 492.074 271.797C492.074 270.727 492.942 269.859 494.012 269.859C495.082 269.859 495.949 270.727 495.949 271.797Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M500.672 271.797C500.672 272.867 499.805 273.734 498.735 273.734C497.665 273.734 496.797 272.867 496.797 271.797C496.797 270.727 497.665 269.859 498.735 269.859C499.805 269.859 500.672 270.727 500.672 271.797Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M505.395 271.797C505.395 272.867 504.528 273.734 503.458 273.734C502.388 273.734 501.52 272.867 501.52 271.797C501.52 270.727 502.388 269.859 503.458 269.859C504.528 269.859 505.395 270.727 505.395 271.797Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M505.395 267.074C505.395 268.144 504.528 269.012 503.458 269.012C502.388 269.012 501.52 268.144 501.52 267.074C501.52 266.004 502.388 265.137 503.458 265.137C504.528 265.137 505.395 266.004 505.395 267.074Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M510.118 267.074C510.118 268.144 509.251 269.012 508.181 269.012C507.111 269.012 506.243 268.144 506.243 267.074C506.243 266.004 507.111 265.137 508.181 265.137C509.251 265.137 510.118 266.004 510.118 267.074Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M514.841 267.074C514.841 268.144 513.974 269.012 512.904 269.012C511.834 269.012 510.966 268.144 510.966 267.074C510.966 266.004 511.834 265.137 512.904 265.137C513.974 265.137 514.841 266.004 514.841 267.074Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M519.565 267.074C519.565 268.144 518.697 269.012 517.627 269.012C516.557 269.012 515.689 268.144 515.689 267.074C515.689 266.004 516.557 265.137 517.627 265.137C518.697 265.137 519.565 266.004 519.565 267.074Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M519.565 271.797C519.565 272.867 518.697 273.734 517.627 273.734C516.557 273.734 515.689 272.867 515.689 271.797C515.689 270.727 516.557 269.859 517.627 269.859C518.697 269.859 519.565 270.727 519.565 271.797Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M524.288 276.519C524.288 277.589 523.421 278.457 522.351 278.457C521.281 278.457 520.413 277.589 520.413 276.519C520.413 275.449 521.281 274.582 522.351 274.582C523.421 274.582 524.288 275.449 524.288 276.519Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M519.565 276.519C519.565 277.589 518.697 278.457 517.627 278.457C516.557 278.457 515.689 277.589 515.689 276.519C515.689 275.449 516.557 274.582 517.627 274.582C518.697 274.582 519.565 275.449 519.565 276.519Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M519.565 281.246C519.565 282.316 518.697 283.184 517.627 283.184C516.557 283.184 515.689 282.316 515.689 281.246C515.689 280.176 516.557 279.308 517.627 279.308C518.697 279.308 519.565 280.176 519.565 281.246Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M514.841 276.519C514.841 277.589 513.974 278.457 512.904 278.457C511.834 278.457 510.966 277.589 510.966 276.519C510.966 275.449 511.834 274.582 512.904 274.582C513.974 274.582 514.841 275.449 514.841 276.519Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M514.841 271.797C514.841 272.867 513.974 273.734 512.904 273.734C511.834 273.734 510.966 272.867 510.966 271.797C510.966 270.727 511.834 269.859 512.904 269.859C513.974 269.859 514.841 270.727 514.841 271.797Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M510.118 271.797C510.118 272.867 509.251 273.734 508.181 273.734C507.111 273.734 506.243 272.867 506.243 271.797C506.243 270.727 507.111 269.859 508.181 269.859C509.251 269.859 510.118 270.727 510.118 271.797Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M510.118 276.519C510.118 277.589 509.251 278.457 508.181 278.457C507.111 278.457 506.243 277.589 506.243 276.519C506.243 275.449 507.111 274.582 508.181 274.582C509.251 274.582 510.118 275.449 510.118 276.519Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M505.395 276.519C505.395 277.589 504.528 278.457 503.458 278.457C502.388 278.457 501.52 277.589 501.52 276.519C501.52 275.449 502.388 274.582 503.458 274.582C504.528 274.582 505.395 275.449 505.395 276.519Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M500.672 276.519C500.672 277.589 499.805 278.457 498.735 278.457C497.665 278.457 496.797 277.589 496.797 276.519C496.797 275.449 497.665 274.582 498.735 274.582C499.805 274.582 500.672 275.449 500.672 276.519Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M495.949 276.519C495.949 277.589 495.082 278.457 494.012 278.457C492.942 278.457 492.074 277.589 492.074 276.519C492.074 275.449 492.942 274.582 494.012 274.582C495.082 274.582 495.949 275.449 495.949 276.519Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M529.011 234.012C529.011 235.082 528.144 235.949 527.074 235.949C526.004 235.949 525.136 235.082 525.136 234.012C525.136 232.942 526.004 232.074 527.074 232.074C528.144 232.074 529.011 232.942 529.011 234.012Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M538.457 234.012C538.457 235.082 537.59 235.949 536.52 235.949C535.45 235.949 534.582 235.082 534.582 234.012C534.582 232.942 535.45 232.074 536.52 232.074C537.59 232.074 538.457 232.942 538.457 234.012Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M547.903 229.289C547.903 230.359 547.036 231.227 545.966 231.227C544.896 231.227 544.028 230.359 544.028 229.289C544.028 228.219 544.896 227.351 545.966 227.351C547.036 227.351 547.903 228.219 547.903 229.289Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M557.35 234.012C557.35 235.082 556.483 235.949 555.413 235.949C554.343 235.949 553.475 235.082 553.475 234.012C553.475 232.942 554.343 232.074 555.413 232.074C556.483 232.074 557.35 232.942 557.35 234.012Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M562.073 234.012C562.073 235.082 561.206 235.949 560.136 235.949C559.066 235.949 558.198 235.082 558.198 234.012C558.198 232.942 559.066 232.074 560.136 232.074C561.206 232.074 562.073 232.942 562.073 234.012Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M566.796 238.734C566.796 239.804 565.929 240.672 564.859 240.672C563.789 240.672 562.921 239.804 562.921 238.734C562.921 237.664 563.789 236.797 564.859 236.797C565.929 236.797 566.796 237.664 566.796 238.734Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M576.242 252.906C576.242 253.976 575.375 254.844 574.305 254.844C573.235 254.844 572.367 253.976 572.367 252.906C572.367 251.836 573.235 250.969 574.305 250.969C575.375 250.969 576.242 251.836 576.242 252.906Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M595.135 252.906C595.135 253.976 594.268 254.844 593.198 254.844C592.128 254.844 591.26 253.976 591.26 252.906C591.26 251.836 592.128 250.969 593.198 250.969C594.268 250.969 595.135 251.836 595.135 252.906Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M571.52 262.351C571.52 263.421 570.652 264.289 569.582 264.289C568.513 264.289 567.645 263.421 567.645 262.351C567.645 261.281 568.513 260.414 569.582 260.414C570.652 260.414 571.52 261.281 571.52 262.351Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M543.18 238.734C543.18 239.804 542.313 240.672 541.243 240.672C540.173 240.672 539.305 239.804 539.305 238.734C539.305 237.664 540.173 236.797 541.243 236.797C542.313 236.797 543.18 237.664 543.18 238.734Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M495.949 229.289C495.949 230.359 495.082 231.227 494.012 231.227C492.942 231.227 492.074 230.359 492.074 229.289C492.074 228.219 492.942 227.351 494.012 227.351C495.082 227.351 495.949 228.219 495.949 229.289Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M481.779 224.566C481.779 225.636 480.912 226.504 479.842 226.504C478.772 226.504 477.904 225.636 477.904 224.566C477.904 223.496 478.772 222.629 479.842 222.629C480.912 222.629 481.779 223.496 481.779 224.566Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M467.61 229.289C467.61 230.359 466.743 231.227 465.673 231.227C464.603 231.227 463.735 230.359 463.735 229.289C463.735 228.219 464.603 227.351 465.673 227.351C466.743 227.351 467.61 228.219 467.61 229.289Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M472.333 234.012C472.333 235.082 471.466 235.949 470.396 235.949C469.326 235.949 468.458 235.082 468.458 234.012C468.458 232.942 469.326 232.074 470.396 232.074C471.466 232.074 472.333 232.942 472.333 234.012Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M477.056 234.012C477.056 235.082 476.189 235.949 475.119 235.949C474.049 235.949 473.181 235.082 473.181 234.012C473.181 232.942 474.049 232.074 475.119 232.074C476.189 232.074 477.056 232.942 477.056 234.012Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M481.779 234.012C481.779 235.082 480.912 235.949 479.842 235.949C478.772 235.949 477.904 235.082 477.904 234.012C477.904 232.942 478.772 232.074 479.842 232.074C480.912 232.074 481.779 232.942 481.779 234.012Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M491.226 238.734C491.226 239.804 490.359 240.672 489.289 240.672C488.219 240.672 487.351 239.804 487.351 238.734C487.351 237.664 488.219 236.797 489.289 236.797C490.359 236.797 491.226 237.664 491.226 238.734Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M495.949 238.734C495.949 239.804 495.082 240.672 494.012 240.672C492.942 240.672 492.074 239.804 492.074 238.734C492.074 237.664 492.942 236.797 494.012 236.797C495.082 236.797 495.949 237.664 495.949 238.734Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M500.672 238.734C500.672 239.804 499.805 240.672 498.735 240.672C497.665 240.672 496.797 239.804 496.797 238.734C496.797 237.664 497.665 236.797 498.735 236.797C499.805 236.797 500.672 237.664 500.672 238.734Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M458.164 219.844C458.164 220.914 457.296 221.781 456.226 221.781C455.156 221.781 454.288 220.914 454.288 219.844C454.288 218.774 455.156 217.906 456.226 217.906C457.296 217.906 458.164 218.774 458.164 219.844Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M453.44 215.121C453.44 216.191 452.573 217.059 451.503 217.059C450.433 217.059 449.565 216.191 449.565 215.121C449.565 214.051 450.433 213.183 451.503 213.183C452.573 213.183 453.44 214.051 453.44 215.121Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M462.887 191.504C462.887 192.574 462.019 193.441 460.949 193.441C459.879 193.441 459.011 192.574 459.011 191.504C459.011 190.434 459.879 189.566 460.949 189.566C462.019 189.566 462.887 190.434 462.887 191.504Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M467.61 191.504C467.61 192.574 466.743 193.441 465.673 193.441C464.603 193.441 463.735 192.574 463.735 191.504C463.735 190.434 464.603 189.566 465.673 189.566C466.743 189.566 467.61 190.434 467.61 191.504Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M462.887 186.781C462.887 187.851 462.019 188.719 460.949 188.719C459.879 188.719 459.011 187.851 459.011 186.781C459.011 185.711 459.879 184.844 460.949 184.844C462.019 184.844 462.887 185.711 462.887 186.781Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M462.887 182.059C462.887 183.128 462.019 183.996 460.949 183.996C459.879 183.996 459.011 183.128 459.011 182.059C459.011 180.989 459.879 180.121 460.949 180.121C462.019 180.121 462.887 180.989 462.887 182.059Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M458.164 182.059C458.164 183.128 457.296 183.996 456.226 183.996C455.156 183.996 454.288 183.128 454.288 182.059C454.288 180.989 455.156 180.121 456.226 180.121C457.296 180.121 458.164 180.989 458.164 182.059Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M453.44 182.059C453.44 183.128 452.573 183.996 451.503 183.996C450.433 183.996 449.565 183.128 449.565 182.059C449.565 180.989 450.433 180.121 451.503 180.121C452.573 180.121 453.44 180.989 453.44 182.059Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M453.44 177.336C453.44 178.406 452.573 179.273 451.503 179.273C450.433 179.273 449.565 178.406 449.565 177.336C449.565 176.266 450.433 175.398 451.503 175.398C452.573 175.398 453.44 176.266 453.44 177.336Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M458.164 177.336C458.164 178.406 457.296 179.273 456.226 179.273C455.156 179.273 454.288 178.406 454.288 177.336C454.288 176.266 455.156 175.398 456.226 175.398C457.296 175.398 458.164 176.266 458.164 177.336Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M462.887 177.336C462.887 178.406 462.019 179.273 460.949 179.273C459.879 179.273 459.011 178.406 459.011 177.336C459.011 176.266 459.879 175.398 460.949 175.398C462.019 175.398 462.887 176.266 462.887 177.336Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M467.61 177.336C467.61 178.406 466.743 179.273 465.673 179.273C464.603 179.273 463.735 178.406 463.735 177.336C463.735 176.266 464.603 175.398 465.673 175.398C466.743 175.398 467.61 176.266 467.61 177.336Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M472.333 177.336C472.333 178.406 471.466 179.273 470.396 179.273C469.326 179.273 468.458 178.406 468.458 177.336C468.458 176.266 469.326 175.398 470.396 175.398C471.466 175.398 472.333 176.266 472.333 177.336Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M477.056 177.336C477.056 178.406 476.189 179.273 475.119 179.273C474.049 179.273 473.181 178.406 473.181 177.336C473.181 176.266 474.049 175.398 475.119 175.398C476.189 175.398 477.056 176.266 477.056 177.336Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M477.056 186.781C477.056 187.851 476.189 188.719 475.119 188.719C474.049 188.719 473.181 187.851 473.181 186.781C473.181 185.711 474.049 184.844 475.119 184.844C476.189 184.844 477.056 185.711 477.056 186.781Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M477.056 172.613C477.056 173.683 476.189 174.551 475.119 174.551C474.049 174.551 473.181 173.683 473.181 172.613C473.181 171.543 474.049 170.676 475.119 170.676C476.189 170.676 477.056 171.543 477.056 172.613Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M481.779 172.613C481.779 173.683 480.912 174.551 479.842 174.551C478.772 174.551 477.904 173.683 477.904 172.613C477.904 171.543 478.772 170.676 479.842 170.676C480.912 170.676 481.779 171.543 481.779 172.613Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M486.503 172.613C486.503 173.683 485.635 174.551 484.565 174.551C483.495 174.551 482.627 173.683 482.627 172.613C482.627 171.543 483.495 170.676 484.565 170.676C485.635 170.676 486.503 171.543 486.503 172.613Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M491.226 177.336C491.226 178.406 490.359 179.273 489.289 179.273C488.219 179.273 487.351 178.406 487.351 177.336C487.351 176.266 488.219 175.398 489.289 175.398C490.359 175.398 491.226 176.266 491.226 177.336Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M495.949 191.504C495.949 192.574 495.082 193.441 494.012 193.441C492.942 193.441 492.074 192.574 492.074 191.504C492.074 190.434 492.942 189.566 494.012 189.566C495.082 189.566 495.949 190.434 495.949 191.504Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M495.949 196.226C495.949 197.296 495.082 198.164 494.012 198.164C492.942 198.164 492.074 197.296 492.074 196.226C492.074 195.156 492.942 194.289 494.012 194.289C495.082 194.289 495.949 195.156 495.949 196.226Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M500.672 200.949C500.672 202.019 499.805 202.887 498.735 202.887C497.665 202.887 496.797 202.019 496.797 200.949C496.797 199.879 497.665 199.012 498.735 199.012C499.805 199.012 500.672 199.879 500.672 200.949Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M500.672 205.672C500.672 206.742 499.805 207.609 498.735 207.609C497.665 207.609 496.797 206.742 496.797 205.672C496.797 204.602 497.665 203.734 498.735 203.734C499.805 203.734 500.672 204.602 500.672 205.672Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M505.395 205.672C505.395 206.742 504.528 207.609 503.458 207.609C502.388 207.609 501.52 206.742 501.52 205.672C501.52 204.602 502.388 203.734 503.458 203.734C504.528 203.734 505.395 204.602 505.395 205.672Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M486.503 167.887C486.503 168.957 485.635 169.824 484.565 169.824C483.495 169.824 482.627 168.957 482.627 167.887C482.627 166.817 483.495 165.949 484.565 165.949C485.635 165.949 486.503 166.817 486.503 167.887Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M486.503 163.164C486.503 164.234 485.635 165.102 484.565 165.102C483.495 165.102 482.627 164.234 482.627 163.164C482.627 162.094 483.495 161.226 484.565 161.226C485.635 161.226 486.503 162.094 486.503 163.164Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M491.226 163.164C491.226 164.234 490.359 165.102 489.289 165.102C488.219 165.102 487.351 164.234 487.351 163.164C487.351 162.094 488.219 161.226 489.289 161.226C490.359 161.226 491.226 162.094 491.226 163.164Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M486.503 158.441C486.503 159.511 485.635 160.379 484.565 160.379C483.495 160.379 482.627 159.511 482.627 158.441C482.627 157.371 483.495 156.504 484.565 156.504C485.635 156.504 486.503 157.371 486.503 158.441Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M481.779 158.441C481.779 159.511 480.912 160.379 479.842 160.379C478.772 160.379 477.904 159.511 477.904 158.441C477.904 157.371 478.772 156.504 479.842 156.504C480.912 156.504 481.779 157.371 481.779 158.441Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M481.779 153.719C481.779 154.789 480.912 155.656 479.842 155.656C478.772 155.656 477.904 154.789 477.904 153.719C477.904 152.649 478.772 151.781 479.842 151.781C480.912 151.781 481.779 152.649 481.779 153.719Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M481.779 148.996C481.779 150.066 480.912 150.934 479.842 150.934C478.772 150.934 477.904 150.066 477.904 148.996C477.904 147.926 478.772 147.058 479.842 147.058C480.912 147.058 481.779 147.926 481.779 148.996Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M477.056 148.996C477.056 150.066 476.189 150.934 475.119 150.934C474.049 150.934 473.181 150.066 473.181 148.996C473.181 147.926 474.049 147.058 475.119 147.058C476.189 147.058 477.056 147.926 477.056 148.996Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M477.056 144.273C477.056 145.343 476.189 146.211 475.119 146.211C474.049 146.211 473.181 145.343 473.181 144.273C473.181 143.203 474.049 142.336 475.119 142.336C476.189 142.336 477.056 143.203 477.056 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M477.056 139.551C477.056 140.621 476.189 141.488 475.119 141.488C474.049 141.488 473.181 140.621 473.181 139.551C473.181 138.481 474.049 137.613 475.119 137.613C476.189 137.613 477.056 138.481 477.056 139.551Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M481.779 139.551C481.779 140.621 480.912 141.488 479.842 141.488C478.772 141.488 477.904 140.621 477.904 139.551C477.904 138.481 478.772 137.613 479.842 137.613C480.912 137.613 481.779 138.481 481.779 139.551Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M477.056 134.828C477.056 135.898 476.189 136.766 475.119 136.766C474.049 136.766 473.181 135.898 473.181 134.828C473.181 133.758 474.049 132.89 475.119 132.89C476.189 132.89 477.056 133.758 477.056 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M481.779 134.828C481.779 135.898 480.912 136.766 479.842 136.766C478.772 136.766 477.904 135.898 477.904 134.828C477.904 133.758 478.772 132.89 479.842 132.89C480.912 132.89 481.779 133.758 481.779 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M486.503 134.828C486.503 135.898 485.635 136.766 484.565 136.766C483.495 136.766 482.627 135.898 482.627 134.828C482.627 133.758 483.495 132.89 484.565 132.89C485.635 132.89 486.503 133.758 486.503 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M491.226 134.828C491.226 135.898 490.359 136.766 489.289 136.766C488.219 136.766 487.351 135.898 487.351 134.828C487.351 133.758 488.219 132.89 489.289 132.89C490.359 132.89 491.226 133.758 491.226 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M495.949 134.828C495.949 135.898 495.082 136.766 494.012 136.766C492.942 136.766 492.074 135.898 492.074 134.828C492.074 133.758 492.942 132.89 494.012 132.89C495.082 132.89 495.949 133.758 495.949 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M495.949 130.101C495.949 131.171 495.082 132.039 494.012 132.039C492.942 132.039 492.074 131.171 492.074 130.101C492.074 129.031 492.942 128.164 494.012 128.164C495.082 128.164 495.949 129.031 495.949 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M495.949 125.379C495.949 126.449 495.082 127.316 494.012 127.316C492.942 127.316 492.074 126.449 492.074 125.379C492.074 124.309 492.942 123.441 494.012 123.441C495.082 123.441 495.949 124.309 495.949 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M500.672 125.379C500.672 126.449 499.805 127.316 498.735 127.316C497.665 127.316 496.797 126.449 496.797 125.379C496.797 124.309 497.665 123.441 498.735 123.441C499.805 123.441 500.672 124.309 500.672 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M505.395 125.379C505.395 126.449 504.528 127.316 503.458 127.316C502.388 127.316 501.52 126.449 501.52 125.379C501.52 124.309 502.388 123.441 503.458 123.441C504.528 123.441 505.395 124.309 505.395 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M505.395 120.656C505.395 121.726 504.528 122.594 503.458 122.594C502.388 122.594 501.52 121.726 501.52 120.656C501.52 119.586 502.388 118.719 503.458 118.719C504.528 118.719 505.395 119.586 505.395 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M505.395 115.934C505.395 117.003 504.528 117.871 503.458 117.871C502.388 117.871 501.52 117.003 501.52 115.934C501.52 114.864 502.388 113.996 503.458 113.996C504.528 113.996 505.395 114.864 505.395 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M505.395 111.211C505.395 112.281 504.528 113.148 503.458 113.148C502.388 113.148 501.52 112.281 501.52 111.211C501.52 110.141 502.388 109.273 503.458 109.273C504.528 109.273 505.395 110.141 505.395 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M505.395 106.488C505.395 107.558 504.528 108.426 503.458 108.426C502.388 108.426 501.52 107.558 501.52 106.488C501.52 105.418 502.388 104.551 503.458 104.551C504.528 104.551 505.395 105.418 505.395 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M505.395 101.766C505.395 102.836 504.528 103.703 503.458 103.703C502.388 103.703 501.52 102.836 501.52 101.766C501.52 100.696 502.388 99.828 503.458 99.828C504.528 99.828 505.395 100.696 505.395 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M510.118 101.766C510.118 102.836 509.251 103.703 508.181 103.703C507.111 103.703 506.243 102.836 506.243 101.766C506.243 100.696 507.111 99.828 508.181 99.828C509.251 99.828 510.118 100.696 510.118 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M514.841 106.488C514.841 107.558 513.974 108.426 512.904 108.426C511.834 108.426 510.966 107.558 510.966 106.488C510.966 105.418 511.834 104.551 512.904 104.551C513.974 104.551 514.841 105.418 514.841 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M514.841 111.211C514.841 112.281 513.974 113.148 512.904 113.148C511.834 113.148 510.966 112.281 510.966 111.211C510.966 110.141 511.834 109.273 512.904 109.273C513.974 109.273 514.841 110.141 514.841 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M514.841 115.934C514.841 117.003 513.974 117.871 512.904 117.871C511.834 117.871 510.966 117.003 510.966 115.934C510.966 114.864 511.834 113.996 512.904 113.996C513.974 113.996 514.841 114.864 514.841 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M519.565 125.379C519.565 126.449 518.697 127.316 517.627 127.316C516.557 127.316 515.689 126.449 515.689 125.379C515.689 124.309 516.557 123.441 517.627 123.441C518.697 123.441 519.565 124.309 519.565 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M524.288 125.379C524.288 126.449 523.421 127.316 522.351 127.316C521.281 127.316 520.413 126.449 520.413 125.379C520.413 124.309 521.281 123.441 522.351 123.441C523.421 123.441 524.288 124.309 524.288 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M529.011 120.656C529.011 121.726 528.144 122.594 527.074 122.594C526.004 122.594 525.136 121.726 525.136 120.656C525.136 119.586 526.004 118.719 527.074 118.719C528.144 118.719 529.011 119.586 529.011 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M533.734 111.211C533.734 112.281 532.867 113.148 531.797 113.148C530.727 113.148 529.859 112.281 529.859 111.211C529.859 110.141 530.727 109.273 531.797 109.273C532.867 109.273 533.734 110.141 533.734 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M519.565 130.101C519.565 131.171 518.697 132.039 517.627 132.039C516.557 132.039 515.689 131.171 515.689 130.101C515.689 129.031 516.557 128.164 517.627 128.164C518.697 128.164 519.565 129.031 519.565 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M519.565 134.828C519.565 135.898 518.697 136.766 517.627 136.766C516.557 136.766 515.689 135.898 515.689 134.828C515.689 133.758 516.557 132.89 517.627 132.89C518.697 132.89 519.565 133.758 519.565 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M519.565 139.551C519.565 140.621 518.697 141.488 517.627 141.488C516.557 141.488 515.689 140.621 515.689 139.551C515.689 138.481 516.557 137.613 517.627 137.613C518.697 137.613 519.565 138.481 519.565 139.551Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M519.565 144.273C519.565 145.343 518.697 146.211 517.627 146.211C516.557 146.211 515.689 145.343 515.689 144.273C515.689 143.203 516.557 142.336 517.627 142.336C518.697 142.336 519.565 143.203 519.565 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M514.841 148.996C514.841 150.066 513.974 150.934 512.904 150.934C511.834 150.934 510.966 150.066 510.966 148.996C510.966 147.926 511.834 147.058 512.904 147.058C513.974 147.058 514.841 147.926 514.841 148.996Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M510.118 153.719C510.118 154.789 509.251 155.656 508.181 155.656C507.111 155.656 506.243 154.789 506.243 153.719C506.243 152.649 507.111 151.781 508.181 151.781C509.251 151.781 510.118 152.649 510.118 153.719Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M505.395 158.441C505.395 159.511 504.528 160.379 503.458 160.379C502.388 160.379 501.52 159.511 501.52 158.441C501.52 157.371 502.388 156.504 503.458 156.504C504.528 156.504 505.395 157.371 505.395 158.441Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M500.672 101.766C500.672 102.836 499.805 103.703 498.735 103.703C497.665 103.703 496.797 102.836 496.797 101.766C496.797 100.696 497.665 99.828 498.735 99.828C499.805 99.828 500.672 100.696 500.672 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M495.949 101.766C495.949 102.836 495.082 103.703 494.012 103.703C492.942 103.703 492.074 102.836 492.074 101.766C492.074 100.696 492.942 99.828 494.012 99.828C495.082 99.828 495.949 100.696 495.949 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M495.949 106.488C495.949 107.558 495.082 108.426 494.012 108.426C492.942 108.426 492.074 107.558 492.074 106.488C492.074 105.418 492.942 104.551 494.012 104.551C495.082 104.551 495.949 105.418 495.949 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M500.672 106.488C500.672 107.558 499.805 108.426 498.735 108.426C497.665 108.426 496.797 107.558 496.797 106.488C496.797 105.418 497.665 104.551 498.735 104.551C499.805 104.551 500.672 105.418 500.672 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M500.672 111.211C500.672 112.281 499.805 113.148 498.735 113.148C497.665 113.148 496.797 112.281 496.797 111.211C496.797 110.141 497.665 109.273 498.735 109.273C499.805 109.273 500.672 110.141 500.672 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M500.672 115.934C500.672 117.003 499.805 117.871 498.735 117.871C497.665 117.871 496.797 117.003 496.797 115.934C496.797 114.864 497.665 113.996 498.735 113.996C499.805 113.996 500.672 114.864 500.672 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M500.672 120.656C500.672 121.726 499.805 122.594 498.735 122.594C497.665 122.594 496.797 121.726 496.797 120.656C496.797 119.586 497.665 118.719 498.735 118.719C499.805 118.719 500.672 119.586 500.672 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M495.949 120.656C495.949 121.726 495.082 122.594 494.012 122.594C492.942 122.594 492.074 121.726 492.074 120.656C492.074 119.586 492.942 118.719 494.012 118.719C495.082 118.719 495.949 119.586 495.949 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M495.949 115.934C495.949 117.003 495.082 117.871 494.012 117.871C492.942 117.871 492.074 117.003 492.074 115.934C492.074 114.864 492.942 113.996 494.012 113.996C495.082 113.996 495.949 114.864 495.949 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M495.949 111.211C495.949 112.281 495.082 113.148 494.012 113.148C492.942 113.148 492.074 112.281 492.074 111.211C492.074 110.141 492.942 109.273 494.012 109.273C495.082 109.273 495.949 110.141 495.949 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M491.226 111.211C491.226 112.281 490.359 113.148 489.289 113.148C488.219 113.148 487.351 112.281 487.351 111.211C487.351 110.141 488.219 109.273 489.289 109.273C490.359 109.273 491.226 110.141 491.226 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M491.226 115.934C491.226 117.003 490.359 117.871 489.289 117.871C488.219 117.871 487.351 117.003 487.351 115.934C487.351 114.864 488.219 113.996 489.289 113.996C490.359 113.996 491.226 114.864 491.226 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M491.226 120.656C491.226 121.726 490.359 122.594 489.289 122.594C488.219 122.594 487.351 121.726 487.351 120.656C487.351 119.586 488.219 118.719 489.289 118.719C490.359 118.719 491.226 119.586 491.226 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M491.226 125.379C491.226 126.449 490.359 127.316 489.289 127.316C488.219 127.316 487.351 126.449 487.351 125.379C487.351 124.309 488.219 123.441 489.289 123.441C490.359 123.441 491.226 124.309 491.226 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M491.226 130.101C491.226 131.171 490.359 132.039 489.289 132.039C488.219 132.039 487.351 131.171 487.351 130.101C487.351 129.031 488.219 128.164 489.289 128.164C490.359 128.164 491.226 129.031 491.226 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M486.503 130.101C486.503 131.171 485.635 132.039 484.565 132.039C483.495 132.039 482.627 131.171 482.627 130.101C482.627 129.031 483.495 128.164 484.565 128.164C485.635 128.164 486.503 129.031 486.503 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M481.779 130.101C481.779 131.171 480.912 132.039 479.842 132.039C478.772 132.039 477.904 131.171 477.904 130.101C477.904 129.031 478.772 128.164 479.842 128.164C480.912 128.164 481.779 129.031 481.779 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M477.056 130.101C477.056 131.171 476.189 132.039 475.119 132.039C474.049 132.039 473.181 131.171 473.181 130.101C473.181 129.031 474.049 128.164 475.119 128.164C476.189 128.164 477.056 129.031 477.056 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M472.333 130.101C472.333 131.171 471.466 132.039 470.396 132.039C469.326 132.039 468.458 131.171 468.458 130.101C468.458 129.031 469.326 128.164 470.396 128.164C471.466 128.164 472.333 129.031 472.333 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M467.61 130.101C467.61 131.171 466.743 132.039 465.673 132.039C464.603 132.039 463.735 131.171 463.735 130.101C463.735 129.031 464.603 128.164 465.673 128.164C466.743 128.164 467.61 129.031 467.61 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M467.61 134.828C467.61 135.898 466.743 136.766 465.673 136.766C464.603 136.766 463.735 135.898 463.735 134.828C463.735 133.758 464.603 132.89 465.673 132.89C466.743 132.89 467.61 133.758 467.61 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M467.61 139.551C467.61 140.621 466.743 141.488 465.673 141.488C464.603 141.488 463.735 140.621 463.735 139.551C463.735 138.481 464.603 137.613 465.673 137.613C466.743 137.613 467.61 138.481 467.61 139.551Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M467.61 144.273C467.61 145.343 466.743 146.211 465.673 146.211C464.603 146.211 463.735 145.343 463.735 144.273C463.735 143.203 464.603 142.336 465.673 142.336C466.743 142.336 467.61 143.203 467.61 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M467.61 148.996C467.61 150.066 466.743 150.934 465.673 150.934C464.603 150.934 463.735 150.066 463.735 148.996C463.735 147.926 464.603 147.058 465.673 147.058C466.743 147.058 467.61 147.926 467.61 148.996Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M467.61 153.719C467.61 154.789 466.743 155.656 465.673 155.656C464.603 155.656 463.735 154.789 463.735 153.719C463.735 152.649 464.603 151.781 465.673 151.781C466.743 151.781 467.61 152.649 467.61 153.719Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M467.61 158.441C467.61 159.511 466.743 160.379 465.673 160.379C464.603 160.379 463.735 159.511 463.735 158.441C463.735 157.371 464.603 156.504 465.673 156.504C466.743 156.504 467.61 157.371 467.61 158.441Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M467.61 163.164C467.61 164.234 466.743 165.102 465.673 165.102C464.603 165.102 463.735 164.234 463.735 163.164C463.735 162.094 464.603 161.226 465.673 161.226C466.743 161.226 467.61 162.094 467.61 163.164Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M462.887 163.164C462.887 164.234 462.019 165.102 460.949 165.102C459.879 165.102 459.011 164.234 459.011 163.164C459.011 162.094 459.879 161.226 460.949 161.226C462.019 161.226 462.887 162.094 462.887 163.164Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M462.887 167.887C462.887 168.957 462.019 169.824 460.949 169.824C459.879 169.824 459.011 168.957 459.011 167.887C459.011 166.817 459.879 165.949 460.949 165.949C462.019 165.949 462.887 166.817 462.887 167.887Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M458.164 167.887C458.164 168.957 457.296 169.824 456.226 169.824C455.156 169.824 454.288 168.957 454.288 167.887C454.288 166.817 455.156 165.949 456.226 165.949C457.296 165.949 458.164 166.817 458.164 167.887Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M453.44 167.887C453.44 168.957 452.573 169.824 451.503 169.824C450.433 169.824 449.565 168.957 449.565 167.887C449.565 166.817 450.433 165.949 451.503 165.949C452.573 165.949 453.44 166.817 453.44 167.887Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M453.44 172.613C453.44 173.683 452.573 174.551 451.503 174.551C450.433 174.551 449.565 173.683 449.565 172.613C449.565 171.543 450.433 170.676 451.503 170.676C452.573 170.676 453.44 171.543 453.44 172.613Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M448.717 172.613C448.717 173.683 447.85 174.551 446.78 174.551C445.71 174.551 444.842 173.683 444.842 172.613C444.842 171.543 445.71 170.676 446.78 170.676C447.85 170.676 448.717 171.543 448.717 172.613Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M443.994 172.613C443.994 173.683 443.127 174.551 442.057 174.551C440.987 174.551 440.119 173.683 440.119 172.613C440.119 171.543 440.987 170.676 442.057 170.676C443.127 170.676 443.994 171.543 443.994 172.613Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M439.271 172.613C439.271 173.683 438.403 174.551 437.333 174.551C436.263 174.551 435.396 173.683 435.396 172.613C435.396 171.543 436.263 170.676 437.333 170.676C438.403 170.676 439.271 171.543 439.271 172.613Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M434.548 172.613C434.548 173.683 433.681 174.551 432.611 174.551C431.541 174.551 430.673 173.683 430.673 172.613C430.673 171.543 431.541 170.676 432.611 170.676C433.681 170.676 434.548 171.543 434.548 172.613Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M429.825 172.613C429.825 173.683 428.957 174.551 427.887 174.551C426.817 174.551 425.949 173.683 425.949 172.613C425.949 171.543 426.817 170.676 427.887 170.676C428.957 170.676 429.825 171.543 429.825 172.613Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M425.101 172.613C425.101 173.683 424.234 174.551 423.164 174.551C422.094 174.551 421.226 173.683 421.226 172.613C421.226 171.543 422.094 170.676 423.164 170.676C424.234 170.676 425.101 171.543 425.101 172.613Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M420.378 172.613C420.378 173.683 419.511 174.551 418.441 174.551C417.371 174.551 416.503 173.683 416.503 172.613C416.503 171.543 417.371 170.676 418.441 170.676C419.511 170.676 420.378 171.543 420.378 172.613Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M420.378 177.336C420.378 178.406 419.511 179.273 418.441 179.273C417.371 179.273 416.503 178.406 416.503 177.336C416.503 176.266 417.371 175.398 418.441 175.398C419.511 175.398 420.378 176.266 420.378 177.336Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M420.378 182.059C420.378 183.128 419.511 183.996 418.441 183.996C417.371 183.996 416.503 183.128 416.503 182.059C416.503 180.989 417.371 180.121 418.441 180.121C419.511 180.121 420.378 180.989 420.378 182.059Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M425.101 177.336C425.101 178.406 424.234 179.273 423.164 179.273C422.094 179.273 421.226 178.406 421.226 177.336C421.226 176.266 422.094 175.398 423.164 175.398C424.234 175.398 425.101 176.266 425.101 177.336Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M420.378 167.887C420.378 168.957 419.511 169.824 418.441 169.824C417.371 169.824 416.503 168.957 416.503 167.887C416.503 166.817 417.371 165.949 418.441 165.949C419.511 165.949 420.378 166.817 420.378 167.887Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M415.655 167.887C415.655 168.957 414.788 169.824 413.718 169.824C412.648 169.824 411.78 168.957 411.78 167.887C411.78 166.817 412.648 165.949 413.718 165.949C414.788 165.949 415.655 166.817 415.655 167.887Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M415.655 172.613C415.655 173.683 414.788 174.551 413.718 174.551C412.648 174.551 411.78 173.683 411.78 172.613C411.78 171.543 412.648 170.676 413.718 170.676C414.788 170.676 415.655 171.543 415.655 172.613Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M410.932 172.613C410.932 173.683 410.065 174.551 408.995 174.551C407.925 174.551 407.057 173.683 407.057 172.613C407.057 171.543 407.925 170.676 408.995 170.676C410.065 170.676 410.932 171.543 410.932 172.613Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M410.932 167.887C410.932 168.957 410.065 169.824 408.995 169.824C407.925 169.824 407.057 168.957 407.057 167.887C407.057 166.817 407.925 165.949 408.995 165.949C410.065 165.949 410.932 166.817 410.932 167.887Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M406.209 167.887C406.209 168.957 405.341 169.824 404.271 169.824C403.201 169.824 402.333 168.957 402.333 167.887C402.333 166.817 403.201 165.949 404.271 165.949C405.341 165.949 406.209 166.817 406.209 167.887Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M401.486 167.887C401.486 168.957 400.618 169.824 399.548 169.824C398.478 169.824 397.61 168.957 397.61 167.887C397.61 166.817 398.478 165.949 399.548 165.949C400.618 165.949 401.486 166.817 401.486 167.887Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M396.762 167.887C396.762 168.957 395.895 169.824 394.825 169.824C393.755 169.824 392.887 168.957 392.887 167.887C392.887 166.817 393.755 165.949 394.825 165.949C395.895 165.949 396.762 166.817 396.762 167.887Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M392.039 167.887C392.039 168.957 391.172 169.824 390.102 169.824C389.032 169.824 388.164 168.957 388.164 167.887C388.164 166.817 389.032 165.949 390.102 165.949C391.172 165.949 392.039 166.817 392.039 167.887Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M392.039 163.164C392.039 164.234 391.172 165.102 390.102 165.102C389.032 165.102 388.164 164.234 388.164 163.164C388.164 162.094 389.032 161.226 390.102 161.226C391.172 161.226 392.039 162.094 392.039 163.164Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M387.316 163.164C387.316 164.234 386.449 165.102 385.379 165.102C384.309 165.102 383.441 164.234 383.441 163.164C383.441 162.094 384.309 161.226 385.379 161.226C386.449 161.226 387.316 162.094 387.316 163.164Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M382.593 163.164C382.593 164.234 381.726 165.102 380.656 165.102C379.586 165.102 378.718 164.234 378.718 163.164C378.718 162.094 379.586 161.226 380.656 161.226C381.726 161.226 382.593 162.094 382.593 163.164Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M382.593 158.441C382.593 159.511 381.726 160.379 380.656 160.379C379.586 160.379 378.718 159.511 378.718 158.441C378.718 157.371 379.586 156.504 380.656 156.504C381.726 156.504 382.593 157.371 382.593 158.441Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M382.593 153.719C382.593 154.789 381.726 155.656 380.656 155.656C379.586 155.656 378.718 154.789 378.718 153.719C378.718 152.649 379.586 151.781 380.656 151.781C381.726 151.781 382.593 152.649 382.593 153.719Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M382.593 148.996C382.593 150.066 381.726 150.934 380.656 150.934C379.586 150.934 378.718 150.066 378.718 148.996C378.718 147.926 379.586 147.058 380.656 147.058C381.726 147.058 382.593 147.926 382.593 148.996Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M382.593 144.273C382.593 145.343 381.726 146.211 380.656 146.211C379.586 146.211 378.718 145.343 378.718 144.273C378.718 143.203 379.586 142.336 380.656 142.336C381.726 142.336 382.593 143.203 382.593 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M382.593 139.551C382.593 140.621 381.726 141.488 380.656 141.488C379.586 141.488 378.718 140.621 378.718 139.551C378.718 138.481 379.586 137.613 380.656 137.613C381.726 137.613 382.593 138.481 382.593 139.551Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M377.87 139.551C377.87 140.621 377.003 141.488 375.933 141.488C374.863 141.488 373.995 140.621 373.995 139.551C373.995 138.481 374.863 137.613 375.933 137.613C377.003 137.613 377.87 138.481 377.87 139.551Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M377.87 134.828C377.87 135.898 377.003 136.766 375.933 136.766C374.863 136.766 373.995 135.898 373.995 134.828C373.995 133.758 374.863 132.89 375.933 132.89C377.003 132.89 377.87 133.758 377.87 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M377.87 130.101C377.87 131.171 377.003 132.039 375.933 132.039C374.863 132.039 373.995 131.171 373.995 130.101C373.995 129.031 374.863 128.164 375.933 128.164C377.003 128.164 377.87 129.031 377.87 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M377.87 125.379C377.87 126.449 377.003 127.316 375.933 127.316C374.863 127.316 373.995 126.449 373.995 125.379C373.995 124.309 374.863 123.441 375.933 123.441C377.003 123.441 377.87 124.309 377.87 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M382.593 125.379C382.593 126.449 381.726 127.316 380.656 127.316C379.586 127.316 378.718 126.449 378.718 125.379C378.718 124.309 379.586 123.441 380.656 123.441C381.726 123.441 382.593 124.309 382.593 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M387.316 125.379C387.316 126.449 386.449 127.316 385.379 127.316C384.309 127.316 383.441 126.449 383.441 125.379C383.441 124.309 384.309 123.441 385.379 123.441C386.449 123.441 387.316 124.309 387.316 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M387.316 130.101C387.316 131.171 386.449 132.039 385.379 132.039C384.309 132.039 383.441 131.171 383.441 130.101C383.441 129.031 384.309 128.164 385.379 128.164C386.449 128.164 387.316 129.031 387.316 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M382.593 130.101C382.593 131.171 381.726 132.039 380.656 132.039C379.586 132.039 378.718 131.171 378.718 130.101C378.718 129.031 379.586 128.164 380.656 128.164C381.726 128.164 382.593 129.031 382.593 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M387.316 134.828C387.316 135.898 386.449 136.766 385.379 136.766C384.309 136.766 383.441 135.898 383.441 134.828C383.441 133.758 384.309 132.89 385.379 132.89C386.449 132.89 387.316 133.758 387.316 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M387.316 139.551C387.316 140.621 386.449 141.488 385.379 141.488C384.309 141.488 383.441 140.621 383.441 139.551C383.441 138.481 384.309 137.613 385.379 137.613C386.449 137.613 387.316 138.481 387.316 139.551Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M387.316 144.273C387.316 145.343 386.449 146.211 385.379 146.211C384.309 146.211 383.441 145.343 383.441 144.273C383.441 143.203 384.309 142.336 385.379 142.336C386.449 142.336 387.316 143.203 387.316 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M387.316 148.996C387.316 150.066 386.449 150.934 385.379 150.934C384.309 150.934 383.441 150.066 383.441 148.996C383.441 147.926 384.309 147.058 385.379 147.058C386.449 147.058 387.316 147.926 387.316 148.996Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M387.316 153.719C387.316 154.789 386.449 155.656 385.379 155.656C384.309 155.656 383.441 154.789 383.441 153.719C383.441 152.649 384.309 151.781 385.379 151.781C386.449 151.781 387.316 152.649 387.316 153.719Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M387.316 158.441C387.316 159.511 386.449 160.379 385.379 160.379C384.309 160.379 383.441 159.511 383.441 158.441C383.441 157.371 384.309 156.504 385.379 156.504C386.449 156.504 387.316 157.371 387.316 158.441Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M392.039 158.441C392.039 159.511 391.172 160.379 390.102 160.379C389.032 160.379 388.164 159.511 388.164 158.441C388.164 157.371 389.032 156.504 390.102 156.504C391.172 156.504 392.039 157.371 392.039 158.441Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M396.762 158.441C396.762 159.511 395.895 160.379 394.825 160.379C393.755 160.379 392.887 159.511 392.887 158.441C392.887 157.371 393.755 156.504 394.825 156.504C395.895 156.504 396.762 157.371 396.762 158.441Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M401.486 158.441C401.486 159.511 400.618 160.379 399.548 160.379C398.478 160.379 397.61 159.511 397.61 158.441C397.61 157.371 398.478 156.504 399.548 156.504C400.618 156.504 401.486 157.371 401.486 158.441Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M406.209 158.441C406.209 159.511 405.341 160.379 404.271 160.379C403.201 160.379 402.333 159.511 402.333 158.441C402.333 157.371 403.201 156.504 404.271 156.504C405.341 156.504 406.209 157.371 406.209 158.441Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M410.932 158.441C410.932 159.511 410.065 160.379 408.995 160.379C407.925 160.379 407.057 159.511 407.057 158.441C407.057 157.371 407.925 156.504 408.995 156.504C410.065 156.504 410.932 157.371 410.932 158.441Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M410.932 163.164C410.932 164.234 410.065 165.102 408.995 165.102C407.925 165.102 407.057 164.234 407.057 163.164C407.057 162.094 407.925 161.226 408.995 161.226C410.065 161.226 410.932 162.094 410.932 163.164Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M415.655 163.164C415.655 164.234 414.788 165.102 413.718 165.102C412.648 165.102 411.78 164.234 411.78 163.164C411.78 162.094 412.648 161.226 413.718 161.226C414.788 161.226 415.655 162.094 415.655 163.164Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M420.378 163.164C420.378 164.234 419.511 165.102 418.441 165.102C417.371 165.102 416.503 164.234 416.503 163.164C416.503 162.094 417.371 161.226 418.441 161.226C419.511 161.226 420.378 162.094 420.378 163.164Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M425.101 163.164C425.101 164.234 424.234 165.102 423.164 165.102C422.094 165.102 421.226 164.234 421.226 163.164C421.226 162.094 422.094 161.226 423.164 161.226C424.234 161.226 425.101 162.094 425.101 163.164Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M425.101 167.887C425.101 168.957 424.234 169.824 423.164 169.824C422.094 169.824 421.226 168.957 421.226 167.887C421.226 166.817 422.094 165.949 423.164 165.949C424.234 165.949 425.101 166.817 425.101 167.887Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M429.825 167.887C429.825 168.957 428.957 169.824 427.887 169.824C426.817 169.824 425.949 168.957 425.949 167.887C425.949 166.817 426.817 165.949 427.887 165.949C428.957 165.949 429.825 166.817 429.825 167.887Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M434.548 167.887C434.548 168.957 433.681 169.824 432.611 169.824C431.541 169.824 430.673 168.957 430.673 167.887C430.673 166.817 431.541 165.949 432.611 165.949C433.681 165.949 434.548 166.817 434.548 167.887Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M439.271 167.891C439.271 168.961 438.403 169.828 437.333 169.828C436.263 169.828 435.396 168.961 435.396 167.891C435.396 166.821 436.263 165.953 437.333 165.953C438.403 165.953 439.271 166.821 439.271 167.891Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M443.994 167.891C443.994 168.961 443.127 169.828 442.057 169.828C440.987 169.828 440.119 168.961 440.119 167.891C440.119 166.821 440.987 165.953 442.057 165.953C443.127 165.953 443.994 166.821 443.994 167.891Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M448.717 167.887C448.717 168.957 447.85 169.824 446.78 169.824C445.71 169.824 444.842 168.957 444.842 167.887C444.842 166.817 445.71 165.949 446.78 165.949C447.85 165.949 448.717 166.817 448.717 167.887Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M448.717 163.164C448.717 164.234 447.85 165.102 446.78 165.102C445.71 165.102 444.842 164.234 444.842 163.164C444.842 162.094 445.71 161.226 446.78 161.226C447.85 161.226 448.717 162.094 448.717 163.164Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M453.44 163.164C453.44 164.234 452.573 165.102 451.503 165.102C450.433 165.102 449.565 164.234 449.565 163.164C449.565 162.094 450.433 161.226 451.503 161.226C452.573 161.226 453.44 162.094 453.44 163.164Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M458.164 163.164C458.164 164.234 457.296 165.102 456.226 165.102C455.156 165.102 454.288 164.234 454.288 163.164C454.288 162.094 455.156 161.226 456.226 161.226C457.296 161.226 458.164 162.094 458.164 163.164Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M458.164 158.441C458.164 159.511 457.296 160.379 456.226 160.379C455.156 160.379 454.288 159.511 454.288 158.441C454.288 157.371 455.156 156.504 456.226 156.504C457.296 156.504 458.164 157.371 458.164 158.441Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M462.887 158.441C462.887 159.511 462.019 160.379 460.949 160.379C459.879 160.379 459.011 159.511 459.011 158.441C459.011 157.371 459.879 156.504 460.949 156.504C462.019 156.504 462.887 157.371 462.887 158.441Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M462.887 153.719C462.887 154.789 462.019 155.656 460.949 155.656C459.879 155.656 459.011 154.789 459.011 153.719C459.011 152.649 459.879 151.781 460.949 151.781C462.019 151.781 462.887 152.649 462.887 153.719Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M462.887 148.996C462.887 150.066 462.02 150.934 460.95 150.934C459.88 150.934 459.012 150.066 459.012 148.996C459.012 147.926 459.88 147.058 460.95 147.058C462.02 147.058 462.887 147.926 462.887 148.996Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M462.887 144.273C462.887 145.343 462.02 146.211 460.95 146.211C459.88 146.211 459.012 145.343 459.012 144.273C459.012 143.203 459.88 142.336 460.95 142.336C462.02 142.336 462.887 143.203 462.887 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M462.887 139.551C462.887 140.621 462.02 141.488 460.95 141.488C459.88 141.488 459.012 140.621 459.012 139.551C459.012 138.481 459.88 137.613 460.95 137.613C462.02 137.613 462.887 138.481 462.887 139.551Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M462.887 134.828C462.887 135.898 462.019 136.766 460.949 136.766C459.879 136.766 459.011 135.898 459.011 134.828C459.011 133.758 459.879 132.89 460.949 132.89C462.019 132.89 462.887 133.758 462.887 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M458.164 134.828C458.164 135.898 457.296 136.766 456.226 136.766C455.156 136.766 454.288 135.898 454.288 134.828C454.288 133.758 455.156 132.89 456.226 132.89C457.296 132.89 458.164 133.758 458.164 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M458.164 139.551C458.164 140.621 457.297 141.488 456.227 141.488C455.157 141.488 454.289 140.621 454.289 139.551C454.289 138.481 455.157 137.613 456.227 137.613C457.297 137.613 458.164 138.481 458.164 139.551Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M458.164 144.273C458.164 145.343 457.297 146.211 456.227 146.211C455.157 146.211 454.289 145.343 454.289 144.273C454.289 143.203 455.157 142.336 456.227 142.336C457.297 142.336 458.164 143.203 458.164 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M458.164 148.996C458.164 150.066 457.297 150.934 456.227 150.934C455.157 150.934 454.289 150.066 454.289 148.996C454.289 147.926 455.157 147.058 456.227 147.058C457.297 147.058 458.164 147.926 458.164 148.996Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M458.164 153.719C458.164 154.789 457.296 155.656 456.226 155.656C455.156 155.656 454.288 154.789 454.288 153.719C454.288 152.649 455.156 151.781 456.226 151.781C457.296 151.781 458.164 152.649 458.164 153.719Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M453.44 153.719C453.44 154.789 452.573 155.656 451.503 155.656C450.433 155.656 449.565 154.789 449.565 153.719C449.565 152.649 450.433 151.781 451.503 151.781C452.573 151.781 453.44 152.649 453.44 153.719Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M453.44 158.441C453.44 159.511 452.573 160.379 451.503 160.379C450.433 160.379 449.565 159.511 449.565 158.441C449.565 157.371 450.433 156.504 451.503 156.504C452.573 156.504 453.44 157.371 453.44 158.441Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M448.717 158.441C448.717 159.511 447.85 160.379 446.78 160.379C445.71 160.379 444.842 159.511 444.842 158.441C444.842 157.371 445.71 156.504 446.78 156.504C447.85 156.504 448.717 157.371 448.717 158.441Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M443.994 158.441C443.994 159.511 443.127 160.379 442.057 160.379C440.987 160.379 440.119 159.511 440.119 158.441C440.119 157.371 440.987 156.504 442.057 156.504C443.127 156.504 443.994 157.371 443.994 158.441Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M443.994 163.164C443.994 164.234 443.127 165.102 442.057 165.102C440.987 165.102 440.119 164.234 440.119 163.164C440.119 162.094 440.987 161.226 442.057 161.226C443.127 161.226 443.994 162.094 443.994 163.164Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M439.271 163.164C439.271 164.234 438.403 165.102 437.333 165.102C436.263 165.102 435.396 164.234 435.396 163.164C435.396 162.094 436.263 161.226 437.333 161.226C438.403 161.226 439.271 162.094 439.271 163.164Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M434.548 163.164C434.548 164.234 433.681 165.102 432.611 165.102C431.541 165.102 430.673 164.234 430.673 163.164C430.673 162.094 431.541 161.226 432.611 161.226C433.681 161.226 434.548 162.094 434.548 163.164Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M429.825 163.164C429.825 164.234 428.957 165.102 427.887 165.102C426.817 165.102 425.949 164.234 425.949 163.164C425.949 162.094 426.817 161.226 427.887 161.226C428.957 161.226 429.825 162.094 429.825 163.164Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M429.825 158.441C429.825 159.511 428.957 160.379 427.887 160.379C426.817 160.379 425.949 159.511 425.949 158.441C425.949 157.371 426.817 156.504 427.887 156.504C428.957 156.504 429.825 157.371 429.825 158.441Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M425.101 158.441C425.101 159.511 424.234 160.379 423.164 160.379C422.094 160.379 421.226 159.511 421.226 158.441C421.226 157.371 422.094 156.504 423.164 156.504C424.234 156.504 425.101 157.371 425.101 158.441Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M420.378 158.441C420.378 159.511 419.511 160.379 418.441 160.379C417.371 160.379 416.503 159.511 416.503 158.441C416.503 157.371 417.371 156.504 418.441 156.504C419.511 156.504 420.378 157.371 420.378 158.441Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M415.655 158.441C415.655 159.511 414.788 160.379 413.718 160.379C412.648 160.379 411.78 159.511 411.78 158.441C411.78 157.371 412.648 156.504 413.718 156.504C414.788 156.504 415.655 157.371 415.655 158.441Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M425.101 153.719C425.101 154.789 424.234 155.656 423.164 155.656C422.094 155.656 421.226 154.789 421.226 153.719C421.226 152.649 422.094 151.781 423.164 151.781C424.234 151.781 425.101 152.649 425.101 153.719Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M429.825 153.719C429.825 154.789 428.957 155.656 427.887 155.656C426.817 155.656 425.949 154.789 425.949 153.719C425.949 152.649 426.817 151.781 427.887 151.781C428.957 151.781 429.825 152.649 429.825 153.719Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M434.548 153.719C434.548 154.789 433.681 155.656 432.611 155.656C431.541 155.656 430.673 154.789 430.673 153.719C430.673 152.649 431.541 151.781 432.611 151.781C433.681 151.781 434.548 152.649 434.548 153.719Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M434.548 158.441C434.548 159.511 433.681 160.379 432.611 160.379C431.541 160.379 430.673 159.511 430.673 158.441C430.673 157.371 431.541 156.504 432.611 156.504C433.681 156.504 434.548 157.371 434.548 158.441Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M439.271 158.441C439.271 159.511 438.403 160.379 437.333 160.379C436.263 160.379 435.396 159.511 435.396 158.441C435.396 157.371 436.263 156.504 437.333 156.504C438.403 156.504 439.271 157.371 439.271 158.441Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M439.271 153.719C439.271 154.789 438.403 155.656 437.333 155.656C436.263 155.656 435.396 154.789 435.396 153.719C435.396 152.649 436.263 151.781 437.333 151.781C438.403 151.781 439.271 152.649 439.271 153.719Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M443.994 153.719C443.994 154.789 443.127 155.656 442.057 155.656C440.987 155.656 440.119 154.789 440.119 153.719C440.119 152.649 440.987 151.781 442.057 151.781C443.127 151.781 443.994 152.649 443.994 153.719Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M448.717 153.719C448.717 154.789 447.85 155.656 446.78 155.656C445.71 155.656 444.842 154.789 444.842 153.719C444.842 152.649 445.71 151.781 446.78 151.781C447.85 151.781 448.717 152.649 448.717 153.719Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M448.717 148.996C448.717 150.066 447.85 150.934 446.78 150.934C445.71 150.934 444.842 150.066 444.842 148.996C444.842 147.926 445.71 147.058 446.78 147.058C447.85 147.058 448.717 147.926 448.717 148.996Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M453.441 148.996C453.441 150.066 452.573 150.934 451.503 150.934C450.433 150.934 449.565 150.066 449.565 148.996C449.565 147.926 450.433 147.058 451.503 147.058C452.573 147.058 453.441 147.926 453.441 148.996Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M453.441 144.273C453.441 145.343 452.573 146.211 451.503 146.211C450.433 146.211 449.565 145.343 449.565 144.273C449.565 143.203 450.433 142.336 451.503 142.336C452.573 142.336 453.441 143.203 453.441 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M453.441 139.551C453.441 140.621 452.573 141.488 451.503 141.488C450.433 141.488 449.565 140.621 449.565 139.551C449.565 138.481 450.433 137.613 451.503 137.613C452.573 137.613 453.441 138.481 453.441 139.551Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M453.44 134.828C453.44 135.898 452.573 136.766 451.503 136.766C450.433 136.766 449.565 135.898 449.565 134.828C449.565 133.758 450.433 132.89 451.503 132.89C452.573 132.89 453.44 133.758 453.44 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M448.717 134.828C448.717 135.898 447.85 136.766 446.78 136.766C445.71 136.766 444.842 135.898 444.842 134.828C444.842 133.758 445.71 132.89 446.78 132.89C447.85 132.89 448.717 133.758 448.717 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M448.717 139.551C448.717 140.621 447.85 141.488 446.78 141.488C445.71 141.488 444.842 140.621 444.842 139.551C444.842 138.481 445.71 137.613 446.78 137.613C447.85 137.613 448.717 138.481 448.717 139.551Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M448.717 144.273C448.717 145.343 447.85 146.211 446.78 146.211C445.71 146.211 444.842 145.343 444.842 144.273C444.842 143.203 445.71 142.336 446.78 142.336C447.85 142.336 448.717 143.203 448.717 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M443.994 144.273C443.994 145.343 443.127 146.211 442.057 146.211C440.987 146.211 440.119 145.343 440.119 144.273C440.119 143.203 440.987 142.336 442.057 142.336C443.127 142.336 443.994 143.203 443.994 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M443.994 148.996C443.994 150.066 443.127 150.934 442.057 150.934C440.987 150.934 440.119 150.066 440.119 148.996C440.119 147.926 440.987 147.058 442.057 147.058C443.127 147.058 443.994 147.926 443.994 148.996Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M439.271 148.996C439.271 150.066 438.403 150.934 437.333 150.934C436.263 150.934 435.396 150.066 435.396 148.996C435.396 147.926 436.263 147.058 437.333 147.058C438.403 147.058 439.271 147.926 439.271 148.996Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M434.548 148.996C434.548 150.066 433.68 150.934 432.61 150.934C431.54 150.934 430.672 150.066 430.672 148.996C430.672 147.926 431.54 147.058 432.61 147.058C433.68 147.058 434.548 147.926 434.548 148.996Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M429.824 148.996C429.824 150.066 428.957 150.934 427.887 150.934C426.817 150.934 425.949 150.066 425.949 148.996C425.949 147.926 426.817 147.058 427.887 147.058C428.957 147.058 429.824 147.926 429.824 148.996Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M425.101 148.996C425.101 150.066 424.234 150.934 423.164 150.934C422.094 150.934 421.226 150.066 421.226 148.996C421.226 147.926 422.094 147.058 423.164 147.058C424.234 147.058 425.101 147.926 425.101 148.996Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M425.101 144.273C425.101 145.343 424.234 146.211 423.164 146.211C422.094 146.211 421.226 145.343 421.226 144.273C421.226 143.203 422.094 142.336 423.164 142.336C424.234 142.336 425.101 143.203 425.101 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M429.824 144.273C429.824 145.343 428.957 146.211 427.887 146.211C426.817 146.211 425.949 145.343 425.949 144.273C425.949 143.203 426.817 142.336 427.887 142.336C428.957 142.336 429.824 143.203 429.824 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M434.548 144.273C434.548 145.343 433.68 146.211 432.61 146.211C431.54 146.211 430.672 145.343 430.672 144.273C430.672 143.203 431.54 142.336 432.61 142.336C433.68 142.336 434.548 143.203 434.548 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M439.271 144.273C439.271 145.343 438.403 146.211 437.333 146.211C436.263 146.211 435.396 145.343 435.396 144.273C435.396 143.203 436.263 142.336 437.333 142.336C438.403 142.336 439.271 143.203 439.271 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M439.271 139.551C439.271 140.621 438.403 141.488 437.333 141.488C436.263 141.488 435.396 140.621 435.396 139.551C435.396 138.481 436.263 137.613 437.333 137.613C438.403 137.613 439.271 138.481 439.271 139.551Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M443.994 139.551C443.994 140.621 443.127 141.488 442.057 141.488C440.987 141.488 440.119 140.621 440.119 139.551C440.119 138.481 440.987 137.613 442.057 137.613C443.127 137.613 443.994 138.481 443.994 139.551Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M443.994 134.828C443.994 135.898 443.127 136.766 442.057 136.766C440.987 136.766 440.119 135.898 440.119 134.828C440.119 133.758 440.987 132.89 442.057 132.89C443.127 132.89 443.994 133.758 443.994 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M443.994 130.101C443.994 131.171 443.127 132.039 442.057 132.039C440.987 132.039 440.119 131.171 440.119 130.101C440.119 129.031 440.987 128.164 442.057 128.164C443.127 128.164 443.994 129.031 443.994 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M448.717 130.101C448.717 131.171 447.85 132.039 446.78 132.039C445.71 132.039 444.842 131.171 444.842 130.101C444.842 129.031 445.71 128.164 446.78 128.164C447.85 128.164 448.717 129.031 448.717 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M453.44 130.101C453.44 131.171 452.573 132.039 451.503 132.039C450.433 132.039 449.565 131.171 449.565 130.101C449.565 129.031 450.433 128.164 451.503 128.164C452.573 128.164 453.44 129.031 453.44 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M458.164 130.101C458.164 131.171 457.296 132.039 456.226 132.039C455.156 132.039 454.288 131.171 454.288 130.101C454.288 129.031 455.156 128.164 456.226 128.164C457.296 128.164 458.164 129.031 458.164 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M462.887 130.101C462.887 131.171 462.019 132.039 460.949 132.039C459.879 132.039 459.011 131.171 459.011 130.101C459.011 129.031 459.879 128.164 460.949 128.164C462.019 128.164 462.887 129.031 462.887 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M462.887 125.379C462.887 126.449 462.019 127.316 460.949 127.316C459.879 127.316 459.011 126.449 459.011 125.379C459.011 124.309 459.879 123.441 460.949 123.441C462.019 123.441 462.887 124.309 462.887 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M467.61 125.379C467.61 126.449 466.743 127.316 465.673 127.316C464.603 127.316 463.735 126.449 463.735 125.379C463.735 124.309 464.603 123.441 465.673 123.441C466.743 123.441 467.61 124.309 467.61 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M472.333 125.379C472.333 126.449 471.466 127.316 470.396 127.316C469.326 127.316 468.458 126.449 468.458 125.379C468.458 124.309 469.326 123.441 470.396 123.441C471.466 123.441 472.333 124.309 472.333 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M477.056 125.379C477.056 126.449 476.189 127.316 475.119 127.316C474.049 127.316 473.181 126.449 473.181 125.379C473.181 124.309 474.049 123.441 475.119 123.441C476.189 123.441 477.056 124.309 477.056 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M481.779 125.379C481.779 126.449 480.912 127.316 479.842 127.316C478.772 127.316 477.904 126.449 477.904 125.379C477.904 124.309 478.772 123.441 479.842 123.441C480.912 123.441 481.779 124.309 481.779 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M486.503 125.379C486.503 126.449 485.635 127.316 484.565 127.316C483.495 127.316 482.627 126.449 482.627 125.379C482.627 124.309 483.495 123.441 484.565 123.441C485.635 123.441 486.503 124.309 486.503 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M486.503 120.656C486.503 121.726 485.635 122.594 484.565 122.594C483.495 122.594 482.627 121.726 482.627 120.656C482.627 119.586 483.495 118.719 484.565 118.719C485.635 118.719 486.503 119.586 486.503 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M486.503 115.934C486.503 117.003 485.635 117.871 484.565 117.871C483.495 117.871 482.627 117.003 482.627 115.934C482.627 114.864 483.495 113.996 484.565 113.996C485.635 113.996 486.503 114.864 486.503 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M486.503 111.211C486.503 112.281 485.635 113.148 484.565 113.148C483.495 113.148 482.627 112.281 482.627 111.211C482.627 110.141 483.495 109.273 484.565 109.273C485.635 109.273 486.503 110.141 486.503 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M486.503 106.488C486.503 107.558 485.635 108.426 484.565 108.426C483.495 108.426 482.627 107.558 482.627 106.488C482.627 105.418 483.495 104.551 484.565 104.551C485.635 104.551 486.503 105.418 486.503 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M486.503 101.766C486.503 102.836 485.635 103.703 484.565 103.703C483.495 103.703 482.627 102.836 482.627 101.766C482.627 100.696 483.495 99.828 484.565 99.828C485.635 99.828 486.503 100.696 486.503 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M486.503 97.0429C486.503 98.1129 485.635 98.9805 484.565 98.9805C483.495 98.9805 482.627 98.1129 482.627 97.0429C482.627 95.9729 483.495 95.1053 484.565 95.1053C485.635 95.1053 486.503 95.9729 486.503 97.0429Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M486.503 92.3163C486.503 93.3863 485.635 94.2539 484.565 94.2539C483.495 94.2539 482.627 93.3863 482.627 92.3163C482.627 91.2463 483.495 90.3787 484.565 90.3787C485.635 90.3787 486.503 91.2463 486.503 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M486.503 87.5937C486.503 88.6636 485.635 89.5312 484.565 89.5312C483.495 89.5312 482.627 88.6636 482.627 87.5937C482.627 86.5237 483.495 85.6561 484.565 85.6561C485.635 85.6561 486.503 86.5237 486.503 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M486.503 82.871C486.503 83.941 485.635 84.8086 484.565 84.8086C483.495 84.8086 482.627 83.941 482.627 82.871C482.627 81.801 483.495 80.9334 484.565 80.9334C485.635 80.9334 486.503 81.801 486.503 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M491.226 82.871C491.226 83.941 490.359 84.8086 489.289 84.8086C488.219 84.8086 487.351 83.941 487.351 82.871C487.351 81.801 488.219 80.9334 489.289 80.9334C490.359 80.9334 491.226 81.801 491.226 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M491.226 78.1484C491.226 79.2183 490.359 80.0859 489.289 80.0859C488.219 80.0859 487.351 79.2183 487.351 78.1484C487.351 77.0784 488.219 76.2108 489.289 76.2108C490.359 76.2108 491.226 77.0784 491.226 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M491.226 73.4257C491.226 74.4957 490.359 75.3633 489.289 75.3633C488.219 75.3633 487.351 74.4957 487.351 73.4257C487.351 72.3557 488.219 71.4881 489.289 71.4881C490.359 71.4881 491.226 72.3557 491.226 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M495.949 73.4257C495.949 74.4957 495.082 75.3633 494.012 75.3633C492.942 75.3633 492.074 74.4957 492.074 73.4257C492.074 72.3557 492.942 71.4881 494.012 71.4881C495.082 71.4881 495.949 72.3557 495.949 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M500.672 68.703C500.672 69.773 499.805 70.6406 498.735 70.6406C497.665 70.6406 496.797 69.773 496.797 68.703C496.797 67.6331 497.665 66.7655 498.735 66.7655C499.805 66.7655 500.672 67.6331 500.672 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M505.395 68.703C505.395 69.773 504.528 70.6406 503.458 70.6406C502.388 70.6406 501.52 69.773 501.52 68.703C501.52 67.6331 502.388 66.7655 503.458 66.7655C504.528 66.7655 505.395 67.6331 505.395 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M510.118 68.703C510.118 69.773 509.251 70.6406 508.181 70.6406C507.111 70.6406 506.243 69.773 506.243 68.703C506.243 67.6331 507.111 66.7655 508.181 66.7655C509.251 66.7655 510.118 67.6331 510.118 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M510.118 63.9804C510.118 65.0504 509.251 65.918 508.181 65.918C507.111 65.918 506.243 65.0504 506.243 63.9804C506.243 62.9104 507.111 62.0428 508.181 62.0428C509.251 62.0428 510.118 62.9104 510.118 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M510.118 59.2538C510.118 60.3238 509.251 61.1914 508.181 61.1914C507.111 61.1914 506.243 60.3238 506.243 59.2538C506.243 58.1838 507.111 57.3162 508.181 57.3162C509.251 57.3162 510.118 58.1838 510.118 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M510.118 54.5312C510.118 55.6011 509.251 56.4688 508.181 56.4688C507.111 56.4688 506.243 55.6011 506.243 54.5312C506.243 53.4612 507.111 52.5936 508.181 52.5936C509.251 52.5936 510.118 53.4612 510.118 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M514.841 54.5312C514.841 55.6011 513.974 56.4688 512.904 56.4688C511.834 56.4688 510.966 55.6011 510.966 54.5312C510.966 53.4612 511.834 52.5936 512.904 52.5936C513.974 52.5936 514.841 53.4612 514.841 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M519.565 54.5312C519.565 55.6011 518.697 56.4688 517.627 56.4688C516.557 56.4688 515.689 55.6011 515.689 54.5312C515.689 53.4612 516.557 52.5936 517.627 52.5936C518.697 52.5936 519.565 53.4612 519.565 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M524.288 54.5312C524.288 55.6011 523.421 56.4688 522.351 56.4688C521.281 56.4688 520.413 55.6011 520.413 54.5312C520.413 53.4612 521.281 52.5936 522.351 52.5936C523.421 52.5936 524.288 53.4612 524.288 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M524.288 49.8085C524.288 50.8785 523.421 51.7461 522.351 51.7461C521.281 51.7461 520.413 50.8785 520.413 49.8085C520.413 48.7385 521.281 47.8709 522.351 47.8709C523.421 47.8709 524.288 48.7385 524.288 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M529.011 49.8085C529.011 50.8785 528.144 51.7461 527.074 51.7461C526.004 51.7461 525.136 50.8785 525.136 49.8085C525.136 48.7385 526.004 47.8709 527.074 47.8709C528.144 47.8709 529.011 48.7385 529.011 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M529.011 45.0859C529.011 46.1558 528.144 47.0234 527.074 47.0234C526.004 47.0234 525.136 46.1558 525.136 45.0859C525.136 44.0159 526.004 43.1483 527.074 43.1483C528.144 43.1483 529.011 44.0159 529.011 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M524.288 45.0859C524.288 46.1558 523.421 47.0234 522.351 47.0234C521.281 47.0234 520.413 46.1558 520.413 45.0859C520.413 44.0159 521.281 43.1483 522.351 43.1483C523.421 43.1483 524.288 44.0159 524.288 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M519.565 45.0859C519.565 46.1558 518.697 47.0234 517.627 47.0234C516.557 47.0234 515.689 46.1558 515.689 45.0859C515.689 44.0159 516.557 43.1483 517.627 43.1483C518.697 43.1483 519.565 44.0159 519.565 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M519.565 49.8085C519.565 50.8785 518.697 51.7461 517.627 51.7461C516.557 51.7461 515.689 50.8785 515.689 49.8085C515.689 48.7385 516.557 47.8709 517.627 47.8709C518.697 47.8709 519.565 48.7385 519.565 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M514.841 49.8085C514.841 50.8785 513.974 51.7461 512.904 51.7461C511.834 51.7461 510.966 50.8785 510.966 49.8085C510.966 48.7385 511.834 47.8709 512.904 47.8709C513.974 47.8709 514.841 48.7385 514.841 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M514.841 45.0859C514.841 46.1558 513.974 47.0234 512.904 47.0234C511.834 47.0234 510.966 46.1558 510.966 45.0859C510.966 44.0159 511.834 43.1483 512.904 43.1483C513.974 43.1483 514.841 44.0159 514.841 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M510.118 45.0859C510.118 46.1558 509.251 47.0234 508.181 47.0234C507.111 47.0234 506.243 46.1558 506.243 45.0859C506.243 44.0159 507.111 43.1483 508.181 43.1483C509.251 43.1483 510.118 44.0159 510.118 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M510.118 49.8085C510.118 50.8785 509.251 51.7461 508.181 51.7461C507.111 51.7461 506.243 50.8785 506.243 49.8085C506.243 48.7385 507.111 47.8709 508.181 47.8709C509.251 47.8709 510.118 48.7385 510.118 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M505.395 49.8085C505.395 50.8785 504.528 51.7461 503.458 51.7461C502.388 51.7461 501.52 50.8785 501.52 49.8085C501.52 48.7385 502.388 47.8709 503.458 47.8709C504.528 47.8709 505.395 48.7385 505.395 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M505.395 45.0859C505.395 46.1558 504.528 47.0234 503.458 47.0234C502.388 47.0234 501.52 46.1558 501.52 45.0859C501.52 44.0159 502.388 43.1483 503.458 43.1483C504.528 43.1483 505.395 44.0159 505.395 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M500.672 45.0859C500.672 46.1558 499.805 47.0234 498.735 47.0234C497.665 47.0234 496.797 46.1558 496.797 45.0859C496.797 44.0159 497.665 43.1483 498.735 43.1483C499.805 43.1483 500.672 44.0159 500.672 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M500.672 49.8085C500.672 50.8785 499.805 51.7461 498.735 51.7461C497.665 51.7461 496.797 50.8785 496.797 49.8085C496.797 48.7385 497.665 47.8709 498.735 47.8709C499.805 47.8709 500.672 48.7385 500.672 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M500.672 54.5312C500.672 55.6011 499.805 56.4688 498.735 56.4688C497.665 56.4688 496.797 55.6011 496.797 54.5312C496.797 53.4612 497.665 52.5936 498.735 52.5936C499.805 52.5936 500.672 53.4612 500.672 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M505.395 54.5312C505.395 55.6011 504.528 56.4688 503.458 56.4688C502.388 56.4688 501.52 55.6011 501.52 54.5312C501.52 53.4612 502.388 52.5936 503.458 52.5936C504.528 52.5936 505.395 53.4612 505.395 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M505.395 59.2538C505.395 60.3238 504.528 61.1914 503.458 61.1914C502.388 61.1914 501.52 60.3238 501.52 59.2538C501.52 58.1838 502.388 57.3162 503.458 57.3162C504.528 57.3162 505.395 58.1838 505.395 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M505.395 63.9804C505.395 65.0504 504.528 65.918 503.458 65.918C502.388 65.918 501.52 65.0504 501.52 63.9804C501.52 62.9104 502.388 62.0428 503.458 62.0428C504.528 62.0428 505.395 62.9104 505.395 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M500.672 63.9804C500.672 65.0504 499.805 65.918 498.735 65.918C497.665 65.918 496.797 65.0504 496.797 63.9804C496.797 62.9104 497.665 62.0428 498.735 62.0428C499.805 62.0428 500.672 62.9104 500.672 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M500.672 59.2538C500.672 60.3238 499.805 61.1914 498.735 61.1914C497.665 61.1914 496.797 60.3238 496.797 59.2538C496.797 58.1838 497.665 57.3162 498.735 57.3162C499.805 57.3162 500.672 58.1838 500.672 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M486.503 73.4257C486.503 74.4957 485.635 75.3633 484.565 75.3633C483.495 75.3633 482.627 74.4957 482.627 73.4257C482.627 72.3557 483.495 71.4881 484.565 71.4881C485.635 71.4881 486.503 72.3557 486.503 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M481.779 73.4257C481.779 74.4957 480.912 75.3633 479.842 75.3633C478.772 75.3633 477.904 74.4957 477.904 73.4257C477.904 72.3557 478.772 71.4881 479.842 71.4881C480.912 71.4881 481.779 72.3557 481.779 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M477.056 73.4257C477.056 74.4957 476.189 75.3633 475.119 75.3633C474.049 75.3633 473.181 74.4957 473.181 73.4257C473.181 72.3557 474.049 71.4881 475.119 71.4881C476.189 71.4881 477.056 72.3557 477.056 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M477.056 78.1484C477.056 79.2183 476.189 80.0859 475.119 80.0859C474.049 80.0859 473.181 79.2183 473.181 78.1484C473.181 77.0784 474.049 76.2108 475.119 76.2108C476.189 76.2108 477.056 77.0784 477.056 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M477.056 82.871C477.056 83.941 476.189 84.8086 475.119 84.8086C474.049 84.8086 473.181 83.941 473.181 82.871C473.181 81.801 474.049 80.9334 475.119 80.9334C476.189 80.9334 477.056 81.801 477.056 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M481.779 82.871C481.779 83.941 480.912 84.8086 479.842 84.8086C478.772 84.8086 477.904 83.941 477.904 82.871C477.904 81.801 478.772 80.9334 479.842 80.9334C480.912 80.9334 481.779 81.801 481.779 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M481.779 78.1484C481.779 79.2183 480.912 80.0859 479.842 80.0859C478.772 80.0859 477.904 79.2183 477.904 78.1484C477.904 77.0784 478.772 76.2108 479.842 76.2108C480.912 76.2108 481.779 77.0784 481.779 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M486.503 78.1484C486.503 79.2183 485.635 80.0859 484.565 80.0859C483.495 80.0859 482.627 79.2183 482.627 78.1484C482.627 77.0784 483.495 76.2108 484.565 76.2108C485.635 76.2108 486.503 77.0784 486.503 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M420.378 144.273C420.378 145.343 419.511 146.211 418.441 146.211C417.371 146.211 416.503 145.343 416.503 144.273C416.503 143.203 417.371 142.336 418.441 142.336C419.511 142.336 420.378 143.203 420.378 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M415.655 144.273C415.655 145.343 414.788 146.211 413.718 146.211C412.648 146.211 411.78 145.343 411.78 144.273C411.78 143.203 412.648 142.336 413.718 142.336C414.788 142.336 415.655 143.203 415.655 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M410.932 144.273C410.932 145.343 410.065 146.211 408.995 146.211C407.925 146.211 407.057 145.343 407.057 144.273C407.057 143.203 407.925 142.336 408.995 142.336C410.065 142.336 410.932 143.203 410.932 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M406.209 144.273C406.209 145.343 405.341 146.211 404.271 146.211C403.201 146.211 402.333 145.343 402.333 144.273C402.333 143.203 403.201 142.336 404.271 142.336C405.341 142.336 406.209 143.203 406.209 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M401.486 144.273C401.486 145.343 400.618 146.211 399.548 146.211C398.478 146.211 397.61 145.343 397.61 144.273C397.61 143.203 398.478 142.336 399.548 142.336C400.618 142.336 401.486 143.203 401.486 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M396.762 144.273C396.762 145.343 395.895 146.211 394.825 146.211C393.755 146.211 392.887 145.343 392.887 144.273C392.887 143.203 393.755 142.336 394.825 142.336C395.895 142.336 396.762 143.203 396.762 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M392.039 144.273C392.039 145.343 391.172 146.211 390.102 146.211C389.032 146.211 388.164 145.343 388.164 144.273C388.164 143.203 389.032 142.336 390.102 142.336C391.172 142.336 392.039 143.203 392.039 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M392.039 139.551C392.039 140.621 391.172 141.488 390.102 141.488C389.032 141.488 388.164 140.621 388.164 139.551C388.164 138.481 389.032 137.613 390.102 137.613C391.172 137.613 392.039 138.481 392.039 139.551Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M392.039 134.828C392.039 135.898 391.172 136.766 390.102 136.766C389.032 136.766 388.164 135.898 388.164 134.828C388.164 133.758 389.032 132.89 390.102 132.89C391.172 132.89 392.039 133.758 392.039 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M392.039 130.101C392.039 131.171 391.172 132.039 390.102 132.039C389.032 132.039 388.164 131.171 388.164 130.101C388.164 129.031 389.032 128.164 390.102 128.164C391.172 128.164 392.039 129.031 392.039 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M392.039 125.379C392.039 126.449 391.172 127.316 390.102 127.316C389.032 127.316 388.164 126.449 388.164 125.379C388.164 124.309 389.032 123.441 390.102 123.441C391.172 123.441 392.039 124.309 392.039 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M396.762 125.379C396.762 126.449 395.895 127.316 394.825 127.316C393.755 127.316 392.887 126.449 392.887 125.379C392.887 124.309 393.755 123.441 394.825 123.441C395.895 123.441 396.762 124.309 396.762 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M396.762 130.101C396.762 131.171 395.895 132.039 394.825 132.039C393.755 132.039 392.887 131.171 392.887 130.101C392.887 129.031 393.755 128.164 394.825 128.164C395.895 128.164 396.762 129.031 396.762 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M396.762 163.164C396.762 164.234 395.895 165.102 394.825 165.102C393.755 165.102 392.887 164.234 392.887 163.164C392.887 162.094 393.755 161.226 394.825 161.226C395.895 161.226 396.762 162.094 396.762 163.164Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M401.486 163.164C401.486 164.234 400.618 165.102 399.548 165.102C398.478 165.102 397.61 164.234 397.61 163.164C397.61 162.094 398.478 161.226 399.548 161.226C400.618 161.226 401.486 162.094 401.486 163.164Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M406.209 163.164C406.209 164.234 405.341 165.102 404.271 165.102C403.201 165.102 402.333 164.234 402.333 163.164C402.333 162.094 403.201 161.226 404.271 161.226C405.341 161.226 406.209 162.094 406.209 163.164Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M472.333 134.828C472.333 135.898 471.466 136.766 470.396 136.766C469.326 136.766 468.458 135.898 468.458 134.828C468.458 133.758 469.326 132.89 470.396 132.89C471.466 132.89 472.333 133.758 472.333 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M472.333 139.551C472.333 140.621 471.466 141.488 470.396 141.488C469.326 141.488 468.458 140.621 468.458 139.551C468.458 138.481 469.326 137.613 470.396 137.613C471.466 137.613 472.333 138.481 472.333 139.551Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M472.333 144.273C472.333 145.343 471.466 146.211 470.396 146.211C469.326 146.211 468.458 145.343 468.458 144.273C468.458 143.203 469.326 142.336 470.396 142.336C471.466 142.336 472.333 143.203 472.333 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M472.333 148.996C472.333 150.066 471.466 150.934 470.396 150.934C469.326 150.934 468.458 150.066 468.458 148.996C468.458 147.926 469.326 147.058 470.396 147.058C471.466 147.058 472.333 147.926 472.333 148.996Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M472.333 153.719C472.333 154.789 471.466 155.656 470.396 155.656C469.326 155.656 468.458 154.789 468.458 153.719C468.458 152.649 469.326 151.781 470.396 151.781C471.466 151.781 472.333 152.649 472.333 153.719Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M477.056 153.719C477.056 154.789 476.189 155.656 475.119 155.656C474.049 155.656 473.181 154.789 473.181 153.719C473.181 152.649 474.049 151.781 475.119 151.781C476.189 151.781 477.056 152.649 477.056 153.719Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M477.056 158.441C477.056 159.511 476.189 160.379 475.119 160.379C474.049 160.379 473.181 159.511 473.181 158.441C473.181 157.371 474.049 156.504 475.119 156.504C476.189 156.504 477.056 157.371 477.056 158.441Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M477.056 163.164C477.056 164.234 476.189 165.102 475.119 165.102C474.049 165.102 473.181 164.234 473.181 163.164C473.181 162.094 474.049 161.226 475.119 161.226C476.189 161.226 477.056 162.094 477.056 163.164Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M477.056 167.887C477.056 168.957 476.189 169.824 475.119 169.824C474.049 169.824 473.181 168.957 473.181 167.887C473.181 166.817 474.049 165.949 475.119 165.949C476.189 165.949 477.056 166.817 477.056 167.887Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M481.779 167.887C481.779 168.957 480.912 169.824 479.842 169.824C478.772 169.824 477.904 168.957 477.904 167.887C477.904 166.817 478.772 165.949 479.842 165.949C480.912 165.949 481.779 166.817 481.779 167.887Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M481.779 163.164C481.779 164.234 480.912 165.102 479.842 165.102C478.772 165.102 477.904 164.234 477.904 163.164C477.904 162.094 478.772 161.226 479.842 161.226C480.912 161.226 481.779 162.094 481.779 163.164Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M472.333 163.164C472.333 164.234 471.466 165.102 470.396 165.102C469.326 165.102 468.458 164.234 468.458 163.164C468.458 162.094 469.326 161.226 470.396 161.226C471.466 161.226 472.333 162.094 472.333 163.164Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M472.333 158.441C472.333 159.511 471.466 160.379 470.396 160.379C469.326 160.379 468.458 159.511 468.458 158.441C468.458 157.371 469.326 156.504 470.396 156.504C471.466 156.504 472.333 157.371 472.333 158.441Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M472.333 172.613C472.333 173.683 471.466 174.551 470.396 174.551C469.326 174.551 468.458 173.683 468.458 172.613C468.458 171.543 469.326 170.676 470.396 170.676C471.466 170.676 472.333 171.543 472.333 172.613Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M472.333 167.887C472.333 168.957 471.466 169.824 470.396 169.824C469.326 169.824 468.458 168.957 468.458 167.887C468.458 166.817 469.326 165.949 470.396 165.949C471.466 165.949 472.333 166.817 472.333 167.887Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M467.61 167.887C467.61 168.957 466.743 169.824 465.673 169.824C464.603 169.824 463.735 168.957 463.735 167.887C463.735 166.817 464.603 165.949 465.673 165.949C466.743 165.949 467.61 166.817 467.61 167.887Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M467.61 172.613C467.61 173.683 466.743 174.551 465.673 174.551C464.603 174.551 463.735 173.683 463.735 172.613C463.735 171.543 464.603 170.676 465.673 170.676C466.743 170.676 467.61 171.543 467.61 172.613Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M462.887 172.613C462.887 173.683 462.019 174.551 460.949 174.551C459.879 174.551 459.011 173.683 459.011 172.613C459.011 171.543 459.879 170.676 460.949 170.676C462.019 170.676 462.887 171.543 462.887 172.613Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M458.164 172.613C458.164 173.683 457.296 174.551 456.226 174.551C455.156 174.551 454.288 173.683 454.288 172.613C454.288 171.543 455.156 170.676 456.226 170.676C457.296 170.676 458.164 171.543 458.164 172.613Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M510.118 111.211C510.118 112.281 509.251 113.148 508.181 113.148C507.111 113.148 506.243 112.281 506.243 111.211C506.243 110.141 507.111 109.273 508.181 109.273C509.251 109.273 510.118 110.141 510.118 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M495.949 139.551C495.949 140.621 495.082 141.488 494.012 141.488C492.942 141.488 492.074 140.621 492.074 139.551C492.074 138.481 492.942 137.613 494.012 137.613C495.082 137.613 495.949 138.481 495.949 139.551Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M500.672 144.273C500.672 145.343 499.805 146.211 498.735 146.211C497.665 146.211 496.797 145.343 496.797 144.273C496.797 143.203 497.665 142.336 498.735 142.336C499.805 142.336 500.672 143.203 500.672 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M500.672 148.996C500.672 150.066 499.805 150.934 498.735 150.934C497.665 150.934 496.797 150.066 496.797 148.996C496.797 147.926 497.665 147.058 498.735 147.058C499.805 147.058 500.672 147.926 500.672 148.996Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M486.503 148.996C486.503 150.066 485.635 150.934 484.565 150.934C483.495 150.934 482.627 150.066 482.627 148.996C482.627 147.926 483.495 147.058 484.565 147.058C485.635 147.058 486.503 147.926 486.503 148.996Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M481.779 177.336C481.779 178.406 480.912 179.273 479.842 179.273C478.772 179.273 477.904 178.406 477.904 177.336C477.904 176.266 478.772 175.398 479.842 175.398C480.912 175.398 481.779 176.266 481.779 177.336Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M462.887 196.226C462.887 197.296 462.019 198.164 460.949 198.164C459.879 198.164 459.011 197.296 459.011 196.226C459.011 195.156 459.879 194.289 460.949 194.289C462.019 194.289 462.887 195.156 462.887 196.226Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M467.61 196.226C467.61 197.296 466.743 198.164 465.673 198.164C464.603 198.164 463.735 197.296 463.735 196.226C463.735 195.156 464.603 194.289 465.673 194.289C466.743 194.289 467.61 195.156 467.61 196.226Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M472.333 196.226C472.333 197.296 471.466 198.164 470.396 198.164C469.326 198.164 468.458 197.296 468.458 196.226C468.458 195.156 469.326 194.289 470.396 194.289C471.466 194.289 472.333 195.156 472.333 196.226Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M472.333 200.949C472.333 202.019 471.466 202.887 470.396 202.887C469.326 202.887 468.458 202.019 468.458 200.949C468.458 199.879 469.326 199.012 470.396 199.012C471.466 199.012 472.333 199.879 472.333 200.949Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M467.61 200.949C467.61 202.019 466.743 202.887 465.673 202.887C464.603 202.887 463.735 202.019 463.735 200.949C463.735 199.879 464.603 199.012 465.673 199.012C466.743 199.012 467.61 199.879 467.61 200.949Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M420.378 200.949C420.378 202.019 419.511 202.887 418.441 202.887C417.371 202.887 416.503 202.019 416.503 200.949C416.503 199.879 417.371 199.012 418.441 199.012C419.511 199.012 420.378 199.879 420.378 200.949Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M425.101 205.672C425.101 206.742 424.234 207.609 423.164 207.609C422.094 207.609 421.226 206.742 421.226 205.672C421.226 204.602 422.094 203.734 423.164 203.734C424.234 203.734 425.101 204.602 425.101 205.672Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M358.977 158.441C358.977 159.511 358.11 160.379 357.04 160.379C355.97 160.379 355.102 159.511 355.102 158.441C355.102 157.371 355.97 156.504 357.04 156.504C358.11 156.504 358.977 157.371 358.977 158.441Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M354.254 158.441C354.254 159.511 353.387 160.379 352.317 160.379C351.247 160.379 350.379 159.511 350.379 158.441C350.379 157.371 351.247 156.504 352.317 156.504C353.387 156.504 354.254 157.371 354.254 158.441Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M349.531 158.441C349.531 159.511 348.664 160.379 347.594 160.379C346.524 160.379 345.656 159.511 345.656 158.441C345.656 157.371 346.524 156.504 347.594 156.504C348.664 156.504 349.531 157.371 349.531 158.441Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M349.531 163.164C349.531 164.234 348.664 165.102 347.594 165.102C346.524 165.102 345.656 164.234 345.656 163.164C345.656 162.094 346.524 161.226 347.594 161.226C348.664 161.226 349.531 162.094 349.531 163.164Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M344.808 82.871C344.808 83.941 343.941 84.8086 342.871 84.8086C341.801 84.8086 340.933 83.941 340.933 82.871C340.933 81.801 341.801 80.9334 342.871 80.9334C343.941 80.9334 344.808 81.801 344.808 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M349.531 82.871C349.531 83.941 348.664 84.8086 347.594 84.8086C346.524 84.8086 345.656 83.941 345.656 82.871C345.656 81.801 346.524 80.9334 347.594 80.9334C348.664 80.9334 349.531 81.801 349.531 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M349.531 78.1484C349.531 79.2183 348.664 80.0859 347.594 80.0859C346.524 80.0859 345.656 79.2183 345.656 78.1484C345.656 77.0784 346.524 76.2108 347.594 76.2108C348.664 76.2108 349.531 77.0784 349.531 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M354.254 78.1484C354.254 79.2183 353.387 80.0859 352.317 80.0859C351.247 80.0859 350.379 79.2183 350.379 78.1484C350.379 77.0784 351.247 76.2108 352.317 76.2108C353.387 76.2108 354.254 77.0784 354.254 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M358.977 78.1484C358.977 79.2183 358.11 80.0859 357.04 80.0859C355.97 80.0859 355.102 79.2183 355.102 78.1484C355.102 77.0784 355.97 76.2108 357.04 76.2108C358.11 76.2108 358.977 77.0784 358.977 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M363.7 78.1484C363.7 79.2183 362.833 80.0859 361.763 80.0859C360.693 80.0859 359.825 79.2183 359.825 78.1484C359.825 77.0784 360.693 76.2108 361.763 76.2108C362.833 76.2108 363.7 77.0784 363.7 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M368.424 78.1484C368.424 79.2183 367.556 80.0859 366.486 80.0859C365.416 80.0859 364.548 79.2183 364.548 78.1484C364.548 77.0784 365.416 76.2108 366.486 76.2108C367.556 76.2108 368.424 77.0784 368.424 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M373.147 78.1484C373.147 79.2183 372.279 80.0859 371.209 80.0859C370.139 80.0859 369.271 79.2183 369.271 78.1484C369.271 77.0784 370.139 76.2108 371.209 76.2108C372.279 76.2108 373.147 77.0784 373.147 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M373.147 82.871C373.147 83.941 372.279 84.8086 371.209 84.8086C370.139 84.8086 369.271 83.941 369.271 82.871C369.271 81.801 370.139 80.9334 371.209 80.9334C372.279 80.9334 373.147 81.801 373.147 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M368.424 82.871C368.424 83.941 367.556 84.8086 366.486 84.8086C365.416 84.8086 364.548 83.941 364.548 82.871C364.548 81.801 365.416 80.9334 366.486 80.9334C367.556 80.9334 368.424 81.801 368.424 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M363.7 82.871C363.7 83.941 362.833 84.8086 361.763 84.8086C360.693 84.8086 359.825 83.941 359.825 82.871C359.825 81.801 360.693 80.9334 361.763 80.9334C362.833 80.9334 363.7 81.801 363.7 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M358.977 82.871C358.977 83.941 358.11 84.8086 357.04 84.8086C355.97 84.8086 355.102 83.941 355.102 82.871C355.102 81.801 355.97 80.9334 357.04 80.9334C358.11 80.9334 358.977 81.801 358.977 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M354.254 82.871C354.254 83.941 353.387 84.8086 352.317 84.8086C351.247 84.8086 350.379 83.941 350.379 82.871C350.379 81.801 351.247 80.9334 352.317 80.9334C353.387 80.9334 354.254 81.801 354.254 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M354.254 73.4257C354.254 74.4957 353.387 75.3633 352.317 75.3633C351.247 75.3633 350.379 74.4957 350.379 73.4257C350.379 72.3557 351.247 71.4881 352.317 71.4881C353.387 71.4881 354.254 72.3557 354.254 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M358.977 73.4257C358.977 74.4957 358.11 75.3633 357.04 75.3633C355.97 75.3633 355.102 74.4957 355.102 73.4257C355.102 72.3557 355.97 71.4881 357.04 71.4881C358.11 71.4881 358.977 72.3557 358.977 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M363.7 73.4257C363.7 74.4957 362.833 75.3633 361.763 75.3633C360.693 75.3633 359.825 74.4957 359.825 73.4257C359.825 72.3557 360.693 71.4881 361.763 71.4881C362.833 71.4881 363.7 72.3557 363.7 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M368.424 73.4257C368.424 74.4957 367.556 75.3633 366.486 75.3633C365.416 75.3633 364.548 74.4957 364.548 73.4257C364.548 72.3557 365.416 71.4881 366.486 71.4881C367.556 71.4881 368.424 72.3557 368.424 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M368.424 68.703C368.424 69.773 367.556 70.6406 366.486 70.6406C365.416 70.6406 364.548 69.773 364.548 68.703C364.548 67.6331 365.416 66.7655 366.486 66.7655C367.556 66.7655 368.424 67.6331 368.424 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M373.147 68.703C373.147 69.773 372.279 70.6406 371.209 70.6406C370.139 70.6406 369.271 69.773 369.271 68.703C369.271 67.6331 370.139 66.7655 371.209 66.7655C372.279 66.7655 373.147 67.6331 373.147 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M373.147 73.4257C373.147 74.4957 372.279 75.3633 371.209 75.3633C370.139 75.3633 369.271 74.4957 369.271 73.4257C369.271 72.3557 370.139 71.4881 371.209 71.4881C372.279 71.4881 373.147 72.3557 373.147 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M377.87 73.4257C377.87 74.4957 377.003 75.3633 375.933 75.3633C374.863 75.3633 373.995 74.4957 373.995 73.4257C373.995 72.3557 374.863 71.4881 375.933 71.4881C377.003 71.4881 377.87 72.3557 377.87 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M377.87 78.1484C377.87 79.2183 377.003 80.0859 375.933 80.0859C374.863 80.0859 373.995 79.2183 373.995 78.1484C373.995 77.0784 374.863 76.2108 375.933 76.2108C377.003 76.2108 377.87 77.0784 377.87 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M382.593 78.1484C382.593 79.2183 381.726 80.0859 380.656 80.0859C379.586 80.0859 378.718 79.2183 378.718 78.1484C378.718 77.0784 379.586 76.2108 380.656 76.2108C381.726 76.2108 382.593 77.0784 382.593 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M387.316 78.1484C387.316 79.2183 386.449 80.0859 385.379 80.0859C384.309 80.0859 383.441 79.2183 383.441 78.1484C383.441 77.0784 384.309 76.2108 385.379 76.2108C386.449 76.2108 387.316 77.0784 387.316 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M392.039 78.1484C392.039 79.2183 391.172 80.0859 390.102 80.0859C389.032 80.0859 388.164 79.2183 388.164 78.1484C388.164 77.0784 389.032 76.2108 390.102 76.2108C391.172 76.2108 392.039 77.0784 392.039 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M392.039 73.4257C392.039 74.4957 391.172 75.3633 390.102 75.3633C389.032 75.3633 388.164 74.4957 388.164 73.4257C388.164 72.3557 389.032 71.4881 390.102 71.4881C391.172 71.4881 392.039 72.3557 392.039 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M387.316 73.4257C387.316 74.4957 386.449 75.3633 385.379 75.3633C384.309 75.3633 383.441 74.4957 383.441 73.4257C383.441 72.3557 384.309 71.4881 385.379 71.4881C386.449 71.4881 387.316 72.3557 387.316 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M387.316 68.703C387.316 69.773 386.449 70.6406 385.379 70.6406C384.309 70.6406 383.441 69.773 383.441 68.703C383.441 67.6331 384.309 66.7655 385.379 66.7655C386.449 66.7655 387.316 67.6331 387.316 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M396.762 68.703C396.762 69.773 395.895 70.6406 394.825 70.6406C393.755 70.6406 392.887 69.773 392.887 68.703C392.887 67.6331 393.755 66.7655 394.825 66.7655C395.895 66.7655 396.762 67.6331 396.762 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M396.762 63.9804C396.762 65.0504 395.895 65.918 394.825 65.918C393.755 65.918 392.887 65.0504 392.887 63.9804C392.887 62.9104 393.755 62.0428 394.825 62.0428C395.895 62.0428 396.762 62.9104 396.762 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M401.486 63.9804C401.486 65.0504 400.618 65.918 399.548 65.918C398.478 65.918 397.61 65.0504 397.61 63.9804C397.61 62.9104 398.478 62.0428 399.548 62.0428C400.618 62.0428 401.486 62.9104 401.486 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M401.486 59.2538C401.486 60.3238 400.618 61.1914 399.548 61.1914C398.478 61.1914 397.61 60.3238 397.61 59.2538C397.61 58.1838 398.478 57.3162 399.548 57.3162C400.618 57.3162 401.486 58.1838 401.486 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M401.486 54.5312C401.486 55.6011 400.618 56.4688 399.548 56.4688C398.478 56.4688 397.61 55.6011 397.61 54.5312C397.61 53.4612 398.478 52.5936 399.548 52.5936C400.618 52.5936 401.486 53.4612 401.486 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M396.762 54.5312C396.762 55.6011 395.895 56.4688 394.825 56.4688C393.755 56.4688 392.887 55.6011 392.887 54.5312C392.887 53.4612 393.755 52.5936 394.825 52.5936C395.895 52.5936 396.762 53.4612 396.762 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M396.762 49.8085C396.762 50.8785 395.895 51.7461 394.825 51.7461C393.755 51.7461 392.887 50.8785 392.887 49.8085C392.887 48.7385 393.755 47.8709 394.825 47.8709C395.895 47.8709 396.762 48.7385 396.762 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M392.039 49.8085C392.039 50.8785 391.172 51.7461 390.102 51.7461C389.032 51.7461 388.164 50.8785 388.164 49.8085C388.164 48.7385 389.032 47.8709 390.102 47.8709C391.172 47.8709 392.039 48.7385 392.039 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M387.316 45.0859C387.316 46.1558 386.449 47.0234 385.379 47.0234C384.309 47.0234 383.441 46.1558 383.441 45.0859C383.441 44.0159 384.309 43.1483 385.379 43.1483C386.449 43.1483 387.316 44.0159 387.316 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M396.762 45.0859C396.762 46.1558 395.895 47.0234 394.825 47.0234C393.755 47.0234 392.887 46.1558 392.887 45.0859C392.887 44.0159 393.755 43.1483 394.825 43.1483C395.895 43.1483 396.762 44.0159 396.762 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M396.762 40.3632C396.762 41.4332 395.895 42.3008 394.825 42.3008C393.755 42.3008 392.887 41.4332 392.887 40.3632C392.887 39.2932 393.755 38.4256 394.825 38.4256C395.895 38.4256 396.762 39.2932 396.762 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M396.762 35.6405C396.762 36.7105 395.895 37.5781 394.825 37.5781C393.755 37.5781 392.887 36.7105 392.887 35.6405C392.887 34.5706 393.755 33.703 394.825 33.703C395.895 33.703 396.762 34.5706 396.762 35.6405Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M401.486 35.6405C401.486 36.7105 400.618 37.5781 399.548 37.5781C398.478 37.5781 397.61 36.7105 397.61 35.6405C397.61 34.5706 398.478 33.703 399.548 33.703C400.618 33.703 401.486 34.5706 401.486 35.6405Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M401.486 30.9179C401.486 31.9879 400.618 32.8555 399.548 32.8555C398.478 32.8555 397.61 31.9879 397.61 30.9179C397.61 29.8479 398.478 28.9803 399.548 28.9803C400.618 28.9803 401.486 29.8479 401.486 30.9179Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M406.209 35.6405C406.209 36.7105 405.341 37.5781 404.271 37.5781C403.201 37.5781 402.333 36.7105 402.333 35.6405C402.333 34.5706 403.201 33.703 404.271 33.703C405.341 33.703 406.209 34.5706 406.209 35.6405Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M406.209 30.9179C406.209 31.9879 405.341 32.8555 404.271 32.8555C403.201 32.8555 402.333 31.9879 402.333 30.9179C402.333 29.8479 403.201 28.9803 404.271 28.9803C405.341 28.9803 406.209 29.8479 406.209 30.9179Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M410.932 30.9179C410.932 31.9879 410.065 32.8555 408.995 32.8555C407.925 32.8555 407.057 31.9879 407.057 30.9179C407.057 29.8479 407.925 28.9803 408.995 28.9803C410.065 28.9803 410.932 29.8479 410.932 30.9179Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M406.209 26.1952C406.209 27.2652 405.341 28.1328 404.271 28.1328C403.201 28.1328 402.333 27.2652 402.333 26.1952C402.333 25.1252 403.201 24.2576 404.271 24.2576C405.341 24.2576 406.209 25.1252 406.209 26.1952Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M406.209 21.4687C406.209 22.5386 405.341 23.4062 404.271 23.4062C403.201 23.4062 402.333 22.5386 402.333 21.4687C402.333 20.3987 403.201 19.5311 404.271 19.5311C405.341 19.5311 406.209 20.3987 406.209 21.4687Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M401.486 16.746C401.486 17.816 400.618 18.6836 399.548 18.6836C398.478 18.6836 397.61 17.816 397.61 16.746C397.61 15.676 398.478 14.8084 399.548 14.8084C400.618 14.8084 401.486 15.676 401.486 16.746Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M392.039 12.0234C392.039 13.0933 391.172 13.9609 390.102 13.9609C389.032 13.9609 388.164 13.0933 388.164 12.0234C388.164 10.9534 389.032 10.0858 390.102 10.0858C391.172 10.0858 392.039 10.9534 392.039 12.0234Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M387.316 12.0234C387.316 13.0933 386.449 13.9609 385.379 13.9609C384.309 13.9609 383.441 13.0933 383.441 12.0234C383.441 10.9534 384.309 10.0858 385.379 10.0858C386.449 10.0858 387.316 10.9534 387.316 12.0234Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M382.593 7.30069C382.593 8.37067 381.726 9.23828 380.656 9.23828C379.586 9.23828 378.718 8.37067 378.718 7.30069C378.718 6.23072 379.586 5.36311 380.656 5.36311C381.726 5.36311 382.593 6.23072 382.593 7.30069Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M410.932 26.1952C410.932 27.2652 410.065 28.1328 408.995 28.1328C407.925 28.1328 407.057 27.2652 407.057 26.1952C407.057 25.1252 407.925 24.2576 408.995 24.2576C410.065 24.2576 410.932 25.1252 410.932 26.1952Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M415.655 26.1952C415.655 27.2652 414.788 28.1328 413.718 28.1328C412.648 28.1328 411.78 27.2652 411.78 26.1952C411.78 25.1252 412.648 24.2576 413.718 24.2576C414.788 24.2576 415.655 25.1252 415.655 26.1952Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M415.655 21.4687C415.655 22.5386 414.788 23.4062 413.718 23.4062C412.648 23.4062 411.78 22.5386 411.78 21.4687C411.78 20.3987 412.648 19.5311 413.718 19.5311C414.788 19.5311 415.655 20.3987 415.655 21.4687Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M415.655 30.9179C415.655 31.9879 414.788 32.8555 413.718 32.8555C412.648 32.8555 411.78 31.9879 411.78 30.9179C411.78 29.8479 412.648 28.9803 413.718 28.9803C414.788 28.9803 415.655 29.8479 415.655 30.9179Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M415.655 35.6405C415.655 36.7105 414.788 37.5781 413.718 37.5781C412.648 37.5781 411.78 36.7105 411.78 35.6405C411.78 34.5706 412.648 33.703 413.718 33.703C414.788 33.703 415.655 34.5706 415.655 35.6405Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M415.655 40.3632C415.655 41.4332 414.788 42.3008 413.718 42.3008C412.648 42.3008 411.78 41.4332 411.78 40.3632C411.78 39.2932 412.648 38.4256 413.718 38.4256C414.788 38.4256 415.655 39.2932 415.655 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M415.655 45.0859C415.655 46.1558 414.788 47.0234 413.718 47.0234C412.648 47.0234 411.78 46.1558 411.78 45.0859C411.78 44.0159 412.648 43.1483 413.718 43.1483C414.788 43.1483 415.655 44.0159 415.655 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M420.378 45.0859C420.378 46.1558 419.511 47.0234 418.441 47.0234C417.371 47.0234 416.503 46.1558 416.503 45.0859C416.503 44.0159 417.371 43.1483 418.441 43.1483C419.511 43.1483 420.378 44.0159 420.378 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M425.101 45.0859C425.101 46.1558 424.234 47.0234 423.164 47.0234C422.094 47.0234 421.226 46.1558 421.226 45.0859C421.226 44.0159 422.094 43.1483 423.164 43.1483C424.234 43.1483 425.101 44.0159 425.101 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M425.101 40.3632C425.101 41.4332 424.234 42.3008 423.164 42.3008C422.094 42.3008 421.226 41.4332 421.226 40.3632C421.226 39.2932 422.094 38.4256 423.164 38.4256C424.234 38.4256 425.101 39.2932 425.101 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M429.825 40.3632C429.825 41.4332 428.957 42.3008 427.887 42.3008C426.817 42.3008 425.949 41.4332 425.949 40.3632C425.949 39.2932 426.817 38.4256 427.887 38.4256C428.957 38.4256 429.825 39.2932 429.825 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M434.548 40.3632C434.548 41.4332 433.681 42.3008 432.611 42.3008C431.541 42.3008 430.673 41.4332 430.673 40.3632C430.673 39.2932 431.541 38.4256 432.611 38.4256C433.681 38.4256 434.548 39.2932 434.548 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M434.548 35.6405C434.548 36.7105 433.681 37.5781 432.611 37.5781C431.541 37.5781 430.673 36.7105 430.673 35.6405C430.673 34.5706 431.541 33.703 432.611 33.703C433.681 33.703 434.548 34.5706 434.548 35.6405Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M439.271 40.3632C439.271 41.4332 438.403 42.3008 437.333 42.3008C436.263 42.3008 435.396 41.4332 435.396 40.3632C435.396 39.2932 436.263 38.4256 437.333 38.4256C438.403 38.4256 439.271 39.2932 439.271 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M443.994 40.3632C443.994 41.4332 443.127 42.3008 442.057 42.3008C440.987 42.3008 440.119 41.4332 440.119 40.3632C440.119 39.2932 440.987 38.4256 442.057 38.4256C443.127 38.4256 443.994 39.2932 443.994 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M443.994 35.6405C443.994 36.7105 443.127 37.5781 442.057 37.5781C440.987 37.5781 440.119 36.7105 440.119 35.6405C440.119 34.5706 440.987 33.703 442.057 33.703C443.127 33.703 443.994 34.5706 443.994 35.6405Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M448.717 35.6405C448.717 36.7105 447.85 37.5781 446.78 37.5781C445.71 37.5781 444.842 36.7105 444.842 35.6405C444.842 34.5706 445.71 33.703 446.78 33.703C447.85 33.703 448.717 34.5706 448.717 35.6405Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M448.717 40.3632C448.717 41.4332 447.85 42.3008 446.78 42.3008C445.71 42.3008 444.842 41.4332 444.842 40.3632C444.842 39.2932 445.71 38.4256 446.78 38.4256C447.85 38.4256 448.717 39.2932 448.717 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M453.44 40.3632C453.44 41.4332 452.573 42.3008 451.503 42.3008C450.433 42.3008 449.565 41.4332 449.565 40.3632C449.565 39.2932 450.433 38.4256 451.503 38.4256C452.573 38.4256 453.44 39.2932 453.44 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M453.44 45.0859C453.44 46.1558 452.573 47.0234 451.503 47.0234C450.433 47.0234 449.565 46.1558 449.565 45.0859C449.565 44.0159 450.433 43.1483 451.503 43.1483C452.573 43.1483 453.44 44.0159 453.44 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M458.164 45.0859C458.164 46.1558 457.296 47.0234 456.226 47.0234C455.156 47.0234 454.288 46.1558 454.288 45.0859C454.288 44.0159 455.156 43.1483 456.226 43.1483C457.296 43.1483 458.164 44.0159 458.164 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M462.887 45.0859C462.887 46.1558 462.019 47.0234 460.949 47.0234C459.879 47.0234 459.011 46.1558 459.011 45.0859C459.011 44.0159 459.879 43.1483 460.949 43.1483C462.019 43.1483 462.887 44.0159 462.887 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M462.887 40.3632C462.887 41.4332 462.019 42.3008 460.949 42.3008C459.879 42.3008 459.011 41.4332 459.011 40.3632C459.011 39.2932 459.879 38.4256 460.949 38.4256C462.019 38.4256 462.887 39.2932 462.887 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M467.61 40.3632C467.61 41.4332 466.743 42.3008 465.673 42.3008C464.603 42.3008 463.735 41.4332 463.735 40.3632C463.735 39.2932 464.603 38.4256 465.673 38.4256C466.743 38.4256 467.61 39.2932 467.61 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M467.61 35.6405C467.61 36.7105 466.743 37.5781 465.673 37.5781C464.603 37.5781 463.735 36.7105 463.735 35.6405C463.735 34.5706 464.603 33.703 465.673 33.703C466.743 33.703 467.61 34.5706 467.61 35.6405Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M472.333 35.6405C472.333 36.7105 471.466 37.5781 470.396 37.5781C469.326 37.5781 468.458 36.7105 468.458 35.6405C468.458 34.5706 469.326 33.703 470.396 33.703C471.466 33.703 472.333 34.5706 472.333 35.6405Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M472.333 30.9179C472.333 31.9879 471.466 32.8555 470.396 32.8555C469.326 32.8555 468.458 31.9879 468.458 30.9179C468.458 29.8479 469.326 28.9803 470.396 28.9803C471.466 28.9803 472.333 29.8479 472.333 30.9179Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M462.887 21.4687C462.887 22.5386 462.02 23.4062 460.95 23.4062C459.88 23.4062 459.012 22.5386 459.012 21.4687C459.012 20.3987 459.88 19.5311 460.95 19.5311C462.02 19.5311 462.887 20.3987 462.887 21.4687Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M453.441 16.746C453.441 17.816 452.573 18.6836 451.503 18.6836C450.433 18.6836 449.565 17.816 449.565 16.746C449.565 15.676 450.433 14.8084 451.503 14.8084C452.573 14.8084 453.441 15.676 453.441 16.746Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M458.164 16.746C458.164 17.816 457.297 18.6836 456.227 18.6836C455.157 18.6836 454.289 17.816 454.289 16.746C454.289 15.676 455.157 14.8084 456.227 14.8084C457.297 14.8084 458.164 15.676 458.164 16.746Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M458.164 12.0234C458.164 13.0933 457.297 13.9609 456.227 13.9609C455.157 13.9609 454.289 13.0933 454.289 12.0234C454.289 10.9534 455.157 10.0858 456.227 10.0858C457.297 10.0858 458.164 10.9534 458.164 12.0234Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M467.61 12.0234C467.61 13.0933 466.743 13.9609 465.673 13.9609C464.603 13.9609 463.735 13.0933 463.735 12.0234C463.735 10.9534 464.603 10.0858 465.673 10.0858C466.743 10.0858 467.61 10.9534 467.61 12.0234Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M477.056 30.9179C477.056 31.9879 476.189 32.8555 475.119 32.8555C474.049 32.8555 473.181 31.9879 473.181 30.9179C473.181 29.8479 474.049 28.9803 475.119 28.9803C476.189 28.9803 477.056 29.8479 477.056 30.9179Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M477.056 26.1952C477.056 27.2652 476.189 28.1328 475.119 28.1328C474.049 28.1328 473.181 27.2652 473.181 26.1952C473.181 25.1252 474.049 24.2576 475.119 24.2576C476.189 24.2576 477.056 25.1252 477.056 26.1952Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M477.056 35.6405C477.056 36.7105 476.189 37.5781 475.119 37.5781C474.049 37.5781 473.181 36.7105 473.181 35.6405C473.181 34.5706 474.049 33.703 475.119 33.703C476.189 33.703 477.056 34.5706 477.056 35.6405Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M481.779 35.6405C481.779 36.7105 480.912 37.5781 479.842 37.5781C478.772 37.5781 477.904 36.7105 477.904 35.6405C477.904 34.5706 478.772 33.703 479.842 33.703C480.912 33.703 481.779 34.5706 481.779 35.6405Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M481.779 30.9179C481.779 31.9879 480.912 32.8555 479.842 32.8555C478.772 32.8555 477.904 31.9879 477.904 30.9179C477.904 29.8479 478.772 28.9803 479.842 28.9803C480.912 28.9803 481.779 29.8479 481.779 30.9179Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M486.503 35.6405C486.503 36.7105 485.635 37.5781 484.565 37.5781C483.495 37.5781 482.627 36.7105 482.627 35.6405C482.627 34.5706 483.495 33.703 484.565 33.703C485.635 33.703 486.503 34.5706 486.503 35.6405Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M491.226 35.6405C491.226 36.7105 490.359 37.5781 489.289 37.5781C488.219 37.5781 487.351 36.7105 487.351 35.6405C487.351 34.5706 488.219 33.703 489.289 33.703C490.359 33.703 491.226 34.5706 491.226 35.6405Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M491.226 30.9179C491.226 31.9879 490.359 32.8555 489.289 32.8555C488.219 32.8555 487.351 31.9879 487.351 30.9179C487.351 29.8479 488.219 28.9803 489.289 28.9803C490.359 28.9803 491.226 29.8479 491.226 30.9179Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M495.949 30.9179C495.949 31.9879 495.082 32.8555 494.012 32.8555C492.942 32.8555 492.074 31.9879 492.074 30.9179C492.074 29.8479 492.942 28.9803 494.012 28.9803C495.082 28.9803 495.949 29.8479 495.949 30.9179Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M495.949 35.6405C495.949 36.7105 495.082 37.5781 494.012 37.5781C492.942 37.5781 492.074 36.7105 492.074 35.6405C492.074 34.5706 492.942 33.703 494.012 33.703C495.082 33.703 495.949 34.5706 495.949 35.6405Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M500.672 35.6405C500.672 36.7105 499.805 37.5781 498.735 37.5781C497.665 37.5781 496.797 36.7105 496.797 35.6405C496.797 34.5706 497.665 33.703 498.735 33.703C499.805 33.703 500.672 34.5706 500.672 35.6405Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M505.395 35.6405C505.395 36.7105 504.528 37.5781 503.458 37.5781C502.388 37.5781 501.52 36.7105 501.52 35.6405C501.52 34.5706 502.388 33.703 503.458 33.703C504.528 33.703 505.395 34.5706 505.395 35.6405Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M510.118 35.6405C510.118 36.7105 509.251 37.5781 508.181 37.5781C507.111 37.5781 506.243 36.7105 506.243 35.6405C506.243 34.5706 507.111 33.703 508.181 33.703C509.251 33.703 510.118 34.5706 510.118 35.6405Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M510.118 30.9179C510.118 31.9879 509.251 32.8555 508.181 32.8555C507.111 32.8555 506.243 31.9879 506.243 30.9179C506.243 29.8479 507.111 28.9803 508.181 28.9803C509.251 28.9803 510.118 29.8479 510.118 30.9179Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M514.841 30.9179C514.841 31.9879 513.974 32.8555 512.904 32.8555C511.834 32.8555 510.966 31.9879 510.966 30.9179C510.966 29.8479 511.834 28.9803 512.904 28.9803C513.974 28.9803 514.841 29.8479 514.841 30.9179Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M514.841 35.6405C514.841 36.7105 513.974 37.5781 512.904 37.5781C511.834 37.5781 510.966 36.7105 510.966 35.6405C510.966 34.5706 511.834 33.703 512.904 33.703C513.974 33.703 514.841 34.5706 514.841 35.6405Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M519.565 35.6405C519.565 36.7105 518.697 37.5781 517.627 37.5781C516.557 37.5781 515.689 36.7105 515.689 35.6405C515.689 34.5706 516.557 33.703 517.627 33.703C518.697 33.703 519.565 34.5706 519.565 35.6405Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M519.565 30.9179C519.565 31.9879 518.697 32.8555 517.627 32.8555C516.557 32.8555 515.689 31.9879 515.689 30.9179C515.689 29.8479 516.557 28.9803 517.627 28.9803C518.697 28.9803 519.565 29.8479 519.565 30.9179Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M524.288 30.9179C524.288 31.9879 523.421 32.8555 522.351 32.8555C521.281 32.8555 520.413 31.9879 520.413 30.9179C520.413 29.8479 521.281 28.9803 522.351 28.9803C523.421 28.9803 524.288 29.8479 524.288 30.9179Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M529.011 30.9179C529.011 31.9879 528.144 32.8555 527.074 32.8555C526.004 32.8555 525.136 31.9879 525.136 30.9179C525.136 29.8479 526.004 28.9803 527.074 28.9803C528.144 28.9803 529.011 29.8479 529.011 30.9179Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M533.734 30.9179C533.734 31.9879 532.867 32.8555 531.797 32.8555C530.727 32.8555 529.859 31.9879 529.859 30.9179C529.859 29.8479 530.727 28.9803 531.797 28.9803C532.867 28.9803 533.734 29.8479 533.734 30.9179Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M533.734 35.6405C533.734 36.7105 532.867 37.5781 531.797 37.5781C530.727 37.5781 529.859 36.7105 529.859 35.6405C529.859 34.5706 530.727 33.703 531.797 33.703C532.867 33.703 533.734 34.5706 533.734 35.6405Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M538.457 35.6405C538.457 36.7105 537.59 37.5781 536.52 37.5781C535.45 37.5781 534.582 36.7105 534.582 35.6405C534.582 34.5706 535.45 33.703 536.52 33.703C537.59 33.703 538.457 34.5706 538.457 35.6405Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M529.011 35.6405C529.011 36.7105 528.144 37.5781 527.074 37.5781C526.004 37.5781 525.136 36.7105 525.136 35.6405C525.136 34.5706 526.004 33.703 527.074 33.703C528.144 33.703 529.011 34.5706 529.011 35.6405Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M524.288 35.6405C524.288 36.7105 523.421 37.5781 522.351 37.5781C521.281 37.5781 520.413 36.7105 520.413 35.6405C520.413 34.5706 521.281 33.703 522.351 33.703C523.421 33.703 524.288 34.5706 524.288 35.6405Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M524.288 40.3632C524.288 41.4332 523.421 42.3008 522.351 42.3008C521.281 42.3008 520.413 41.4332 520.413 40.3632C520.413 39.2932 521.281 38.4256 522.351 38.4256C523.421 38.4256 524.288 39.2932 524.288 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M519.565 40.3632C519.565 41.4332 518.697 42.3008 517.627 42.3008C516.557 42.3008 515.689 41.4332 515.689 40.3632C515.689 39.2932 516.557 38.4256 517.627 38.4256C518.697 38.4256 519.565 39.2932 519.565 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M514.841 40.3632C514.841 41.4332 513.974 42.3008 512.904 42.3008C511.834 42.3008 510.966 41.4332 510.966 40.3632C510.966 39.2932 511.834 38.4256 512.904 38.4256C513.974 38.4256 514.841 39.2932 514.841 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M510.118 40.3632C510.118 41.4332 509.251 42.3008 508.181 42.3008C507.111 42.3008 506.243 41.4332 506.243 40.3632C506.243 39.2932 507.111 38.4256 508.181 38.4256C509.251 38.4256 510.118 39.2932 510.118 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M505.395 40.3632C505.395 41.4332 504.528 42.3008 503.458 42.3008C502.388 42.3008 501.52 41.4332 501.52 40.3632C501.52 39.2932 502.388 38.4256 503.458 38.4256C504.528 38.4256 505.395 39.2932 505.395 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M500.672 40.3632C500.672 41.4332 499.805 42.3008 498.735 42.3008C497.665 42.3008 496.797 41.4332 496.797 40.3632C496.797 39.2932 497.665 38.4256 498.735 38.4256C499.805 38.4256 500.672 39.2932 500.672 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M495.949 40.3632C495.949 41.4332 495.082 42.3008 494.012 42.3008C492.942 42.3008 492.074 41.4332 492.074 40.3632C492.074 39.2932 492.942 38.4256 494.012 38.4256C495.082 38.4256 495.949 39.2932 495.949 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M491.226 40.3632C491.226 41.4332 490.359 42.3008 489.289 42.3008C488.219 42.3008 487.351 41.4332 487.351 40.3632C487.351 39.2932 488.219 38.4256 489.289 38.4256C490.359 38.4256 491.226 39.2932 491.226 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M491.226 45.0859C491.226 46.1558 490.359 47.0234 489.289 47.0234C488.219 47.0234 487.351 46.1558 487.351 45.0859C487.351 44.0159 488.219 43.1483 489.289 43.1483C490.359 43.1483 491.226 44.0159 491.226 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M491.226 49.8085C491.226 50.8785 490.359 51.7461 489.289 51.7461C488.219 51.7461 487.351 50.8785 487.351 49.8085C487.351 48.7385 488.219 47.8709 489.289 47.8709C490.359 47.8709 491.226 48.7385 491.226 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M491.226 54.5312C491.226 55.6011 490.359 56.4688 489.289 56.4688C488.219 56.4688 487.351 55.6011 487.351 54.5312C487.351 53.4612 488.219 52.5936 489.289 52.5936C490.359 52.5936 491.226 53.4612 491.226 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M491.226 59.2538C491.226 60.3238 490.359 61.1914 489.289 61.1914C488.219 61.1914 487.351 60.3238 487.351 59.2538C487.351 58.1838 488.219 57.3162 489.289 57.3162C490.359 57.3162 491.226 58.1838 491.226 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M491.226 63.9804C491.226 65.0504 490.359 65.918 489.289 65.918C488.219 65.918 487.351 65.0504 487.351 63.9804C487.351 62.9104 488.219 62.0428 489.289 62.0428C490.359 62.0428 491.226 62.9104 491.226 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M486.503 63.9804C486.503 65.0504 485.635 65.918 484.565 65.918C483.495 65.918 482.627 65.0504 482.627 63.9804C482.627 62.9104 483.495 62.0428 484.565 62.0428C485.635 62.0428 486.503 62.9104 486.503 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M486.503 59.2538C486.503 60.3238 485.635 61.1914 484.565 61.1914C483.495 61.1914 482.627 60.3238 482.627 59.2538C482.627 58.1838 483.495 57.3162 484.565 57.3162C485.635 57.3162 486.503 58.1838 486.503 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M486.503 54.5312C486.503 55.6011 485.635 56.4688 484.565 56.4688C483.495 56.4688 482.627 55.6011 482.627 54.5312C482.627 53.4612 483.495 52.5936 484.565 52.5936C485.635 52.5936 486.503 53.4612 486.503 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M486.503 49.8085C486.503 50.8785 485.635 51.7461 484.565 51.7461C483.495 51.7461 482.627 50.8785 482.627 49.8085C482.627 48.7385 483.495 47.8709 484.565 47.8709C485.635 47.8709 486.503 48.7385 486.503 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M486.503 45.0859C486.503 46.1558 485.635 47.0234 484.565 47.0234C483.495 47.0234 482.627 46.1558 482.627 45.0859C482.627 44.0159 483.495 43.1483 484.565 43.1483C485.635 43.1483 486.503 44.0159 486.503 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M486.503 40.3632C486.503 41.4332 485.635 42.3008 484.565 42.3008C483.495 42.3008 482.627 41.4332 482.627 40.3632C482.627 39.2932 483.495 38.4256 484.565 38.4256C485.635 38.4256 486.503 39.2932 486.503 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M481.779 40.3632C481.779 41.4332 480.912 42.3008 479.842 42.3008C478.772 42.3008 477.904 41.4332 477.904 40.3632C477.904 39.2932 478.772 38.4256 479.842 38.4256C480.912 38.4256 481.779 39.2932 481.779 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M477.056 40.3632C477.056 41.4332 476.189 42.3008 475.119 42.3008C474.049 42.3008 473.181 41.4332 473.181 40.3632C473.181 39.2932 474.049 38.4256 475.119 38.4256C476.189 38.4256 477.056 39.2932 477.056 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M477.056 45.0859C477.056 46.1558 476.189 47.0234 475.119 47.0234C474.049 47.0234 473.181 46.1558 473.181 45.0859C473.181 44.0159 474.049 43.1483 475.119 43.1483C476.189 43.1483 477.056 44.0159 477.056 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M481.779 45.0859C481.779 46.1558 480.912 47.0234 479.842 47.0234C478.772 47.0234 477.904 46.1558 477.904 45.0859C477.904 44.0159 478.772 43.1483 479.842 43.1483C480.912 43.1483 481.779 44.0159 481.779 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M481.779 49.8085C481.779 50.8785 480.912 51.7461 479.842 51.7461C478.772 51.7461 477.904 50.8785 477.904 49.8085C477.904 48.7385 478.772 47.8709 479.842 47.8709C480.912 47.8709 481.779 48.7385 481.779 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M481.779 54.5312C481.779 55.6011 480.912 56.4688 479.842 56.4688C478.772 56.4688 477.904 55.6011 477.904 54.5312C477.904 53.4612 478.772 52.5936 479.842 52.5936C480.912 52.5936 481.779 53.4612 481.779 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M481.779 59.2538C481.779 60.3238 480.912 61.1914 479.842 61.1914C478.772 61.1914 477.904 60.3238 477.904 59.2538C477.904 58.1838 478.772 57.3162 479.842 57.3162C480.912 57.3162 481.779 58.1838 481.779 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M481.779 63.9804C481.779 65.0504 480.912 65.918 479.842 65.918C478.772 65.918 477.904 65.0504 477.904 63.9804C477.904 62.9104 478.772 62.0428 479.842 62.0428C480.912 62.0428 481.779 62.9104 481.779 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M477.056 63.9804C477.056 65.0504 476.189 65.918 475.119 65.918C474.049 65.918 473.181 65.0504 473.181 63.9804C473.181 62.9104 474.049 62.0428 475.119 62.0428C476.189 62.0428 477.056 62.9104 477.056 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M477.056 59.2538C477.056 60.3238 476.189 61.1914 475.119 61.1914C474.049 61.1914 473.181 60.3238 473.181 59.2538C473.181 58.1838 474.049 57.3162 475.119 57.3162C476.189 57.3162 477.056 58.1838 477.056 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M477.056 54.5312C477.056 55.6011 476.189 56.4688 475.119 56.4688C474.049 56.4688 473.181 55.6011 473.181 54.5312C473.181 53.4612 474.049 52.5936 475.119 52.5936C476.189 52.5936 477.056 53.4612 477.056 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M477.056 49.8085C477.056 50.8785 476.189 51.7461 475.119 51.7461C474.049 51.7461 473.181 50.8785 473.181 49.8085C473.181 48.7385 474.049 47.8709 475.119 47.8709C476.189 47.8709 477.056 48.7385 477.056 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M472.333 49.8085C472.333 50.8785 471.466 51.7461 470.396 51.7461C469.326 51.7461 468.458 50.8785 468.458 49.8085C468.458 48.7385 469.326 47.8709 470.396 47.8709C471.466 47.8709 472.333 48.7385 472.333 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M472.333 45.0859C472.333 46.1558 471.466 47.0234 470.396 47.0234C469.326 47.0234 468.458 46.1558 468.458 45.0859C468.458 44.0159 469.326 43.1483 470.396 43.1483C471.466 43.1483 472.333 44.0159 472.333 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M472.333 40.3632C472.333 41.4332 471.466 42.3008 470.396 42.3008C469.326 42.3008 468.458 41.4332 468.458 40.3632C468.458 39.2932 469.326 38.4256 470.396 38.4256C471.466 38.4256 472.333 39.2932 472.333 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M467.61 45.0859C467.61 46.1558 466.743 47.0234 465.673 47.0234C464.603 47.0234 463.735 46.1558 463.735 45.0859C463.735 44.0159 464.603 43.1483 465.673 43.1483C466.743 43.1483 467.61 44.0159 467.61 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M467.61 49.8085C467.61 50.8785 466.743 51.7461 465.673 51.7461C464.603 51.7461 463.735 50.8785 463.735 49.8085C463.735 48.7385 464.603 47.8709 465.673 47.8709C466.743 47.8709 467.61 48.7385 467.61 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M467.61 54.5312C467.61 55.6011 466.743 56.4688 465.673 56.4688C464.603 56.4688 463.735 55.6011 463.735 54.5312C463.735 53.4612 464.603 52.5936 465.673 52.5936C466.743 52.5936 467.61 53.4612 467.61 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M472.333 54.5312C472.333 55.6011 471.466 56.4688 470.396 56.4688C469.326 56.4688 468.458 55.6011 468.458 54.5312C468.458 53.4612 469.326 52.5936 470.396 52.5936C471.466 52.5936 472.333 53.4612 472.333 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M472.333 59.2538C472.333 60.3238 471.466 61.1914 470.396 61.1914C469.326 61.1914 468.458 60.3238 468.458 59.2538C468.458 58.1838 469.326 57.3162 470.396 57.3162C471.466 57.3162 472.333 58.1838 472.333 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M472.333 63.9804C472.333 65.0504 471.466 65.918 470.396 65.918C469.326 65.918 468.458 65.0504 468.458 63.9804C468.458 62.9104 469.326 62.0428 470.396 62.0428C471.466 62.0428 472.333 62.9104 472.333 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M467.61 63.9804C467.61 65.0504 466.743 65.918 465.673 65.918C464.603 65.918 463.735 65.0504 463.735 63.9804C463.735 62.9104 464.603 62.0428 465.673 62.0428C466.743 62.0428 467.61 62.9104 467.61 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M467.61 59.2538C467.61 60.3238 466.743 61.1914 465.673 61.1914C464.603 61.1914 463.735 60.3238 463.735 59.2538C463.735 58.1838 464.603 57.3162 465.673 57.3162C466.743 57.3162 467.61 58.1838 467.61 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M462.887 59.2538C462.887 60.3238 462.019 61.1914 460.949 61.1914C459.879 61.1914 459.011 60.3238 459.011 59.2538C459.011 58.1838 459.879 57.3162 460.949 57.3162C462.019 57.3162 462.887 58.1838 462.887 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M462.887 54.5312C462.887 55.6011 462.019 56.4688 460.949 56.4688C459.879 56.4688 459.011 55.6011 459.011 54.5312C459.011 53.4612 459.879 52.5936 460.949 52.5936C462.019 52.5936 462.887 53.4612 462.887 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M462.887 49.8085C462.887 50.8785 462.019 51.7461 460.949 51.7461C459.879 51.7461 459.011 50.8785 459.011 49.8085C459.011 48.7385 459.879 47.8709 460.949 47.8709C462.019 47.8709 462.887 48.7385 462.887 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M458.164 49.8085C458.164 50.8785 457.296 51.7461 456.226 51.7461C455.156 51.7461 454.288 50.8785 454.288 49.8085C454.288 48.7385 455.156 47.8709 456.226 47.8709C457.296 47.8709 458.164 48.7385 458.164 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M453.44 49.8085C453.44 50.8785 452.573 51.7461 451.503 51.7461C450.433 51.7461 449.565 50.8785 449.565 49.8085C449.565 48.7385 450.433 47.8709 451.503 47.8709C452.573 47.8709 453.44 48.7385 453.44 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M448.717 49.8085C448.717 50.8785 447.85 51.7461 446.78 51.7461C445.71 51.7461 444.842 50.8785 444.842 49.8085C444.842 48.7385 445.71 47.8709 446.78 47.8709C447.85 47.8709 448.717 48.7385 448.717 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M448.717 45.0859C448.717 46.1558 447.85 47.0234 446.78 47.0234C445.71 47.0234 444.842 46.1558 444.842 45.0859C444.842 44.0159 445.71 43.1483 446.78 43.1483C447.85 43.1483 448.717 44.0159 448.717 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M443.994 45.0859C443.994 46.1558 443.127 47.0234 442.057 47.0234C440.987 47.0234 440.119 46.1558 440.119 45.0859C440.119 44.0159 440.987 43.1483 442.057 43.1483C443.127 43.1483 443.994 44.0159 443.994 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M439.271 45.0859C439.271 46.1558 438.403 47.0234 437.333 47.0234C436.263 47.0234 435.396 46.1558 435.396 45.0859C435.396 44.0159 436.263 43.1483 437.333 43.1483C438.403 43.1483 439.271 44.0159 439.271 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M434.548 45.0859C434.548 46.1558 433.681 47.0234 432.611 47.0234C431.541 47.0234 430.673 46.1558 430.673 45.0859C430.673 44.0159 431.541 43.1483 432.611 43.1483C433.681 43.1483 434.548 44.0159 434.548 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M429.825 45.0859C429.825 46.1558 428.957 47.0234 427.887 47.0234C426.817 47.0234 425.949 46.1558 425.949 45.0859C425.949 44.0159 426.817 43.1483 427.887 43.1483C428.957 43.1483 429.825 44.0159 429.825 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M429.825 49.8085C429.825 50.8785 428.957 51.7461 427.887 51.7461C426.817 51.7461 425.949 50.8785 425.949 49.8085C425.949 48.7385 426.817 47.8709 427.887 47.8709C428.957 47.8709 429.825 48.7385 429.825 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M425.101 49.8085C425.101 50.8785 424.234 51.7461 423.164 51.7461C422.094 51.7461 421.226 50.8785 421.226 49.8085C421.226 48.7385 422.094 47.8709 423.164 47.8709C424.234 47.8709 425.101 48.7385 425.101 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M420.378 49.8085C420.378 50.8785 419.511 51.7461 418.441 51.7461C417.371 51.7461 416.503 50.8785 416.503 49.8085C416.503 48.7385 417.371 47.8709 418.441 47.8709C419.511 47.8709 420.378 48.7385 420.378 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M415.655 49.8085C415.655 50.8785 414.788 51.7461 413.718 51.7461C412.648 51.7461 411.78 50.8785 411.78 49.8085C411.78 48.7385 412.648 47.8709 413.718 47.8709C414.788 47.8709 415.655 48.7385 415.655 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M410.932 49.8085C410.932 50.8785 410.065 51.7461 408.995 51.7461C407.925 51.7461 407.057 50.8785 407.057 49.8085C407.057 48.7385 407.925 47.8709 408.995 47.8709C410.065 47.8709 410.932 48.7385 410.932 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M410.932 45.0859C410.932 46.1558 410.065 47.0234 408.995 47.0234C407.925 47.0234 407.057 46.1558 407.057 45.0859C407.057 44.0159 407.925 43.1483 408.995 43.1483C410.065 43.1483 410.932 44.0159 410.932 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M410.932 40.3632C410.932 41.4332 410.065 42.3008 408.995 42.3008C407.925 42.3008 407.057 41.4332 407.057 40.3632C407.057 39.2932 407.925 38.4256 408.995 38.4256C410.065 38.4256 410.932 39.2932 410.932 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M406.209 40.3632C406.209 41.4332 405.341 42.3008 404.271 42.3008C403.201 42.3008 402.333 41.4332 402.333 40.3632C402.333 39.2932 403.201 38.4256 404.271 38.4256C405.341 38.4256 406.209 39.2932 406.209 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M401.486 40.3632C401.486 41.4332 400.618 42.3008 399.548 42.3008C398.478 42.3008 397.61 41.4332 397.61 40.3632C397.61 39.2932 398.478 38.4256 399.548 38.4256C400.618 38.4256 401.486 39.2932 401.486 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M401.486 45.0859C401.486 46.1558 400.618 47.0234 399.548 47.0234C398.478 47.0234 397.61 46.1558 397.61 45.0859C397.61 44.0159 398.478 43.1483 399.548 43.1483C400.618 43.1483 401.486 44.0159 401.486 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M406.209 45.0859C406.209 46.1558 405.341 47.0234 404.271 47.0234C403.201 47.0234 402.333 46.1558 402.333 45.0859C402.333 44.0159 403.201 43.1483 404.271 43.1483C405.341 43.1483 406.209 44.0159 406.209 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M406.209 49.8085C406.209 50.8785 405.341 51.7461 404.271 51.7461C403.201 51.7461 402.333 50.8785 402.333 49.8085C402.333 48.7385 403.201 47.8709 404.271 47.8709C405.341 47.8709 406.209 48.7385 406.209 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M401.486 49.8085C401.486 50.8785 400.618 51.7461 399.548 51.7461C398.478 51.7461 397.61 50.8785 397.61 49.8085C397.61 48.7385 398.478 47.8709 399.548 47.8709C400.618 47.8709 401.486 48.7385 401.486 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M406.209 54.5312C406.209 55.6011 405.341 56.4688 404.271 56.4688C403.201 56.4688 402.333 55.6011 402.333 54.5312C402.333 53.4612 403.201 52.5936 404.271 52.5936C405.341 52.5936 406.209 53.4612 406.209 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M406.209 59.2538C406.209 60.3238 405.341 61.1914 404.271 61.1914C403.201 61.1914 402.333 60.3238 402.333 59.2538C402.333 58.1838 403.201 57.3162 404.271 57.3162C405.341 57.3162 406.209 58.1838 406.209 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M406.209 63.9804C406.209 65.0504 405.341 65.918 404.271 65.918C403.201 65.918 402.333 65.0504 402.333 63.9804C402.333 62.9104 403.201 62.0428 404.271 62.0428C405.341 62.0428 406.209 62.9104 406.209 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M406.209 68.703C406.209 69.773 405.341 70.6406 404.271 70.6406C403.201 70.6406 402.333 69.773 402.333 68.703C402.333 67.6331 403.201 66.7655 404.271 66.7655C405.341 66.7655 406.209 67.6331 406.209 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M401.486 68.703C401.486 69.773 400.618 70.6406 399.548 70.6406C398.478 70.6406 397.61 69.773 397.61 68.703C397.61 67.6331 398.478 66.7655 399.548 66.7655C400.618 66.7655 401.486 67.6331 401.486 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M401.486 73.4257C401.486 74.4957 400.618 75.3633 399.548 75.3633C398.478 75.3633 397.61 74.4957 397.61 73.4257C397.61 72.3557 398.478 71.4881 399.548 71.4881C400.618 71.4881 401.486 72.3557 401.486 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M396.762 73.4257C396.762 74.4957 395.895 75.3633 394.825 75.3633C393.755 75.3633 392.887 74.4957 392.887 73.4257C392.887 72.3557 393.755 71.4881 394.825 71.4881C395.895 71.4881 396.762 72.3557 396.762 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M396.762 78.1484C396.762 79.2183 395.895 80.0859 394.825 80.0859C393.755 80.0859 392.887 79.2183 392.887 78.1484C392.887 77.0784 393.755 76.2108 394.825 76.2108C395.895 76.2108 396.762 77.0784 396.762 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M396.762 82.871C396.762 83.941 395.895 84.8086 394.825 84.8086C393.755 84.8086 392.887 83.941 392.887 82.871C392.887 81.801 393.755 80.9334 394.825 80.9334C395.895 80.9334 396.762 81.801 396.762 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M392.039 82.871C392.039 83.941 391.172 84.8086 390.102 84.8086C389.032 84.8086 388.164 83.941 388.164 82.871C388.164 81.801 389.032 80.9334 390.102 80.9334C391.172 80.9334 392.039 81.801 392.039 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M392.039 87.5937C392.039 88.6636 391.172 89.5312 390.102 89.5312C389.032 89.5312 388.164 88.6636 388.164 87.5937C388.164 86.5237 389.032 85.6561 390.102 85.6561C391.172 85.6561 392.039 86.5237 392.039 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M392.039 92.3163C392.039 93.3863 391.172 94.2539 390.102 94.2539C389.032 94.2539 388.164 93.3863 388.164 92.3163C388.164 91.2463 389.032 90.3787 390.102 90.3787C391.172 90.3787 392.039 91.2463 392.039 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M392.039 97.0429C392.039 98.1129 391.172 98.9805 390.102 98.9805C389.032 98.9805 388.164 98.1129 388.164 97.0429C388.164 95.9729 389.032 95.1053 390.102 95.1053C391.172 95.1053 392.039 95.9729 392.039 97.0429Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M392.039 101.766C392.039 102.836 391.172 103.703 390.102 103.703C389.032 103.703 388.164 102.836 388.164 101.766C388.164 100.696 389.032 99.828 390.102 99.828C391.172 99.828 392.039 100.696 392.039 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M392.039 106.488C392.039 107.558 391.172 108.426 390.102 108.426C389.032 108.426 388.164 107.558 388.164 106.488C388.164 105.418 389.032 104.551 390.102 104.551C391.172 104.551 392.039 105.418 392.039 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M396.762 106.488C396.762 107.558 395.895 108.426 394.825 108.426C393.755 108.426 392.887 107.558 392.887 106.488C392.887 105.418 393.755 104.551 394.825 104.551C395.895 104.551 396.762 105.418 396.762 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M401.486 106.488C401.486 107.558 400.618 108.426 399.548 108.426C398.478 108.426 397.61 107.558 397.61 106.488C397.61 105.418 398.478 104.551 399.548 104.551C400.618 104.551 401.486 105.418 401.486 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M406.209 106.488C406.209 107.558 405.341 108.426 404.271 108.426C403.201 108.426 402.333 107.558 402.333 106.488C402.333 105.418 403.201 104.551 404.271 104.551C405.341 104.551 406.209 105.418 406.209 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M410.932 106.488C410.932 107.558 410.065 108.426 408.995 108.426C407.925 108.426 407.057 107.558 407.057 106.488C407.057 105.418 407.925 104.551 408.995 104.551C410.065 104.551 410.932 105.418 410.932 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M410.932 101.766C410.932 102.836 410.065 103.703 408.995 103.703C407.925 103.703 407.057 102.836 407.057 101.766C407.057 100.696 407.925 99.828 408.995 99.828C410.065 99.828 410.932 100.696 410.932 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M410.932 97.0429C410.932 98.1129 410.065 98.9805 408.995 98.9805C407.925 98.9805 407.057 98.1129 407.057 97.0429C407.057 95.9729 407.925 95.1053 408.995 95.1053C410.065 95.1053 410.932 95.9729 410.932 97.0429Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M410.932 92.3163C410.932 93.3863 410.065 94.2539 408.995 94.2539C407.925 94.2539 407.057 93.3863 407.057 92.3163C407.057 91.2463 407.925 90.3787 408.995 90.3787C410.065 90.3787 410.932 91.2463 410.932 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M410.932 87.5937C410.932 88.6636 410.065 89.5312 408.995 89.5312C407.925 89.5312 407.057 88.6636 407.057 87.5937C407.057 86.5237 407.925 85.6561 408.995 85.6561C410.065 85.6561 410.932 86.5237 410.932 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M410.932 82.871C410.932 83.941 410.065 84.8086 408.995 84.8086C407.925 84.8086 407.057 83.941 407.057 82.871C407.057 81.801 407.925 80.9334 408.995 80.9334C410.065 80.9334 410.932 81.801 410.932 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M410.932 78.1484C410.932 79.2183 410.065 80.0859 408.995 80.0859C407.925 80.0859 407.057 79.2183 407.057 78.1484C407.057 77.0784 407.925 76.2108 408.995 76.2108C410.065 76.2108 410.932 77.0784 410.932 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M415.655 78.1484C415.655 79.2183 414.788 80.0859 413.718 80.0859C412.648 80.0859 411.78 79.2183 411.78 78.1484C411.78 77.0784 412.648 76.2108 413.718 76.2108C414.788 76.2108 415.655 77.0784 415.655 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M420.378 78.1484C420.378 79.2183 419.511 80.0859 418.441 80.0859C417.371 80.0859 416.503 79.2183 416.503 78.1484C416.503 77.0784 417.371 76.2108 418.441 76.2108C419.511 76.2108 420.378 77.0784 420.378 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M425.101 78.1484C425.101 79.2183 424.234 80.0859 423.164 80.0859C422.094 80.0859 421.226 79.2183 421.226 78.1484C421.226 77.0784 422.094 76.2108 423.164 76.2108C424.234 76.2108 425.101 77.0784 425.101 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M429.825 78.1484C429.825 79.2183 428.957 80.0859 427.887 80.0859C426.817 80.0859 425.949 79.2183 425.949 78.1484C425.949 77.0784 426.817 76.2108 427.887 76.2108C428.957 76.2108 429.825 77.0784 429.825 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M434.548 78.1484C434.548 79.2183 433.681 80.0859 432.611 80.0859C431.541 80.0859 430.673 79.2183 430.673 78.1484C430.673 77.0784 431.541 76.2108 432.611 76.2108C433.681 76.2108 434.548 77.0784 434.548 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M439.271 78.1484C439.271 79.2183 438.403 80.0859 437.333 80.0859C436.263 80.0859 435.396 79.2183 435.396 78.1484C435.396 77.0784 436.263 76.2108 437.333 76.2108C438.403 76.2108 439.271 77.0784 439.271 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M443.994 78.1484C443.994 79.2183 443.127 80.0859 442.057 80.0859C440.987 80.0859 440.119 79.2183 440.119 78.1484C440.119 77.0784 440.987 76.2108 442.057 76.2108C443.127 76.2108 443.994 77.0784 443.994 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M448.717 78.1484C448.717 79.2183 447.85 80.0859 446.78 80.0859C445.71 80.0859 444.842 79.2183 444.842 78.1484C444.842 77.0784 445.71 76.2108 446.78 76.2108C447.85 76.2108 448.717 77.0784 448.717 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M453.44 78.1484C453.44 79.2183 452.573 80.0859 451.503 80.0859C450.433 80.0859 449.565 79.2183 449.565 78.1484C449.565 77.0784 450.433 76.2108 451.503 76.2108C452.573 76.2108 453.44 77.0784 453.44 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M458.164 78.1484C458.164 79.2183 457.296 80.0859 456.226 80.0859C455.156 80.0859 454.288 79.2183 454.288 78.1484C454.288 77.0784 455.156 76.2108 456.226 76.2108C457.296 76.2108 458.164 77.0784 458.164 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M458.164 82.871C458.164 83.941 457.296 84.8086 456.226 84.8086C455.156 84.8086 454.288 83.941 454.288 82.871C454.288 81.801 455.156 80.9334 456.226 80.9334C457.296 80.9334 458.164 81.801 458.164 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M458.164 87.5937C458.164 88.6636 457.296 89.5312 456.226 89.5312C455.156 89.5312 454.288 88.6636 454.288 87.5937C454.288 86.5237 455.156 85.6561 456.226 85.6561C457.296 85.6561 458.164 86.5237 458.164 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M458.164 92.3163C458.164 93.3863 457.296 94.2539 456.226 94.2539C455.156 94.2539 454.288 93.3863 454.288 92.3163C454.288 91.2463 455.156 90.3787 456.226 90.3787C457.296 90.3787 458.164 91.2463 458.164 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M462.887 92.3163C462.887 93.3863 462.019 94.2539 460.949 94.2539C459.879 94.2539 459.011 93.3863 459.011 92.3163C459.011 91.2463 459.879 90.3787 460.949 90.3787C462.019 90.3787 462.887 91.2463 462.887 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M467.61 92.3163C467.61 93.3863 466.743 94.2539 465.673 94.2539C464.603 94.2539 463.735 93.3863 463.735 92.3163C463.735 91.2463 464.603 90.3787 465.673 90.3787C466.743 90.3787 467.61 91.2463 467.61 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M467.61 87.5937C467.61 88.6636 466.743 89.5312 465.673 89.5312C464.603 89.5312 463.735 88.6636 463.735 87.5937C463.735 86.5237 464.603 85.6561 465.673 85.6561C466.743 85.6561 467.61 86.5237 467.61 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M462.887 87.5937C462.887 88.6636 462.019 89.5312 460.949 89.5312C459.879 89.5312 459.011 88.6636 459.011 87.5937C459.011 86.5237 459.879 85.6561 460.949 85.6561C462.019 85.6561 462.887 86.5237 462.887 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M462.887 82.871C462.887 83.941 462.019 84.8086 460.949 84.8086C459.879 84.8086 459.011 83.941 459.011 82.871C459.011 81.801 459.879 80.9334 460.949 80.9334C462.019 80.9334 462.887 81.801 462.887 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M467.61 82.871C467.61 83.941 466.743 84.8086 465.673 84.8086C464.603 84.8086 463.735 83.941 463.735 82.871C463.735 81.801 464.603 80.9334 465.673 80.9334C466.743 80.9334 467.61 81.801 467.61 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M467.61 78.1484C467.61 79.2183 466.743 80.0859 465.673 80.0859C464.603 80.0859 463.735 79.2183 463.735 78.1484C463.735 77.0784 464.603 76.2108 465.673 76.2108C466.743 76.2108 467.61 77.0784 467.61 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M462.887 78.1484C462.887 79.2183 462.019 80.0859 460.949 80.0859C459.879 80.0859 459.011 79.2183 459.011 78.1484C459.011 77.0784 459.879 76.2108 460.949 76.2108C462.019 76.2108 462.887 77.0784 462.887 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M462.887 73.4257C462.887 74.4957 462.019 75.3633 460.949 75.3633C459.879 75.3633 459.011 74.4957 459.011 73.4257C459.011 72.3557 459.879 71.4881 460.949 71.4881C462.019 71.4881 462.887 72.3557 462.887 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M467.61 73.4257C467.61 74.4957 466.743 75.3633 465.673 75.3633C464.603 75.3633 463.735 74.4957 463.735 73.4257C463.735 72.3557 464.603 71.4881 465.673 71.4881C466.743 71.4881 467.61 72.3557 467.61 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M467.61 68.703C467.61 69.773 466.743 70.6406 465.673 70.6406C464.603 70.6406 463.735 69.773 463.735 68.703C463.735 67.6331 464.603 66.7655 465.673 66.7655C466.743 66.7655 467.61 67.6331 467.61 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M462.887 68.703C462.887 69.773 462.019 70.6406 460.949 70.6406C459.879 70.6406 459.011 69.773 459.011 68.703C459.011 67.6331 459.879 66.7655 460.949 66.7655C462.019 66.7655 462.887 67.6331 462.887 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M462.887 63.9804C462.887 65.0504 462.019 65.918 460.949 65.918C459.879 65.918 459.011 65.0504 459.011 63.9804C459.011 62.9104 459.879 62.0428 460.949 62.0428C462.019 62.0428 462.887 62.9104 462.887 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M458.164 63.9804C458.164 65.0504 457.296 65.918 456.226 65.918C455.156 65.918 454.288 65.0504 454.288 63.9804C454.288 62.9104 455.156 62.0428 456.226 62.0428C457.296 62.0428 458.164 62.9104 458.164 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M458.164 59.2538C458.164 60.3238 457.296 61.1914 456.226 61.1914C455.156 61.1914 454.288 60.3238 454.288 59.2538C454.288 58.1838 455.156 57.3162 456.226 57.3162C457.296 57.3162 458.164 58.1838 458.164 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M458.164 54.5312C458.164 55.6011 457.296 56.4688 456.226 56.4688C455.156 56.4688 454.288 55.6011 454.288 54.5312C454.288 53.4612 455.156 52.5936 456.226 52.5936C457.296 52.5936 458.164 53.4612 458.164 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M453.44 54.5312C453.44 55.6011 452.573 56.4688 451.503 56.4688C450.433 56.4688 449.565 55.6011 449.565 54.5312C449.565 53.4612 450.433 52.5936 451.503 52.5936C452.573 52.5936 453.44 53.4612 453.44 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M448.717 54.5312C448.717 55.6011 447.85 56.4688 446.78 56.4688C445.71 56.4688 444.842 55.6011 444.842 54.5312C444.842 53.4612 445.71 52.5936 446.78 52.5936C447.85 52.5936 448.717 53.4612 448.717 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M443.994 54.5312C443.994 55.6011 443.127 56.4688 442.057 56.4688C440.987 56.4688 440.119 55.6011 440.119 54.5312C440.119 53.4612 440.987 52.5936 442.057 52.5936C443.127 52.5936 443.994 53.4612 443.994 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M443.994 49.8085C443.994 50.8785 443.127 51.7461 442.057 51.7461C440.987 51.7461 440.119 50.8785 440.119 49.8085C440.119 48.7385 440.987 47.8709 442.057 47.8709C443.127 47.8709 443.994 48.7385 443.994 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M439.271 49.8085C439.271 50.8785 438.403 51.7461 437.333 51.7461C436.263 51.7461 435.396 50.8785 435.396 49.8085C435.396 48.7385 436.263 47.8709 437.333 47.8709C438.403 47.8709 439.271 48.7385 439.271 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M434.548 49.8085C434.548 50.8785 433.681 51.7461 432.611 51.7461C431.541 51.7461 430.673 50.8785 430.673 49.8085C430.673 48.7385 431.541 47.8709 432.611 47.8709C433.681 47.8709 434.548 48.7385 434.548 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M434.548 54.5312C434.548 55.6011 433.681 56.4688 432.611 56.4688C431.541 56.4688 430.673 55.6011 430.673 54.5312C430.673 53.4612 431.541 52.5936 432.611 52.5936C433.681 52.5936 434.548 53.4612 434.548 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M439.271 54.5312C439.271 55.6011 438.403 56.4688 437.333 56.4688C436.263 56.4688 435.396 55.6011 435.396 54.5312C435.396 53.4612 436.263 52.5936 437.333 52.5936C438.403 52.5936 439.271 53.4612 439.271 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M439.271 59.2577C439.271 60.3277 438.403 61.1953 437.333 61.1953C436.263 61.1953 435.396 60.3277 435.396 59.2577C435.396 58.1877 436.263 57.3201 437.333 57.3201C438.403 57.3201 439.271 58.1877 439.271 59.2577Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M443.994 59.2577C443.994 60.3277 443.127 61.1953 442.057 61.1953C440.987 61.1953 440.119 60.3277 440.119 59.2577C440.119 58.1877 440.987 57.3201 442.057 57.3201C443.127 57.3201 443.994 58.1877 443.994 59.2577Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M448.717 59.2538C448.717 60.3238 447.85 61.1914 446.78 61.1914C445.71 61.1914 444.842 60.3238 444.842 59.2538C444.842 58.1838 445.71 57.3162 446.78 57.3162C447.85 57.3162 448.717 58.1838 448.717 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M453.44 59.2538C453.44 60.3238 452.573 61.1914 451.503 61.1914C450.433 61.1914 449.565 60.3238 449.565 59.2538C449.565 58.1838 450.433 57.3162 451.503 57.3162C452.573 57.3162 453.44 58.1838 453.44 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M453.44 63.9804C453.44 65.0504 452.573 65.918 451.503 65.918C450.433 65.918 449.565 65.0504 449.565 63.9804C449.565 62.9104 450.433 62.0428 451.503 62.0428C452.573 62.0428 453.44 62.9104 453.44 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M453.44 68.703C453.44 69.773 452.573 70.6406 451.503 70.6406C450.433 70.6406 449.565 69.773 449.565 68.703C449.565 67.6331 450.433 66.7655 451.503 66.7655C452.573 66.7655 453.44 67.6331 453.44 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M458.164 68.703C458.164 69.773 457.296 70.6406 456.226 70.6406C455.156 70.6406 454.288 69.773 454.288 68.703C454.288 67.6331 455.156 66.7655 456.226 66.7655C457.296 66.7655 458.164 67.6331 458.164 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M458.164 73.4257C458.164 74.4957 457.296 75.3633 456.226 75.3633C455.156 75.3633 454.288 74.4957 454.288 73.4257C454.288 72.3557 455.156 71.4881 456.226 71.4881C457.296 71.4881 458.164 72.3557 458.164 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M453.44 73.4257C453.44 74.4957 452.573 75.3633 451.503 75.3633C450.433 75.3633 449.565 74.4957 449.565 73.4257C449.565 72.3557 450.433 71.4881 451.503 71.4881C452.573 71.4881 453.44 72.3557 453.44 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M448.717 73.4257C448.717 74.4957 447.85 75.3633 446.78 75.3633C445.71 75.3633 444.842 74.4957 444.842 73.4257C444.842 72.3557 445.71 71.4881 446.78 71.4881C447.85 71.4881 448.717 72.3557 448.717 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M448.717 68.703C448.717 69.773 447.85 70.6406 446.78 70.6406C445.71 70.6406 444.842 69.773 444.842 68.703C444.842 67.6331 445.71 66.7655 446.78 66.7655C447.85 66.7655 448.717 67.6331 448.717 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M448.717 63.9804C448.717 65.0504 447.85 65.918 446.78 65.918C445.71 65.918 444.842 65.0504 444.842 63.9804C444.842 62.9104 445.71 62.0428 446.78 62.0428C447.85 62.0428 448.717 62.9104 448.717 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M443.994 63.9804C443.994 65.0504 443.127 65.918 442.057 65.918C440.987 65.918 440.119 65.0504 440.119 63.9804C440.119 62.9104 440.987 62.0428 442.057 62.0428C443.127 62.0428 443.994 62.9104 443.994 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M443.994 68.703C443.994 69.773 443.127 70.6406 442.057 70.6406C440.987 70.6406 440.119 69.773 440.119 68.703C440.119 67.6331 440.987 66.7655 442.057 66.7655C443.127 66.7655 443.994 67.6331 443.994 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M443.994 73.4257C443.994 74.4957 443.127 75.3633 442.057 75.3633C440.987 75.3633 440.119 74.4957 440.119 73.4257C440.119 72.3557 440.987 71.4881 442.057 71.4881C443.127 71.4881 443.994 72.3557 443.994 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M439.271 73.4257C439.271 74.4957 438.403 75.3633 437.333 75.3633C436.263 75.3633 435.396 74.4957 435.396 73.4257C435.396 72.3557 436.263 71.4881 437.333 71.4881C438.403 71.4881 439.271 72.3557 439.271 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M439.271 68.703C439.271 69.773 438.403 70.6406 437.333 70.6406C436.263 70.6406 435.396 69.773 435.396 68.703C435.396 67.6331 436.263 66.7655 437.333 66.7655C438.403 66.7655 439.271 67.6331 439.271 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M439.271 63.9804C439.271 65.0504 438.403 65.918 437.333 65.918C436.263 65.918 435.396 65.0504 435.396 63.9804C435.396 62.9104 436.263 62.0428 437.333 62.0428C438.403 62.0428 439.271 62.9104 439.271 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M434.548 63.9804C434.548 65.0504 433.681 65.918 432.611 65.918C431.541 65.918 430.673 65.0504 430.673 63.9804C430.673 62.9104 431.541 62.0428 432.611 62.0428C433.681 62.0428 434.548 62.9104 434.548 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M434.548 59.2538C434.548 60.3238 433.681 61.1914 432.611 61.1914C431.541 61.1914 430.673 60.3238 430.673 59.2538C430.673 58.1838 431.541 57.3162 432.611 57.3162C433.681 57.3162 434.548 58.1838 434.548 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M429.825 59.2538C429.825 60.3238 428.957 61.1914 427.887 61.1914C426.817 61.1914 425.949 60.3238 425.949 59.2538C425.949 58.1838 426.817 57.3162 427.887 57.3162C428.957 57.3162 429.825 58.1838 429.825 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M429.825 54.5312C429.825 55.6011 428.957 56.4688 427.887 56.4688C426.817 56.4688 425.949 55.6011 425.949 54.5312C425.949 53.4612 426.817 52.5936 427.887 52.5936C428.957 52.5936 429.825 53.4612 429.825 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M425.101 54.5312C425.101 55.6011 424.234 56.4688 423.164 56.4688C422.094 56.4688 421.226 55.6011 421.226 54.5312C421.226 53.4612 422.094 52.5936 423.164 52.5936C424.234 52.5936 425.101 53.4612 425.101 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M420.378 54.5312C420.378 55.6011 419.511 56.4688 418.441 56.4688C417.371 56.4688 416.503 55.6011 416.503 54.5312C416.503 53.4612 417.371 52.5936 418.441 52.5936C419.511 52.5936 420.378 53.4612 420.378 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M415.655 54.5312C415.655 55.6011 414.788 56.4688 413.718 56.4688C412.648 56.4688 411.78 55.6011 411.78 54.5312C411.78 53.4612 412.648 52.5936 413.718 52.5936C414.788 52.5936 415.655 53.4612 415.655 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M410.932 54.5312C410.932 55.6011 410.065 56.4688 408.995 56.4688C407.925 56.4688 407.057 55.6011 407.057 54.5312C407.057 53.4612 407.925 52.5936 408.995 52.5936C410.065 52.5936 410.932 53.4612 410.932 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M410.932 59.2538C410.932 60.3238 410.065 61.1914 408.995 61.1914C407.925 61.1914 407.057 60.3238 407.057 59.2538C407.057 58.1838 407.925 57.3162 408.995 57.3162C410.065 57.3162 410.932 58.1838 410.932 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M415.655 59.2538C415.655 60.3238 414.788 61.1914 413.718 61.1914C412.648 61.1914 411.78 60.3238 411.78 59.2538C411.78 58.1838 412.648 57.3162 413.718 57.3162C414.788 57.3162 415.655 58.1838 415.655 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M420.378 59.2538C420.378 60.3238 419.511 61.1914 418.441 61.1914C417.371 61.1914 416.503 60.3238 416.503 59.2538C416.503 58.1838 417.371 57.3162 418.441 57.3162C419.511 57.3162 420.378 58.1838 420.378 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M425.101 59.2538C425.101 60.3238 424.234 61.1914 423.164 61.1914C422.094 61.1914 421.226 60.3238 421.226 59.2538C421.226 58.1838 422.094 57.3162 423.164 57.3162C424.234 57.3162 425.101 58.1838 425.101 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M425.101 63.9804C425.101 65.0504 424.234 65.918 423.164 65.918C422.094 65.918 421.226 65.0504 421.226 63.9804C421.226 62.9104 422.094 62.0428 423.164 62.0428C424.234 62.0428 425.101 62.9104 425.101 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M429.825 63.9804C429.825 65.0504 428.957 65.918 427.887 65.918C426.817 65.918 425.949 65.0504 425.949 63.9804C425.949 62.9104 426.817 62.0428 427.887 62.0428C428.957 62.0428 429.825 62.9104 429.825 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M429.825 68.703C429.825 69.773 428.957 70.6406 427.887 70.6406C426.817 70.6406 425.949 69.773 425.949 68.703C425.949 67.6331 426.817 66.7655 427.887 66.7655C428.957 66.7655 429.825 67.6331 429.825 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M434.548 68.703C434.548 69.773 433.681 70.6406 432.611 70.6406C431.541 70.6406 430.673 69.773 430.673 68.703C430.673 67.6331 431.541 66.7655 432.611 66.7655C433.681 66.7655 434.548 67.6331 434.548 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M434.548 73.4257C434.548 74.4957 433.681 75.3633 432.611 75.3633C431.541 75.3633 430.673 74.4957 430.673 73.4257C430.673 72.3557 431.541 71.4881 432.611 71.4881C433.681 71.4881 434.548 72.3557 434.548 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M429.825 73.4257C429.825 74.4957 428.957 75.3633 427.887 75.3633C426.817 75.3633 425.949 74.4957 425.949 73.4257C425.949 72.3557 426.817 71.4881 427.887 71.4881C428.957 71.4881 429.825 72.3557 429.825 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M425.101 73.4257C425.101 74.4957 424.234 75.3633 423.164 75.3633C422.094 75.3633 421.226 74.4957 421.226 73.4257C421.226 72.3557 422.094 71.4881 423.164 71.4881C424.234 71.4881 425.101 72.3557 425.101 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M420.378 73.4257C420.378 74.4957 419.511 75.3633 418.441 75.3633C417.371 75.3633 416.503 74.4957 416.503 73.4257C416.503 72.3557 417.371 71.4881 418.441 71.4881C419.511 71.4881 420.378 72.3557 420.378 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M415.655 73.4257C415.655 74.4957 414.788 75.3633 413.718 75.3633C412.648 75.3633 411.78 74.4957 411.78 73.4257C411.78 72.3557 412.648 71.4881 413.718 71.4881C414.788 71.4881 415.655 72.3557 415.655 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M415.655 68.703C415.655 69.773 414.788 70.6406 413.718 70.6406C412.648 70.6406 411.78 69.773 411.78 68.703C411.78 67.6331 412.648 66.7655 413.718 66.7655C414.788 66.7655 415.655 67.6331 415.655 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M415.655 63.9804C415.655 65.0504 414.788 65.918 413.718 65.918C412.648 65.918 411.78 65.0504 411.78 63.9804C411.78 62.9104 412.648 62.0428 413.718 62.0428C414.788 62.0428 415.655 62.9104 415.655 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M420.378 63.9804C420.378 65.0504 419.511 65.918 418.441 65.918C417.371 65.918 416.503 65.0504 416.503 63.9804C416.503 62.9104 417.371 62.0428 418.441 62.0428C419.511 62.0428 420.378 62.9104 420.378 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M420.378 68.703C420.378 69.773 419.511 70.6406 418.441 70.6406C417.371 70.6406 416.503 69.773 416.503 68.703C416.503 67.6331 417.371 66.7655 418.441 66.7655C419.511 66.7655 420.378 67.6331 420.378 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M425.101 68.703C425.101 69.773 424.234 70.6406 423.164 70.6406C422.094 70.6406 421.226 69.773 421.226 68.703C421.226 67.6331 422.094 66.7655 423.164 66.7655C424.234 66.7655 425.101 67.6331 425.101 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M410.932 63.9804C410.932 65.0504 410.065 65.918 408.995 65.918C407.925 65.918 407.057 65.0504 407.057 63.9804C407.057 62.9104 407.925 62.0428 408.995 62.0428C410.065 62.0428 410.932 62.9104 410.932 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M410.932 68.703C410.932 69.773 410.065 70.6406 408.995 70.6406C407.925 70.6406 407.057 69.773 407.057 68.703C407.057 67.6331 407.925 66.7655 408.995 66.7655C410.065 66.7655 410.932 67.6331 410.932 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M410.932 73.4257C410.932 74.4957 410.065 75.3633 408.995 75.3633C407.925 75.3633 407.057 74.4957 407.057 73.4257C407.057 72.3557 407.925 71.4881 408.995 71.4881C410.065 71.4881 410.932 72.3557 410.932 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M406.209 73.4257C406.209 74.4957 405.341 75.3633 404.271 75.3633C403.201 75.3633 402.333 74.4957 402.333 73.4257C402.333 72.3557 403.201 71.4881 404.271 71.4881C405.341 71.4881 406.209 72.3557 406.209 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M406.209 78.1484C406.209 79.2183 405.341 80.0859 404.271 80.0859C403.201 80.0859 402.333 79.2183 402.333 78.1484C402.333 77.0784 403.201 76.2108 404.271 76.2108C405.341 76.2108 406.209 77.0784 406.209 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M401.486 78.1484C401.486 79.2183 400.618 80.0859 399.548 80.0859C398.478 80.0859 397.61 79.2183 397.61 78.1484C397.61 77.0784 398.478 76.2108 399.548 76.2108C400.618 76.2108 401.486 77.0784 401.486 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M401.486 82.871C401.486 83.941 400.618 84.8086 399.548 84.8086C398.478 84.8086 397.61 83.941 397.61 82.871C397.61 81.801 398.478 80.9334 399.548 80.9334C400.618 80.9334 401.486 81.801 401.486 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M401.486 87.5937C401.486 88.6636 400.618 89.5312 399.548 89.5312C398.478 89.5312 397.61 88.6636 397.61 87.5937C397.61 86.5237 398.478 85.6561 399.548 85.6561C400.618 85.6561 401.486 86.5237 401.486 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M396.762 87.5937C396.762 88.6636 395.895 89.5312 394.825 89.5312C393.755 89.5312 392.887 88.6636 392.887 87.5937C392.887 86.5237 393.755 85.6561 394.825 85.6561C395.895 85.6561 396.762 86.5237 396.762 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M396.762 92.3163C396.762 93.3863 395.895 94.2539 394.825 94.2539C393.755 94.2539 392.887 93.3863 392.887 92.3163C392.887 91.2463 393.755 90.3787 394.825 90.3787C395.895 90.3787 396.762 91.2463 396.762 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M396.762 97.0429C396.762 98.1129 395.895 98.9805 394.825 98.9805C393.755 98.9805 392.887 98.1129 392.887 97.0429C392.887 95.9729 393.755 95.1053 394.825 95.1053C395.895 95.1053 396.762 95.9729 396.762 97.0429Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M396.762 101.766C396.762 102.836 395.895 103.703 394.825 103.703C393.755 103.703 392.887 102.836 392.887 101.766C392.887 100.696 393.755 99.828 394.825 99.828C395.895 99.828 396.762 100.696 396.762 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M401.486 101.766C401.486 102.836 400.618 103.703 399.548 103.703C398.478 103.703 397.61 102.836 397.61 101.766C397.61 100.696 398.478 99.828 399.548 99.828C400.618 99.828 401.486 100.696 401.486 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M401.486 97.0429C401.486 98.1129 400.618 98.9805 399.548 98.9805C398.478 98.9805 397.61 98.1129 397.61 97.0429C397.61 95.9729 398.478 95.1053 399.548 95.1053C400.618 95.1053 401.486 95.9729 401.486 97.0429Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M401.486 92.3163C401.486 93.3863 400.618 94.2539 399.548 94.2539C398.478 94.2539 397.61 93.3863 397.61 92.3163C397.61 91.2463 398.478 90.3787 399.548 90.3787C400.618 90.3787 401.486 91.2463 401.486 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M406.209 92.3163C406.209 93.3863 405.341 94.2539 404.271 94.2539C403.201 94.2539 402.333 93.3863 402.333 92.3163C402.333 91.2463 403.201 90.3787 404.271 90.3787C405.341 90.3787 406.209 91.2463 406.209 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M406.209 87.5937C406.209 88.6636 405.341 89.5312 404.271 89.5312C403.201 89.5312 402.333 88.6636 402.333 87.5937C402.333 86.5237 403.201 85.6561 404.271 85.6561C405.341 85.6561 406.209 86.5237 406.209 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M406.209 82.871C406.209 83.941 405.341 84.8086 404.271 84.8086C403.201 84.8086 402.333 83.941 402.333 82.871C402.333 81.801 403.201 80.9334 404.271 80.9334C405.341 80.9334 406.209 81.801 406.209 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M406.209 97.0429C406.209 98.1129 405.341 98.9805 404.271 98.9805C403.201 98.9805 402.333 98.1129 402.333 97.0429C402.333 95.9729 403.201 95.1053 404.271 95.1053C405.341 95.1053 406.209 95.9729 406.209 97.0429Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M406.209 101.766C406.209 102.836 405.341 103.703 404.271 103.703C403.201 103.703 402.333 102.836 402.333 101.766C402.333 100.696 403.201 99.828 404.271 99.828C405.341 99.828 406.209 100.696 406.209 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M472.333 92.3163C472.333 93.3863 471.466 94.2539 470.396 94.2539C469.326 94.2539 468.458 93.3863 468.458 92.3163C468.458 91.2463 469.326 90.3787 470.396 90.3787C471.466 90.3787 472.333 91.2463 472.333 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M477.056 92.3163C477.056 93.3863 476.189 94.2539 475.119 94.2539C474.049 94.2539 473.181 93.3863 473.181 92.3163C473.181 91.2463 474.049 90.3787 475.119 90.3787C476.189 90.3787 477.056 91.2463 477.056 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M495.949 45.0859C495.949 46.1558 495.082 47.0234 494.012 47.0234C492.942 47.0234 492.074 46.1558 492.074 45.0859C492.074 44.0159 492.942 43.1483 494.012 43.1483C495.082 43.1483 495.949 44.0159 495.949 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M495.949 49.8085C495.949 50.8785 495.082 51.7461 494.012 51.7461C492.942 51.7461 492.074 50.8785 492.074 49.8085C492.074 48.7385 492.942 47.8709 494.012 47.8709C495.082 47.8709 495.949 48.7385 495.949 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M495.949 54.5312C495.949 55.6011 495.082 56.4688 494.012 56.4688C492.942 56.4688 492.074 55.6011 492.074 54.5312C492.074 53.4612 492.942 52.5936 494.012 52.5936C495.082 52.5936 495.949 53.4612 495.949 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M495.949 59.2538C495.949 60.3238 495.082 61.1914 494.012 61.1914C492.942 61.1914 492.074 60.3238 492.074 59.2538C492.074 58.1838 492.942 57.3162 494.012 57.3162C495.082 57.3162 495.949 58.1838 495.949 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M495.949 63.9804C495.949 65.0504 495.082 65.918 494.012 65.918C492.942 65.918 492.074 65.0504 492.074 63.9804C492.074 62.9104 492.942 62.0428 494.012 62.0428C495.082 62.0428 495.949 62.9104 495.949 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M495.949 68.703C495.949 69.773 495.082 70.6406 494.012 70.6406C492.942 70.6406 492.074 69.773 492.074 68.703C492.074 67.6331 492.942 66.7655 494.012 66.7655C495.082 66.7655 495.949 67.6331 495.949 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M491.226 68.703C491.226 69.773 490.359 70.6406 489.289 70.6406C488.219 70.6406 487.351 69.773 487.351 68.703C487.351 67.6331 488.219 66.7655 489.289 66.7655C490.359 66.7655 491.226 67.6331 491.226 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M486.503 68.703C486.503 69.773 485.635 70.6406 484.565 70.6406C483.495 70.6406 482.627 69.773 482.627 68.703C482.627 67.6331 483.495 66.7655 484.565 66.7655C485.635 66.7655 486.503 67.6331 486.503 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M481.779 68.703C481.779 69.773 480.912 70.6406 479.842 70.6406C478.772 70.6406 477.904 69.773 477.904 68.703C477.904 67.6331 478.772 66.7655 479.842 66.7655C480.912 66.7655 481.779 67.6331 481.779 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M477.056 68.703C477.056 69.773 476.189 70.6406 475.119 70.6406C474.049 70.6406 473.181 69.773 473.181 68.703C473.181 67.6331 474.049 66.7655 475.119 66.7655C476.189 66.7655 477.056 67.6331 477.056 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M472.333 68.703C472.333 69.773 471.466 70.6406 470.396 70.6406C469.326 70.6406 468.458 69.773 468.458 68.703C468.458 67.6331 469.326 66.7655 470.396 66.7655C471.466 66.7655 472.333 67.6331 472.333 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M472.333 73.4257C472.333 74.4957 471.466 75.3633 470.396 75.3633C469.326 75.3633 468.458 74.4957 468.458 73.4257C468.458 72.3557 469.326 71.4881 470.396 71.4881C471.466 71.4881 472.333 72.3557 472.333 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M472.333 78.1484C472.333 79.2183 471.466 80.0859 470.396 80.0859C469.326 80.0859 468.458 79.2183 468.458 78.1484C468.458 77.0784 469.326 76.2108 470.396 76.2108C471.466 76.2108 472.333 77.0784 472.333 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M472.333 82.871C472.333 83.941 471.466 84.8086 470.396 84.8086C469.326 84.8086 468.458 83.941 468.458 82.871C468.458 81.801 469.326 80.9334 470.396 80.9334C471.466 80.9334 472.333 81.801 472.333 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M472.333 87.5937C472.333 88.6636 471.466 89.5312 470.396 89.5312C469.326 89.5312 468.458 88.6636 468.458 87.5937C468.458 86.5237 469.326 85.6561 470.396 85.6561C471.466 85.6561 472.333 86.5237 472.333 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M477.056 87.5937C477.056 88.6636 476.189 89.5312 475.119 89.5312C474.049 89.5312 473.181 88.6636 473.181 87.5937C473.181 86.5237 474.049 85.6561 475.119 85.6561C476.189 85.6561 477.056 86.5237 477.056 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M481.779 87.5937C481.779 88.6636 480.912 89.5312 479.842 89.5312C478.772 89.5312 477.904 88.6636 477.904 87.5937C477.904 86.5237 478.772 85.6561 479.842 85.6561C480.912 85.6561 481.779 86.5237 481.779 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M481.779 92.3163C481.779 93.3863 480.912 94.2539 479.842 94.2539C478.772 94.2539 477.904 93.3863 477.904 92.3163C477.904 91.2463 478.772 90.3787 479.842 90.3787C480.912 90.3787 481.779 91.2463 481.779 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M481.779 97.0429C481.779 98.1129 480.912 98.9805 479.842 98.9805C478.772 98.9805 477.904 98.1129 477.904 97.0429C477.904 95.9729 478.772 95.1053 479.842 95.1053C480.912 95.1053 481.779 95.9729 481.779 97.0429Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M477.056 97.0429C477.056 98.1129 476.189 98.9805 475.119 98.9805C474.049 98.9805 473.181 98.1129 473.181 97.0429C473.181 95.9729 474.049 95.1053 475.119 95.1053C476.189 95.1053 477.056 95.9729 477.056 97.0429Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M472.333 97.0429C472.333 98.1129 471.466 98.9805 470.396 98.9805C469.326 98.9805 468.458 98.1129 468.458 97.0429C468.458 95.9729 469.326 95.1053 470.396 95.1053C471.466 95.1053 472.333 95.9729 472.333 97.0429Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M467.61 97.0429C467.61 98.1129 466.743 98.9805 465.673 98.9805C464.603 98.9805 463.735 98.1129 463.735 97.0429C463.735 95.9729 464.603 95.1053 465.673 95.1053C466.743 95.1053 467.61 95.9729 467.61 97.0429Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M462.887 97.0429C462.887 98.1129 462.019 98.9805 460.949 98.9805C459.879 98.9805 459.011 98.1129 459.011 97.0429C459.011 95.9729 459.879 95.1053 460.949 95.1053C462.019 95.1053 462.887 95.9729 462.887 97.0429Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M458.164 97.0429C458.164 98.1129 457.296 98.9805 456.226 98.9805C455.156 98.9805 454.288 98.1129 454.288 97.0429C454.288 95.9729 455.156 95.1053 456.226 95.1053C457.296 95.1053 458.164 95.9729 458.164 97.0429Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M458.164 101.766C458.164 102.836 457.296 103.703 456.226 103.703C455.156 103.703 454.288 102.836 454.288 101.766C454.288 100.696 455.156 99.828 456.226 99.828C457.296 99.828 458.164 100.696 458.164 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M458.164 106.488C458.164 107.558 457.296 108.426 456.226 108.426C455.156 108.426 454.288 107.558 454.288 106.488C454.288 105.418 455.156 104.551 456.226 104.551C457.296 104.551 458.164 105.418 458.164 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M458.164 111.211C458.164 112.281 457.296 113.148 456.226 113.148C455.156 113.148 454.288 112.281 454.288 111.211C454.288 110.141 455.156 109.273 456.226 109.273C457.296 109.273 458.164 110.141 458.164 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M458.164 115.934C458.164 117.003 457.296 117.871 456.226 117.871C455.156 117.871 454.288 117.003 454.288 115.934C454.288 114.864 455.156 113.996 456.226 113.996C457.296 113.996 458.164 114.864 458.164 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M453.44 115.934C453.44 117.003 452.573 117.871 451.503 117.871C450.433 117.871 449.565 117.003 449.565 115.934C449.565 114.864 450.433 113.996 451.503 113.996C452.573 113.996 453.44 114.864 453.44 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M453.44 120.656C453.44 121.726 452.573 122.594 451.503 122.594C450.433 122.594 449.565 121.726 449.565 120.656C449.565 119.586 450.433 118.719 451.503 118.719C452.573 118.719 453.44 119.586 453.44 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M448.717 115.934C448.717 117.003 447.85 117.871 446.78 117.871C445.71 117.871 444.842 117.003 444.842 115.934C444.842 114.864 445.71 113.996 446.78 113.996C447.85 113.996 448.717 114.864 448.717 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M448.717 120.656C448.717 121.726 447.85 122.594 446.78 122.594C445.71 122.594 444.842 121.726 444.842 120.656C444.842 119.586 445.71 118.719 446.78 118.719C447.85 118.719 448.717 119.586 448.717 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M443.994 120.656C443.994 121.726 443.127 122.594 442.057 122.594C440.987 122.594 440.119 121.726 440.119 120.656C440.119 119.586 440.987 118.719 442.057 118.719C443.127 118.719 443.994 119.586 443.994 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M439.271 120.656C439.271 121.726 438.403 122.594 437.333 122.594C436.263 122.594 435.396 121.726 435.396 120.656C435.396 119.586 436.263 118.719 437.333 118.719C438.403 118.719 439.271 119.586 439.271 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M439.271 115.934C439.271 117.003 438.403 117.871 437.333 117.871C436.263 117.871 435.396 117.003 435.396 115.934C435.396 114.864 436.263 113.996 437.333 113.996C438.403 113.996 439.271 114.864 439.271 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M439.271 111.211C439.271 112.281 438.403 113.148 437.333 113.148C436.263 113.148 435.396 112.281 435.396 111.211C435.396 110.141 436.263 109.273 437.333 109.273C438.403 109.273 439.271 110.141 439.271 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M443.994 111.211C443.994 112.281 443.127 113.148 442.057 113.148C440.987 113.148 440.119 112.281 440.119 111.211C440.119 110.141 440.987 109.273 442.057 109.273C443.127 109.273 443.994 110.141 443.994 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M443.994 106.488C443.994 107.558 443.127 108.426 442.057 108.426C440.987 108.426 440.119 107.558 440.119 106.488C440.119 105.418 440.987 104.551 442.057 104.551C443.127 104.551 443.994 105.418 443.994 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M439.271 106.488C439.271 107.558 438.403 108.426 437.333 108.426C436.263 108.426 435.396 107.558 435.396 106.488C435.396 105.418 436.263 104.551 437.333 104.551C438.403 104.551 439.271 105.418 439.271 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M434.548 106.488C434.548 107.558 433.681 108.426 432.611 108.426C431.541 108.426 430.673 107.558 430.673 106.488C430.673 105.418 431.541 104.551 432.611 104.551C433.681 104.551 434.548 105.418 434.548 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M434.548 101.766C434.548 102.836 433.681 103.703 432.611 103.703C431.541 103.703 430.673 102.836 430.673 101.766C430.673 100.696 431.541 99.828 432.611 99.828C433.681 99.828 434.548 100.696 434.548 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M439.271 101.766C439.271 102.836 438.403 103.703 437.333 103.703C436.263 103.703 435.396 102.836 435.396 101.766C435.396 100.696 436.263 99.828 437.333 99.828C438.403 99.828 439.271 100.696 439.271 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M439.271 97.039C439.271 98.109 438.403 98.9766 437.333 98.9766C436.263 98.9766 435.396 98.109 435.396 97.039C435.396 95.969 436.263 95.1014 437.333 95.1014C438.403 95.1014 439.271 95.969 439.271 97.039Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M439.271 92.3163C439.271 93.3863 438.403 94.2539 437.333 94.2539C436.263 94.2539 435.396 93.3863 435.396 92.3163C435.396 91.2463 436.263 90.3787 437.333 90.3787C438.403 90.3787 439.271 91.2463 439.271 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M443.994 92.3163C443.994 93.3863 443.127 94.2539 442.057 94.2539C440.987 94.2539 440.119 93.3863 440.119 92.3163C440.119 91.2463 440.987 90.3787 442.057 90.3787C443.127 90.3787 443.994 91.2463 443.994 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M443.994 97.039C443.994 98.109 443.127 98.9766 442.057 98.9766C440.987 98.9766 440.119 98.109 440.119 97.039C440.119 95.969 440.987 95.1014 442.057 95.1014C443.127 95.1014 443.994 95.969 443.994 97.039Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M448.717 92.3163C448.717 93.3863 447.85 94.2539 446.78 94.2539C445.71 94.2539 444.842 93.3863 444.842 92.3163C444.842 91.2463 445.71 90.3787 446.78 90.3787C447.85 90.3787 448.717 91.2463 448.717 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M448.717 97.0429C448.717 98.1129 447.85 98.9805 446.78 98.9805C445.71 98.9805 444.842 98.1129 444.842 97.0429C444.842 95.9729 445.71 95.1053 446.78 95.1053C447.85 95.1053 448.717 95.9729 448.717 97.0429Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M448.717 101.766C448.717 102.836 447.85 103.703 446.78 103.703C445.71 103.703 444.842 102.836 444.842 101.766C444.842 100.696 445.71 99.828 446.78 99.828C447.85 99.828 448.717 100.696 448.717 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M448.717 106.488C448.717 107.558 447.85 108.426 446.78 108.426C445.71 108.426 444.842 107.558 444.842 106.488C444.842 105.418 445.71 104.551 446.78 104.551C447.85 104.551 448.717 105.418 448.717 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M453.44 101.766C453.44 102.836 452.573 103.703 451.503 103.703C450.433 103.703 449.565 102.836 449.565 101.766C449.565 100.696 450.433 99.828 451.503 99.828C452.573 99.828 453.44 100.696 453.44 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M453.44 97.0429C453.44 98.1129 452.573 98.9805 451.503 98.9805C450.433 98.9805 449.565 98.1129 449.565 97.0429C449.565 95.9729 450.433 95.1053 451.503 95.1053C452.573 95.1053 453.44 95.9729 453.44 97.0429Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M453.44 92.3163C453.44 93.3863 452.573 94.2539 451.503 94.2539C450.433 94.2539 449.565 93.3863 449.565 92.3163C449.565 91.2463 450.433 90.3787 451.503 90.3787C452.573 90.3787 453.44 91.2463 453.44 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M453.44 87.5937C453.44 88.6636 452.573 89.5312 451.503 89.5312C450.433 89.5312 449.565 88.6636 449.565 87.5937C449.565 86.5237 450.433 85.6561 451.503 85.6561C452.573 85.6561 453.44 86.5237 453.44 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M453.44 82.871C453.44 83.941 452.573 84.8086 451.503 84.8086C450.433 84.8086 449.565 83.941 449.565 82.871C449.565 81.801 450.433 80.9334 451.503 80.9334C452.573 80.9334 453.44 81.801 453.44 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M448.717 82.871C448.717 83.941 447.85 84.8086 446.78 84.8086C445.71 84.8086 444.842 83.941 444.842 82.871C444.842 81.801 445.71 80.9334 446.78 80.9334C447.85 80.9334 448.717 81.801 448.717 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M443.994 82.871C443.994 83.941 443.127 84.8086 442.057 84.8086C440.987 84.8086 440.119 83.941 440.119 82.871C440.119 81.801 440.987 80.9334 442.057 80.9334C443.127 80.9334 443.994 81.801 443.994 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M439.271 82.871C439.271 83.941 438.403 84.8086 437.333 84.8086C436.263 84.8086 435.396 83.941 435.396 82.871C435.396 81.801 436.263 80.9334 437.333 80.9334C438.403 80.9334 439.271 81.801 439.271 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M434.548 82.871C434.548 83.941 433.681 84.8086 432.611 84.8086C431.541 84.8086 430.673 83.941 430.673 82.871C430.673 81.801 431.541 80.9334 432.611 80.9334C433.681 80.9334 434.548 81.801 434.548 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M429.825 82.871C429.825 83.941 428.957 84.8086 427.887 84.8086C426.817 84.8086 425.949 83.941 425.949 82.871C425.949 81.801 426.817 80.9334 427.887 80.9334C428.957 80.9334 429.825 81.801 429.825 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M425.101 82.871C425.101 83.941 424.234 84.8086 423.164 84.8086C422.094 84.8086 421.226 83.941 421.226 82.871C421.226 81.801 422.094 80.9334 423.164 80.9334C424.234 80.9334 425.101 81.801 425.101 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M420.378 82.871C420.378 83.941 419.511 84.8086 418.441 84.8086C417.371 84.8086 416.503 83.941 416.503 82.871C416.503 81.801 417.371 80.9334 418.441 80.9334C419.511 80.9334 420.378 81.801 420.378 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M420.378 87.5937C420.378 88.6636 419.511 89.5312 418.441 89.5312C417.371 89.5312 416.503 88.6636 416.503 87.5937C416.503 86.5237 417.371 85.6561 418.441 85.6561C419.511 85.6561 420.378 86.5237 420.378 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M420.378 92.3163C420.378 93.3863 419.511 94.2539 418.441 94.2539C417.371 94.2539 416.503 93.3863 416.503 92.3163C416.503 91.2463 417.371 90.3787 418.441 90.3787C419.511 90.3787 420.378 91.2463 420.378 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M420.378 97.0429C420.378 98.1129 419.511 98.9805 418.441 98.9805C417.371 98.9805 416.503 98.1129 416.503 97.0429C416.503 95.9729 417.371 95.1053 418.441 95.1053C419.511 95.1053 420.378 95.9729 420.378 97.0429Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M420.378 101.766C420.378 102.836 419.511 103.703 418.441 103.703C417.371 103.703 416.503 102.836 416.503 101.766C416.503 100.696 417.371 99.828 418.441 99.828C419.511 99.828 420.378 100.696 420.378 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M420.378 106.488C420.378 107.558 419.511 108.426 418.441 108.426C417.371 108.426 416.503 107.558 416.503 106.488C416.503 105.418 417.371 104.551 418.441 104.551C419.511 104.551 420.378 105.418 420.378 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M420.378 111.211C420.378 112.281 419.511 113.148 418.441 113.148C417.371 113.148 416.503 112.281 416.503 111.211C416.503 110.141 417.371 109.273 418.441 109.273C419.511 109.273 420.378 110.141 420.378 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M420.378 115.934C420.378 117.003 419.511 117.871 418.441 117.871C417.371 117.871 416.503 117.003 416.503 115.934C416.503 114.864 417.371 113.996 418.441 113.996C419.511 113.996 420.378 114.864 420.378 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M420.378 120.656C420.378 121.726 419.511 122.594 418.441 122.594C417.371 122.594 416.503 121.726 416.503 120.656C416.503 119.586 417.371 118.719 418.441 118.719C419.511 118.719 420.378 119.586 420.378 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M420.378 125.379C420.378 126.449 419.511 127.316 418.441 127.316C417.371 127.316 416.503 126.449 416.503 125.379C416.503 124.309 417.371 123.441 418.441 123.441C419.511 123.441 420.378 124.309 420.378 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M415.655 125.379C415.655 126.449 414.788 127.316 413.718 127.316C412.648 127.316 411.78 126.449 411.78 125.379C411.78 124.309 412.648 123.441 413.718 123.441C414.788 123.441 415.655 124.309 415.655 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M410.932 125.379C410.932 126.449 410.065 127.316 408.995 127.316C407.925 127.316 407.057 126.449 407.057 125.379C407.057 124.309 407.925 123.441 408.995 123.441C410.065 123.441 410.932 124.309 410.932 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M406.209 125.379C406.209 126.449 405.341 127.316 404.271 127.316C403.201 127.316 402.333 126.449 402.333 125.379C402.333 124.309 403.201 123.441 404.271 123.441C405.341 123.441 406.209 124.309 406.209 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M401.486 125.379C401.486 126.449 400.618 127.316 399.548 127.316C398.478 127.316 397.61 126.449 397.61 125.379C397.61 124.309 398.478 123.441 399.548 123.441C400.618 123.441 401.486 124.309 401.486 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M401.486 130.101C401.486 131.171 400.618 132.039 399.548 132.039C398.478 132.039 397.61 131.171 397.61 130.101C397.61 129.031 398.478 128.164 399.548 128.164C400.618 128.164 401.486 129.031 401.486 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M410.932 130.101C410.932 131.171 410.065 132.039 408.995 132.039C407.925 132.039 407.057 131.171 407.057 130.101C407.057 129.031 407.925 128.164 408.995 128.164C410.065 128.164 410.932 129.031 410.932 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M410.932 134.828C410.932 135.898 410.065 136.766 408.995 136.766C407.925 136.766 407.057 135.898 407.057 134.828C407.057 133.758 407.925 132.89 408.995 132.89C410.065 132.89 410.932 133.758 410.932 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M406.209 134.828C406.209 135.898 405.341 136.766 404.271 136.766C403.201 136.766 402.333 135.898 402.333 134.828C402.333 133.758 403.201 132.89 404.271 132.89C405.341 132.89 406.209 133.758 406.209 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M415.655 134.828C415.655 135.898 414.788 136.766 413.718 136.766C412.648 136.766 411.78 135.898 411.78 134.828C411.78 133.758 412.648 132.89 413.718 132.89C414.788 132.89 415.655 133.758 415.655 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M415.655 130.101C415.655 131.171 414.788 132.039 413.718 132.039C412.648 132.039 411.78 131.171 411.78 130.101C411.78 129.031 412.648 128.164 413.718 128.164C414.788 128.164 415.655 129.031 415.655 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M420.378 130.101C420.378 131.171 419.511 132.039 418.441 132.039C417.371 132.039 416.503 131.171 416.503 130.101C416.503 129.031 417.371 128.164 418.441 128.164C419.511 128.164 420.378 129.031 420.378 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M420.378 134.828C420.378 135.898 419.511 136.766 418.441 136.766C417.371 136.766 416.503 135.898 416.503 134.828C416.503 133.758 417.371 132.89 418.441 132.89C419.511 132.89 420.378 133.758 420.378 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M425.101 134.828C425.101 135.898 424.234 136.766 423.164 136.766C422.094 136.766 421.226 135.898 421.226 134.828C421.226 133.758 422.094 132.89 423.164 132.89C424.234 132.89 425.101 133.758 425.101 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M429.825 134.828C429.825 135.898 428.957 136.766 427.887 136.766C426.817 136.766 425.949 135.898 425.949 134.828C425.949 133.758 426.817 132.89 427.887 132.89C428.957 132.89 429.825 133.758 429.825 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M429.825 130.101C429.825 131.171 428.957 132.039 427.887 132.039C426.817 132.039 425.949 131.171 425.949 130.101C425.949 129.031 426.817 128.164 427.887 128.164C428.957 128.164 429.825 129.031 429.825 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M434.548 130.101C434.548 131.171 433.681 132.039 432.611 132.039C431.541 132.039 430.673 131.171 430.673 130.101C430.673 129.031 431.541 128.164 432.611 128.164C433.681 128.164 434.548 129.031 434.548 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M434.548 125.379C434.548 126.449 433.681 127.316 432.611 127.316C431.541 127.316 430.673 126.449 430.673 125.379C430.673 124.309 431.541 123.441 432.611 123.441C433.681 123.441 434.548 124.309 434.548 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M434.548 120.656C434.548 121.726 433.681 122.594 432.611 122.594C431.541 122.594 430.673 121.726 430.673 120.656C430.673 119.586 431.541 118.719 432.611 118.719C433.681 118.719 434.548 119.586 434.548 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M434.548 115.934C434.548 117.003 433.681 117.871 432.611 117.871C431.541 117.871 430.673 117.003 430.673 115.934C430.673 114.864 431.541 113.996 432.611 113.996C433.681 113.996 434.548 114.864 434.548 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M434.548 111.211C434.548 112.281 433.681 113.148 432.611 113.148C431.541 113.148 430.673 112.281 430.673 111.211C430.673 110.141 431.541 109.273 432.611 109.273C433.681 109.273 434.548 110.141 434.548 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M429.825 111.211C429.825 112.281 428.957 113.148 427.887 113.148C426.817 113.148 425.949 112.281 425.949 111.211C425.949 110.141 426.817 109.273 427.887 109.273C428.957 109.273 429.825 110.141 429.825 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M429.825 106.488C429.825 107.558 428.957 108.426 427.887 108.426C426.817 108.426 425.949 107.558 425.949 106.488C425.949 105.418 426.817 104.551 427.887 104.551C428.957 104.551 429.825 105.418 429.825 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M429.825 101.766C429.825 102.836 428.957 103.703 427.887 103.703C426.817 103.703 425.949 102.836 425.949 101.766C425.949 100.696 426.817 99.828 427.887 99.828C428.957 99.828 429.825 100.696 429.825 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M429.825 97.0429C429.825 98.1129 428.957 98.9805 427.887 98.9805C426.817 98.9805 425.949 98.1129 425.949 97.0429C425.949 95.9729 426.817 95.1053 427.887 95.1053C428.957 95.1053 429.825 95.9729 429.825 97.0429Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M434.548 97.0429C434.548 98.1129 433.681 98.9805 432.611 98.9805C431.541 98.9805 430.673 98.1129 430.673 97.0429C430.673 95.9729 431.541 95.1053 432.611 95.1053C433.681 95.1053 434.548 95.9729 434.548 97.0429Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M434.548 92.3163C434.548 93.3863 433.681 94.2539 432.611 94.2539C431.541 94.2539 430.673 93.3863 430.673 92.3163C430.673 91.2463 431.541 90.3787 432.611 90.3787C433.681 90.3787 434.548 91.2463 434.548 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M434.548 87.5937C434.548 88.6636 433.681 89.5312 432.611 89.5312C431.541 89.5312 430.673 88.6636 430.673 87.5937C430.673 86.5237 431.541 85.6561 432.611 85.6561C433.681 85.6561 434.548 86.5237 434.548 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M429.825 87.5937C429.825 88.6636 428.957 89.5312 427.887 89.5312C426.817 89.5312 425.949 88.6636 425.949 87.5937C425.949 86.5237 426.817 85.6561 427.887 85.6561C428.957 85.6561 429.825 86.5237 429.825 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M425.101 87.5937C425.101 88.6636 424.234 89.5312 423.164 89.5312C422.094 89.5312 421.226 88.6636 421.226 87.5937C421.226 86.5237 422.094 85.6561 423.164 85.6561C424.234 85.6561 425.101 86.5237 425.101 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M425.101 92.3163C425.101 93.3863 424.234 94.2539 423.164 94.2539C422.094 94.2539 421.226 93.3863 421.226 92.3163C421.226 91.2463 422.094 90.3787 423.164 90.3787C424.234 90.3787 425.101 91.2463 425.101 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M429.825 92.3163C429.825 93.3863 428.957 94.2539 427.887 94.2539C426.817 94.2539 425.949 93.3863 425.949 92.3163C425.949 91.2463 426.817 90.3787 427.887 90.3787C428.957 90.3787 429.825 91.2463 429.825 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M425.101 97.0429C425.101 98.1129 424.234 98.9805 423.164 98.9805C422.094 98.9805 421.226 98.1129 421.226 97.0429C421.226 95.9729 422.094 95.1053 423.164 95.1053C424.234 95.1053 425.101 95.9729 425.101 97.0429Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M425.101 101.766C425.101 102.836 424.234 103.703 423.164 103.703C422.094 103.703 421.226 102.836 421.226 101.766C421.226 100.696 422.094 99.828 423.164 99.828C424.234 99.828 425.101 100.696 425.101 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M425.101 106.488C425.101 107.558 424.234 108.426 423.164 108.426C422.094 108.426 421.226 107.558 421.226 106.488C421.226 105.418 422.094 104.551 423.164 104.551C424.234 104.551 425.101 105.418 425.101 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M425.101 111.211C425.101 112.281 424.234 113.148 423.164 113.148C422.094 113.148 421.226 112.281 421.226 111.211C421.226 110.141 422.094 109.273 423.164 109.273C424.234 109.273 425.101 110.141 425.101 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M425.101 115.934C425.101 117.003 424.234 117.871 423.164 117.871C422.094 117.871 421.226 117.003 421.226 115.934C421.226 114.864 422.094 113.996 423.164 113.996C424.234 113.996 425.101 114.864 425.101 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M425.101 120.656C425.101 121.726 424.234 122.594 423.164 122.594C422.094 122.594 421.226 121.726 421.226 120.656C421.226 119.586 422.094 118.719 423.164 118.719C424.234 118.719 425.101 119.586 425.101 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M425.101 125.379C425.101 126.449 424.234 127.316 423.164 127.316C422.094 127.316 421.226 126.449 421.226 125.379C421.226 124.309 422.094 123.441 423.164 123.441C424.234 123.441 425.101 124.309 425.101 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M425.101 130.101C425.101 131.171 424.234 132.039 423.164 132.039C422.094 132.039 421.226 131.171 421.226 130.101C421.226 129.031 422.094 128.164 423.164 128.164C424.234 128.164 425.101 129.031 425.101 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M429.825 125.379C429.825 126.449 428.957 127.316 427.887 127.316C426.817 127.316 425.949 126.449 425.949 125.379C425.949 124.309 426.817 123.441 427.887 123.441C428.957 123.441 429.825 124.309 429.825 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M429.825 120.656C429.825 121.726 428.957 122.594 427.887 122.594C426.817 122.594 425.949 121.726 425.949 120.656C425.949 119.586 426.817 118.719 427.887 118.719C428.957 118.719 429.825 119.586 429.825 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M429.825 115.934C429.825 117.003 428.957 117.871 427.887 117.871C426.817 117.871 425.949 117.003 425.949 115.934C425.949 114.864 426.817 113.996 427.887 113.996C428.957 113.996 429.825 114.864 429.825 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M439.271 87.5937C439.271 88.6636 438.403 89.5312 437.333 89.5312C436.263 89.5312 435.396 88.6636 435.396 87.5937C435.396 86.5237 436.263 85.6561 437.333 85.6561C438.403 85.6561 439.271 86.5237 439.271 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M443.994 87.5937C443.994 88.6636 443.127 89.5312 442.057 89.5312C440.987 89.5312 440.119 88.6636 440.119 87.5937C440.119 86.5237 440.987 85.6561 442.057 85.6561C443.127 85.6561 443.994 86.5237 443.994 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M448.717 87.5937C448.717 88.6636 447.85 89.5312 446.78 89.5312C445.71 89.5312 444.842 88.6636 444.842 87.5937C444.842 86.5237 445.71 85.6561 446.78 85.6561C447.85 85.6561 448.717 86.5237 448.717 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M401.486 134.828C401.486 135.898 400.618 136.766 399.548 136.766C398.478 136.766 397.61 135.898 397.61 134.828C397.61 133.758 398.478 132.89 399.548 132.89C400.618 132.89 401.486 133.758 401.486 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M396.762 134.828C396.762 135.898 395.895 136.766 394.825 136.766C393.755 136.766 392.887 135.898 392.887 134.828C392.887 133.758 393.755 132.89 394.825 132.89C395.895 132.89 396.762 133.758 396.762 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M396.762 139.551C396.762 140.621 395.895 141.488 394.825 141.488C393.755 141.488 392.887 140.621 392.887 139.551C392.887 138.481 393.755 137.613 394.825 137.613C395.895 137.613 396.762 138.481 396.762 139.551Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M401.486 139.551C401.486 140.621 400.618 141.488 399.548 141.488C398.478 141.488 397.61 140.621 397.61 139.551C397.61 138.481 398.478 137.613 399.548 137.613C400.618 137.613 401.486 138.481 401.486 139.551Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M406.209 139.551C406.209 140.621 405.341 141.488 404.271 141.488C403.201 141.488 402.333 140.621 402.333 139.551C402.333 138.481 403.201 137.613 404.271 137.613C405.341 137.613 406.209 138.481 406.209 139.551Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M410.932 139.551C410.932 140.621 410.065 141.488 408.995 141.488C407.925 141.488 407.057 140.621 407.057 139.551C407.057 138.481 407.925 137.613 408.995 137.613C410.065 137.613 410.932 138.481 410.932 139.551Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M415.655 139.551C415.655 140.621 414.788 141.488 413.718 141.488C412.648 141.488 411.78 140.621 411.78 139.551C411.78 138.481 412.648 137.613 413.718 137.613C414.788 137.613 415.655 138.481 415.655 139.551Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M420.378 139.551C420.378 140.621 419.511 141.488 418.441 141.488C417.371 141.488 416.503 140.621 416.503 139.551C416.503 138.481 417.371 137.613 418.441 137.613C419.511 137.613 420.378 138.481 420.378 139.551Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M425.101 139.551C425.101 140.621 424.234 141.488 423.164 141.488C422.094 141.488 421.226 140.621 421.226 139.551C421.226 138.481 422.094 137.613 423.164 137.613C424.234 137.613 425.101 138.481 425.101 139.551Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M429.824 139.551C429.824 140.621 428.957 141.488 427.887 141.488C426.817 141.488 425.949 140.621 425.949 139.551C425.949 138.481 426.817 137.613 427.887 137.613C428.957 137.613 429.824 138.481 429.824 139.551Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M434.548 139.551C434.548 140.621 433.68 141.488 432.61 141.488C431.54 141.488 430.672 140.621 430.672 139.551C430.672 138.481 431.54 137.613 432.61 137.613C433.68 137.613 434.548 138.481 434.548 139.551Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M434.548 134.828C434.548 135.898 433.681 136.766 432.611 136.766C431.541 136.766 430.673 135.898 430.673 134.828C430.673 133.758 431.541 132.89 432.611 132.89C433.681 132.89 434.548 133.758 434.548 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M439.271 134.828C439.271 135.898 438.403 136.766 437.333 136.766C436.263 136.766 435.396 135.898 435.396 134.828C435.396 133.758 436.263 132.89 437.333 132.89C438.403 132.89 439.271 133.758 439.271 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M439.271 130.101C439.271 131.171 438.403 132.039 437.333 132.039C436.263 132.039 435.396 131.171 435.396 130.101C435.396 129.031 436.263 128.164 437.333 128.164C438.403 128.164 439.271 129.031 439.271 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M439.271 125.379C439.271 126.449 438.403 127.316 437.333 127.316C436.263 127.316 435.396 126.449 435.396 125.379C435.396 124.309 436.263 123.441 437.333 123.441C438.403 123.441 439.271 124.309 439.271 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M443.994 125.379C443.994 126.449 443.127 127.316 442.057 127.316C440.987 127.316 440.119 126.449 440.119 125.379C440.119 124.309 440.987 123.441 442.057 123.441C443.127 123.441 443.994 124.309 443.994 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M448.717 125.379C448.717 126.449 447.85 127.316 446.78 127.316C445.71 127.316 444.842 126.449 444.842 125.379C444.842 124.309 445.71 123.441 446.78 123.441C447.85 123.441 448.717 124.309 448.717 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M453.44 125.379C453.44 126.449 452.573 127.316 451.503 127.316C450.433 127.316 449.565 126.449 449.565 125.379C449.565 124.309 450.433 123.441 451.503 123.441C452.573 123.441 453.44 124.309 453.44 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M458.164 125.379C458.164 126.449 457.296 127.316 456.226 127.316C455.156 127.316 454.288 126.449 454.288 125.379C454.288 124.309 455.156 123.441 456.226 123.441C457.296 123.441 458.164 124.309 458.164 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M458.164 120.656C458.164 121.726 457.296 122.594 456.226 122.594C455.156 122.594 454.288 121.726 454.288 120.656C454.288 119.586 455.156 118.719 456.226 118.719C457.296 118.719 458.164 119.586 458.164 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M462.887 120.656C462.887 121.726 462.019 122.594 460.949 122.594C459.879 122.594 459.011 121.726 459.011 120.656C459.011 119.586 459.879 118.719 460.949 118.719C462.019 118.719 462.887 119.586 462.887 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M467.61 120.656C467.61 121.726 466.743 122.594 465.673 122.594C464.603 122.594 463.735 121.726 463.735 120.656C463.735 119.586 464.603 118.719 465.673 118.719C466.743 118.719 467.61 119.586 467.61 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M472.333 120.656C472.333 121.726 471.466 122.594 470.396 122.594C469.326 122.594 468.458 121.726 468.458 120.656C468.458 119.586 469.326 118.719 470.396 118.719C471.466 118.719 472.333 119.586 472.333 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M477.056 120.656C477.056 121.726 476.189 122.594 475.119 122.594C474.049 122.594 473.181 121.726 473.181 120.656C473.181 119.586 474.049 118.719 475.119 118.719C476.189 118.719 477.056 119.586 477.056 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M481.779 120.656C481.779 121.726 480.912 122.594 479.842 122.594C478.772 122.594 477.904 121.726 477.904 120.656C477.904 119.586 478.772 118.719 479.842 118.719C480.912 118.719 481.779 119.586 481.779 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M481.779 115.934C481.779 117.003 480.912 117.871 479.842 117.871C478.772 117.871 477.904 117.003 477.904 115.934C477.904 114.864 478.772 113.996 479.842 113.996C480.912 113.996 481.779 114.864 481.779 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M481.779 111.211C481.779 112.281 480.912 113.148 479.842 113.148C478.772 113.148 477.904 112.281 477.904 111.211C477.904 110.141 478.772 109.273 479.842 109.273C480.912 109.273 481.779 110.141 481.779 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M481.779 106.488C481.779 107.558 480.912 108.426 479.842 108.426C478.772 108.426 477.904 107.558 477.904 106.488C477.904 105.418 478.772 104.551 479.842 104.551C480.912 104.551 481.779 105.418 481.779 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M481.779 101.766C481.779 102.836 480.912 103.703 479.842 103.703C478.772 103.703 477.904 102.836 477.904 101.766C477.904 100.696 478.772 99.828 479.842 99.828C480.912 99.828 481.779 100.696 481.779 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M477.056 101.766C477.056 102.836 476.189 103.703 475.119 103.703C474.049 103.703 473.181 102.836 473.181 101.766C473.181 100.696 474.049 99.828 475.119 99.828C476.189 99.828 477.056 100.696 477.056 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M472.333 101.766C472.333 102.836 471.466 103.703 470.396 103.703C469.326 103.703 468.458 102.836 468.458 101.766C468.458 100.696 469.326 99.828 470.396 99.828C471.466 99.828 472.333 100.696 472.333 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M467.61 101.766C467.61 102.836 466.743 103.703 465.673 103.703C464.603 103.703 463.735 102.836 463.735 101.766C463.735 100.696 464.603 99.828 465.673 99.828C466.743 99.828 467.61 100.696 467.61 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M462.887 101.766C462.887 102.836 462.019 103.703 460.949 103.703C459.879 103.703 459.011 102.836 459.011 101.766C459.011 100.696 459.879 99.828 460.949 99.828C462.019 99.828 462.887 100.696 462.887 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M462.887 106.488C462.887 107.558 462.019 108.426 460.949 108.426C459.879 108.426 459.011 107.558 459.011 106.488C459.011 105.418 459.879 104.551 460.949 104.551C462.019 104.551 462.887 105.418 462.887 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M462.887 111.211C462.887 112.281 462.019 113.148 460.949 113.148C459.879 113.148 459.011 112.281 459.011 111.211C459.011 110.141 459.879 109.273 460.949 109.273C462.019 109.273 462.887 110.141 462.887 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M462.887 115.934C462.887 117.003 462.019 117.871 460.949 117.871C459.879 117.871 459.011 117.003 459.011 115.934C459.011 114.864 459.879 113.996 460.949 113.996C462.019 113.996 462.887 114.864 462.887 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M467.61 115.934C467.61 117.003 466.743 117.871 465.673 117.871C464.603 117.871 463.735 117.003 463.735 115.934C463.735 114.864 464.603 113.996 465.673 113.996C466.743 113.996 467.61 114.864 467.61 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M472.333 115.934C472.333 117.003 471.466 117.871 470.396 117.871C469.326 117.871 468.458 117.003 468.458 115.934C468.458 114.864 469.326 113.996 470.396 113.996C471.466 113.996 472.333 114.864 472.333 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M477.056 115.934C477.056 117.003 476.189 117.871 475.119 117.871C474.049 117.871 473.181 117.003 473.181 115.934C473.181 114.864 474.049 113.996 475.119 113.996C476.189 113.996 477.056 114.864 477.056 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M477.056 111.211C477.056 112.281 476.189 113.148 475.119 113.148C474.049 113.148 473.181 112.281 473.181 111.211C473.181 110.141 474.049 109.273 475.119 109.273C476.189 109.273 477.056 110.141 477.056 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M477.056 106.488C477.056 107.558 476.189 108.426 475.119 108.426C474.049 108.426 473.181 107.558 473.181 106.488C473.181 105.418 474.049 104.551 475.119 104.551C476.189 104.551 477.056 105.418 477.056 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M472.333 106.488C472.333 107.558 471.466 108.426 470.396 108.426C469.326 108.426 468.458 107.558 468.458 106.488C468.458 105.418 469.326 104.551 470.396 104.551C471.466 104.551 472.333 105.418 472.333 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M467.61 106.488C467.61 107.558 466.743 108.426 465.673 108.426C464.603 108.426 463.735 107.558 463.735 106.488C463.735 105.418 464.603 104.551 465.673 104.551C466.743 104.551 467.61 105.418 467.61 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M467.61 111.211C467.61 112.281 466.743 113.148 465.673 113.148C464.603 113.148 463.735 112.281 463.735 111.211C463.735 110.141 464.603 109.273 465.673 109.273C466.743 109.273 467.61 110.141 467.61 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M472.333 111.211C472.333 112.281 471.466 113.148 470.396 113.148C469.326 113.148 468.458 112.281 468.458 111.211C468.458 110.141 469.326 109.273 470.396 109.273C471.466 109.273 472.333 110.141 472.333 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M415.655 82.871C415.655 83.941 414.788 84.8086 413.718 84.8086C412.648 84.8086 411.78 83.941 411.78 82.871C411.78 81.801 412.648 80.9334 413.718 80.9334C414.788 80.9334 415.655 81.801 415.655 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M415.655 87.5937C415.655 88.6636 414.788 89.5312 413.718 89.5312C412.648 89.5312 411.78 88.6636 411.78 87.5937C411.78 86.5237 412.648 85.6561 413.718 85.6561C414.788 85.6561 415.655 86.5237 415.655 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M415.655 92.3163C415.655 93.3863 414.788 94.2539 413.718 94.2539C412.648 94.2539 411.78 93.3863 411.78 92.3163C411.78 91.2463 412.648 90.3787 413.718 90.3787C414.788 90.3787 415.655 91.2463 415.655 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M415.655 97.0429C415.655 98.1129 414.788 98.9805 413.718 98.9805C412.648 98.9805 411.78 98.1129 411.78 97.0429C411.78 95.9729 412.648 95.1053 413.718 95.1053C414.788 95.1053 415.655 95.9729 415.655 97.0429Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M415.655 101.766C415.655 102.836 414.788 103.703 413.718 103.703C412.648 103.703 411.78 102.836 411.78 101.766C411.78 100.696 412.648 99.828 413.718 99.828C414.788 99.828 415.655 100.696 415.655 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M415.655 106.488C415.655 107.558 414.788 108.426 413.718 108.426C412.648 108.426 411.78 107.558 411.78 106.488C411.78 105.418 412.648 104.551 413.718 104.551C414.788 104.551 415.655 105.418 415.655 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M415.655 111.211C415.655 112.281 414.788 113.148 413.718 113.148C412.648 113.148 411.78 112.281 411.78 111.211C411.78 110.141 412.648 109.273 413.718 109.273C414.788 109.273 415.655 110.141 415.655 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M410.932 111.211C410.932 112.281 410.065 113.148 408.995 113.148C407.925 113.148 407.057 112.281 407.057 111.211C407.057 110.141 407.925 109.273 408.995 109.273C410.065 109.273 410.932 110.141 410.932 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M406.209 111.211C406.209 112.281 405.341 113.148 404.271 113.148C403.201 113.148 402.333 112.281 402.333 111.211C402.333 110.141 403.201 109.273 404.271 109.273C405.341 109.273 406.209 110.141 406.209 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M401.486 111.211C401.486 112.281 400.618 113.148 399.548 113.148C398.478 113.148 397.61 112.281 397.61 111.211C397.61 110.141 398.478 109.273 399.548 109.273C400.618 109.273 401.486 110.141 401.486 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M396.762 111.211C396.762 112.281 395.895 113.148 394.825 113.148C393.755 113.148 392.887 112.281 392.887 111.211C392.887 110.141 393.755 109.273 394.825 109.273C395.895 109.273 396.762 110.141 396.762 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M392.039 111.211C392.039 112.281 391.172 113.148 390.102 113.148C389.032 113.148 388.164 112.281 388.164 111.211C388.164 110.141 389.032 109.273 390.102 109.273C391.172 109.273 392.039 110.141 392.039 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M387.316 111.211C387.316 112.281 386.449 113.148 385.379 113.148C384.309 113.148 383.441 112.281 383.441 111.211C383.441 110.141 384.309 109.273 385.379 109.273C386.449 109.273 387.316 110.141 387.316 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M387.316 106.488C387.316 107.558 386.449 108.426 385.379 108.426C384.309 108.426 383.441 107.558 383.441 106.488C383.441 105.418 384.309 104.551 385.379 104.551C386.449 104.551 387.316 105.418 387.316 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M387.316 101.766C387.316 102.836 386.449 103.703 385.379 103.703C384.309 103.703 383.441 102.836 383.441 101.766C383.441 100.696 384.309 99.828 385.379 99.828C386.449 99.828 387.316 100.696 387.316 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M387.316 97.0429C387.316 98.1129 386.449 98.9805 385.379 98.9805C384.309 98.9805 383.441 98.1129 383.441 97.0429C383.441 95.9729 384.309 95.1053 385.379 95.1053C386.449 95.1053 387.316 95.9729 387.316 97.0429Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M387.316 92.3163C387.316 93.3863 386.449 94.2539 385.379 94.2539C384.309 94.2539 383.441 93.3863 383.441 92.3163C383.441 91.2463 384.309 90.3787 385.379 90.3787C386.449 90.3787 387.316 91.2463 387.316 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M387.316 87.5937C387.316 88.6636 386.449 89.5312 385.379 89.5312C384.309 89.5312 383.441 88.6636 383.441 87.5937C383.441 86.5237 384.309 85.6561 385.379 85.6561C386.449 85.6561 387.316 86.5237 387.316 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M387.316 82.871C387.316 83.941 386.449 84.8086 385.379 84.8086C384.309 84.8086 383.441 83.941 383.441 82.871C383.441 81.801 384.309 80.9334 385.379 80.9334C386.449 80.9334 387.316 81.801 387.316 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M382.593 82.871C382.593 83.941 381.726 84.8086 380.656 84.8086C379.586 84.8086 378.718 83.941 378.718 82.871C378.718 81.801 379.586 80.9334 380.656 80.9334C381.726 80.9334 382.593 81.801 382.593 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M377.87 82.871C377.87 83.941 377.003 84.8086 375.933 84.8086C374.863 84.8086 373.995 83.941 373.995 82.871C373.995 81.801 374.863 80.9334 375.933 80.9334C377.003 80.9334 377.87 81.801 377.87 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M377.87 87.5937C377.87 88.6636 377.003 89.5312 375.933 89.5312C374.863 89.5312 373.995 88.6636 373.995 87.5937C373.995 86.5237 374.863 85.6561 375.933 85.6561C377.003 85.6561 377.87 86.5237 377.87 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M373.147 87.5937C373.147 88.6636 372.279 89.5312 371.209 89.5312C370.139 89.5312 369.271 88.6636 369.271 87.5937C369.271 86.5237 370.139 85.6561 371.209 85.6561C372.279 85.6561 373.147 86.5237 373.147 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M368.424 87.5937C368.424 88.6636 367.556 89.5312 366.486 89.5312C365.416 89.5312 364.548 88.6636 364.548 87.5937C364.548 86.5237 365.416 85.6561 366.486 85.6561C367.556 85.6561 368.424 86.5237 368.424 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M363.7 87.5937C363.7 88.6636 362.833 89.5312 361.763 89.5312C360.693 89.5312 359.825 88.6636 359.825 87.5937C359.825 86.5237 360.693 85.6561 361.763 85.6561C362.833 85.6561 363.7 86.5237 363.7 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M358.977 87.5937C358.977 88.6636 358.11 89.5312 357.04 89.5312C355.97 89.5312 355.102 88.6636 355.102 87.5937C355.102 86.5237 355.97 85.6561 357.04 85.6561C358.11 85.6561 358.977 86.5237 358.977 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M354.254 87.5937C354.254 88.6636 353.387 89.5312 352.317 89.5312C351.247 89.5312 350.379 88.6636 350.379 87.5937C350.379 86.5237 351.247 85.6561 352.317 85.6561C353.387 85.6561 354.254 86.5237 354.254 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M349.531 87.5937C349.531 88.6636 348.664 89.5312 347.594 89.5312C346.524 89.5312 345.656 88.6636 345.656 87.5937C345.656 86.5237 346.524 85.6561 347.594 85.6561C348.664 85.6561 349.531 86.5237 349.531 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M354.254 92.3163C354.254 93.3863 353.387 94.2539 352.317 94.2539C351.247 94.2539 350.379 93.3863 350.379 92.3163C350.379 91.2463 351.247 90.3787 352.317 90.3787C353.387 90.3787 354.254 91.2463 354.254 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M354.254 97.0429C354.254 98.1129 353.387 98.9805 352.317 98.9805C351.247 98.9805 350.379 98.1129 350.379 97.0429C350.379 95.9729 351.247 95.1053 352.317 95.1053C353.387 95.1053 354.254 95.9729 354.254 97.0429Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M354.254 101.766C354.254 102.836 353.387 103.703 352.317 103.703C351.247 103.703 350.379 102.836 350.379 101.766C350.379 100.696 351.247 99.828 352.317 99.828C353.387 99.828 354.254 100.696 354.254 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M354.254 106.488C354.254 107.558 353.387 108.426 352.317 108.426C351.247 108.426 350.379 107.558 350.379 106.488C350.379 105.418 351.247 104.551 352.317 104.551C353.387 104.551 354.254 105.418 354.254 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M354.254 111.211C354.254 112.281 353.387 113.148 352.317 113.148C351.247 113.148 350.379 112.281 350.379 111.211C350.379 110.141 351.247 109.273 352.317 109.273C353.387 109.273 354.254 110.141 354.254 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M354.254 115.934C354.254 117.003 353.387 117.871 352.317 117.871C351.247 117.871 350.379 117.003 350.379 115.934C350.379 114.864 351.247 113.996 352.317 113.996C353.387 113.996 354.254 114.864 354.254 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M354.254 120.656C354.254 121.726 353.387 122.594 352.317 122.594C351.247 122.594 350.379 121.726 350.379 120.656C350.379 119.586 351.247 118.719 352.317 118.719C353.387 118.719 354.254 119.586 354.254 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M354.254 125.379C354.254 126.449 353.387 127.316 352.317 127.316C351.247 127.316 350.379 126.449 350.379 125.379C350.379 124.309 351.247 123.441 352.317 123.441C353.387 123.441 354.254 124.309 354.254 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M358.977 120.656C358.977 121.726 358.11 122.594 357.04 122.594C355.97 122.594 355.102 121.726 355.102 120.656C355.102 119.586 355.97 118.719 357.04 118.719C358.11 118.719 358.977 119.586 358.977 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M363.7 120.656C363.7 121.726 362.833 122.594 361.763 122.594C360.693 122.594 359.825 121.726 359.825 120.656C359.825 119.586 360.693 118.719 361.763 118.719C362.833 118.719 363.7 119.586 363.7 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M368.424 120.656C368.424 121.726 367.556 122.594 366.486 122.594C365.416 122.594 364.548 121.726 364.548 120.656C364.548 119.586 365.416 118.719 366.486 118.719C367.556 118.719 368.424 119.586 368.424 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M373.147 120.656C373.147 121.726 372.279 122.594 371.209 122.594C370.139 122.594 369.271 121.726 369.271 120.656C369.271 119.586 370.139 118.719 371.209 118.719C372.279 118.719 373.147 119.586 373.147 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M377.87 120.656C377.87 121.726 377.003 122.594 375.933 122.594C374.863 122.594 373.995 121.726 373.995 120.656C373.995 119.586 374.863 118.719 375.933 118.719C377.003 118.719 377.87 119.586 377.87 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M382.593 120.656C382.593 121.726 381.726 122.594 380.656 122.594C379.586 122.594 378.718 121.726 378.718 120.656C378.718 119.586 379.586 118.719 380.656 118.719C381.726 118.719 382.593 119.586 382.593 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M387.316 120.656C387.316 121.726 386.449 122.594 385.379 122.594C384.309 122.594 383.441 121.726 383.441 120.656C383.441 119.586 384.309 118.719 385.379 118.719C386.449 118.719 387.316 119.586 387.316 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M392.039 120.656C392.039 121.726 391.172 122.594 390.102 122.594C389.032 122.594 388.164 121.726 388.164 120.656C388.164 119.586 389.032 118.719 390.102 118.719C391.172 118.719 392.039 119.586 392.039 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M396.762 120.656C396.762 121.726 395.895 122.594 394.825 122.594C393.755 122.594 392.887 121.726 392.887 120.656C392.887 119.586 393.755 118.719 394.825 118.719C395.895 118.719 396.762 119.586 396.762 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M401.486 120.656C401.486 121.726 400.618 122.594 399.548 122.594C398.478 122.594 397.61 121.726 397.61 120.656C397.61 119.586 398.478 118.719 399.548 118.719C400.618 118.719 401.486 119.586 401.486 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M406.209 120.656C406.209 121.726 405.341 122.594 404.271 122.594C403.201 122.594 402.333 121.726 402.333 120.656C402.333 119.586 403.201 118.719 404.271 118.719C405.341 118.719 406.209 119.586 406.209 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M410.932 120.656C410.932 121.726 410.065 122.594 408.995 122.594C407.925 122.594 407.057 121.726 407.057 120.656C407.057 119.586 407.925 118.719 408.995 118.719C410.065 118.719 410.932 119.586 410.932 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M415.655 120.656C415.655 121.726 414.788 122.594 413.718 122.594C412.648 122.594 411.78 121.726 411.78 120.656C411.78 119.586 412.648 118.719 413.718 118.719C414.788 118.719 415.655 119.586 415.655 120.656Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M415.655 115.934C415.655 117.003 414.788 117.871 413.718 117.871C412.648 117.871 411.78 117.003 411.78 115.934C411.78 114.864 412.648 113.996 413.718 113.996C414.788 113.996 415.655 114.864 415.655 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M410.932 115.934C410.932 117.003 410.065 117.871 408.995 117.871C407.925 117.871 407.057 117.003 407.057 115.934C407.057 114.864 407.925 113.996 408.995 113.996C410.065 113.996 410.932 114.864 410.932 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M406.209 115.934C406.209 117.003 405.341 117.871 404.271 117.871C403.201 117.871 402.333 117.003 402.333 115.934C402.333 114.864 403.201 113.996 404.271 113.996C405.341 113.996 406.209 114.864 406.209 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M401.486 115.934C401.486 117.003 400.618 117.871 399.548 117.871C398.478 117.871 397.61 117.003 397.61 115.934C397.61 114.864 398.478 113.996 399.548 113.996C400.618 113.996 401.486 114.864 401.486 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M396.762 115.934C396.762 117.003 395.895 117.871 394.825 117.871C393.755 117.871 392.887 117.003 392.887 115.934C392.887 114.864 393.755 113.996 394.825 113.996C395.895 113.996 396.762 114.864 396.762 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M392.039 115.934C392.039 117.003 391.172 117.871 390.102 117.871C389.032 117.871 388.164 117.003 388.164 115.934C388.164 114.864 389.032 113.996 390.102 113.996C391.172 113.996 392.039 114.864 392.039 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M387.316 115.934C387.316 117.003 386.449 117.871 385.379 117.871C384.309 117.871 383.441 117.003 383.441 115.934C383.441 114.864 384.309 113.996 385.379 113.996C386.449 113.996 387.316 114.864 387.316 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M382.593 115.934C382.593 117.003 381.726 117.871 380.656 117.871C379.586 117.871 378.718 117.003 378.718 115.934C378.718 114.864 379.586 113.996 380.656 113.996C381.726 113.996 382.593 114.864 382.593 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M382.593 111.211C382.593 112.281 381.726 113.148 380.656 113.148C379.586 113.148 378.718 112.281 378.718 111.211C378.718 110.141 379.586 109.273 380.656 109.273C381.726 109.273 382.593 110.141 382.593 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M382.593 106.488C382.593 107.558 381.726 108.426 380.656 108.426C379.586 108.426 378.718 107.558 378.718 106.488C378.718 105.418 379.586 104.551 380.656 104.551C381.726 104.551 382.593 105.418 382.593 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M382.593 101.766C382.593 102.836 381.726 103.703 380.656 103.703C379.586 103.703 378.718 102.836 378.718 101.766C378.718 100.696 379.586 99.828 380.656 99.828C381.726 99.828 382.593 100.696 382.593 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M382.593 97.0429C382.593 98.1129 381.726 98.9805 380.656 98.9805C379.586 98.9805 378.718 98.1129 378.718 97.0429C378.718 95.9729 379.586 95.1053 380.656 95.1053C381.726 95.1053 382.593 95.9729 382.593 97.0429Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M382.593 92.3163C382.593 93.3863 381.726 94.2539 380.656 94.2539C379.586 94.2539 378.718 93.3863 378.718 92.3163C378.718 91.2463 379.586 90.3787 380.656 90.3787C381.726 90.3787 382.593 91.2463 382.593 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M382.593 87.5937C382.593 88.6636 381.726 89.5312 380.656 89.5312C379.586 89.5312 378.718 88.6636 378.718 87.5937C378.718 86.5237 379.586 85.6561 380.656 85.6561C381.726 85.6561 382.593 86.5237 382.593 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M377.87 92.3163C377.87 93.3863 377.003 94.2539 375.933 94.2539C374.863 94.2539 373.995 93.3863 373.995 92.3163C373.995 91.2463 374.863 90.3787 375.933 90.3787C377.003 90.3787 377.87 91.2463 377.87 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M377.87 97.0429C377.87 98.1129 377.003 98.9805 375.933 98.9805C374.863 98.9805 373.995 98.1129 373.995 97.0429C373.995 95.9729 374.863 95.1053 375.933 95.1053C377.003 95.1053 377.87 95.9729 377.87 97.0429Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M377.87 101.766C377.87 102.836 377.003 103.703 375.933 103.703C374.863 103.703 373.995 102.836 373.995 101.766C373.995 100.696 374.863 99.828 375.933 99.828C377.003 99.828 377.87 100.696 377.87 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M377.87 106.488C377.87 107.558 377.003 108.426 375.933 108.426C374.863 108.426 373.995 107.558 373.995 106.488C373.995 105.418 374.863 104.551 375.933 104.551C377.003 104.551 377.87 105.418 377.87 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M377.87 111.211C377.87 112.281 377.003 113.148 375.933 113.148C374.863 113.148 373.995 112.281 373.995 111.211C373.995 110.141 374.863 109.273 375.933 109.273C377.003 109.273 377.87 110.141 377.87 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M377.87 115.934C377.87 117.003 377.003 117.871 375.933 117.871C374.863 117.871 373.995 117.003 373.995 115.934C373.995 114.864 374.863 113.996 375.933 113.996C377.003 113.996 377.87 114.864 377.87 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M373.147 115.934C373.147 117.003 372.279 117.871 371.209 117.871C370.139 117.871 369.271 117.003 369.271 115.934C369.271 114.864 370.139 113.996 371.209 113.996C372.279 113.996 373.147 114.864 373.147 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M373.147 111.211C373.147 112.281 372.279 113.148 371.209 113.148C370.139 113.148 369.271 112.281 369.271 111.211C369.271 110.141 370.139 109.273 371.209 109.273C372.279 109.273 373.147 110.141 373.147 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M373.147 106.488C373.147 107.558 372.279 108.426 371.209 108.426C370.139 108.426 369.271 107.558 369.271 106.488C369.271 105.418 370.139 104.551 371.209 104.551C372.279 104.551 373.147 105.418 373.147 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M373.147 101.766C373.147 102.836 372.279 103.703 371.209 103.703C370.139 103.703 369.271 102.836 369.271 101.766C369.271 100.696 370.139 99.828 371.209 99.828C372.279 99.828 373.147 100.696 373.147 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M373.147 97.0429C373.147 98.1129 372.279 98.9805 371.209 98.9805C370.139 98.9805 369.271 98.1129 369.271 97.0429C369.271 95.9729 370.139 95.1053 371.209 95.1053C372.279 95.1053 373.147 95.9729 373.147 97.0429Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M373.147 92.3163C373.147 93.3863 372.279 94.2539 371.209 94.2539C370.139 94.2539 369.271 93.3863 369.271 92.3163C369.271 91.2463 370.139 90.3787 371.209 90.3787C372.279 90.3787 373.147 91.2463 373.147 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M368.424 92.3163C368.424 93.3863 367.556 94.2539 366.486 94.2539C365.416 94.2539 364.548 93.3863 364.548 92.3163C364.548 91.2463 365.416 90.3787 366.486 90.3787C367.556 90.3787 368.424 91.2463 368.424 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M363.7 92.3163C363.7 93.3863 362.833 94.2539 361.763 94.2539C360.693 94.2539 359.825 93.3863 359.825 92.3163C359.825 91.2463 360.693 90.3787 361.763 90.3787C362.833 90.3787 363.7 91.2463 363.7 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M358.977 92.3163C358.977 93.3863 358.11 94.2539 357.04 94.2539C355.97 94.2539 355.102 93.3863 355.102 92.3163C355.102 91.2463 355.97 90.3787 357.04 90.3787C358.11 90.3787 358.977 91.2463 358.977 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M358.977 97.0429C358.977 98.1129 358.11 98.9805 357.04 98.9805C355.97 98.9805 355.102 98.1129 355.102 97.0429C355.102 95.9729 355.97 95.1053 357.04 95.1053C358.11 95.1053 358.977 95.9729 358.977 97.0429Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M358.977 101.766C358.977 102.836 358.11 103.703 357.04 103.703C355.97 103.703 355.102 102.836 355.102 101.766C355.102 100.696 355.97 99.828 357.04 99.828C358.11 99.828 358.977 100.696 358.977 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M363.7 101.766C363.7 102.836 362.833 103.703 361.763 103.703C360.693 103.703 359.825 102.836 359.825 101.766C359.825 100.696 360.693 99.828 361.763 99.828C362.833 99.828 363.7 100.696 363.7 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M363.7 97.0429C363.7 98.1129 362.833 98.9805 361.763 98.9805C360.693 98.9805 359.825 98.1129 359.825 97.0429C359.825 95.9729 360.693 95.1053 361.763 95.1053C362.833 95.1053 363.7 95.9729 363.7 97.0429Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M368.424 97.0429C368.424 98.1129 367.556 98.9805 366.486 98.9805C365.416 98.9805 364.548 98.1129 364.548 97.0429C364.548 95.9729 365.416 95.1053 366.486 95.1053C367.556 95.1053 368.424 95.9729 368.424 97.0429Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M368.424 101.766C368.424 102.836 367.556 103.703 366.486 103.703C365.416 103.703 364.548 102.836 364.548 101.766C364.548 100.696 365.416 99.828 366.486 99.828C367.556 99.828 368.424 100.696 368.424 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M368.424 106.488C368.424 107.558 367.556 108.426 366.486 108.426C365.416 108.426 364.548 107.558 364.548 106.488C364.548 105.418 365.416 104.551 366.486 104.551C367.556 104.551 368.424 105.418 368.424 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M368.424 111.211C368.424 112.281 367.556 113.148 366.486 113.148C365.416 113.148 364.548 112.281 364.548 111.211C364.548 110.141 365.416 109.273 366.486 109.273C367.556 109.273 368.424 110.141 368.424 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M368.424 115.934C368.424 117.003 367.556 117.871 366.486 117.871C365.416 117.871 364.548 117.003 364.548 115.934C364.548 114.864 365.416 113.996 366.486 113.996C367.556 113.996 368.424 114.864 368.424 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M363.7 115.934C363.7 117.003 362.833 117.871 361.763 117.871C360.693 117.871 359.825 117.003 359.825 115.934C359.825 114.864 360.693 113.996 361.763 113.996C362.833 113.996 363.7 114.864 363.7 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M363.7 111.211C363.7 112.281 362.833 113.148 361.763 113.148C360.693 113.148 359.825 112.281 359.825 111.211C359.825 110.141 360.693 109.273 361.763 109.273C362.833 109.273 363.7 110.141 363.7 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M363.7 106.488C363.7 107.558 362.833 108.426 361.763 108.426C360.693 108.426 359.825 107.558 359.825 106.488C359.825 105.418 360.693 104.551 361.763 104.551C362.833 104.551 363.7 105.418 363.7 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M358.977 106.488C358.977 107.558 358.11 108.426 357.04 108.426C355.97 108.426 355.102 107.558 355.102 106.488C355.102 105.418 355.97 104.551 357.04 104.551C358.11 104.551 358.977 105.418 358.977 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M358.977 111.211C358.977 112.281 358.11 113.148 357.04 113.148C355.97 113.148 355.102 112.281 355.102 111.211C355.102 110.141 355.97 109.273 357.04 109.273C358.11 109.273 358.977 110.141 358.977 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M358.977 115.934C358.977 117.003 358.11 117.871 357.04 117.871C355.97 117.871 355.102 117.003 355.102 115.934C355.102 114.864 355.97 113.996 357.04 113.996C358.11 113.996 358.977 114.864 358.977 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M529.011 40.3632C529.011 41.4332 528.144 42.3008 527.074 42.3008C526.004 42.3008 525.136 41.4332 525.136 40.3632C525.136 39.2932 526.004 38.4256 527.074 38.4256C528.144 38.4256 529.011 39.2932 529.011 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M533.734 40.3632C533.734 41.4332 532.867 42.3008 531.797 42.3008C530.727 42.3008 529.859 41.4332 529.859 40.3632C529.859 39.2932 530.727 38.4256 531.797 38.4256C532.867 38.4256 533.734 39.2932 533.734 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M533.734 45.0859C533.734 46.1558 532.867 47.0234 531.797 47.0234C530.727 47.0234 529.859 46.1558 529.859 45.0859C529.859 44.0159 530.727 43.1483 531.797 43.1483C532.867 43.1483 533.734 44.0159 533.734 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M538.457 45.0859C538.457 46.1558 537.59 47.0234 536.52 47.0234C535.45 47.0234 534.582 46.1558 534.582 45.0859C534.582 44.0159 535.45 43.1483 536.52 43.1483C537.59 43.1483 538.457 44.0159 538.457 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M533.734 49.8085C533.734 50.8785 532.867 51.7461 531.797 51.7461C530.727 51.7461 529.859 50.8785 529.859 49.8085C529.859 48.7385 530.727 47.8709 531.797 47.8709C532.867 47.8709 533.734 48.7385 533.734 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M538.457 49.8085C538.457 50.8785 537.59 51.7461 536.52 51.7461C535.45 51.7461 534.582 50.8785 534.582 49.8085C534.582 48.7385 535.45 47.8709 536.52 47.8709C537.59 47.8709 538.457 48.7385 538.457 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M543.18 49.8085C543.18 50.8785 542.313 51.7461 541.243 51.7461C540.173 51.7461 539.305 50.8785 539.305 49.8085C539.305 48.7385 540.173 47.8709 541.243 47.8709C542.313 47.8709 543.18 48.7385 543.18 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M547.903 54.5312C547.903 55.6011 547.036 56.4688 545.966 56.4688C544.896 56.4688 544.028 55.6011 544.028 54.5312C544.028 53.4612 544.896 52.5936 545.966 52.5936C547.036 52.5936 547.903 53.4612 547.903 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M543.18 54.5312C543.18 55.6011 542.313 56.4688 541.243 56.4688C540.173 56.4688 539.305 55.6011 539.305 54.5312C539.305 53.4612 540.173 52.5936 541.243 52.5936C542.313 52.5936 543.18 53.4612 543.18 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M538.457 54.5312C538.457 55.6011 537.59 56.4688 536.52 56.4688C535.45 56.4688 534.582 55.6011 534.582 54.5312C534.582 53.4612 535.45 52.5936 536.52 52.5936C537.59 52.5936 538.457 53.4612 538.457 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M538.457 59.2538C538.457 60.3238 537.59 61.1914 536.52 61.1914C535.45 61.1914 534.582 60.3238 534.582 59.2538C534.582 58.1838 535.45 57.3162 536.52 57.3162C537.59 57.3162 538.457 58.1838 538.457 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M538.457 63.9804C538.457 65.0504 537.59 65.918 536.52 65.918C535.45 65.918 534.582 65.0504 534.582 63.9804C534.582 62.9104 535.45 62.0428 536.52 62.0428C537.59 62.0428 538.457 62.9104 538.457 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M533.734 63.9804C533.734 65.0504 532.867 65.918 531.797 65.918C530.727 65.918 529.859 65.0504 529.859 63.9804C529.859 62.9104 530.727 62.0428 531.797 62.0428C532.867 62.0428 533.734 62.9104 533.734 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M529.011 68.703C529.011 69.773 528.144 70.6406 527.074 70.6406C526.004 70.6406 525.136 69.773 525.136 68.703C525.136 67.6331 526.004 66.7655 527.074 66.7655C528.144 66.7655 529.011 67.6331 529.011 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M529.011 73.4257C529.011 74.4957 528.144 75.3633 527.074 75.3633C526.004 75.3633 525.136 74.4957 525.136 73.4257C525.136 72.3557 526.004 71.4881 527.074 71.4881C528.144 71.4881 529.011 72.3557 529.011 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M529.011 78.1484C529.011 79.2183 528.144 80.0859 527.074 80.0859C526.004 80.0859 525.136 79.2183 525.136 78.1484C525.136 77.0784 526.004 76.2108 527.074 76.2108C528.144 76.2108 529.011 77.0784 529.011 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M533.734 78.1484C533.734 79.2183 532.867 80.0859 531.797 80.0859C530.727 80.0859 529.859 79.2183 529.859 78.1484C529.859 77.0784 530.727 76.2108 531.797 76.2108C532.867 76.2108 533.734 77.0784 533.734 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M533.734 82.871C533.734 83.941 532.867 84.8086 531.797 84.8086C530.727 84.8086 529.859 83.941 529.859 82.871C529.859 81.801 530.727 80.9334 531.797 80.9334C532.867 80.9334 533.734 81.801 533.734 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M533.734 87.5937C533.734 88.6636 532.867 89.5312 531.797 89.5312C530.727 89.5312 529.859 88.6636 529.859 87.5937C529.859 86.5237 530.727 85.6561 531.797 85.6561C532.867 85.6561 533.734 86.5237 533.734 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M538.457 87.5937C538.457 88.6636 537.59 89.5312 536.52 89.5312C535.45 89.5312 534.582 88.6636 534.582 87.5937C534.582 86.5237 535.45 85.6561 536.52 85.6561C537.59 85.6561 538.457 86.5237 538.457 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M547.903 87.5937C547.903 88.6636 547.036 89.5312 545.966 89.5312C544.896 89.5312 544.028 88.6636 544.028 87.5937C544.028 86.5237 544.896 85.6561 545.966 85.6561C547.036 85.6561 547.903 86.5237 547.903 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M533.734 92.3163C533.734 93.3863 532.867 94.2539 531.797 94.2539C530.727 94.2539 529.859 93.3863 529.859 92.3163C529.859 91.2463 530.727 90.3787 531.797 90.3787C532.867 90.3787 533.734 91.2463 533.734 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M533.734 97.0429C533.734 98.1129 532.867 98.9805 531.797 98.9805C530.727 98.9805 529.859 98.1129 529.859 97.0429C529.859 95.9729 530.727 95.1053 531.797 95.1053C532.867 95.1053 533.734 95.9729 533.734 97.0429Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M533.734 101.766C533.734 102.836 532.867 103.703 531.797 103.703C530.727 103.703 529.859 102.836 529.859 101.766C529.859 100.696 530.727 99.828 531.797 99.828C532.867 99.828 533.734 100.696 533.734 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M529.011 87.5937C529.011 88.6636 528.144 89.5312 527.074 89.5312C526.004 89.5312 525.136 88.6636 525.136 87.5937C525.136 86.5237 526.004 85.6561 527.074 85.6561C528.144 85.6561 529.011 86.5237 529.011 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M529.011 82.871C529.011 83.941 528.144 84.8086 527.074 84.8086C526.004 84.8086 525.136 83.941 525.136 82.871C525.136 81.801 526.004 80.9334 527.074 80.9334C528.144 80.9334 529.011 81.801 529.011 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M533.734 59.2538C533.734 60.3238 532.867 61.1914 531.797 61.1914C530.727 61.1914 529.859 60.3238 529.859 59.2538C529.859 58.1838 530.727 57.3162 531.797 57.3162C532.867 57.3162 533.734 58.1838 533.734 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M533.734 54.5312C533.734 55.6011 532.867 56.4688 531.797 56.4688C530.727 56.4688 529.859 55.6011 529.859 54.5312C529.859 53.4612 530.727 52.5936 531.797 52.5936C532.867 52.5936 533.734 53.4612 533.734 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M529.011 54.5312C529.011 55.6011 528.144 56.4688 527.074 56.4688C526.004 56.4688 525.136 55.6011 525.136 54.5312C525.136 53.4612 526.004 52.5936 527.074 52.5936C528.144 52.5936 529.011 53.4612 529.011 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M529.011 59.2538C529.011 60.3238 528.144 61.1914 527.074 61.1914C526.004 61.1914 525.136 60.3238 525.136 59.2538C525.136 58.1838 526.004 57.3162 527.074 57.3162C528.144 57.3162 529.011 58.1838 529.011 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M524.288 59.2538C524.288 60.3238 523.421 61.1914 522.351 61.1914C521.281 61.1914 520.413 60.3238 520.413 59.2538C520.413 58.1838 521.281 57.3162 522.351 57.3162C523.421 57.3162 524.288 58.1838 524.288 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M524.288 63.9804C524.288 65.0504 523.421 65.918 522.351 65.918C521.281 65.918 520.413 65.0504 520.413 63.9804C520.413 62.9104 521.281 62.0428 522.351 62.0428C523.421 62.0428 524.288 62.9104 524.288 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M519.565 59.2538C519.565 60.3238 518.697 61.1914 517.627 61.1914C516.557 61.1914 515.689 60.3238 515.689 59.2538C515.689 58.1838 516.557 57.3162 517.627 57.3162C518.697 57.3162 519.565 58.1838 519.565 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M514.841 59.2538C514.841 60.3238 513.974 61.1914 512.904 61.1914C511.834 61.1914 510.966 60.3238 510.966 59.2538C510.966 58.1838 511.834 57.3162 512.904 57.3162C513.974 57.3162 514.841 58.1838 514.841 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M514.841 63.9804C514.841 65.0504 513.974 65.918 512.904 65.918C511.834 65.918 510.966 65.0504 510.966 63.9804C510.966 62.9104 511.834 62.0428 512.904 62.0428C513.974 62.0428 514.841 62.9104 514.841 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M519.565 63.9804C519.565 65.0504 518.697 65.918 517.627 65.918C516.557 65.918 515.689 65.0504 515.689 63.9804C515.689 62.9104 516.557 62.0428 517.627 62.0428C518.697 62.0428 519.565 62.9104 519.565 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M514.841 68.703C514.841 69.773 513.974 70.6406 512.904 70.6406C511.834 70.6406 510.966 69.773 510.966 68.703C510.966 67.6331 511.834 66.7655 512.904 66.7655C513.974 66.7655 514.841 67.6331 514.841 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M514.841 73.4257C514.841 74.4957 513.974 75.3633 512.904 75.3633C511.834 75.3633 510.966 74.4957 510.966 73.4257C510.966 72.3557 511.834 71.4881 512.904 71.4881C513.974 71.4881 514.841 72.3557 514.841 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M510.118 73.4257C510.118 74.4957 509.251 75.3633 508.181 75.3633C507.111 75.3633 506.243 74.4957 506.243 73.4257C506.243 72.3557 507.111 71.4881 508.181 71.4881C509.251 71.4881 510.118 72.3557 510.118 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M505.395 73.4257C505.395 74.4957 504.528 75.3633 503.458 75.3633C502.388 75.3633 501.52 74.4957 501.52 73.4257C501.52 72.3557 502.388 71.4881 503.458 71.4881C504.528 71.4881 505.395 72.3557 505.395 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M500.672 73.4257C500.672 74.4957 499.805 75.3633 498.735 75.3633C497.665 75.3633 496.797 74.4957 496.797 73.4257C496.797 72.3557 497.665 71.4881 498.735 71.4881C499.805 71.4881 500.672 72.3557 500.672 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M500.672 78.1484C500.672 79.2183 499.805 80.0859 498.735 80.0859C497.665 80.0859 496.797 79.2183 496.797 78.1484C496.797 77.0784 497.665 76.2108 498.735 76.2108C499.805 76.2108 500.672 77.0784 500.672 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M495.949 78.1484C495.949 79.2183 495.082 80.0859 494.012 80.0859C492.942 80.0859 492.074 79.2183 492.074 78.1484C492.074 77.0784 492.942 76.2108 494.012 76.2108C495.082 76.2108 495.949 77.0784 495.949 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M495.949 82.871C495.949 83.941 495.082 84.8086 494.012 84.8086C492.942 84.8086 492.074 83.941 492.074 82.871C492.074 81.801 492.942 80.9334 494.012 80.9334C495.082 80.9334 495.949 81.801 495.949 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M495.949 87.5937C495.949 88.6636 495.082 89.5312 494.012 89.5312C492.942 89.5312 492.074 88.6636 492.074 87.5937C492.074 86.5237 492.942 85.6561 494.012 85.6561C495.082 85.6561 495.949 86.5237 495.949 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M491.226 87.5937C491.226 88.6636 490.359 89.5312 489.289 89.5312C488.219 89.5312 487.351 88.6636 487.351 87.5937C487.351 86.5237 488.219 85.6561 489.289 85.6561C490.359 85.6561 491.226 86.5237 491.226 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M491.226 92.3163C491.226 93.3863 490.359 94.2539 489.289 94.2539C488.219 94.2539 487.351 93.3863 487.351 92.3163C487.351 91.2463 488.219 90.3787 489.289 90.3787C490.359 90.3787 491.226 91.2463 491.226 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M495.949 92.3163C495.949 93.3863 495.082 94.2539 494.012 94.2539C492.942 94.2539 492.074 93.3863 492.074 92.3163C492.074 91.2463 492.942 90.3787 494.012 90.3787C495.082 90.3787 495.949 91.2463 495.949 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M491.226 97.0429C491.226 98.1129 490.359 98.9805 489.289 98.9805C488.219 98.9805 487.351 98.1129 487.351 97.0429C487.351 95.9729 488.219 95.1053 489.289 95.1053C490.359 95.1053 491.226 95.9729 491.226 97.0429Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M495.949 97.0429C495.949 98.1129 495.082 98.9805 494.012 98.9805C492.942 98.9805 492.074 98.1129 492.074 97.0429C492.074 95.9729 492.942 95.1053 494.012 95.1053C495.082 95.1053 495.949 95.9729 495.949 97.0429Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M491.226 101.766C491.226 102.836 490.359 103.703 489.289 103.703C488.219 103.703 487.351 102.836 487.351 101.766C487.351 100.696 488.219 99.828 489.289 99.828C490.359 99.828 491.226 100.696 491.226 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M491.226 106.488C491.226 107.558 490.359 108.426 489.289 108.426C488.219 108.426 487.351 107.558 487.351 106.488C487.351 105.418 488.219 104.551 489.289 104.551C490.359 104.551 491.226 105.418 491.226 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M538.457 40.3632C538.457 41.4332 537.59 42.3008 536.52 42.3008C535.45 42.3008 534.582 41.4332 534.582 40.3632C534.582 39.2932 535.45 38.4256 536.52 38.4256C537.59 38.4256 538.457 39.2932 538.457 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M543.18 40.3632C543.18 41.4332 542.313 42.3008 541.243 42.3008C540.173 42.3008 539.305 41.4332 539.305 40.3632C539.305 39.2932 540.173 38.4256 541.243 38.4256C542.313 38.4256 543.18 39.2932 543.18 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M519.565 26.1952C519.565 27.2652 518.697 28.1328 517.627 28.1328C516.557 28.1328 515.689 27.2652 515.689 26.1952C515.689 25.1252 516.557 24.2576 517.627 24.2576C518.697 24.2576 519.565 25.1252 519.565 26.1952Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M524.288 26.1952C524.288 27.2652 523.421 28.1328 522.351 28.1328C521.281 28.1328 520.413 27.2652 520.413 26.1952C520.413 25.1252 521.281 24.2576 522.351 24.2576C523.421 24.2576 524.288 25.1252 524.288 26.1952Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M529.011 26.1952C529.011 27.2652 528.144 28.1328 527.074 28.1328C526.004 28.1328 525.136 27.2652 525.136 26.1952C525.136 25.1252 526.004 24.2576 527.074 24.2576C528.144 24.2576 529.011 25.1252 529.011 26.1952Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M533.734 26.1952C533.734 27.2652 532.867 28.1328 531.797 28.1328C530.727 28.1328 529.859 27.2652 529.859 26.1952C529.859 25.1252 530.727 24.2576 531.797 24.2576C532.867 24.2576 533.734 25.1252 533.734 26.1952Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M538.457 26.1952C538.457 27.2652 537.59 28.1328 536.52 28.1328C535.45 28.1328 534.582 27.2652 534.582 26.1952C534.582 25.1252 535.45 24.2576 536.52 24.2576C537.59 24.2576 538.457 25.1252 538.457 26.1952Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M538.457 30.9179C538.457 31.9879 537.59 32.8555 536.52 32.8555C535.45 32.8555 534.582 31.9879 534.582 30.9179C534.582 29.8479 535.45 28.9803 536.52 28.9803C537.59 28.9803 538.457 29.8479 538.457 30.9179Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M543.18 30.9179C543.18 31.9879 542.313 32.8555 541.243 32.8555C540.173 32.8555 539.305 31.9879 539.305 30.9179C539.305 29.8479 540.173 28.9803 541.243 28.9803C542.313 28.9803 543.18 29.8479 543.18 30.9179Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M547.903 30.9179C547.903 31.9879 547.036 32.8555 545.966 32.8555C544.896 32.8555 544.028 31.9879 544.028 30.9179C544.028 29.8479 544.896 28.9803 545.966 28.9803C547.036 28.9803 547.903 29.8479 547.903 30.9179Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M547.903 26.1952C547.903 27.2652 547.036 28.1328 545.966 28.1328C544.896 28.1328 544.028 27.2652 544.028 26.1952C544.028 25.1252 544.896 24.2576 545.966 24.2576C547.036 24.2576 547.903 25.1252 547.903 26.1952Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M547.903 35.6405C547.903 36.7105 547.036 37.5781 545.966 37.5781C544.896 37.5781 544.028 36.7105 544.028 35.6405C544.028 34.5706 544.896 33.703 545.966 33.703C547.036 33.703 547.903 34.5706 547.903 35.6405Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M420.378 30.9179C420.378 31.9879 419.511 32.8555 418.441 32.8555C417.371 32.8555 416.503 31.9879 416.503 30.9179C416.503 29.8479 417.371 28.9803 418.441 28.9803C419.511 28.9803 420.378 29.8479 420.378 30.9179Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M420.378 26.1952C420.378 27.2652 419.511 28.1328 418.441 28.1328C417.371 28.1328 416.503 27.2652 416.503 26.1952C416.503 25.1252 417.371 24.2576 418.441 24.2576C419.511 24.2576 420.378 25.1252 420.378 26.1952Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M392.039 63.9804C392.039 65.0504 391.172 65.918 390.102 65.918C389.032 65.918 388.164 65.0504 388.164 63.9804C388.164 62.9104 389.032 62.0428 390.102 62.0428C391.172 62.0428 392.039 62.9104 392.039 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M392.039 59.2538C392.039 60.3238 391.172 61.1914 390.102 61.1914C389.032 61.1914 388.164 60.3238 388.164 59.2538C388.164 58.1838 389.032 57.3162 390.102 57.3162C391.172 57.3162 392.039 58.1838 392.039 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M387.316 59.2538C387.316 60.3238 386.449 61.1914 385.379 61.1914C384.309 61.1914 383.441 60.3238 383.441 59.2538C383.441 58.1838 384.309 57.3162 385.379 57.3162C386.449 57.3162 387.316 58.1838 387.316 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M387.316 54.5312C387.316 55.6011 386.449 56.4688 385.379 56.4688C384.309 56.4688 383.441 55.6011 383.441 54.5312C383.441 53.4612 384.309 52.5936 385.379 52.5936C386.449 52.5936 387.316 53.4612 387.316 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M382.593 54.5312C382.593 55.6011 381.726 56.4688 380.656 56.4688C379.586 56.4688 378.718 55.6011 378.718 54.5312C378.718 53.4612 379.586 52.5936 380.656 52.5936C381.726 52.5936 382.593 53.4612 382.593 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M382.593 68.703C382.593 69.773 381.726 70.6406 380.656 70.6406C379.586 70.6406 378.718 69.773 378.718 68.703C378.718 67.6331 379.586 66.7655 380.656 66.7655C381.726 66.7655 382.593 67.6331 382.593 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M377.87 63.9804C377.87 65.0504 377.003 65.918 375.933 65.918C374.863 65.918 373.995 65.0504 373.995 63.9804C373.995 62.9104 374.863 62.0428 375.933 62.0428C377.003 62.0428 377.87 62.9104 377.87 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M377.87 59.2538C377.87 60.3238 377.003 61.1914 375.933 61.1914C374.863 61.1914 373.995 60.3238 373.995 59.2538C373.995 58.1838 374.863 57.3162 375.933 57.3162C377.003 57.3162 377.87 58.1838 377.87 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M373.147 59.2538C373.147 60.3238 372.279 61.1914 371.209 61.1914C370.139 61.1914 369.271 60.3238 369.271 59.2538C369.271 58.1838 370.139 57.3162 371.209 57.3162C372.279 57.3162 373.147 58.1838 373.147 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M377.87 54.5312C377.87 55.6011 377.003 56.4688 375.933 56.4688C374.863 56.4688 373.995 55.6011 373.995 54.5312C373.995 53.4612 374.863 52.5936 375.933 52.5936C377.003 52.5936 377.87 53.4612 377.87 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M373.147 49.8085C373.147 50.8785 372.279 51.7461 371.209 51.7461C370.139 51.7461 369.271 50.8785 369.271 49.8085C369.271 48.7385 370.139 47.8709 371.209 47.8709C372.279 47.8709 373.147 48.7385 373.147 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M363.7 35.6405C363.7 36.7105 362.833 37.5781 361.763 37.5781C360.693 37.5781 359.825 36.7105 359.825 35.6405C359.825 34.5706 360.693 33.703 361.763 33.703C362.833 33.703 363.7 34.5706 363.7 35.6405Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M358.977 40.3632C358.977 41.4332 358.11 42.3008 357.04 42.3008C355.97 42.3008 355.102 41.4332 355.102 40.3632C355.102 39.2932 355.97 38.4256 357.04 38.4256C358.11 38.4256 358.977 39.2932 358.977 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M354.254 45.0859C354.254 46.1558 353.387 47.0234 352.317 47.0234C351.247 47.0234 350.379 46.1558 350.379 45.0859C350.379 44.0159 351.247 43.1483 352.317 43.1483C353.387 43.1483 354.254 44.0159 354.254 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M354.254 49.8085C354.254 50.8785 353.387 51.7461 352.317 51.7461C351.247 51.7461 350.379 50.8785 350.379 49.8085C350.379 48.7385 351.247 47.8709 352.317 47.8709C353.387 47.8709 354.254 48.7385 354.254 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M354.254 54.5312C354.254 55.6011 353.387 56.4688 352.317 56.4688C351.247 56.4688 350.379 55.6011 350.379 54.5312C350.379 53.4612 351.247 52.5936 352.317 52.5936C353.387 52.5936 354.254 53.4612 354.254 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M354.254 59.2538C354.254 60.3238 353.387 61.1914 352.317 61.1914C351.247 61.1914 350.379 60.3238 350.379 59.2538C350.379 58.1838 351.247 57.3162 352.317 57.3162C353.387 57.3162 354.254 58.1838 354.254 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M358.977 63.9804C358.977 65.0504 358.11 65.918 357.04 65.918C355.97 65.918 355.102 65.0504 355.102 63.9804C355.102 62.9104 355.97 62.0428 357.04 62.0428C358.11 62.0428 358.977 62.9104 358.977 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M344.808 73.4257C344.808 74.4957 343.941 75.3633 342.871 75.3633C341.801 75.3633 340.933 74.4957 340.933 73.4257C340.933 72.3557 341.801 71.4881 342.871 71.4881C343.941 71.4881 344.808 72.3557 344.808 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M349.531 68.703C349.531 69.773 348.664 70.6406 347.594 70.6406C346.524 70.6406 345.656 69.773 345.656 68.703C345.656 67.6331 346.524 66.7655 347.594 66.7655C348.664 66.7655 349.531 67.6331 349.531 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M321.192 101.766C321.192 102.836 320.325 103.703 319.255 103.703C318.185 103.703 317.317 102.836 317.317 101.766C317.317 100.696 318.185 99.828 319.255 99.828C320.325 99.828 321.192 100.696 321.192 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M316.469 139.551C316.469 140.621 315.602 141.488 314.532 141.488C313.462 141.488 312.594 140.621 312.594 139.551C312.594 138.481 313.462 137.613 314.532 137.613C315.602 137.613 316.469 138.481 316.469 139.551Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M316.469 144.273C316.469 145.343 315.602 146.211 314.532 146.211C313.462 146.211 312.594 145.343 312.594 144.273C312.594 143.203 313.462 142.336 314.532 142.336C315.602 142.336 316.469 143.203 316.469 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M321.192 148.996C321.192 150.066 320.325 150.934 319.255 150.934C318.185 150.934 317.317 150.066 317.317 148.996C317.317 147.926 318.185 147.058 319.255 147.058C320.325 147.058 321.192 147.926 321.192 148.996Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M321.192 139.551C321.192 140.621 320.325 141.488 319.255 141.488C318.185 141.488 317.317 140.621 317.317 139.551C317.317 138.481 318.185 137.613 319.255 137.613C320.325 137.613 321.192 138.481 321.192 139.551Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M325.915 139.551C325.915 140.621 325.048 141.488 323.978 141.488C322.908 141.488 322.04 140.621 322.04 139.551C322.04 138.481 322.908 137.613 323.978 137.613C325.048 137.613 325.915 138.481 325.915 139.551Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M325.915 144.273C325.915 145.343 325.048 146.211 323.978 146.211C322.908 146.211 322.04 145.343 322.04 144.273C322.04 143.203 322.908 142.336 323.978 142.336C325.048 142.336 325.915 143.203 325.915 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M330.638 148.996C330.638 150.066 329.771 150.934 328.701 150.934C327.631 150.934 326.763 150.066 326.763 148.996C326.763 147.926 327.631 147.058 328.701 147.058C329.771 147.058 330.638 147.926 330.638 148.996Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M311.745 115.934C311.745 117.003 310.878 117.871 309.808 117.871C308.738 117.871 307.87 117.003 307.87 115.934C307.87 114.864 308.738 113.996 309.808 113.996C310.878 113.996 311.745 114.864 311.745 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M297.576 115.934C297.576 117.003 296.709 117.871 295.639 117.871C294.569 117.871 293.701 117.003 293.701 115.934C293.701 114.864 294.569 113.996 295.639 113.996C296.709 113.996 297.576 114.864 297.576 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M297.576 111.211C297.576 112.281 296.709 113.148 295.639 113.148C294.569 113.148 293.701 112.281 293.701 111.211C293.701 110.141 294.569 109.273 295.639 109.273C296.709 109.273 297.576 110.141 297.576 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M302.299 106.488C302.299 107.558 301.432 108.426 300.362 108.426C299.292 108.426 298.424 107.558 298.424 106.488C298.424 105.418 299.292 104.551 300.362 104.551C301.432 104.551 302.299 105.418 302.299 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M302.299 101.766C302.299 102.836 301.432 103.703 300.362 103.703C299.292 103.703 298.424 102.836 298.424 101.766C298.424 100.696 299.292 99.828 300.362 99.828C301.432 99.828 302.299 100.696 302.299 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M307.022 101.766C307.022 102.836 306.155 103.703 305.085 103.703C304.015 103.703 303.147 102.836 303.147 101.766C303.147 100.696 304.015 99.828 305.085 99.828C306.155 99.828 307.022 100.696 307.022 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M302.299 97.0429C302.299 98.1129 301.432 98.9805 300.362 98.9805C299.292 98.9805 298.424 98.1129 298.424 97.0429C298.424 95.9729 299.292 95.1053 300.362 95.1053C301.432 95.1053 302.299 95.9729 302.299 97.0429Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M297.576 97.0429C297.576 98.1129 296.709 98.9805 295.639 98.9805C294.569 98.9805 293.701 98.1129 293.701 97.0429C293.701 95.9729 294.569 95.1053 295.639 95.1053C296.709 95.1053 297.576 95.9729 297.576 97.0429Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M292.853 101.766C292.853 102.836 291.986 103.703 290.916 103.703C289.846 103.703 288.978 102.836 288.978 101.766C288.978 100.696 289.846 99.828 290.916 99.828C291.986 99.828 292.853 100.696 292.853 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M292.853 97.0429C292.853 98.1129 291.986 98.9805 290.916 98.9805C289.846 98.9805 288.978 98.1129 288.978 97.0429C288.978 95.9729 289.846 95.1053 290.916 95.1053C291.986 95.1053 292.853 95.9729 292.853 97.0429Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M297.576 92.3163C297.576 93.3863 296.709 94.2539 295.639 94.2539C294.569 94.2539 293.701 93.3863 293.701 92.3163C293.701 91.2463 294.569 90.3787 295.639 90.3787C296.709 90.3787 297.576 91.2463 297.576 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M302.299 92.3163C302.299 93.3863 301.432 94.2539 300.362 94.2539C299.292 94.2539 298.424 93.3863 298.424 92.3163C298.424 91.2463 299.292 90.3787 300.362 90.3787C301.432 90.3787 302.299 91.2463 302.299 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M307.022 92.3163C307.022 93.3863 306.155 94.2539 305.085 94.2539C304.015 94.2539 303.147 93.3863 303.147 92.3163C303.147 91.2463 304.015 90.3787 305.085 90.3787C306.155 90.3787 307.022 91.2463 307.022 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M307.022 87.5937C307.022 88.6636 306.155 89.5312 305.085 89.5312C304.015 89.5312 303.147 88.6636 303.147 87.5937C303.147 86.5237 304.015 85.6561 305.085 85.6561C306.155 85.6561 307.022 86.5237 307.022 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M302.299 87.5937C302.299 88.6636 301.432 89.5312 300.362 89.5312C299.292 89.5312 298.424 88.6636 298.424 87.5937C298.424 86.5237 299.292 85.6561 300.362 85.6561C301.432 85.6561 302.299 86.5237 302.299 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M302.299 82.871C302.299 83.941 301.432 84.8086 300.362 84.8086C299.292 84.8086 298.424 83.941 298.424 82.871C298.424 81.801 299.292 80.9334 300.362 80.9334C301.432 80.9334 302.299 81.801 302.299 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M307.022 82.871C307.022 83.941 306.155 84.8086 305.085 84.8086C304.015 84.8086 303.147 83.941 303.147 82.871C303.147 81.801 304.015 80.9334 305.085 80.9334C306.155 80.9334 307.022 81.801 307.022 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M311.745 82.871C311.745 83.941 310.878 84.8086 309.808 84.8086C308.738 84.8086 307.87 83.941 307.87 82.871C307.87 81.801 308.738 80.9334 309.808 80.9334C310.878 80.9334 311.745 81.801 311.745 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M311.745 78.1484C311.745 79.2183 310.878 80.0859 309.808 80.0859C308.738 80.0859 307.87 79.2183 307.87 78.1484C307.87 77.0784 308.738 76.2108 309.808 76.2108C310.878 76.2108 311.745 77.0784 311.745 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M307.022 78.1484C307.022 79.2183 306.155 80.0859 305.085 80.0859C304.015 80.0859 303.147 79.2183 303.147 78.1484C303.147 77.0784 304.015 76.2108 305.085 76.2108C306.155 76.2108 307.022 77.0784 307.022 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M311.745 73.4257C311.745 74.4957 310.878 75.3633 309.808 75.3633C308.738 75.3633 307.87 74.4957 307.87 73.4257C307.87 72.3557 308.738 71.4881 309.808 71.4881C310.878 71.4881 311.745 72.3557 311.745 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M316.469 73.4257C316.469 74.4957 315.602 75.3633 314.532 75.3633C313.462 75.3633 312.594 74.4957 312.594 73.4257C312.594 72.3557 313.462 71.4881 314.532 71.4881C315.602 71.4881 316.469 72.3557 316.469 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M316.469 68.703C316.469 69.773 315.602 70.6406 314.532 70.6406C313.462 70.6406 312.594 69.773 312.594 68.703C312.594 67.6331 313.462 66.7655 314.532 66.7655C315.602 66.7655 316.469 67.6331 316.469 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M321.192 68.703C321.192 69.773 320.325 70.6406 319.255 70.6406C318.185 70.6406 317.317 69.773 317.317 68.703C317.317 67.6331 318.185 66.7655 319.255 66.7655C320.325 66.7655 321.192 67.6331 321.192 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M321.192 73.4257C321.192 74.4957 320.325 75.3633 319.255 75.3633C318.185 75.3633 317.317 74.4957 317.317 73.4257C317.317 72.3557 318.185 71.4881 319.255 71.4881C320.325 71.4881 321.192 72.3557 321.192 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M325.915 73.4257C325.915 74.4957 325.048 75.3633 323.978 75.3633C322.908 75.3633 322.04 74.4957 322.04 73.4257C322.04 72.3557 322.908 71.4881 323.978 71.4881C325.048 71.4881 325.915 72.3557 325.915 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M330.638 73.4257C330.638 74.4957 329.771 75.3633 328.701 75.3633C327.631 75.3633 326.763 74.4957 326.763 73.4257C326.763 72.3557 327.631 71.4881 328.701 71.4881C329.771 71.4881 330.638 72.3557 330.638 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M330.638 78.1484C330.638 79.2183 329.771 80.0859 328.701 80.0859C327.631 80.0859 326.763 79.2183 326.763 78.1484C326.763 77.0784 327.631 76.2108 328.701 76.2108C329.771 76.2108 330.638 77.0784 330.638 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M335.361 78.1484C335.361 79.2183 334.494 80.0859 333.424 80.0859C332.354 80.0859 331.486 79.2183 331.486 78.1484C331.486 77.0784 332.354 76.2108 333.424 76.2108C334.494 76.2108 335.361 77.0784 335.361 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M325.915 78.1484C325.915 79.2183 325.048 80.0859 323.978 80.0859C322.908 80.0859 322.04 79.2183 322.04 78.1484C322.04 77.0784 322.908 76.2108 323.978 76.2108C325.048 76.2108 325.915 77.0784 325.915 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M321.192 78.1484C321.192 79.2183 320.325 80.0859 319.255 80.0859C318.185 80.0859 317.317 79.2183 317.317 78.1484C317.317 77.0784 318.185 76.2108 319.255 76.2108C320.325 76.2108 321.192 77.0784 321.192 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M316.469 78.1484C316.469 79.2183 315.602 80.0859 314.532 80.0859C313.462 80.0859 312.594 79.2183 312.594 78.1484C312.594 77.0784 313.462 76.2108 314.532 76.2108C315.602 76.2108 316.469 77.0784 316.469 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M321.192 82.871C321.192 83.941 320.325 84.8086 319.255 84.8086C318.185 84.8086 317.317 83.941 317.317 82.871C317.317 81.801 318.185 80.9334 319.255 80.9334C320.325 80.9334 321.192 81.801 321.192 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M321.192 87.5937C321.192 88.6636 320.325 89.5312 319.255 89.5312C318.185 89.5312 317.317 88.6636 317.317 87.5937C317.317 86.5237 318.185 85.6561 319.255 85.6561C320.325 85.6561 321.192 86.5237 321.192 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M316.469 92.3163C316.469 93.3863 315.602 94.2539 314.532 94.2539C313.462 94.2539 312.594 93.3863 312.594 92.3163C312.594 91.2463 313.462 90.3787 314.532 90.3787C315.602 90.3787 316.469 91.2463 316.469 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M316.469 97.039C316.469 98.109 315.602 98.9766 314.532 98.9766C313.462 98.9766 312.594 98.109 312.594 97.039C312.594 95.969 313.462 95.1014 314.532 95.1014C315.602 95.1014 316.469 95.969 316.469 97.039Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M321.192 97.0429C321.192 98.1129 320.325 98.9805 319.255 98.9805C318.185 98.9805 317.317 98.1129 317.317 97.0429C317.317 95.9729 318.185 95.1053 319.255 95.1053C320.325 95.1053 321.192 95.9729 321.192 97.0429Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M325.915 97.0429C325.915 98.1129 325.048 98.9805 323.978 98.9805C322.908 98.9805 322.04 98.1129 322.04 97.0429C322.04 95.9729 322.908 95.1053 323.978 95.1053C325.048 95.1053 325.915 95.9729 325.915 97.0429Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M325.915 101.766C325.915 102.836 325.048 103.703 323.978 103.703C322.908 103.703 322.04 102.836 322.04 101.766C322.04 100.696 322.908 99.828 323.978 99.828C325.048 99.828 325.915 100.696 325.915 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M330.638 101.766C330.638 102.836 329.771 103.703 328.701 103.703C327.631 103.703 326.763 102.836 326.763 101.766C326.763 100.696 327.631 99.828 328.701 99.828C329.771 99.828 330.638 100.696 330.638 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M335.361 101.766C335.361 102.836 334.494 103.703 333.424 103.703C332.354 103.703 331.486 102.836 331.486 101.766C331.486 100.696 332.354 99.828 333.424 99.828C334.494 99.828 335.361 100.696 335.361 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M335.361 97.0429C335.361 98.1129 334.494 98.9805 333.424 98.9805C332.354 98.9805 331.486 98.1129 331.486 97.0429C331.486 95.9729 332.354 95.1053 333.424 95.1053C334.494 95.1053 335.361 95.9729 335.361 97.0429Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M330.638 92.3163C330.638 93.3863 329.771 94.2539 328.701 94.2539C327.631 94.2539 326.763 93.3863 326.763 92.3163C326.763 91.2463 327.631 90.3787 328.701 90.3787C329.771 90.3787 330.638 91.2463 330.638 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M330.638 87.5937C330.638 88.6636 329.771 89.5312 328.701 89.5312C327.631 89.5312 326.763 88.6636 326.763 87.5937C326.763 86.5237 327.631 85.6561 328.701 85.6561C329.771 85.6561 330.638 86.5237 330.638 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M325.915 82.871C325.915 83.941 325.048 84.8086 323.978 84.8086C322.908 84.8086 322.04 83.941 322.04 82.871C322.04 81.801 322.908 80.9334 323.978 80.9334C325.048 80.9334 325.915 81.801 325.915 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M325.915 87.5937C325.915 88.6636 325.048 89.5312 323.978 89.5312C322.908 89.5312 322.04 88.6636 322.04 87.5937C322.04 86.5237 322.908 85.6561 323.978 85.6561C325.048 85.6561 325.915 86.5237 325.915 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M297.576 125.379C297.576 126.449 296.709 127.316 295.639 127.316C294.569 127.316 293.701 126.449 293.701 125.379C293.701 124.309 294.569 123.441 295.639 123.441C296.709 123.441 297.576 124.309 297.576 125.379Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M297.576 130.101C297.576 131.171 296.709 132.039 295.639 132.039C294.569 132.039 293.701 131.171 293.701 130.101C293.701 129.031 294.569 128.164 295.639 128.164C296.709 128.164 297.576 129.031 297.576 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M302.299 130.101C302.299 131.171 301.432 132.039 300.362 132.039C299.292 132.039 298.424 131.171 298.424 130.101C298.424 129.031 299.292 128.164 300.362 128.164C301.432 128.164 302.299 129.031 302.299 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M302.299 134.828C302.299 135.898 301.432 136.766 300.362 136.766C299.292 136.766 298.424 135.898 298.424 134.828C298.424 133.758 299.292 132.89 300.362 132.89C301.432 132.89 302.299 133.758 302.299 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M297.576 134.828C297.576 135.898 296.709 136.766 295.639 136.766C294.569 136.766 293.701 135.898 293.701 134.828C293.701 133.758 294.569 132.89 295.639 132.89C296.709 132.89 297.576 133.758 297.576 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M297.576 144.273C297.576 145.343 296.709 146.211 295.639 146.211C294.568 146.211 293.701 145.343 293.701 144.273C293.701 143.203 294.568 142.336 295.639 142.336C296.709 142.336 297.576 143.203 297.576 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M302.299 139.551C302.299 140.621 301.432 141.488 300.362 141.488C299.292 141.488 298.424 140.621 298.424 139.551C298.424 138.481 299.292 137.613 300.362 137.613C301.432 137.613 302.299 138.481 302.299 139.551Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M307.022 144.273C307.022 145.343 306.155 146.211 305.085 146.211C304.015 146.211 303.147 145.343 303.147 144.273C303.147 143.203 304.015 142.336 305.085 142.336C306.155 142.336 307.022 143.203 307.022 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M311.745 148.996C311.745 150.066 310.878 150.934 309.808 150.934C308.738 150.934 307.87 150.066 307.87 148.996C307.87 147.926 308.738 147.058 309.808 147.058C310.878 147.058 311.745 147.926 311.745 148.996Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M307.022 153.719C307.022 154.789 306.155 155.656 305.085 155.656C304.015 155.656 303.147 154.789 303.147 153.719C303.147 152.649 304.015 151.781 305.085 151.781C306.155 151.781 307.022 152.649 307.022 153.719Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M292.853 139.551C292.853 140.621 291.985 141.488 290.915 141.488C289.845 141.488 288.978 140.621 288.978 139.551C288.978 138.481 289.845 137.613 290.915 137.613C291.985 137.613 292.853 138.481 292.853 139.551Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M283.406 134.828C283.406 135.898 282.539 136.766 281.469 136.766C280.399 136.766 279.531 135.898 279.531 134.828C279.531 133.758 280.399 132.89 281.469 132.89C282.539 132.89 283.406 133.758 283.406 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M217.282 78.1484C217.282 79.2183 216.415 80.0859 215.345 80.0859C214.275 80.0859 213.407 79.2183 213.407 78.1484C213.407 77.0784 214.275 76.2108 215.345 76.2108C216.415 76.2108 217.282 77.0784 217.282 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M207.836 78.1484C207.836 79.2183 206.968 80.0859 205.898 80.0859C204.828 80.0859 203.961 79.2183 203.961 78.1484C203.961 77.0784 204.828 76.2108 205.898 76.2108C206.968 76.2108 207.836 77.0784 207.836 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M207.836 63.9804C207.836 65.0504 206.968 65.918 205.898 65.918C204.828 65.918 203.961 65.0504 203.961 63.9804C203.961 62.9104 204.828 62.0428 205.898 62.0428C206.968 62.0428 207.836 62.9104 207.836 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M212.559 30.9179C212.559 31.9879 211.692 32.8555 210.622 32.8555C209.552 32.8555 208.684 31.9879 208.684 30.9179C208.684 29.8479 209.552 28.9803 210.622 28.9803C211.692 28.9803 212.559 29.8479 212.559 30.9179Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M217.282 30.9179C217.282 31.9879 216.415 32.8555 215.345 32.8555C214.275 32.8555 213.407 31.9879 213.407 30.9179C213.407 29.8479 214.275 28.9803 215.345 28.9803C216.415 28.9803 217.282 29.8479 217.282 30.9179Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M217.282 26.1952C217.282 27.2652 216.415 28.1328 215.345 28.1328C214.275 28.1328 213.407 27.2652 213.407 26.1952C213.407 25.1252 214.275 24.2576 215.345 24.2576C216.415 24.2576 217.282 25.1252 217.282 26.1952Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M217.282 21.4687C217.282 22.5386 216.415 23.4062 215.345 23.4062C214.275 23.4062 213.407 22.5386 213.407 21.4687C213.407 20.3987 214.275 19.5311 215.345 19.5311C216.415 19.5311 217.282 20.3987 217.282 21.4687Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M222.006 21.4687C222.006 22.5386 221.138 23.4062 220.068 23.4062C218.998 23.4062 218.13 22.5386 218.13 21.4687C218.13 20.3987 218.998 19.5311 220.068 19.5311C221.138 19.5311 222.006 20.3987 222.006 21.4687Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M222.006 16.746C222.006 17.816 221.138 18.6836 220.068 18.6836C218.998 18.6836 218.13 17.816 218.13 16.746C218.13 15.676 218.998 14.8084 220.068 14.8084C221.138 14.8084 222.006 15.676 222.006 16.746Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M226.729 16.746C226.729 17.816 225.861 18.6836 224.791 18.6836C223.721 18.6836 222.854 17.816 222.854 16.746C222.854 15.676 223.721 14.8084 224.791 14.8084C225.861 14.8084 226.729 15.676 226.729 16.746Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M231.452 16.746C231.452 17.816 230.584 18.6836 229.514 18.6836C228.444 18.6836 227.577 17.816 227.577 16.746C227.577 15.676 228.444 14.8084 229.514 14.8084C230.584 14.8084 231.452 15.676 231.452 16.746Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M236.175 16.746C236.175 17.816 235.307 18.6836 234.237 18.6836C233.167 18.6836 232.3 17.816 232.3 16.746C232.3 15.676 233.167 14.8084 234.237 14.8084C235.307 14.8084 236.175 15.676 236.175 16.746Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M240.898 16.746C240.898 17.816 240.031 18.6836 238.961 18.6836C237.891 18.6836 237.023 17.816 237.023 16.746C237.023 15.676 237.891 14.8084 238.961 14.8084C240.031 14.8084 240.898 15.676 240.898 16.746Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M245.621 16.746C245.621 17.816 244.754 18.6836 243.684 18.6836C242.614 18.6836 241.746 17.816 241.746 16.746C241.746 15.676 242.614 14.8084 243.684 14.8084C244.754 14.8084 245.621 15.676 245.621 16.746Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M245.621 21.4687C245.621 22.5386 244.754 23.4062 243.684 23.4062C242.614 23.4062 241.746 22.5386 241.746 21.4687C241.746 20.3987 242.614 19.5311 243.684 19.5311C244.754 19.5311 245.621 20.3987 245.621 21.4687Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M250.344 21.4687C250.344 22.5386 249.477 23.4062 248.407 23.4062C247.337 23.4062 246.469 22.5386 246.469 21.4687C246.469 20.3987 247.337 19.5311 248.407 19.5311C249.477 19.5311 250.344 20.3987 250.344 21.4687Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M255.068 21.4687C255.068 22.5386 254.2 23.4062 253.13 23.4062C252.06 23.4062 251.192 22.5386 251.192 21.4687C251.192 20.3987 252.06 19.5311 253.13 19.5311C254.2 19.5311 255.068 20.3987 255.068 21.4687Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M259.791 21.4687C259.791 22.5386 258.923 23.4062 257.853 23.4062C256.783 23.4062 255.916 22.5386 255.916 21.4687C255.916 20.3987 256.783 19.5311 257.853 19.5311C258.923 19.5311 259.791 20.3987 259.791 21.4687Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M264.514 21.4687C264.514 22.5386 263.646 23.4062 262.576 23.4062C261.506 23.4062 260.639 22.5386 260.639 21.4687C260.639 20.3987 261.506 19.5311 262.576 19.5311C263.646 19.5311 264.514 20.3987 264.514 21.4687Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M297.576 30.9179C297.576 31.9879 296.709 32.8555 295.639 32.8555C294.568 32.8555 293.701 31.9879 293.701 30.9179C293.701 29.8479 294.568 28.9803 295.639 28.9803C296.709 28.9803 297.576 29.8479 297.576 30.9179Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M302.299 30.9179C302.299 31.9879 301.432 32.8555 300.362 32.8555C299.292 32.8555 298.424 31.9879 298.424 30.9179C298.424 29.8479 299.292 28.9803 300.362 28.9803C301.432 28.9803 302.299 29.8479 302.299 30.9179Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M302.299 35.6405C302.299 36.7105 301.432 37.5781 300.362 37.5781C299.292 37.5781 298.424 36.7105 298.424 35.6405C298.424 34.5706 299.292 33.703 300.362 33.703C301.432 33.703 302.299 34.5706 302.299 35.6405Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M302.299 40.3632C302.299 41.4332 301.432 42.3008 300.362 42.3008C299.292 42.3008 298.424 41.4332 298.424 40.3632C298.424 39.2932 299.292 38.4256 300.362 38.4256C301.432 38.4256 302.299 39.2932 302.299 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M307.022 35.6405C307.022 36.7105 306.155 37.5781 305.085 37.5781C304.015 37.5781 303.147 36.7105 303.147 35.6405C303.147 34.5706 304.015 33.703 305.085 33.703C306.155 33.703 307.022 34.5706 307.022 35.6405Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M311.745 26.1952C311.745 27.2652 310.878 28.1328 309.808 28.1328C308.738 28.1328 307.87 27.2652 307.87 26.1952C307.87 25.1252 308.738 24.2576 309.808 24.2576C310.878 24.2576 311.745 25.1252 311.745 26.1952Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M335.362 21.4687C335.362 22.5386 334.494 23.4062 333.424 23.4062C332.354 23.4062 331.486 22.5386 331.486 21.4687C331.486 20.3987 332.354 19.5311 333.424 19.5311C334.494 19.5311 335.362 20.3987 335.362 21.4687Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M344.808 21.4687C344.808 22.5386 343.941 23.4062 342.871 23.4062C341.801 23.4062 340.933 22.5386 340.933 21.4687C340.933 20.3987 341.801 19.5311 342.871 19.5311C343.941 19.5311 344.808 20.3987 344.808 21.4687Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M344.808 16.746C344.808 17.816 343.941 18.6836 342.871 18.6836C341.801 18.6836 340.933 17.816 340.933 16.746C340.933 15.676 341.801 14.8084 342.871 14.8084C343.941 14.8084 344.808 15.676 344.808 16.746Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M349.531 12.0234C349.531 13.0933 348.664 13.9609 347.594 13.9609C346.524 13.9609 345.656 13.0933 345.656 12.0234C345.656 10.9534 346.524 10.0858 347.594 10.0858C348.664 10.0858 349.531 10.9534 349.531 12.0234Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M307.022 26.1952C307.022 27.2652 306.155 28.1328 305.085 28.1328C304.015 28.1328 303.147 27.2652 303.147 26.1952C303.147 25.1252 304.015 24.2576 305.085 24.2576C306.155 24.2576 307.022 25.1252 307.022 26.1952Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M255.068 16.746C255.068 17.816 254.2 18.6836 253.13 18.6836C252.06 18.6836 251.192 17.816 251.192 16.746C251.192 15.676 252.06 14.8084 253.13 14.8084C254.2 14.8084 255.068 15.676 255.068 16.746Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M250.344 16.746C250.344 17.816 249.477 18.6836 248.407 18.6836C247.337 18.6836 246.469 17.816 246.469 16.746C246.469 15.676 247.337 14.8084 248.407 14.8084C249.477 14.8084 250.344 15.676 250.344 16.746Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M240.898 12.0234C240.898 13.0933 240.031 13.9609 238.961 13.9609C237.891 13.9609 237.023 13.0933 237.023 12.0234C237.023 10.9534 237.891 10.0858 238.961 10.0858C240.031 10.0858 240.898 10.9534 240.898 12.0234Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M240.898 7.30069C240.898 8.37067 240.031 9.23828 238.961 9.23828C237.891 9.23828 237.023 8.37067 237.023 7.30069C237.023 6.23072 237.891 5.36311 238.961 5.36311C240.031 5.36311 240.898 6.23072 240.898 7.30069Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M245.621 7.30069C245.621 8.37067 244.754 9.23828 243.684 9.23828C242.614 9.23828 241.746 8.37067 241.746 7.30069C241.746 6.23072 242.614 5.36311 243.684 5.36311C244.754 5.36311 245.621 6.23072 245.621 7.30069Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M245.621 12.0234C245.621 13.0933 244.754 13.9609 243.684 13.9609C242.614 13.9609 241.746 13.0933 241.746 12.0234C241.746 10.9534 242.614 10.0858 243.684 10.0858C244.754 10.0858 245.621 10.9534 245.621 12.0234Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M250.344 12.0234C250.344 13.0933 249.477 13.9609 248.407 13.9609C247.337 13.9609 246.469 13.0933 246.469 12.0234C246.469 10.9534 247.337 10.0858 248.407 10.0858C249.477 10.0858 250.344 10.9534 250.344 12.0234Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M255.068 12.0234C255.068 13.0933 254.2 13.9609 253.13 13.9609C252.06 13.9609 251.192 13.0933 251.192 12.0234C251.192 10.9534 252.06 10.0858 253.13 10.0858C254.2 10.0858 255.068 10.9534 255.068 12.0234Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M255.068 7.30069C255.068 8.37067 254.2 9.23828 253.13 9.23828C252.06 9.23828 251.192 8.37067 251.192 7.30069C251.192 6.23072 252.06 5.36311 253.13 5.36311C254.2 5.36311 255.068 6.23072 255.068 7.30069Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M259.791 12.0234C259.791 13.0933 258.923 13.9609 257.853 13.9609C256.783 13.9609 255.916 13.0933 255.916 12.0234C255.916 10.9534 256.783 10.0858 257.853 10.0858C258.923 10.0858 259.791 10.9534 259.791 12.0234Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M231.452 12.0234C231.452 13.0933 230.584 13.9609 229.514 13.9609C228.444 13.9609 227.577 13.0933 227.577 12.0234C227.577 10.9534 228.444 10.0858 229.514 10.0858C230.584 10.0858 231.452 10.9534 231.452 12.0234Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M222.006 12.0234C222.006 13.0933 221.138 13.9609 220.068 13.9609C218.998 13.9609 218.13 13.0933 218.13 12.0234C218.13 10.9534 218.998 10.0858 220.068 10.0858C221.138 10.0858 222.006 10.9534 222.006 12.0234Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M203.113 35.6405C203.113 36.7105 202.245 37.5781 201.175 37.5781C200.105 37.5781 199.238 36.7105 199.238 35.6405C199.238 34.5706 200.105 33.703 201.175 33.703C202.245 33.703 203.113 34.5706 203.113 35.6405Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M198.39 35.6405C198.39 36.7105 197.522 37.5781 196.452 37.5781C195.382 37.5781 194.514 36.7105 194.514 35.6405C194.514 34.5706 195.382 33.703 196.452 33.703C197.522 33.703 198.39 34.5706 198.39 35.6405Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M207.836 7.30069C207.836 8.37067 206.968 9.23828 205.898 9.23828C204.828 9.23828 203.961 8.37067 203.961 7.30069C203.961 6.23072 204.828 5.36311 205.898 5.36311C206.968 5.36311 207.836 6.23072 207.836 7.30069Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M207.836 12.0234C207.836 13.0933 206.969 13.9609 205.899 13.9609C204.829 13.9609 203.961 13.0933 203.961 12.0234C203.961 10.9534 204.829 10.0858 205.899 10.0858C206.969 10.0858 207.836 10.9534 207.836 12.0234Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M203.113 12.0234C203.113 13.0933 202.245 13.9609 201.175 13.9609C200.105 13.9609 199.238 13.0933 199.238 12.0234C199.238 10.9534 200.105 10.0858 201.175 10.0858C202.245 10.0858 203.113 10.9534 203.113 12.0234Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M203.113 16.746C203.113 17.816 202.245 18.6836 201.175 18.6836C200.105 18.6836 199.238 17.816 199.238 16.746C199.238 15.676 200.105 14.8084 201.175 14.8084C202.245 14.8084 203.113 15.676 203.113 16.746Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M198.39 16.746C198.39 17.816 197.522 18.6836 196.452 18.6836C195.382 18.6836 194.515 17.816 194.515 16.746C194.515 15.676 195.382 14.8084 196.452 14.8084C197.522 14.8084 198.39 15.676 198.39 16.746Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M193.666 16.746C193.666 17.816 192.799 18.6836 191.729 18.6836C190.659 18.6836 189.791 17.816 189.791 16.746C189.791 15.676 190.659 14.8084 191.729 14.8084C192.799 14.8084 193.666 15.676 193.666 16.746Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M193.666 21.4687C193.666 22.5386 192.799 23.4062 191.729 23.4062C190.659 23.4062 189.791 22.5386 189.791 21.4687C189.791 20.3987 190.659 19.5311 191.729 19.5311C192.799 19.5311 193.666 20.3987 193.666 21.4687Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M188.943 21.4687C188.943 22.5386 188.075 23.4062 187.005 23.4062C185.935 23.4062 185.068 22.5386 185.068 21.4687C185.068 20.3987 185.935 19.5311 187.005 19.5311C188.075 19.5311 188.943 20.3987 188.943 21.4687Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M184.22 21.4687C184.22 22.5386 183.352 23.4062 182.282 23.4062C181.212 23.4062 180.345 22.5386 180.345 21.4687C180.345 20.3987 181.212 19.5311 182.282 19.5311C183.352 19.5311 184.22 20.3987 184.22 21.4687Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M188.943 26.1952C188.943 27.2652 188.075 28.1328 187.005 28.1328C185.935 28.1328 185.068 27.2652 185.068 26.1952C185.068 25.1252 185.935 24.2576 187.005 24.2576C188.075 24.2576 188.943 25.1252 188.943 26.1952Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M184.22 30.9179C184.22 31.9879 183.352 32.8555 182.282 32.8555C181.212 32.8555 180.345 31.9879 180.345 30.9179C180.345 29.8479 181.212 28.9803 182.282 28.9803C183.352 28.9803 184.22 29.8479 184.22 30.9179Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M179.497 30.9179C179.497 31.9879 178.629 32.8555 177.559 32.8555C176.489 32.8555 175.622 31.9879 175.622 30.9179C175.622 29.8479 176.489 28.9803 177.559 28.9803C178.629 28.9803 179.497 29.8479 179.497 30.9179Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M179.497 40.3632C179.497 41.4332 178.629 42.3008 177.559 42.3008C176.489 42.3008 175.622 41.4332 175.622 40.3632C175.622 39.2932 176.489 38.4256 177.559 38.4256C178.629 38.4256 179.497 39.2932 179.497 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M179.497 35.6405C179.497 36.7105 178.629 37.5781 177.559 37.5781C176.489 37.5781 175.622 36.7105 175.622 35.6405C175.622 34.5706 176.489 33.703 177.559 33.703C178.629 33.703 179.497 34.5706 179.497 35.6405Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M174.774 35.6405C174.774 36.7105 173.906 37.5781 172.836 37.5781C171.766 37.5781 170.899 36.7105 170.899 35.6405C170.899 34.5706 171.766 33.703 172.836 33.703C173.906 33.703 174.774 34.5706 174.774 35.6405Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M170.051 35.6405C170.051 36.7105 169.183 37.5781 168.113 37.5781C167.043 37.5781 166.176 36.7105 166.176 35.6405C166.176 34.5706 167.043 33.703 168.113 33.703C169.183 33.703 170.051 34.5706 170.051 35.6405Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M170.05 30.9179C170.05 31.9879 169.183 32.8555 168.113 32.8555C167.043 32.8555 166.175 31.9879 166.175 30.9179C166.175 29.8479 167.043 28.9803 168.113 28.9803C169.183 28.9803 170.05 29.8479 170.05 30.9179Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M160.604 30.9179C160.604 31.9879 159.737 32.8555 158.667 32.8555C157.597 32.8555 156.729 31.9879 156.729 30.9179C156.729 29.8479 157.597 28.9803 158.667 28.9803C159.737 28.9803 160.604 29.8479 160.604 30.9179Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M160.604 26.1952C160.604 27.2652 159.737 28.1328 158.667 28.1328C157.597 28.1328 156.729 27.2652 156.729 26.1952C156.729 25.1252 157.597 24.2576 158.667 24.2576C159.737 24.2576 160.604 25.1252 160.604 26.1952Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M188.943 16.746C188.943 17.816 188.075 18.6836 187.005 18.6836C185.935 18.6836 185.068 17.816 185.068 16.746C185.068 15.676 185.935 14.8084 187.005 14.8084C188.075 14.8084 188.943 15.676 188.943 16.746Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M136.988 16.746C136.988 17.816 136.121 18.6836 135.051 18.6836C133.981 18.6836 133.113 17.816 133.113 16.746C133.113 15.676 133.981 14.8084 135.051 14.8084C136.121 14.8084 136.988 15.676 136.988 16.746Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M132.265 21.4687C132.265 22.5386 131.398 23.4062 130.328 23.4062C129.258 23.4062 128.39 22.5386 128.39 21.4687C128.39 20.3987 129.258 19.5311 130.328 19.5311C131.398 19.5311 132.265 20.3987 132.265 21.4687Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M146.435 30.9179C146.435 31.9879 145.567 32.8555 144.497 32.8555C143.427 32.8555 142.56 31.9879 142.56 30.9179C142.56 29.8479 143.427 28.9803 144.497 28.9803C145.567 28.9803 146.435 29.8479 146.435 30.9179Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M151.158 30.9179C151.158 31.9879 150.29 32.8555 149.22 32.8555C148.15 32.8555 147.283 31.9879 147.283 30.9179C147.283 29.8479 148.15 28.9803 149.22 28.9803C150.29 28.9803 151.158 29.8479 151.158 30.9179Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M151.158 26.1952C151.158 27.2652 150.29 28.1328 149.22 28.1328C148.15 28.1328 147.283 27.2652 147.283 26.1952C147.283 25.1252 148.15 24.2576 149.22 24.2576C150.29 24.2576 151.158 25.1252 151.158 26.1952Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M132.265 45.0859C132.265 46.1558 131.398 47.0234 130.328 47.0234C129.258 47.0234 128.39 46.1558 128.39 45.0859C128.39 44.0159 129.258 43.1483 130.328 43.1483C131.398 43.1483 132.265 44.0159 132.265 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M136.988 45.0859C136.988 46.1558 136.121 47.0234 135.051 47.0234C133.981 47.0234 133.113 46.1558 133.113 45.0859C133.113 44.0159 133.981 43.1483 135.051 43.1483C136.121 43.1483 136.988 44.0159 136.988 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M127.542 45.0859C127.542 46.1558 126.675 47.0234 125.605 47.0234C124.535 47.0234 123.667 46.1558 123.667 45.0859C123.667 44.0159 124.535 43.1483 125.605 43.1483C126.675 43.1483 127.542 44.0159 127.542 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M127.542 40.3632C127.542 41.4332 126.675 42.3008 125.605 42.3008C124.535 42.3008 123.667 41.4332 123.667 40.3632C123.667 39.2932 124.535 38.4256 125.605 38.4256C126.675 38.4256 127.542 39.2932 127.542 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M127.542 30.9179C127.542 31.9879 126.675 32.8555 125.605 32.8555C124.535 32.8555 123.667 31.9879 123.667 30.9179C123.667 29.8479 124.535 28.9803 125.605 28.9803C126.675 28.9803 127.542 29.8479 127.542 30.9179Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M127.542 35.6405C127.542 36.7105 126.675 37.5781 125.605 37.5781C124.535 37.5781 123.667 36.7105 123.667 35.6405C123.667 34.5706 124.535 33.703 125.605 33.703C126.675 33.703 127.542 34.5706 127.542 35.6405Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M132.265 35.6405C132.265 36.7105 131.398 37.5781 130.328 37.5781C129.258 37.5781 128.39 36.7105 128.39 35.6405C128.39 34.5706 129.258 33.703 130.328 33.703C131.398 33.703 132.265 34.5706 132.265 35.6405Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M122.819 35.6405C122.819 36.7105 121.951 37.5781 120.881 37.5781C119.811 37.5781 118.944 36.7105 118.944 35.6405C118.944 34.5706 119.811 33.703 120.881 33.703C121.951 33.703 122.819 34.5706 122.819 35.6405Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M118.096 40.3632C118.096 41.4332 117.228 42.3008 116.158 42.3008C115.088 42.3008 114.221 41.4332 114.221 40.3632C114.221 39.2932 115.088 38.4256 116.158 38.4256C117.228 38.4256 118.096 39.2932 118.096 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M132.265 40.3632C132.265 41.4332 131.398 42.3008 130.328 42.3008C129.258 42.3008 128.39 41.4332 128.39 40.3632C128.39 39.2932 129.258 38.4256 130.328 38.4256C131.398 38.4256 132.265 39.2932 132.265 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M118.096 59.2538C118.096 60.3238 117.228 61.1914 116.158 61.1914C115.088 61.1914 114.221 60.3238 114.221 59.2538C114.221 58.1838 115.088 57.3162 116.158 57.3162C117.228 57.3162 118.096 58.1838 118.096 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M118.096 63.9804C118.096 65.0504 117.228 65.918 116.158 65.918C115.088 65.918 114.221 65.0504 114.221 63.9804C114.221 62.9104 115.088 62.0428 116.158 62.0428C117.228 62.0428 118.096 62.9104 118.096 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M122.819 63.9804C122.819 65.0504 121.951 65.918 120.881 65.918C119.811 65.918 118.944 65.0504 118.944 63.9804C118.944 62.9104 119.811 62.0428 120.881 62.0428C121.951 62.0428 122.819 62.9104 122.819 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M127.542 63.9804C127.542 65.0504 126.675 65.918 125.605 65.918C124.535 65.918 123.667 65.0504 123.667 63.9804C123.667 62.9104 124.535 62.0428 125.605 62.0428C126.675 62.0428 127.542 62.9104 127.542 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M127.542 59.2538C127.542 60.3238 126.675 61.1914 125.605 61.1914C124.535 61.1914 123.667 60.3238 123.667 59.2538C123.667 58.1838 124.535 57.3162 125.605 57.3162C126.675 57.3162 127.542 58.1838 127.542 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M122.819 68.703C122.819 69.773 121.951 70.6406 120.881 70.6406C119.811 70.6406 118.944 69.773 118.944 68.703C118.944 67.6331 119.811 66.7655 120.881 66.7655C121.951 66.7655 122.819 67.6331 122.819 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M127.542 68.703C127.542 69.773 126.675 70.6406 125.605 70.6406C124.535 70.6406 123.667 69.773 123.667 68.703C123.667 67.6331 124.535 66.7655 125.605 66.7655C126.675 66.7655 127.542 67.6331 127.542 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M127.542 73.4257C127.542 74.4957 126.675 75.3633 125.605 75.3633C124.535 75.3633 123.667 74.4957 123.667 73.4257C123.667 72.3557 124.535 71.4881 125.605 71.4881C126.675 71.4881 127.542 72.3557 127.542 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M127.542 78.1484C127.542 79.2183 126.675 80.0859 125.605 80.0859C124.535 80.0859 123.667 79.2183 123.667 78.1484C123.667 77.0784 124.535 76.2108 125.605 76.2108C126.675 76.2108 127.542 77.0784 127.542 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M127.542 82.871C127.542 83.941 126.675 84.8086 125.605 84.8086C124.535 84.8086 123.667 83.941 123.667 82.871C123.667 81.801 124.535 80.9334 125.605 80.9334C126.675 80.9334 127.542 81.801 127.542 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M132.265 73.4257C132.265 74.4957 131.398 75.3633 130.328 75.3633C129.258 75.3633 128.39 74.4957 128.39 73.4257C128.39 72.3557 129.258 71.4881 130.328 71.4881C131.398 71.4881 132.265 72.3557 132.265 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M132.265 78.1484C132.265 79.2183 131.398 80.0859 130.328 80.0859C129.258 80.0859 128.39 79.2183 128.39 78.1484C128.39 77.0784 129.258 76.2108 130.328 76.2108C131.398 76.2108 132.265 77.0784 132.265 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M132.265 68.703C132.265 69.773 131.398 70.6406 130.328 70.6406C129.258 70.6406 128.39 69.773 128.39 68.703C128.39 67.6331 129.258 66.7655 130.328 66.7655C131.398 66.7655 132.265 67.6331 132.265 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M132.265 63.9804C132.265 65.0504 131.398 65.918 130.328 65.918C129.258 65.918 128.39 65.0504 128.39 63.9804C128.39 62.9104 129.258 62.0428 130.328 62.0428C131.398 62.0428 132.265 62.9104 132.265 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M132.265 59.2538C132.265 60.3238 131.398 61.1914 130.328 61.1914C129.258 61.1914 128.39 60.3238 128.39 59.2538C128.39 58.1838 129.258 57.3162 130.328 57.3162C131.398 57.3162 132.265 58.1838 132.265 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M136.988 63.9804C136.988 65.0504 136.121 65.918 135.051 65.918C133.981 65.918 133.113 65.0504 133.113 63.9804C133.113 62.9104 133.981 62.0428 135.051 62.0428C136.121 62.0428 136.988 62.9104 136.988 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M141.712 63.9804C141.712 65.0504 140.844 65.918 139.774 65.918C138.704 65.918 137.836 65.0504 137.836 63.9804C137.836 62.9104 138.704 62.0428 139.774 62.0428C140.844 62.0428 141.712 62.9104 141.712 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M136.988 68.703C136.988 69.773 136.121 70.6406 135.051 70.6406C133.981 70.6406 133.113 69.773 133.113 68.703C133.113 67.6331 133.981 66.7655 135.051 66.7655C136.121 66.7655 136.988 67.6331 136.988 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M136.988 73.4257C136.988 74.4957 136.121 75.3633 135.051 75.3633C133.981 75.3633 133.113 74.4957 133.113 73.4257C133.113 72.3557 133.981 71.4881 135.051 71.4881C136.121 71.4881 136.988 72.3557 136.988 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M141.712 68.703C141.712 69.773 140.844 70.6406 139.774 70.6406C138.704 70.6406 137.836 69.773 137.836 68.703C137.836 67.6331 138.704 66.7655 139.774 66.7655C140.844 66.7655 141.712 67.6331 141.712 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M146.435 63.9804C146.435 65.0504 145.567 65.918 144.497 65.918C143.427 65.918 142.56 65.0504 142.56 63.9804C142.56 62.9104 143.427 62.0428 144.497 62.0428C145.567 62.0428 146.435 62.9104 146.435 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M146.435 59.2538C146.435 60.3238 145.567 61.1914 144.497 61.1914C143.427 61.1914 142.56 60.3238 142.56 59.2538C142.56 58.1838 143.427 57.3162 144.497 57.3162C145.567 57.3162 146.435 58.1838 146.435 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M151.158 68.703C151.158 69.773 150.29 70.6406 149.22 70.6406C148.15 70.6406 147.283 69.773 147.283 68.703C147.283 67.6331 148.15 66.7655 149.22 66.7655C150.29 66.7655 151.158 67.6331 151.158 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M146.435 68.703C146.435 69.773 145.567 70.6406 144.497 70.6406C143.427 70.6406 142.56 69.773 142.56 68.703C142.56 67.6331 143.427 66.7655 144.497 66.7655C145.567 66.7655 146.435 67.6331 146.435 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M146.435 73.4257C146.435 74.4957 145.567 75.3633 144.497 75.3633C143.427 75.3633 142.56 74.4957 142.56 73.4257C142.56 72.3557 143.427 71.4881 144.497 71.4881C145.567 71.4881 146.435 72.3557 146.435 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M146.435 78.1484C146.435 79.2183 145.567 80.0859 144.497 80.0859C143.427 80.0859 142.56 79.2183 142.56 78.1484C142.56 77.0784 143.427 76.2108 144.497 76.2108C145.567 76.2108 146.435 77.0784 146.435 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M141.712 78.1484C141.712 79.2183 140.844 80.0859 139.774 80.0859C138.704 80.0859 137.836 79.2183 137.836 78.1484C137.836 77.0784 138.704 76.2108 139.774 76.2108C140.844 76.2108 141.712 77.0784 141.712 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M141.712 82.871C141.712 83.941 140.844 84.8086 139.774 84.8086C138.704 84.8086 137.836 83.941 137.836 82.871C137.836 81.801 138.704 80.9334 139.774 80.9334C140.844 80.9334 141.712 81.801 141.712 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M155.881 63.9804C155.881 65.0504 155.013 65.918 153.943 65.918C152.873 65.918 152.006 65.0504 152.006 63.9804C152.006 62.9104 152.873 62.0428 153.943 62.0428C155.013 62.0428 155.881 62.9104 155.881 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M151.158 63.9804C151.158 65.0504 150.29 65.918 149.22 65.918C148.15 65.918 147.283 65.0504 147.283 63.9804C147.283 62.9104 148.15 62.0428 149.22 62.0428C150.29 62.0428 151.158 62.9104 151.158 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M155.881 68.703C155.881 69.773 155.013 70.6406 153.943 70.6406C152.873 70.6406 152.006 69.773 152.006 68.703C152.006 67.6331 152.873 66.7655 153.943 66.7655C155.013 66.7655 155.881 67.6331 155.881 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M160.604 68.703C160.604 69.773 159.737 70.6406 158.667 70.6406C157.597 70.6406 156.729 69.773 156.729 68.703C156.729 67.6331 157.597 66.7655 158.667 66.7655C159.737 66.7655 160.604 67.6331 160.604 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M160.604 78.1484C160.604 79.2183 159.737 80.0859 158.667 80.0859C157.597 80.0859 156.729 79.2183 156.729 78.1484C156.729 77.0784 157.597 76.2108 158.667 76.2108C159.737 76.2108 160.604 77.0784 160.604 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M165.328 68.703C165.328 69.773 164.46 70.6406 163.39 70.6406C162.32 70.6406 161.452 69.773 161.452 68.703C161.452 67.6331 162.32 66.7655 163.39 66.7655C164.46 66.7655 165.328 67.6331 165.328 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M165.328 63.9804C165.328 65.0504 164.46 65.918 163.39 65.918C162.32 65.918 161.452 65.0504 161.452 63.9804C161.452 62.9104 162.32 62.0428 163.39 62.0428C164.46 62.0428 165.328 62.9104 165.328 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M155.881 54.5312C155.881 55.6011 155.013 56.4688 153.943 56.4688C152.873 56.4688 152.006 55.6011 152.006 54.5312C152.006 53.4612 152.873 52.5936 153.943 52.5936C155.013 52.5936 155.881 53.4612 155.881 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M165.328 54.5312C165.328 55.6011 164.46 56.4688 163.39 56.4688C162.32 56.4688 161.452 55.6011 161.452 54.5312C161.452 53.4612 162.32 52.5936 163.39 52.5936C164.46 52.5936 165.328 53.4612 165.328 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M170.051 54.5312C170.051 55.6011 169.183 56.4688 168.113 56.4688C167.043 56.4688 166.176 55.6011 166.176 54.5312C166.176 53.4612 167.043 52.5936 168.113 52.5936C169.183 52.5936 170.051 53.4612 170.051 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M170.051 59.2538C170.051 60.3238 169.183 61.1914 168.113 61.1914C167.043 61.1914 166.176 60.3238 166.176 59.2538C166.176 58.1838 167.043 57.3162 168.113 57.3162C169.183 57.3162 170.051 58.1838 170.051 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M174.774 54.5312C174.774 55.6011 173.906 56.4688 172.836 56.4688C171.766 56.4688 170.899 55.6011 170.899 54.5312C170.899 53.4612 171.766 52.5936 172.836 52.5936C173.906 52.5936 174.774 53.4612 174.774 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M174.774 49.8085C174.774 50.8785 173.906 51.7461 172.836 51.7461C171.766 51.7461 170.899 50.8785 170.899 49.8085C170.899 48.7385 171.766 47.8709 172.836 47.8709C173.906 47.8709 174.774 48.7385 174.774 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M179.497 49.8085C179.497 50.8785 178.629 51.7461 177.559 51.7461C176.489 51.7461 175.622 50.8785 175.622 49.8085C175.622 48.7385 176.489 47.8709 177.559 47.8709C178.629 47.8709 179.497 48.7385 179.497 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M179.497 54.5312C179.497 55.6011 178.629 56.4688 177.559 56.4688C176.489 56.4688 175.622 55.6011 175.622 54.5312C175.622 53.4612 176.489 52.5936 177.559 52.5936C178.629 52.5936 179.497 53.4612 179.497 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M179.497 59.2538C179.497 60.3238 178.629 61.1914 177.559 61.1914C176.489 61.1914 175.622 60.3238 175.622 59.2538C175.622 58.1838 176.489 57.3162 177.559 57.3162C178.629 57.3162 179.497 58.1838 179.497 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M184.22 59.2538C184.22 60.3238 183.353 61.1914 182.283 61.1914C181.213 61.1914 180.345 60.3238 180.345 59.2538C180.345 58.1838 181.213 57.3162 182.283 57.3162C183.353 57.3162 184.22 58.1838 184.22 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M184.22 63.9804C184.22 65.0504 183.353 65.918 182.283 65.918C181.213 65.918 180.345 65.0504 180.345 63.9804C180.345 62.9104 181.213 62.0428 182.283 62.0428C183.353 62.0428 184.22 62.9104 184.22 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M188.943 63.9804C188.943 65.0504 188.076 65.918 187.006 65.918C185.936 65.918 185.068 65.0504 185.068 63.9804C185.068 62.9104 185.936 62.0428 187.006 62.0428C188.076 62.0428 188.943 62.9104 188.943 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M184.22 68.703C184.22 69.773 183.353 70.6406 182.283 70.6406C181.213 70.6406 180.345 69.773 180.345 68.703C180.345 67.6331 181.213 66.7655 182.283 66.7655C183.353 66.7655 184.22 67.6331 184.22 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M174.774 68.703C174.774 69.773 173.906 70.6406 172.836 70.6406C171.766 70.6406 170.899 69.773 170.899 68.703C170.899 67.6331 171.766 66.7655 172.836 66.7655C173.906 66.7655 174.774 67.6331 174.774 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M184.22 73.4257C184.22 74.4957 183.353 75.3633 182.283 75.3633C181.213 75.3633 180.345 74.4957 180.345 73.4257C180.345 72.3557 181.213 71.4881 182.283 71.4881C183.353 71.4881 184.22 72.3557 184.22 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M179.497 73.4257C179.497 74.4957 178.629 75.3633 177.559 75.3633C176.489 75.3633 175.622 74.4957 175.622 73.4257C175.622 72.3557 176.489 71.4881 177.559 71.4881C178.629 71.4881 179.497 72.3557 179.497 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M188.943 73.4257C188.943 74.4957 188.076 75.3633 187.006 75.3633C185.936 75.3633 185.068 74.4957 185.068 73.4257C185.068 72.3557 185.936 71.4881 187.006 71.4881C188.076 71.4881 188.943 72.3557 188.943 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M193.666 78.1484C193.666 79.2183 192.799 80.0859 191.729 80.0859C190.659 80.0859 189.791 79.2183 189.791 78.1484C189.791 77.0784 190.659 76.2108 191.729 76.2108C192.799 76.2108 193.666 77.0784 193.666 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M184.22 78.1484C184.22 79.2183 183.353 80.0859 182.283 80.0859C181.213 80.0859 180.345 79.2183 180.345 78.1484C180.345 77.0784 181.213 76.2108 182.283 76.2108C183.353 76.2108 184.22 77.0784 184.22 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M179.497 78.1484C179.497 79.2183 178.629 80.0859 177.559 80.0859C176.489 80.0859 175.622 79.2183 175.622 78.1484C175.622 77.0784 176.489 76.2108 177.559 76.2108C178.629 76.2108 179.497 77.0784 179.497 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M179.497 82.871C179.497 83.941 178.629 84.8086 177.559 84.8086C176.489 84.8086 175.622 83.941 175.622 82.871C175.622 81.801 176.489 80.9334 177.559 80.9334C178.629 80.9334 179.497 81.801 179.497 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M184.22 82.871C184.22 83.941 183.353 84.8086 182.283 84.8086C181.213 84.8086 180.345 83.941 180.345 82.871C180.345 81.801 181.213 80.9334 182.283 80.9334C183.353 80.9334 184.22 81.801 184.22 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M184.22 87.5937C184.22 88.6636 183.353 89.5312 182.283 89.5312C181.213 89.5312 180.345 88.6636 180.345 87.5937C180.345 86.5237 181.213 85.6561 182.283 85.6561C183.353 85.6561 184.22 86.5237 184.22 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M174.774 78.1484C174.774 79.2183 173.906 80.0859 172.836 80.0859C171.766 80.0859 170.899 79.2183 170.899 78.1484C170.899 77.0784 171.766 76.2108 172.836 76.2108C173.906 76.2108 174.774 77.0784 174.774 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M170.051 78.1484C170.051 79.2183 169.183 80.0859 168.113 80.0859C167.043 80.0859 166.176 79.2183 166.176 78.1484C166.176 77.0784 167.043 76.2108 168.113 76.2108C169.183 76.2108 170.051 77.0784 170.051 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M165.328 49.8085C165.328 50.8785 164.46 51.7461 163.39 51.7461C162.32 51.7461 161.452 50.8785 161.452 49.8085C161.452 48.7385 162.32 47.8709 163.39 47.8709C164.46 47.8709 165.328 48.7385 165.328 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M170.051 45.0859C170.051 46.1558 169.183 47.0234 168.113 47.0234C167.043 47.0234 166.176 46.1558 166.176 45.0859C166.176 44.0159 167.043 43.1483 168.113 43.1483C169.183 43.1483 170.051 44.0159 170.051 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M155.881 49.8085C155.881 50.8785 155.013 51.7461 153.943 51.7461C152.873 51.7461 152.006 50.8785 152.006 49.8085C152.006 48.7385 152.873 47.8709 153.943 47.8709C155.013 47.8709 155.881 48.7385 155.881 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M151.158 45.0859C151.158 46.1558 150.29 47.0234 149.22 47.0234C148.15 47.0234 147.283 46.1558 147.283 45.0859C147.283 44.0159 148.15 43.1483 149.22 43.1483C150.29 43.1483 151.158 44.0159 151.158 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M155.881 40.3632C155.881 41.4332 155.013 42.3008 153.943 42.3008C152.873 42.3008 152.006 41.4332 152.006 40.3632C152.006 39.2932 152.873 38.4256 153.943 38.4256C155.013 38.4256 155.881 39.2932 155.881 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M165.328 40.3632C165.328 41.4332 164.46 42.3008 163.39 42.3008C162.32 42.3008 161.452 41.4332 161.452 40.3632C161.452 39.2932 162.32 38.4256 163.39 38.4256C164.46 38.4256 165.328 39.2932 165.328 40.3632Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M160.604 45.0859C160.604 46.1558 159.737 47.0234 158.667 47.0234C157.597 47.0234 156.729 46.1558 156.729 45.0859C156.729 44.0159 157.597 43.1483 158.667 43.1483C159.737 43.1483 160.604 44.0159 160.604 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M151.158 73.4257C151.158 74.4957 150.29 75.3633 149.22 75.3633C148.15 75.3633 147.283 74.4957 147.283 73.4257C147.283 72.3557 148.15 71.4881 149.22 71.4881C150.29 71.4881 151.158 72.3557 151.158 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M155.881 78.1484C155.881 79.2183 155.013 80.0859 153.943 80.0859C152.873 80.0859 152.006 79.2183 152.006 78.1484C152.006 77.0784 152.873 76.2108 153.943 76.2108C155.013 76.2108 155.881 77.0784 155.881 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M113.373 49.8085C113.373 50.8785 112.505 51.7461 111.435 51.7461C110.365 51.7461 109.498 50.8785 109.498 49.8085C109.498 48.7385 110.365 47.8709 111.435 47.8709C112.505 47.8709 113.373 48.7385 113.373 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M94.4799 49.8085C94.4799 50.8785 93.6123 51.7461 92.5423 51.7461C91.4723 51.7461 90.6047 50.8785 90.6047 49.8085C90.6047 48.7385 91.4723 47.8709 92.5423 47.8709C93.6123 47.8709 94.4799 48.7385 94.4799 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M89.7569 59.2538C89.7569 60.3238 88.8893 61.1914 87.8193 61.1914C86.7493 61.1914 85.8817 60.3238 85.8817 59.2538C85.8817 58.1838 86.7493 57.3162 87.8193 57.3162C88.8893 57.3162 89.7569 58.1838 89.7569 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M94.4799 59.2538C94.4799 60.3238 93.6123 61.1914 92.5423 61.1914C91.4723 61.1914 90.6047 60.3238 90.6047 59.2538C90.6047 58.1838 91.4723 57.3162 92.5423 57.3162C93.6123 57.3162 94.4799 58.1838 94.4799 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M99.2033 59.2538C99.2033 60.3238 98.3357 61.1914 97.2657 61.1914C96.1957 61.1914 95.3281 60.3238 95.3281 59.2538C95.3281 58.1838 96.1957 57.3162 97.2657 57.3162C98.3357 57.3162 99.2033 58.1838 99.2033 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M99.2033 63.9804C99.2033 65.0504 98.3357 65.918 97.2657 65.918C96.1957 65.918 95.3281 65.0504 95.3281 63.9804C95.3281 62.9104 96.1957 62.0428 97.2657 62.0428C98.3357 62.0428 99.2033 62.9104 99.2033 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M103.926 63.9804C103.926 65.0504 103.059 65.918 101.989 65.918C100.919 65.918 100.051 65.0504 100.051 63.9804C100.051 62.9104 100.919 62.0428 101.989 62.0428C103.059 62.0428 103.926 62.9104 103.926 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M99.2033 68.703C99.2033 69.773 98.3357 70.6406 97.2657 70.6406C96.1957 70.6406 95.3281 69.773 95.3281 68.703C95.3281 67.6331 96.1957 66.7655 97.2657 66.7655C98.3357 66.7655 99.2033 67.6331 99.2033 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M103.926 68.703C103.926 69.773 103.059 70.6406 101.989 70.6406C100.919 70.6406 100.051 69.773 100.051 68.703C100.051 67.6331 100.919 66.7655 101.989 66.7655C103.059 66.7655 103.926 67.6331 103.926 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M108.65 68.703C108.65 69.773 107.782 70.6406 106.712 70.6406C105.642 70.6406 104.774 69.773 104.774 68.703C104.774 67.6331 105.642 66.7655 106.712 66.7655C107.782 66.7655 108.65 67.6331 108.65 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M113.373 68.703C113.373 69.773 112.505 70.6406 111.435 70.6406C110.365 70.6406 109.498 69.773 109.498 68.703C109.498 67.6331 110.365 66.7655 111.435 66.7655C112.505 66.7655 113.373 67.6331 113.373 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M113.373 73.4257C113.373 74.4957 112.505 75.3633 111.435 75.3633C110.365 75.3633 109.498 74.4957 109.498 73.4257C109.498 72.3557 110.365 71.4881 111.435 71.4881C112.505 71.4881 113.373 72.3557 113.373 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M118.096 73.4257C118.096 74.4957 117.228 75.3633 116.158 75.3633C115.088 75.3633 114.221 74.4957 114.221 73.4257C114.221 72.3557 115.088 71.4881 116.158 71.4881C117.228 71.4881 118.096 72.3557 118.096 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M118.096 68.703C118.096 69.773 117.228 70.6406 116.158 70.6406C115.088 70.6406 114.221 69.773 114.221 68.703C114.221 67.6331 115.088 66.7655 116.158 66.7655C117.228 66.7655 118.096 67.6331 118.096 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M85.0337 59.2538C85.0337 60.3238 84.1661 61.1914 83.0962 61.1914C82.0262 61.1914 81.1586 60.3238 81.1586 59.2538C81.1586 58.1838 82.0262 57.3162 83.0962 57.3162C84.1661 57.3162 85.0337 58.1838 85.0337 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M80.3105 59.2538C80.3105 60.3238 79.4429 61.1914 78.3729 61.1914C77.3029 61.1914 76.4353 60.3238 76.4353 59.2538C76.4353 58.1838 77.3029 57.3162 78.3729 57.3162C79.4429 57.3162 80.3105 58.1838 80.3105 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M75.5873 59.2538C75.5873 60.3238 74.7197 61.1914 73.6497 61.1914C72.5798 61.1914 71.7122 60.3238 71.7122 59.2538C71.7122 58.1838 72.5798 57.3162 73.6497 57.3162C74.7197 57.3162 75.5873 58.1838 75.5873 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M75.5873 63.9804C75.5873 65.0504 74.7197 65.918 73.6497 65.918C72.5798 65.918 71.7122 65.0504 71.7122 63.9804C71.7122 62.9104 72.5798 62.0428 73.6497 62.0428C74.7197 62.0428 75.5873 62.9104 75.5873 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M80.3105 63.9804C80.3105 65.0504 79.4429 65.918 78.3729 65.918C77.3029 65.918 76.4353 65.0504 76.4353 63.9804C76.4353 62.9104 77.3029 62.0428 78.3729 62.0428C79.4429 62.0428 80.3105 62.9104 80.3105 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M85.0337 63.9804C85.0337 65.0504 84.1661 65.918 83.0962 65.918C82.0262 65.918 81.1586 65.0504 81.1586 63.9804C81.1586 62.9104 82.0262 62.0428 83.0962 62.0428C84.1661 62.0428 85.0337 62.9104 85.0337 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M89.7569 63.9804C89.7569 65.0504 88.8893 65.918 87.8193 65.918C86.7493 65.918 85.8817 65.0504 85.8817 63.9804C85.8817 62.9104 86.7493 62.0428 87.8193 62.0428C88.8893 62.0428 89.7569 62.9104 89.7569 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M94.4799 63.9804C94.4799 65.0504 93.6123 65.918 92.5423 65.918C91.4723 65.918 90.6047 65.0504 90.6047 63.9804C90.6047 62.9104 91.4723 62.0428 92.5423 62.0428C93.6123 62.0428 94.4799 62.9104 94.4799 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M94.4799 68.703C94.4799 69.773 93.6123 70.6406 92.5423 70.6406C91.4723 70.6406 90.6047 69.773 90.6047 68.703C90.6047 67.6331 91.4723 66.7655 92.5423 66.7655C93.6123 66.7655 94.4799 67.6331 94.4799 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M89.7569 68.703C89.7569 69.773 88.8893 70.6406 87.8193 70.6406C86.7493 70.6406 85.8817 69.773 85.8817 68.703C85.8817 67.6331 86.7493 66.7655 87.8193 66.7655C88.8893 66.7655 89.7569 67.6331 89.7569 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M89.7569 73.4257C89.7569 74.4957 88.8893 75.3633 87.8193 75.3633C86.7493 75.3633 85.8817 74.4957 85.8817 73.4257C85.8817 72.3557 86.7493 71.4881 87.8193 71.4881C88.8893 71.4881 89.7569 72.3557 89.7569 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M94.4799 73.4257C94.4799 74.4957 93.6123 75.3633 92.5423 75.3633C91.4723 75.3633 90.6047 74.4957 90.6047 73.4257C90.6047 72.3557 91.4723 71.4881 92.5423 71.4881C93.6123 71.4881 94.4799 72.3557 94.4799 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M99.2033 73.4257C99.2033 74.4957 98.3357 75.3633 97.2657 75.3633C96.1957 75.3633 95.3281 74.4957 95.3281 73.4257C95.3281 72.3557 96.1957 71.4881 97.2657 71.4881C98.3357 71.4881 99.2033 72.3557 99.2033 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M103.926 73.4257C103.926 74.4957 103.059 75.3633 101.989 75.3633C100.919 75.3633 100.051 74.4957 100.051 73.4257C100.051 72.3557 100.919 71.4881 101.989 71.4881C103.059 71.4881 103.926 72.3557 103.926 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M103.926 78.1484C103.926 79.2183 103.059 80.0859 101.989 80.0859C100.919 80.0859 100.051 79.2183 100.051 78.1484C100.051 77.0784 100.919 76.2108 101.989 76.2108C103.059 76.2108 103.926 77.0784 103.926 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M108.65 78.1484C108.65 79.2183 107.782 80.0859 106.712 80.0859C105.642 80.0859 104.774 79.2183 104.774 78.1484C104.774 77.0784 105.642 76.2108 106.712 76.2108C107.782 76.2108 108.65 77.0784 108.65 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M99.2033 78.1484C99.2033 79.2183 98.3357 80.0859 97.2657 80.0859C96.1957 80.0859 95.3281 79.2183 95.3281 78.1484C95.3281 77.0784 96.1957 76.2108 97.2657 76.2108C98.3357 76.2108 99.2033 77.0784 99.2033 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M99.2033 82.871C99.2033 83.941 98.3357 84.8086 97.2657 84.8086C96.1957 84.8086 95.3281 83.941 95.3281 82.871C95.3281 81.801 96.1957 80.9334 97.2657 80.9334C98.3357 80.9334 99.2033 81.801 99.2033 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M99.2033 87.5937C99.2033 88.6636 98.3357 89.5312 97.2657 89.5312C96.1957 89.5312 95.3281 88.6636 95.3281 87.5937C95.3281 86.5237 96.1957 85.6561 97.2657 85.6561C98.3357 85.6561 99.2033 86.5237 99.2033 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M99.2033 92.3163C99.2033 93.3863 98.3357 94.2539 97.2657 94.2539C96.1957 94.2539 95.3281 93.3863 95.3281 92.3163C95.3281 91.2463 96.1957 90.3787 97.2657 90.3787C98.3357 90.3787 99.2033 91.2463 99.2033 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M99.2033 97.0429C99.2033 98.1129 98.3357 98.9805 97.2657 98.9805C96.1957 98.9805 95.3281 98.1129 95.3281 97.0429C95.3281 95.9729 96.1957 95.1053 97.2657 95.1053C98.3357 95.1053 99.2033 95.9729 99.2033 97.0429Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M99.2033 101.766C99.2033 102.836 98.3357 103.703 97.2657 103.703C96.1957 103.703 95.3281 102.836 95.3281 101.766C95.3281 100.696 96.1957 99.828 97.2657 99.828C98.3357 99.828 99.2033 100.696 99.2033 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M103.926 101.766C103.926 102.836 103.059 103.703 101.989 103.703C100.919 103.703 100.051 102.836 100.051 101.766C100.051 100.696 100.919 99.828 101.989 99.828C103.059 99.828 103.926 100.696 103.926 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M103.926 97.0429C103.926 98.1129 103.059 98.9805 101.989 98.9805C100.919 98.9805 100.051 98.1129 100.051 97.0429C100.051 95.9729 100.919 95.1053 101.989 95.1053C103.059 95.1053 103.926 95.9729 103.926 97.0429Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M103.926 92.3163C103.926 93.3863 103.059 94.2539 101.989 94.2539C100.919 94.2539 100.051 93.3863 100.051 92.3163C100.051 91.2463 100.919 90.3787 101.989 90.3787C103.059 90.3787 103.926 91.2463 103.926 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M103.926 87.5937C103.926 88.6636 103.059 89.5312 101.989 89.5312C100.919 89.5312 100.051 88.6636 100.051 87.5937C100.051 86.5237 100.919 85.6561 101.989 85.6561C103.059 85.6561 103.926 86.5237 103.926 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M108.65 87.5937C108.65 88.6636 107.782 89.5312 106.712 89.5312C105.642 89.5312 104.774 88.6636 104.774 87.5937C104.774 86.5237 105.642 85.6561 106.712 85.6561C107.782 85.6561 108.65 86.5237 108.65 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M108.65 92.3163C108.65 93.3863 107.782 94.2539 106.712 94.2539C105.642 94.2539 104.774 93.3863 104.774 92.3163C104.774 91.2463 105.642 90.3787 106.712 90.3787C107.782 90.3787 108.65 91.2463 108.65 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M108.65 97.0429C108.65 98.1129 107.782 98.9805 106.712 98.9805C105.642 98.9805 104.774 98.1129 104.774 97.0429C104.774 95.9729 105.642 95.1053 106.712 95.1053C107.782 95.1053 108.65 95.9729 108.65 97.0429Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M113.373 97.0429C113.373 98.1129 112.505 98.9805 111.435 98.9805C110.365 98.9805 109.498 98.1129 109.498 97.0429C109.498 95.9729 110.365 95.1053 111.435 95.1053C112.505 95.1053 113.373 95.9729 113.373 97.0429Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M118.096 97.0429C118.096 98.1129 117.228 98.9805 116.158 98.9805C115.088 98.9805 114.221 98.1129 114.221 97.0429C114.221 95.9729 115.088 95.1053 116.158 95.1053C117.228 95.1053 118.096 95.9729 118.096 97.0429Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M122.819 97.0429C122.819 98.1129 121.951 98.9805 120.881 98.9805C119.811 98.9805 118.944 98.1129 118.944 97.0429C118.944 95.9729 119.811 95.1053 120.881 95.1053C121.951 95.1053 122.819 95.9729 122.819 97.0429Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M118.096 92.3163C118.096 93.3863 117.228 94.2539 116.158 94.2539C115.088 94.2539 114.221 93.3863 114.221 92.3163C114.221 91.2463 115.088 90.3787 116.158 90.3787C117.228 90.3787 118.096 91.2463 118.096 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M113.373 92.3163C113.373 93.3863 112.505 94.2539 111.435 94.2539C110.365 94.2539 109.498 93.3863 109.498 92.3163C109.498 91.2463 110.365 90.3787 111.435 90.3787C112.505 90.3787 113.373 91.2463 113.373 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M127.542 87.5937C127.542 88.6636 126.675 89.5312 125.605 89.5312C124.535 89.5312 123.667 88.6636 123.667 87.5937C123.667 86.5237 124.535 85.6561 125.605 85.6561C126.675 85.6561 127.542 86.5237 127.542 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M127.542 92.3163C127.542 93.3863 126.675 94.2539 125.605 94.2539C124.535 94.2539 123.667 93.3863 123.667 92.3163C123.667 91.2463 124.535 90.3787 125.605 90.3787C126.675 90.3787 127.542 91.2463 127.542 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M113.373 87.5937C113.373 88.6636 112.505 89.5312 111.435 89.5312C110.365 89.5312 109.498 88.6636 109.498 87.5937C109.498 86.5237 110.365 85.6561 111.435 85.6561C112.505 85.6561 113.373 86.5237 113.373 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M113.373 82.871C113.373 83.941 112.505 84.8086 111.435 84.8086C110.365 84.8086 109.498 83.941 109.498 82.871C109.498 81.801 110.365 80.9334 111.435 80.9334C112.505 80.9334 113.373 81.801 113.373 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M122.819 82.871C122.819 83.941 121.951 84.8086 120.881 84.8086C119.811 84.8086 118.944 83.941 118.944 82.871C118.944 81.801 119.811 80.9334 120.881 80.9334C121.951 80.9334 122.819 81.801 122.819 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M118.096 82.871C118.096 83.941 117.228 84.8086 116.158 84.8086C115.088 84.8086 114.221 83.941 114.221 82.871C114.221 81.801 115.088 80.9334 116.158 80.9334C117.228 80.9334 118.096 81.801 118.096 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M122.819 78.1484C122.819 79.2183 121.951 80.0859 120.881 80.0859C119.811 80.0859 118.944 79.2183 118.944 78.1484C118.944 77.0784 119.811 76.2108 120.881 76.2108C121.951 76.2108 122.819 77.0784 122.819 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M118.096 87.5937C118.096 88.6636 117.228 89.5312 116.158 89.5312C115.088 89.5312 114.221 88.6636 114.221 87.5937C114.221 86.5237 115.088 85.6561 116.158 85.6561C117.228 85.6561 118.096 86.5237 118.096 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M122.819 87.5937C122.819 88.6636 121.951 89.5312 120.881 89.5312C119.811 89.5312 118.944 88.6636 118.944 87.5937C118.944 86.5237 119.811 85.6561 120.881 85.6561C121.951 85.6561 122.819 86.5237 122.819 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M103.926 82.871C103.926 83.941 103.059 84.8086 101.989 84.8086C100.919 84.8086 100.051 83.941 100.051 82.871C100.051 81.801 100.919 80.9334 101.989 80.9334C103.059 80.9334 103.926 81.801 103.926 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M108.65 101.766C108.65 102.836 107.782 103.703 106.712 103.703C105.642 103.703 104.774 102.836 104.774 101.766C104.774 100.696 105.642 99.828 106.712 99.828C107.782 99.828 108.65 100.696 108.65 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M113.373 101.766C113.373 102.836 112.505 103.703 111.435 103.703C110.365 103.703 109.498 102.836 109.498 101.766C109.498 100.696 110.365 99.828 111.435 99.828C112.505 99.828 113.373 100.696 113.373 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M85.0337 68.703C85.0337 69.773 84.1661 70.6406 83.0962 70.6406C82.0262 70.6406 81.1586 69.773 81.1586 68.703C81.1586 67.6331 82.0262 66.7655 83.0962 66.7655C84.1661 66.7655 85.0337 67.6331 85.0337 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M85.0337 73.4257C85.0337 74.4957 84.1661 75.3633 83.0962 75.3633C82.0262 75.3633 81.1586 74.4957 81.1586 73.4257C81.1586 72.3557 82.0262 71.4881 83.0962 71.4881C84.1661 71.4881 85.0337 72.3557 85.0337 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M80.3105 73.4257C80.3105 74.4957 79.4429 75.3633 78.3729 75.3633C77.3029 75.3633 76.4353 74.4957 76.4353 73.4257C76.4353 72.3557 77.3029 71.4881 78.3729 71.4881C79.4429 71.4881 80.3105 72.3557 80.3105 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M80.3105 78.1484C80.3105 79.2183 79.4429 80.0859 78.3729 80.0859C77.3029 80.0859 76.4353 79.2183 76.4353 78.1484C76.4353 77.0784 77.3029 76.2108 78.3729 76.2108C79.4429 76.2108 80.3105 77.0784 80.3105 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M80.3105 82.871C80.3105 83.941 79.4429 84.8086 78.3729 84.8086C77.3029 84.8086 76.4353 83.941 76.4353 82.871C76.4353 81.801 77.3029 80.9334 78.3729 80.9334C79.4429 80.9334 80.3105 81.801 80.3105 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M80.3105 87.5937C80.3105 88.6636 79.4429 89.5312 78.3729 89.5312C77.3029 89.5312 76.4353 88.6636 76.4353 87.5937C76.4353 86.5237 77.3029 85.6561 78.3729 85.6561C79.4429 85.6561 80.3105 86.5237 80.3105 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M85.0337 87.5937C85.0337 88.6636 84.1661 89.5312 83.0962 89.5312C82.0262 89.5312 81.1586 88.6636 81.1586 87.5937C81.1586 86.5237 82.0262 85.6561 83.0962 85.6561C84.1661 85.6561 85.0337 86.5237 85.0337 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M85.0337 92.3163C85.0337 93.3863 84.1661 94.2539 83.0962 94.2539C82.0262 94.2539 81.1586 93.3863 81.1586 92.3163C81.1586 91.2463 82.0262 90.3787 83.0962 90.3787C84.1661 90.3787 85.0337 91.2463 85.0337 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M85.0337 97.0429C85.0337 98.1129 84.1661 98.9805 83.0962 98.9805C82.0262 98.9805 81.1586 98.1129 81.1586 97.0429C81.1586 95.9729 82.0262 95.1053 83.0962 95.1053C84.1661 95.1053 85.0337 95.9729 85.0337 97.0429Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M85.0337 101.766C85.0337 102.836 84.1661 103.703 83.0962 103.703C82.0262 103.703 81.1586 102.836 81.1586 101.766C81.1586 100.696 82.0262 99.828 83.0962 99.828C84.1661 99.828 85.0337 100.696 85.0337 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M89.7569 101.766C89.7569 102.836 88.8893 103.703 87.8193 103.703C86.7493 103.703 85.8817 102.836 85.8817 101.766C85.8817 100.696 86.7493 99.828 87.8193 99.828C88.8893 99.828 89.7569 100.696 89.7569 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M89.7569 106.488C89.7569 107.558 88.8893 108.426 87.8193 108.426C86.7493 108.426 85.8817 107.558 85.8817 106.488C85.8817 105.418 86.7493 104.551 87.8193 104.551C88.8893 104.551 89.7569 105.418 89.7569 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M89.7569 111.211C89.7569 112.281 88.8893 113.148 87.8193 113.148C86.7493 113.148 85.8817 112.281 85.8817 111.211C85.8817 110.141 86.7493 109.273 87.8193 109.273C88.8893 109.273 89.7569 110.141 89.7569 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M89.7569 115.934C89.7569 117.003 88.8893 117.871 87.8193 117.871C86.7493 117.871 85.8817 117.003 85.8817 115.934C85.8817 114.864 86.7493 113.996 87.8193 113.996C88.8893 113.996 89.7569 114.864 89.7569 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M94.4799 115.934C94.4799 117.003 93.6123 117.871 92.5423 117.871C91.4723 117.871 90.6047 117.003 90.6047 115.934C90.6047 114.864 91.4723 113.996 92.5423 113.996C93.6123 113.996 94.4799 114.864 94.4799 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M94.4799 111.211C94.4799 112.281 93.6123 113.148 92.5423 113.148C91.4723 113.148 90.6047 112.281 90.6047 111.211C90.6047 110.141 91.4723 109.273 92.5423 109.273C93.6123 109.273 94.4799 110.141 94.4799 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M99.2033 111.211C99.2033 112.281 98.3357 113.148 97.2657 113.148C96.1957 113.148 95.3281 112.281 95.3281 111.211C95.3281 110.141 96.1957 109.273 97.2657 109.273C98.3357 109.273 99.2033 110.141 99.2033 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M103.926 111.211C103.926 112.281 103.059 113.148 101.989 113.148C100.919 113.148 100.051 112.281 100.051 111.211C100.051 110.141 100.919 109.273 101.989 109.273C103.059 109.273 103.926 110.141 103.926 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M108.65 111.211C108.65 112.281 107.782 113.148 106.712 113.148C105.642 113.148 104.774 112.281 104.774 111.211C104.774 110.141 105.642 109.273 106.712 109.273C107.782 109.273 108.65 110.141 108.65 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M113.373 111.211C113.373 112.281 112.505 113.148 111.435 113.148C110.365 113.148 109.498 112.281 109.498 111.211C109.498 110.141 110.365 109.273 111.435 109.273C112.505 109.273 113.373 110.141 113.373 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M118.096 111.211C118.096 112.281 117.228 113.148 116.158 113.148C115.088 113.148 114.221 112.281 114.221 111.211C114.221 110.141 115.088 109.273 116.158 109.273C117.228 109.273 118.096 110.141 118.096 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M122.819 111.211C122.819 112.281 121.951 113.148 120.881 113.148C119.811 113.148 118.944 112.281 118.944 111.211C118.944 110.141 119.811 109.273 120.881 109.273C121.951 109.273 122.819 110.141 122.819 111.211Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M122.819 106.488C122.819 107.558 121.951 108.426 120.881 108.426C119.811 108.426 118.944 107.558 118.944 106.488C118.944 105.418 119.811 104.551 120.881 104.551C121.951 104.551 122.819 105.418 122.819 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M118.096 106.488C118.096 107.558 117.228 108.426 116.158 108.426C115.088 108.426 114.221 107.558 114.221 106.488C114.221 105.418 115.088 104.551 116.158 104.551C117.228 104.551 118.096 105.418 118.096 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M118.096 101.766C118.096 102.836 117.228 103.703 116.158 103.703C115.088 103.703 114.221 102.836 114.221 101.766C114.221 100.696 115.088 99.828 116.158 99.828C117.228 99.828 118.096 100.696 118.096 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M113.373 106.488C113.373 107.558 112.505 108.426 111.435 108.426C110.365 108.426 109.498 107.558 109.498 106.488C109.498 105.418 110.365 104.551 111.435 104.551C112.505 104.551 113.373 105.418 113.373 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M108.65 106.488C108.65 107.558 107.782 108.426 106.712 108.426C105.642 108.426 104.774 107.558 104.774 106.488C104.774 105.418 105.642 104.551 106.712 104.551C107.782 104.551 108.65 105.418 108.65 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M103.926 106.488C103.926 107.558 103.059 108.426 101.989 108.426C100.919 108.426 100.051 107.558 100.051 106.488C100.051 105.418 100.919 104.551 101.989 104.551C103.059 104.551 103.926 105.418 103.926 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M99.2033 106.488C99.2033 107.558 98.3357 108.426 97.2657 108.426C96.1957 108.426 95.3281 107.558 95.3281 106.488C95.3281 105.418 96.1957 104.551 97.2657 104.551C98.3357 104.551 99.2033 105.418 99.2033 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M94.4799 106.488C94.4799 107.558 93.6123 108.426 92.5423 108.426C91.4723 108.426 90.6047 107.558 90.6047 106.488C90.6047 105.418 91.4723 104.551 92.5423 104.551C93.6123 104.551 94.4799 105.418 94.4799 106.488Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M94.4799 101.766C94.4799 102.836 93.6123 103.703 92.5423 103.703C91.4723 103.703 90.6047 102.836 90.6047 101.766C90.6047 100.696 91.4723 99.828 92.5423 99.828C93.6123 99.828 94.4799 100.696 94.4799 101.766Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M94.4799 97.0429C94.4799 98.1129 93.6123 98.9805 92.5423 98.9805C91.4723 98.9805 90.6047 98.1129 90.6047 97.0429C90.6047 95.9729 91.4723 95.1053 92.5423 95.1053C93.6123 95.1053 94.4799 95.9729 94.4799 97.0429Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M94.4799 92.3163C94.4799 93.3863 93.6123 94.2539 92.5423 94.2539C91.4723 94.2539 90.6047 93.3863 90.6047 92.3163C90.6047 91.2463 91.4723 90.3787 92.5423 90.3787C93.6123 90.3787 94.4799 91.2463 94.4799 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M94.4799 87.5937C94.4799 88.6636 93.6123 89.5312 92.5423 89.5312C91.4723 89.5312 90.6047 88.6636 90.6047 87.5937C90.6047 86.5237 91.4723 85.6561 92.5423 85.6561C93.6123 85.6561 94.4799 86.5237 94.4799 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M94.4799 82.871C94.4799 83.941 93.6123 84.8086 92.5423 84.8086C91.4723 84.8086 90.6047 83.941 90.6047 82.871C90.6047 81.801 91.4723 80.9334 92.5423 80.9334C93.6123 80.9334 94.4799 81.801 94.4799 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M94.4799 78.1484C94.4799 79.2183 93.6123 80.0859 92.5423 80.0859C91.4723 80.0859 90.6047 79.2183 90.6047 78.1484C90.6047 77.0784 91.4723 76.2108 92.5423 76.2108C93.6123 76.2108 94.4799 77.0784 94.4799 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M89.7569 78.1484C89.7569 79.2183 88.8893 80.0859 87.8193 80.0859C86.7493 80.0859 85.8817 79.2183 85.8817 78.1484C85.8817 77.0784 86.7493 76.2108 87.8193 76.2108C88.8893 76.2108 89.7569 77.0784 89.7569 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M85.0337 78.1484C85.0337 79.2183 84.1661 80.0859 83.0962 80.0859C82.0262 80.0859 81.1586 79.2183 81.1586 78.1484C81.1586 77.0784 82.0262 76.2108 83.0962 76.2108C84.1661 76.2108 85.0337 77.0784 85.0337 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M85.0337 82.871C85.0337 83.941 84.1661 84.8086 83.0962 84.8086C82.0262 84.8086 81.1586 83.941 81.1586 82.871C81.1586 81.801 82.0262 80.9334 83.0962 80.9334C84.1661 80.9334 85.0337 81.801 85.0337 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M89.7569 82.871C89.7569 83.941 88.8893 84.8086 87.8193 84.8086C86.7493 84.8086 85.8817 83.941 85.8817 82.871C85.8817 81.801 86.7493 80.9334 87.8193 80.9334C88.8893 80.9334 89.7569 81.801 89.7569 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M89.7569 87.5937C89.7569 88.6636 88.8893 89.5312 87.8193 89.5312C86.7493 89.5312 85.8817 88.6636 85.8817 87.5937C85.8817 86.5237 86.7493 85.6561 87.8193 85.6561C88.8893 85.6561 89.7569 86.5237 89.7569 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M89.7569 92.3163C89.7569 93.3863 88.8893 94.2539 87.8193 94.2539C86.7493 94.2539 85.8817 93.3863 85.8817 92.3163C85.8817 91.2463 86.7493 90.3787 87.8193 90.3787C88.8893 90.3787 89.7569 91.2463 89.7569 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M89.7569 97.0429C89.7569 98.1129 88.8893 98.9805 87.8193 98.9805C86.7493 98.9805 85.8817 98.1129 85.8817 97.0429C85.8817 95.9729 86.7493 95.1053 87.8193 95.1053C88.8893 95.1053 89.7569 95.9729 89.7569 97.0429Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M99.2033 115.934C99.2033 117.003 98.3357 117.871 97.2657 117.871C96.1957 117.871 95.3281 117.003 95.3281 115.934C95.3281 114.864 96.1957 113.996 97.2657 113.996C98.3357 113.996 99.2033 114.864 99.2033 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M103.926 115.934C103.926 117.003 103.059 117.871 101.989 117.871C100.919 117.871 100.051 117.003 100.051 115.934C100.051 114.864 100.919 113.996 101.989 113.996C103.059 113.996 103.926 114.864 103.926 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M108.65 115.934C108.65 117.003 107.782 117.871 106.712 117.871C105.642 117.871 104.774 117.003 104.774 115.934C104.774 114.864 105.642 113.996 106.712 113.996C107.782 113.996 108.65 114.864 108.65 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M113.373 115.934C113.373 117.003 112.505 117.871 111.435 117.871C110.365 117.871 109.498 117.003 109.498 115.934C109.498 114.864 110.365 113.996 111.435 113.996C112.505 113.996 113.373 114.864 113.373 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M118.096 115.934C118.096 117.003 117.228 117.871 116.158 117.871C115.088 117.871 114.221 117.003 114.221 115.934C114.221 114.864 115.088 113.996 116.158 113.996C117.228 113.996 118.096 114.864 118.096 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M122.819 115.934C122.819 117.003 121.951 117.871 120.881 117.871C119.811 117.871 118.944 117.003 118.944 115.934C118.944 114.864 119.811 113.996 120.881 113.996C121.951 113.996 122.819 114.864 122.819 115.934Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M75.5873 73.4257C75.5873 74.4957 74.7197 75.3633 73.6497 75.3633C72.5798 75.3633 71.7122 74.4957 71.7122 73.4257C71.7122 72.3557 72.5798 71.4881 73.6497 71.4881C74.7197 71.4881 75.5873 72.3557 75.5873 73.4257Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M80.3105 68.703C80.3105 69.773 79.4429 70.6406 78.3729 70.6406C77.3029 70.6406 76.4353 69.773 76.4353 68.703C76.4353 67.6331 77.3029 66.7655 78.3729 66.7655C79.4429 66.7655 80.3105 67.6331 80.3105 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M75.5873 68.703C75.5873 69.773 74.7197 70.6406 73.6497 70.6406C72.5798 70.6406 71.7122 69.773 71.7122 68.703C71.7122 67.6331 72.5798 66.7655 73.6497 66.7655C74.7197 66.7655 75.5873 67.6331 75.5873 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M70.8642 68.703C70.8642 69.773 69.9966 70.6406 68.9266 70.6406C67.8566 70.6406 66.989 69.773 66.989 68.703C66.989 67.6331 67.8566 66.7655 68.9266 66.7655C69.9966 66.7655 70.8642 67.6331 70.8642 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M56.6948 54.5312C56.6948 55.6011 55.8271 56.4688 54.7572 56.4688C53.6872 56.4688 52.8196 55.6011 52.8196 54.5312C52.8196 53.4612 53.6872 52.5936 54.7572 52.5936C55.8271 52.5936 56.6948 53.4612 56.6948 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M47.2483 49.8085C47.2483 50.8785 46.3807 51.7461 45.3108 51.7461C44.2408 51.7461 43.3732 50.8785 43.3732 49.8085C43.3732 48.7385 44.2408 47.8709 45.3108 47.8709C46.3807 47.8709 47.2483 48.7385 47.2483 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M42.5252 49.8085C42.5252 50.8785 41.6576 51.7461 40.5876 51.7461C39.5176 51.7461 38.65 50.8785 38.65 49.8085C38.65 48.7385 39.5176 47.8709 40.5876 47.8709C41.6576 47.8709 42.5252 48.7385 42.5252 49.8085Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M33.0789 54.5312C33.0789 55.6011 32.2113 56.4688 31.1413 56.4688C30.0713 56.4688 29.2037 55.6011 29.2037 54.5312C29.2037 53.4612 30.0713 52.5936 31.1413 52.5936C32.2113 52.5936 33.0789 53.4612 33.0789 54.5312Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M42.5252 45.0859C42.5252 46.1558 41.6576 47.0234 40.5876 47.0234C39.5176 47.0234 38.65 46.1558 38.65 45.0859C38.65 44.0159 39.5176 43.1483 40.5876 43.1483C41.6576 43.1483 42.5252 44.0159 42.5252 45.0859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M56.6948 59.2538C56.6948 60.3238 55.8271 61.1914 54.7572 61.1914C53.6872 61.1914 52.8196 60.3238 52.8196 59.2538C52.8196 58.1838 53.6872 57.3162 54.7572 57.3162C55.8271 57.3162 56.6948 58.1838 56.6948 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M61.4179 59.2538C61.4179 60.3238 60.5503 61.1914 59.4803 61.1914C58.4103 61.1914 57.5427 60.3238 57.5427 59.2538C57.5427 58.1838 58.4103 57.3162 59.4803 57.3162C60.5503 57.3162 61.4179 58.1838 61.4179 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M66.141 59.2538C66.141 60.3238 65.2734 61.1914 64.2035 61.1914C63.1335 61.1914 62.2659 60.3238 62.2659 59.2538C62.2659 58.1838 63.1335 57.3162 64.2035 57.3162C65.2734 57.3162 66.141 58.1838 66.141 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M70.8642 59.2538C70.8642 60.3238 69.9966 61.1914 68.9266 61.1914C67.8566 61.1914 66.989 60.3238 66.989 59.2538C66.989 58.1838 67.8566 57.3162 68.9266 57.3162C69.9966 57.3162 70.8642 58.1838 70.8642 59.2538Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M70.8642 63.9804C70.8642 65.0504 69.9966 65.918 68.9266 65.918C67.8566 65.918 66.989 65.0504 66.989 63.9804C66.989 62.9104 67.8566 62.0428 68.9266 62.0428C69.9966 62.0428 70.8642 62.9104 70.8642 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M66.141 63.9804C66.141 65.0504 65.2734 65.918 64.2035 65.918C63.1335 65.918 62.2659 65.0504 62.2659 63.9804C62.2659 62.9104 63.1335 62.0428 64.2035 62.0428C65.2734 62.0428 66.141 62.9104 66.141 63.9804Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M42.5252 68.703C42.5252 69.773 41.6576 70.6406 40.5876 70.6406C39.5176 70.6406 38.65 69.773 38.65 68.703C38.65 67.6331 39.5176 66.7655 40.5876 66.7655C41.6576 66.7655 42.5252 67.6331 42.5252 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M33.0789 68.703C33.0789 69.773 32.2113 70.6406 31.1413 70.6406C30.0713 70.6406 29.2037 69.773 29.2037 68.703C29.2037 67.6331 30.0713 66.7655 31.1413 66.7655C32.2113 66.7655 33.0789 67.6331 33.0789 68.703Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M42.5252 78.1484C42.5252 79.2183 41.6576 80.0859 40.5876 80.0859C39.5176 80.0859 38.65 79.2183 38.65 78.1484C38.65 77.0784 39.5176 76.2108 40.5876 76.2108C41.6576 76.2108 42.5252 77.0784 42.5252 78.1484Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M37.8021 82.871C37.8021 83.941 36.9344 84.8086 35.8645 84.8086C34.7945 84.8086 33.9269 83.941 33.9269 82.871C33.9269 81.801 34.7945 80.9334 35.8645 80.9334C36.9344 80.9334 37.8021 81.801 37.8021 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M33.0789 82.871C33.0789 83.941 32.2113 84.8086 31.1413 84.8086C30.0713 84.8086 29.2037 83.941 29.2037 82.871C29.2037 81.801 30.0713 80.9334 31.1413 80.9334C32.2113 80.9334 33.0789 81.801 33.0789 82.871Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M28.3558 87.5937C28.3558 88.6636 27.4882 89.5312 26.4182 89.5312C25.3482 89.5312 24.4806 88.6636 24.4806 87.5937C24.4806 86.5237 25.3482 85.6561 26.4182 85.6561C27.4882 85.6561 28.3558 86.5237 28.3558 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M23.6326 87.5937C23.6326 88.6636 22.765 89.5312 21.695 89.5312C20.6251 89.5312 19.7574 88.6636 19.7574 87.5937C19.7574 86.5237 20.6251 85.6561 21.695 85.6561C22.765 85.6561 23.6326 86.5237 23.6326 87.5937Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M18.9094 92.3163C18.9094 93.3863 18.0417 94.2539 16.9718 94.2539C15.9018 94.2539 15.0342 93.3863 15.0342 92.3163C15.0342 91.2463 15.9018 90.3787 16.9718 90.3787C18.0417 90.3787 18.9094 91.2463 18.9094 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M14.1862 92.3163C14.1862 93.3863 13.3186 94.2539 12.2486 94.2539C11.1786 94.2539 10.311 93.3863 10.311 92.3163C10.311 91.2463 11.1786 90.3787 12.2486 90.3787C13.3186 90.3787 14.1862 91.2463 14.1862 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M9.46306 92.3163C9.46306 93.3863 8.59546 94.2539 7.52548 94.2539C6.4555 94.2539 5.58789 93.3863 5.58789 92.3163C5.58789 91.2463 6.4555 90.3787 7.52548 90.3787C8.59546 90.3787 9.46306 91.2463 9.46306 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M4.73992 92.3163C4.73992 93.3863 3.87231 94.2539 2.80233 94.2539C1.73235 94.2539 0.864746 93.3863 0.864746 92.3163C0.864746 91.2463 1.73235 90.3787 2.80233 90.3787C3.87231 90.3787 4.73992 91.2463 4.73992 92.3163Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M89.7569 130.101C89.7569 131.171 88.8893 132.039 87.8193 132.039C86.7493 132.039 85.8817 131.171 85.8817 130.101C85.8817 129.031 86.7493 128.164 87.8193 128.164C88.8893 128.164 89.7569 129.031 89.7569 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M89.7569 134.828C89.7569 135.898 88.8893 136.766 87.8193 136.766C86.7493 136.766 85.8817 135.898 85.8817 134.828C85.8817 133.758 86.7493 132.89 87.8193 132.89C88.8893 132.89 89.7569 133.758 89.7569 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M89.757 139.551C89.757 140.621 88.8894 141.488 87.8194 141.488C86.7494 141.488 85.8818 140.621 85.8818 139.551C85.8818 138.481 86.7494 137.613 87.8194 137.613C88.8894 137.613 89.757 138.481 89.757 139.551Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M94.4802 139.551C94.4802 140.621 93.6125 141.488 92.5426 141.488C91.4726 141.488 90.605 140.621 90.605 139.551C90.605 138.481 91.4726 137.613 92.5426 137.613C93.6125 137.613 94.4802 138.481 94.4802 139.551Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M99.2033 139.551C99.2033 140.621 98.3357 141.488 97.2657 141.488C96.1957 141.488 95.3281 140.621 95.3281 139.551C95.3281 138.481 96.1957 137.613 97.2657 137.613C98.3357 137.613 99.2033 138.481 99.2033 139.551Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M103.926 139.551C103.926 140.621 103.059 141.488 101.989 141.488C100.919 141.488 100.051 140.621 100.051 139.551C100.051 138.481 100.919 137.613 101.989 137.613C103.059 137.613 103.926 138.481 103.926 139.551Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M108.65 139.551C108.65 140.621 107.782 141.488 106.712 141.488C105.642 141.488 104.774 140.621 104.774 139.551C104.774 138.481 105.642 137.613 106.712 137.613C107.782 137.613 108.65 138.481 108.65 139.551Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M113.373 139.551C113.373 140.621 112.505 141.488 111.435 141.488C110.365 141.488 109.498 140.621 109.498 139.551C109.498 138.481 110.365 137.613 111.435 137.613C112.505 137.613 113.373 138.481 113.373 139.551Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M118.096 139.551C118.096 140.621 117.228 141.488 116.158 141.488C115.088 141.488 114.221 140.621 114.221 139.551C114.221 138.481 115.088 137.613 116.158 137.613C117.228 137.613 118.096 138.481 118.096 139.551Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M122.819 139.551C122.819 140.621 121.951 141.488 120.881 141.488C119.811 141.488 118.944 140.621 118.944 139.551C118.944 138.481 119.811 137.613 120.881 137.613C121.951 137.613 122.819 138.481 122.819 139.551Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M127.542 139.551C127.542 140.621 126.675 141.488 125.605 141.488C124.535 141.488 123.667 140.621 123.667 139.551C123.667 138.481 124.535 137.613 125.605 137.613C126.675 137.613 127.542 138.481 127.542 139.551Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M132.265 139.551C132.265 140.621 131.398 141.488 130.328 141.488C129.258 141.488 128.39 140.621 128.39 139.551C128.39 138.481 129.258 137.613 130.328 137.613C131.398 137.613 132.265 138.481 132.265 139.551Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M132.265 134.828C132.265 135.898 131.398 136.766 130.328 136.766C129.258 136.766 128.39 135.898 128.39 134.828C128.39 133.758 129.258 132.89 130.328 132.89C131.398 132.89 132.265 133.758 132.265 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M136.988 134.828C136.988 135.898 136.121 136.766 135.051 136.766C133.981 136.766 133.113 135.898 133.113 134.828C133.113 133.758 133.981 132.89 135.051 132.89C136.121 132.89 136.988 133.758 136.988 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M136.988 130.101C136.988 131.171 136.121 132.039 135.051 132.039C133.981 132.039 133.113 131.171 133.113 130.101C133.113 129.031 133.981 128.164 135.051 128.164C136.121 128.164 136.988 129.031 136.988 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M132.265 130.101C132.265 131.171 131.398 132.039 130.328 132.039C129.258 132.039 128.39 131.171 128.39 130.101C128.39 129.031 129.258 128.164 130.328 128.164C131.398 128.164 132.265 129.031 132.265 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M127.542 130.101C127.542 131.171 126.675 132.039 125.605 132.039C124.535 132.039 123.667 131.171 123.667 130.101C123.667 129.031 124.535 128.164 125.605 128.164C126.675 128.164 127.542 129.031 127.542 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M122.819 130.101C122.819 131.171 121.951 132.039 120.881 132.039C119.811 132.039 118.944 131.171 118.944 130.101C118.944 129.031 119.811 128.164 120.881 128.164C121.951 128.164 122.819 129.031 122.819 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M118.096 130.101C118.096 131.171 117.228 132.039 116.158 132.039C115.088 132.039 114.221 131.171 114.221 130.101C114.221 129.031 115.088 128.164 116.158 128.164C117.228 128.164 118.096 129.031 118.096 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M113.373 130.101C113.373 131.171 112.505 132.039 111.435 132.039C110.365 132.039 109.498 131.171 109.498 130.101C109.498 129.031 110.365 128.164 111.435 128.164C112.505 128.164 113.373 129.031 113.373 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M108.65 130.101C108.65 131.171 107.782 132.039 106.712 132.039C105.642 132.039 104.774 131.171 104.774 130.101C104.774 129.031 105.642 128.164 106.712 128.164C107.782 128.164 108.65 129.031 108.65 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M103.926 130.101C103.926 131.171 103.059 132.039 101.989 132.039C100.919 132.039 100.051 131.171 100.051 130.101C100.051 129.031 100.919 128.164 101.989 128.164C103.059 128.164 103.926 129.031 103.926 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M99.2033 130.101C99.2033 131.171 98.3357 132.039 97.2657 132.039C96.1957 132.039 95.3281 131.171 95.3281 130.101C95.3281 129.031 96.1957 128.164 97.2657 128.164C98.3357 128.164 99.2033 129.031 99.2033 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M94.4799 130.101C94.4799 131.171 93.6123 132.039 92.5423 132.039C91.4723 132.039 90.6047 131.171 90.6047 130.101C90.6047 129.031 91.4723 128.164 92.5423 128.164C93.6123 128.164 94.4799 129.031 94.4799 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M94.4799 134.828C94.4799 135.898 93.6123 136.766 92.5423 136.766C91.4723 136.766 90.6047 135.898 90.6047 134.828C90.6047 133.758 91.4723 132.89 92.5423 132.89C93.6123 132.89 94.4799 133.758 94.4799 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M99.2033 134.828C99.2033 135.898 98.3357 136.766 97.2657 136.766C96.1957 136.766 95.3281 135.898 95.3281 134.828C95.3281 133.758 96.1957 132.89 97.2657 132.89C98.3357 132.89 99.2033 133.758 99.2033 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M103.926 134.828C103.926 135.898 103.059 136.766 101.989 136.766C100.919 136.766 100.051 135.898 100.051 134.828C100.051 133.758 100.919 132.89 101.989 132.89C103.059 132.89 103.926 133.758 103.926 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M108.65 134.828C108.65 135.898 107.782 136.766 106.712 136.766C105.642 136.766 104.774 135.898 104.774 134.828C104.774 133.758 105.642 132.89 106.712 132.89C107.782 132.89 108.65 133.758 108.65 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M113.373 134.828C113.373 135.898 112.505 136.766 111.435 136.766C110.365 136.766 109.498 135.898 109.498 134.828C109.498 133.758 110.365 132.89 111.435 132.89C112.505 132.89 113.373 133.758 113.373 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M118.096 134.828C118.096 135.898 117.228 136.766 116.158 136.766C115.088 136.766 114.221 135.898 114.221 134.828C114.221 133.758 115.088 132.89 116.158 132.89C117.228 132.89 118.096 133.758 118.096 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M122.819 134.828C122.819 135.898 121.951 136.766 120.881 136.766C119.811 136.766 118.944 135.898 118.944 134.828C118.944 133.758 119.811 132.89 120.881 132.89C121.951 132.89 122.819 133.758 122.819 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M127.542 134.828C127.542 135.898 126.675 136.766 125.605 136.766C124.535 136.766 123.667 135.898 123.667 134.828C123.667 133.758 124.535 132.89 125.605 132.89C126.675 132.89 127.542 133.758 127.542 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M136.988 139.551C136.988 140.621 136.121 141.488 135.051 141.488C133.981 141.488 133.113 140.621 133.113 139.551C133.113 138.481 133.981 137.613 135.051 137.613C136.121 137.613 136.988 138.481 136.988 139.551Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M136.988 144.273C136.988 145.343 136.121 146.211 135.051 146.211C133.981 146.211 133.113 145.343 133.113 144.273C133.113 143.203 133.981 142.336 135.051 142.336C136.121 142.336 136.988 143.203 136.988 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M132.265 144.273C132.265 145.343 131.398 146.211 130.328 146.211C129.258 146.211 128.39 145.343 128.39 144.273C128.39 143.203 129.258 142.336 130.328 142.336C131.398 142.336 132.265 143.203 132.265 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M127.542 144.273C127.542 145.343 126.675 146.211 125.605 146.211C124.535 146.211 123.667 145.343 123.667 144.273C123.667 143.203 124.535 142.336 125.605 142.336C126.675 142.336 127.542 143.203 127.542 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M122.819 144.273C122.819 145.343 121.951 146.211 120.881 146.211C119.811 146.211 118.944 145.343 118.944 144.273C118.944 143.203 119.811 142.336 120.881 142.336C121.951 142.336 122.819 143.203 122.819 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M118.096 144.273C118.096 145.343 117.228 146.211 116.158 146.211C115.088 146.211 114.221 145.343 114.221 144.273C114.221 143.203 115.088 142.336 116.158 142.336C117.228 142.336 118.096 143.203 118.096 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M113.373 144.273C113.373 145.343 112.505 146.211 111.435 146.211C110.365 146.211 109.498 145.343 109.498 144.273C109.498 143.203 110.365 142.336 111.435 142.336C112.505 142.336 113.373 143.203 113.373 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M108.65 144.273C108.65 145.343 107.782 146.211 106.712 146.211C105.642 146.211 104.774 145.343 104.774 144.273C104.774 143.203 105.642 142.336 106.712 142.336C107.782 142.336 108.65 143.203 108.65 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M103.926 144.273C103.926 145.343 103.059 146.211 101.989 146.211C100.919 146.211 100.051 145.343 100.051 144.273C100.051 143.203 100.919 142.336 101.989 142.336C103.059 142.336 103.926 143.203 103.926 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M99.2033 144.273C99.2033 145.343 98.3357 146.211 97.2657 146.211C96.1957 146.211 95.3281 145.343 95.3281 144.273C95.3281 143.203 96.1957 142.336 97.2657 142.336C98.3357 142.336 99.2033 143.203 99.2033 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M94.4802 144.273C94.4802 145.343 93.6125 146.211 92.5426 146.211C91.4726 146.211 90.605 145.343 90.605 144.273C90.605 143.203 91.4726 142.336 92.5426 142.336C93.6125 142.336 94.4802 143.203 94.4802 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M141.712 144.273C141.712 145.343 140.844 146.211 139.774 146.211C138.704 146.211 137.836 145.343 137.836 144.273C137.836 143.203 138.704 142.336 139.774 142.336C140.844 142.336 141.712 143.203 141.712 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M141.712 139.551C141.712 140.621 140.844 141.488 139.774 141.488C138.704 141.488 137.836 140.621 137.836 139.551C137.836 138.481 138.704 137.613 139.774 137.613C140.844 137.613 141.712 138.481 141.712 139.551Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M146.435 134.828C146.435 135.898 145.567 136.766 144.497 136.766C143.427 136.766 142.56 135.898 142.56 134.828C142.56 133.758 143.427 132.89 144.497 132.89C145.567 132.89 146.435 133.758 146.435 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M146.435 130.101C146.435 131.171 145.567 132.039 144.497 132.039C143.427 132.039 142.56 131.171 142.56 130.101C142.56 129.031 143.427 128.164 144.497 128.164C145.567 128.164 146.435 129.031 146.435 130.101Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M85.0337 134.828C85.0337 135.898 84.1661 136.766 83.0962 136.766C82.0262 136.766 81.1586 135.898 81.1586 134.828C81.1586 133.758 82.0262 132.89 83.0962 132.89C84.1661 132.89 85.0337 133.758 85.0337 134.828Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M85.0339 139.551C85.0339 140.621 84.1663 141.488 83.0963 141.488C82.0263 141.488 81.1587 140.621 81.1587 139.551C81.1587 138.481 82.0263 137.613 83.0963 137.613C84.1663 137.613 85.0339 138.481 85.0339 139.551Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M85.0339 144.273C85.0339 145.343 84.1663 146.211 83.0963 146.211C82.0263 146.211 81.1587 145.343 81.1587 144.273C81.1587 143.203 82.0263 142.336 83.0963 142.336C84.1663 142.336 85.0339 143.203 85.0339 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M89.757 144.273C89.757 145.343 88.8894 146.211 87.8194 146.211C86.7494 146.211 85.8818 145.343 85.8818 144.273C85.8818 143.203 86.7494 142.336 87.8194 142.336C88.8894 142.336 89.757 143.203 89.757 144.273Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M89.757 148.996C89.757 150.066 88.8894 150.934 87.8194 150.934C86.7494 150.934 85.8818 150.066 85.8818 148.996C85.8818 147.926 86.7494 147.058 87.8194 147.058C88.8894 147.058 89.757 147.926 89.757 148.996Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M94.4802 148.996C94.4802 150.066 93.6125 150.934 92.5426 150.934C91.4726 150.934 90.605 150.066 90.605 148.996C90.605 147.926 91.4726 147.058 92.5426 147.058C93.6125 147.058 94.4802 147.926 94.4802 148.996Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M99.2033 148.996C99.2033 150.066 98.3357 150.934 97.2657 150.934C96.1957 150.934 95.3281 150.066 95.3281 148.996C95.3281 147.926 96.1957 147.058 97.2657 147.058C98.3357 147.058 99.2033 147.926 99.2033 148.996Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M103.926 148.996C103.926 150.066 103.059 150.934 101.989 150.934C100.919 150.934 100.051 150.066 100.051 148.996C100.051 147.926 100.919 147.058 101.989 147.058C103.059 147.058 103.926 147.926 103.926 148.996Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M108.65 148.996C108.65 150.066 107.782 150.934 106.712 150.934C105.642 150.934 104.774 150.066 104.774 148.996C104.774 147.926 105.642 147.058 106.712 147.058C107.782 147.058 108.65 147.926 108.65 148.996Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M113.373 148.996C113.373 150.066 112.505 150.934 111.435 150.934C110.365 150.934 109.498 150.066 109.498 148.996C109.498 147.926 110.365 147.058 111.435 147.058C112.505 147.058 113.373 147.926 113.373 148.996Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M118.096 148.996C118.096 150.066 117.228 150.934 116.158 150.934C115.088 150.934 114.221 150.066 114.221 148.996C114.221 147.926 115.088 147.058 116.158 147.058C117.228 147.058 118.096 147.926 118.096 148.996Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M122.819 148.996C122.819 150.066 121.951 150.934 120.881 150.934C119.811 150.934 118.944 150.066 118.944 148.996C118.944 147.926 119.811 147.058 120.881 147.058C121.951 147.058 122.819 147.926 122.819 148.996Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M127.542 148.996C127.542 150.066 126.675 150.934 125.605 150.934C124.535 150.934 123.667 150.066 123.667 148.996C123.667 147.926 124.535 147.058 125.605 147.058C126.675 147.058 127.542 147.926 127.542 148.996Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M132.265 148.996C132.265 150.066 131.398 150.934 130.328 150.934C129.258 150.934 128.39 150.066 128.39 148.996C128.39 147.926 129.258 147.058 130.328 147.058C131.398 147.058 132.265 147.926 132.265 148.996Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M136.988 148.996C136.988 150.066 136.121 150.934 135.051 150.934C133.981 150.934 133.113 150.066 133.113 148.996C133.113 147.926 133.981 147.058 135.051 147.058C136.121 147.058 136.988 147.926 136.988 148.996Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M141.712 148.996C141.712 150.066 140.844 150.934 139.774 150.934C138.704 150.934 137.836 150.066 137.836 148.996C137.836 147.926 138.704 147.058 139.774 147.058C140.844 147.058 141.712 147.926 141.712 148.996Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M141.712 153.719C141.712 154.789 140.844 155.656 139.774 155.656C138.704 155.656 137.836 154.789 137.836 153.719C137.836 152.649 138.704 151.781 139.774 151.781C140.844 151.781 141.712 152.649 141.712 153.719Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M136.988 153.719C136.988 154.789 136.121 155.656 135.051 155.656C133.981 155.656 133.113 154.789 133.113 153.719C133.113 152.649 133.981 151.781 135.051 151.781C136.121 151.781 136.988 152.649 136.988 153.719Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M132.265 153.719C132.265 154.789 131.398 155.656 130.328 155.656C129.258 155.656 128.39 154.789 128.39 153.719C128.39 152.649 129.258 151.781 130.328 151.781C131.398 151.781 132.265 152.649 132.265 153.719Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M127.542 153.719C127.542 154.789 126.675 155.656 125.605 155.656C124.535 155.656 123.667 154.789 123.667 153.719C123.667 152.649 124.535 151.781 125.605 151.781C126.675 151.781 127.542 152.649 127.542 153.719Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M122.819 153.719C122.819 154.789 121.951 155.656 120.881 155.656C119.811 155.656 118.944 154.789 118.944 153.719C118.944 152.649 119.811 151.781 120.881 151.781C121.951 151.781 122.819 152.649 122.819 153.719Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M118.096 153.719C118.096 154.789 117.228 155.656 116.158 155.656C115.088 155.656 114.221 154.789 114.221 153.719C114.221 152.649 115.088 151.781 116.158 151.781C117.228 151.781 118.096 152.649 118.096 153.719Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M113.373 153.719C113.373 154.789 112.505 155.656 111.435 155.656C110.365 155.656 109.498 154.789 109.498 153.719C109.498 152.649 110.365 151.781 111.435 151.781C112.505 151.781 113.373 152.649 113.373 153.719Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M108.65 153.719C108.65 154.789 107.782 155.656 106.712 155.656C105.642 155.656 104.774 154.789 104.774 153.719C104.774 152.649 105.642 151.781 106.712 151.781C107.782 151.781 108.65 152.649 108.65 153.719Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M103.926 153.719C103.926 154.789 103.059 155.656 101.989 155.656C100.919 155.656 100.051 154.789 100.051 153.719C100.051 152.649 100.919 151.781 101.989 151.781C103.059 151.781 103.926 152.649 103.926 153.719Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M99.2033 153.719C99.2033 154.789 98.3357 155.656 97.2657 155.656C96.1957 155.656 95.3281 154.789 95.3281 153.719C95.3281 152.649 96.1957 151.781 97.2657 151.781C98.3357 151.781 99.2033 152.649 99.2033 153.719Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M94.4799 153.719C94.4799 154.789 93.6123 155.656 92.5423 155.656C91.4723 155.656 90.6047 154.789 90.6047 153.719C90.6047 152.649 91.4723 151.781 92.5423 151.781C93.6123 151.781 94.4799 152.649 94.4799 153.719Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M75.5876 139.551C75.5876 140.621 74.72 141.488 73.65 141.488C72.58 141.488 71.7124 140.621 71.7124 139.551C71.7124 138.481 72.58 137.613 73.65 137.613C74.72 137.613 75.5876 138.481 75.5876 139.551Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M94.4799 167.887C94.4799 168.957 93.6123 169.824 92.5423 169.824C91.4723 169.824 90.6047 168.957 90.6047 167.887C90.6047 166.817 91.4723 165.949 92.5423 165.949C93.6123 165.949 94.4799 166.817 94.4799 167.887Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M108.65 182.059C108.65 183.128 107.782 183.996 106.712 183.996C105.642 183.996 104.774 183.128 104.774 182.059C104.774 180.989 105.642 180.121 106.712 180.121C107.782 180.121 108.65 180.989 108.65 182.059Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M113.373 182.059C113.373 183.128 112.505 183.996 111.435 183.996C110.365 183.996 109.498 183.128 109.498 182.059C109.498 180.989 110.365 180.121 111.435 180.121C112.505 180.121 113.373 180.989 113.373 182.059Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M113.373 177.336C113.373 178.406 112.505 179.273 111.435 179.273C110.365 179.273 109.498 178.406 109.498 177.336C109.498 176.266 110.365 175.398 111.435 175.398C112.505 175.398 113.373 176.266 113.373 177.336Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M113.373 172.613C113.373 173.683 112.505 174.551 111.435 174.551C110.365 174.551 109.498 173.683 109.498 172.613C109.498 171.543 110.365 170.676 111.435 170.676C112.505 170.676 113.373 171.543 113.373 172.613Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M113.373 167.887C113.373 168.957 112.505 169.824 111.435 169.824C110.365 169.824 109.498 168.957 109.498 167.887C109.498 166.817 110.365 165.949 111.435 165.949C112.505 165.949 113.373 166.817 113.373 167.887Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M118.096 167.887C118.096 168.957 117.228 169.824 116.158 169.824C115.088 169.824 114.221 168.957 114.221 167.887C114.221 166.817 115.088 165.949 116.158 165.949C117.228 165.949 118.096 166.817 118.096 167.887Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M113.373 163.164C113.373 164.234 112.505 165.102 111.435 165.102C110.365 165.102 109.498 164.234 109.498 163.164C109.498 162.094 110.365 161.226 111.435 161.226C112.505 161.226 113.373 162.094 113.373 163.164Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M118.096 163.164C118.096 164.234 117.228 165.102 116.158 165.102C115.088 165.102 114.221 164.234 114.221 163.164C114.221 162.094 115.088 161.226 116.158 161.226C117.228 161.226 118.096 162.094 118.096 163.164Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M122.819 163.164C122.819 164.234 121.951 165.102 120.881 165.102C119.811 165.102 118.944 164.234 118.944 163.164C118.944 162.094 119.811 161.226 120.881 161.226C121.951 161.226 122.819 162.094 122.819 163.164Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M127.542 163.164C127.542 164.234 126.675 165.102 125.605 165.102C124.535 165.102 123.667 164.234 123.667 163.164C123.667 162.094 124.535 161.226 125.605 161.226C126.675 161.226 127.542 162.094 127.542 163.164Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M132.265 163.164C132.265 164.234 131.398 165.102 130.328 165.102C129.258 165.102 128.39 164.234 128.39 163.164C128.39 162.094 129.258 161.226 130.328 161.226C131.398 161.226 132.265 162.094 132.265 163.164Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M136.988 163.164C136.988 164.234 136.121 165.102 135.051 165.102C133.981 165.102 133.113 164.234 133.113 163.164C133.113 162.094 133.981 161.226 135.051 161.226C136.121 161.226 136.988 162.094 136.988 163.164Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M141.712 163.164C141.712 164.234 140.844 165.102 139.774 165.102C138.704 165.102 137.836 164.234 137.836 163.164C137.836 162.094 138.704 161.226 139.774 161.226C140.844 161.226 141.712 162.094 141.712 163.164Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M141.712 167.887C141.712 168.957 140.844 169.824 139.774 169.824C138.704 169.824 137.836 168.957 137.836 167.887C137.836 166.817 138.704 165.949 139.774 165.949C140.844 165.949 141.712 166.817 141.712 167.887Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M146.435 172.613C146.435 173.683 145.567 174.551 144.497 174.551C143.427 174.551 142.56 173.683 142.56 172.613C142.56 171.543 143.427 170.676 144.497 170.676C145.567 170.676 146.435 171.543 146.435 172.613Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M155.881 177.336C155.881 178.406 155.013 179.273 153.943 179.273C152.873 179.273 152.006 178.406 152.006 177.336C152.006 176.266 152.873 175.398 153.943 175.398C155.013 175.398 155.881 176.266 155.881 177.336Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M146.435 182.059C146.435 183.128 145.567 183.996 144.497 183.996C143.427 183.996 142.56 183.128 142.56 182.059C142.56 180.989 143.427 180.121 144.497 180.121C145.567 180.121 146.435 180.989 146.435 182.059Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M141.712 182.059C141.712 183.128 140.844 183.996 139.774 183.996C138.704 183.996 137.836 183.128 137.836 182.059C137.836 180.989 138.704 180.121 139.774 180.121C140.844 180.121 141.712 180.989 141.712 182.059Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M151.158 182.059C151.158 183.128 150.29 183.996 149.22 183.996C148.15 183.996 147.283 183.128 147.283 182.059C147.283 180.989 148.15 180.121 149.22 180.121C150.29 180.121 151.158 180.989 151.158 182.059Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M160.604 186.781C160.604 187.851 159.737 188.719 158.667 188.719C157.597 188.719 156.729 187.851 156.729 186.781C156.729 185.711 157.597 184.844 158.667 184.844C159.737 184.844 160.604 185.711 160.604 186.781Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M170.051 186.781C170.051 187.851 169.183 188.719 168.113 188.719C167.043 188.719 166.176 187.851 166.176 186.781C166.176 185.711 167.043 184.844 168.113 184.844C169.183 184.844 170.051 185.711 170.051 186.781Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M127.542 186.781C127.542 187.851 126.675 188.719 125.605 188.719C124.535 188.719 123.667 187.851 123.667 186.781C123.667 185.711 124.535 184.844 125.605 184.844C126.675 184.844 127.542 185.711 127.542 186.781Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M132.265 182.059C132.265 183.128 131.398 183.996 130.328 183.996C129.258 183.996 128.39 183.128 128.39 182.059C128.39 180.989 129.258 180.121 130.328 180.121C131.398 180.121 132.265 180.989 132.265 182.059Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M151.158 210.398C151.158 211.468 150.29 212.336 149.22 212.336C148.15 212.336 147.283 211.468 147.283 210.398C147.283 209.328 148.15 208.461 149.22 208.461C150.29 208.461 151.158 209.328 151.158 210.398Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M155.881 210.398C155.881 211.468 155.013 212.336 153.943 212.336C152.873 212.336 152.006 211.468 152.006 210.398C152.006 209.328 152.873 208.461 153.943 208.461C155.013 208.461 155.881 209.328 155.881 210.398Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M160.604 210.398C160.604 211.468 159.737 212.336 158.667 212.336C157.597 212.336 156.729 211.468 156.729 210.398C156.729 209.328 157.597 208.461 158.667 208.461C159.737 208.461 160.604 209.328 160.604 210.398Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M165.328 210.398C165.328 211.468 164.46 212.336 163.39 212.336C162.32 212.336 161.452 211.468 161.452 210.398C161.452 209.328 162.32 208.461 163.39 208.461C164.46 208.461 165.328 209.328 165.328 210.398Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M170.051 210.398C170.051 211.468 169.183 212.336 168.113 212.336C167.043 212.336 166.176 211.468 166.176 210.398C166.176 209.328 167.043 208.461 168.113 208.461C169.183 208.461 170.051 209.328 170.051 210.398Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M170.051 215.121C170.051 216.191 169.183 217.059 168.113 217.059C167.043 217.059 166.176 216.191 166.176 215.121C166.176 214.051 167.043 213.183 168.113 213.183C169.183 213.183 170.051 214.051 170.051 215.121Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M174.774 215.121C174.774 216.191 173.906 217.059 172.836 217.059C171.766 217.059 170.899 216.191 170.899 215.121C170.899 214.051 171.766 213.183 172.836 213.183C173.906 213.183 174.774 214.051 174.774 215.121Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M174.774 219.844C174.774 220.914 173.906 221.781 172.836 221.781C171.766 221.781 170.899 220.914 170.899 219.844C170.899 218.774 171.766 217.906 172.836 217.906C173.906 217.906 174.774 218.774 174.774 219.844Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M174.774 224.566C174.774 225.636 173.906 226.504 172.836 226.504C171.766 226.504 170.899 225.636 170.899 224.566C170.899 223.496 171.766 222.629 172.836 222.629C173.906 222.629 174.774 223.496 174.774 224.566Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M174.774 229.289C174.774 230.359 173.906 231.227 172.836 231.227C171.766 231.227 170.899 230.359 170.899 229.289C170.899 228.219 171.766 227.351 172.836 227.351C173.906 227.351 174.774 228.219 174.774 229.289Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M174.774 234.012C174.774 235.082 173.906 235.949 172.836 235.949C171.766 235.949 170.899 235.082 170.899 234.012C170.899 232.942 171.766 232.074 172.836 232.074C173.906 232.074 174.774 232.942 174.774 234.012Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M174.774 238.734C174.774 239.804 173.906 240.672 172.836 240.672C171.766 240.672 170.899 239.804 170.899 238.734C170.899 237.664 171.766 236.797 172.836 236.797C173.906 236.797 174.774 237.664 174.774 238.734Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M174.774 243.461C174.774 244.531 173.906 245.398 172.836 245.398C171.766 245.398 170.899 244.531 170.899 243.461C170.899 242.391 171.766 241.523 172.836 241.523C173.906 241.523 174.774 242.391 174.774 243.461Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M174.774 248.184C174.774 249.253 173.906 250.121 172.836 250.121C171.766 250.121 170.899 249.253 170.899 248.184C170.899 247.114 171.766 246.246 172.836 246.246C173.906 246.246 174.774 247.114 174.774 248.184Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M179.497 248.184C179.497 249.253 178.629 250.121 177.559 250.121C176.489 250.121 175.622 249.253 175.622 248.184C175.622 247.114 176.489 246.246 177.559 246.246C178.629 246.246 179.497 247.114 179.497 248.184Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M179.497 243.461C179.497 244.531 178.629 245.398 177.559 245.398C176.489 245.398 175.622 244.531 175.622 243.461C175.622 242.391 176.489 241.523 177.559 241.523C178.629 241.523 179.497 242.391 179.497 243.461Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M179.497 238.734C179.497 239.804 178.629 240.672 177.559 240.672C176.489 240.672 175.622 239.804 175.622 238.734C175.622 237.664 176.489 236.797 177.559 236.797C178.629 236.797 179.497 237.664 179.497 238.734Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M179.497 234.012C179.497 235.082 178.629 235.949 177.559 235.949C176.489 235.949 175.622 235.082 175.622 234.012C175.622 232.942 176.489 232.074 177.559 232.074C178.629 232.074 179.497 232.942 179.497 234.012Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M179.497 229.289C179.497 230.359 178.629 231.227 177.559 231.227C176.489 231.227 175.622 230.359 175.622 229.289C175.622 228.219 176.489 227.351 177.559 227.351C178.629 227.351 179.497 228.219 179.497 229.289Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M179.497 224.566C179.497 225.636 178.629 226.504 177.559 226.504C176.489 226.504 175.622 225.636 175.622 224.566C175.622 223.496 176.489 222.629 177.559 222.629C178.629 222.629 179.497 223.496 179.497 224.566Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M179.497 219.844C179.497 220.914 178.629 221.781 177.559 221.781C176.489 221.781 175.622 220.914 175.622 219.844C175.622 218.774 176.489 217.906 177.559 217.906C178.629 217.906 179.497 218.774 179.497 219.844Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M184.22 219.844C184.22 220.914 183.353 221.781 182.283 221.781C181.213 221.781 180.345 220.914 180.345 219.844C180.345 218.774 181.213 217.906 182.283 217.906C183.353 217.906 184.22 218.774 184.22 219.844Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M184.22 224.566C184.22 225.636 183.353 226.504 182.283 226.504C181.213 226.504 180.345 225.636 180.345 224.566C180.345 223.496 181.213 222.629 182.283 222.629C183.353 222.629 184.22 223.496 184.22 224.566Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M184.22 229.289C184.22 230.359 183.353 231.227 182.283 231.227C181.213 231.227 180.345 230.359 180.345 229.289C180.345 228.219 181.213 227.351 182.283 227.351C183.353 227.351 184.22 228.219 184.22 229.289Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M184.22 234.012C184.22 235.082 183.353 235.949 182.283 235.949C181.213 235.949 180.345 235.082 180.345 234.012C180.345 232.942 181.213 232.074 182.283 232.074C183.353 232.074 184.22 232.942 184.22 234.012Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M184.22 238.734C184.22 239.804 183.353 240.672 182.283 240.672C181.213 240.672 180.345 239.804 180.345 238.734C180.345 237.664 181.213 236.797 182.283 236.797C183.353 236.797 184.22 237.664 184.22 238.734Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M184.22 243.461C184.22 244.531 183.353 245.398 182.283 245.398C181.213 245.398 180.345 244.531 180.345 243.461C180.345 242.391 181.213 241.523 182.283 241.523C183.353 241.523 184.22 242.391 184.22 243.461Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M184.22 248.184C184.22 249.253 183.353 250.121 182.283 250.121C181.213 250.121 180.345 249.253 180.345 248.184C180.345 247.114 181.213 246.246 182.283 246.246C183.353 246.246 184.22 247.114 184.22 248.184Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M188.943 219.844C188.943 220.914 188.076 221.781 187.006 221.781C185.936 221.781 185.068 220.914 185.068 219.844C185.068 218.774 185.936 217.906 187.006 217.906C188.076 217.906 188.943 218.774 188.943 219.844Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M188.943 224.566C188.943 225.636 188.076 226.504 187.006 226.504C185.936 226.504 185.068 225.636 185.068 224.566C185.068 223.496 185.936 222.629 187.006 222.629C188.076 222.629 188.943 223.496 188.943 224.566Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M188.943 229.289C188.943 230.359 188.076 231.227 187.006 231.227C185.936 231.227 185.068 230.359 185.068 229.289C185.068 228.219 185.936 227.351 187.006 227.351C188.076 227.351 188.943 228.219 188.943 229.289Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M188.943 234.012C188.943 235.082 188.076 235.949 187.006 235.949C185.936 235.949 185.068 235.082 185.068 234.012C185.068 232.942 185.936 232.074 187.006 232.074C188.076 232.074 188.943 232.942 188.943 234.012Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M188.943 238.734C188.943 239.804 188.076 240.672 187.006 240.672C185.936 240.672 185.068 239.804 185.068 238.734C185.068 237.664 185.936 236.797 187.006 236.797C188.076 236.797 188.943 237.664 188.943 238.734Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M188.943 243.461C188.943 244.531 188.076 245.398 187.006 245.398C185.936 245.398 185.068 244.531 185.068 243.461C185.068 242.391 185.936 241.523 187.006 241.523C188.076 241.523 188.943 242.391 188.943 243.461Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M188.943 248.184C188.943 249.253 188.076 250.121 187.006 250.121C185.936 250.121 185.068 249.253 185.068 248.184C185.068 247.114 185.936 246.246 187.006 246.246C188.076 246.246 188.943 247.114 188.943 248.184Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M193.666 248.184C193.666 249.253 192.799 250.121 191.729 250.121C190.659 250.121 189.791 249.253 189.791 248.184C189.791 247.114 190.659 246.246 191.729 246.246C192.799 246.246 193.666 247.114 193.666 248.184Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M198.39 248.184C198.39 249.253 197.522 250.121 196.452 250.121C195.382 250.121 194.514 249.253 194.514 248.184C194.514 247.114 195.382 246.246 196.452 246.246C197.522 246.246 198.39 247.114 198.39 248.184Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M203.113 248.184C203.113 249.253 202.245 250.121 201.175 250.121C200.105 250.121 199.238 249.253 199.238 248.184C199.238 247.114 200.105 246.246 201.175 246.246C202.245 246.246 203.113 247.114 203.113 248.184Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M203.113 243.461C203.113 244.531 202.245 245.398 201.175 245.398C200.105 245.398 199.238 244.531 199.238 243.461C199.238 242.391 200.105 241.523 201.175 241.523C202.245 241.523 203.113 242.391 203.113 243.461Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M203.113 238.734C203.113 239.804 202.245 240.672 201.175 240.672C200.105 240.672 199.238 239.804 199.238 238.734C199.238 237.664 200.105 236.797 201.175 236.797C202.245 236.797 203.113 237.664 203.113 238.734Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M203.113 234.012C203.113 235.082 202.245 235.949 201.175 235.949C200.105 235.949 199.238 235.082 199.238 234.012C199.238 232.942 200.105 232.074 201.175 232.074C202.245 232.074 203.113 232.942 203.113 234.012Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M198.39 234.012C198.39 235.082 197.522 235.949 196.452 235.949C195.382 235.949 194.514 235.082 194.514 234.012C194.514 232.942 195.382 232.074 196.452 232.074C197.522 232.074 198.39 232.942 198.39 234.012Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M198.39 229.289C198.39 230.359 197.522 231.227 196.452 231.227C195.382 231.227 194.514 230.359 194.514 229.289C194.514 228.219 195.382 227.351 196.452 227.351C197.522 227.351 198.39 228.219 198.39 229.289Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M193.666 229.289C193.666 230.359 192.799 231.227 191.729 231.227C190.659 231.227 189.791 230.359 189.791 229.289C189.791 228.219 190.659 227.351 191.729 227.351C192.799 227.351 193.666 228.219 193.666 229.289Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M193.666 234.012C193.666 235.082 192.799 235.949 191.729 235.949C190.659 235.949 189.791 235.082 189.791 234.012C189.791 232.942 190.659 232.074 191.729 232.074C192.799 232.074 193.666 232.942 193.666 234.012Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M193.666 238.734C193.666 239.804 192.799 240.672 191.729 240.672C190.659 240.672 189.791 239.804 189.791 238.734C189.791 237.664 190.659 236.797 191.729 236.797C192.799 236.797 193.666 237.664 193.666 238.734Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M193.666 243.461C193.666 244.531 192.799 245.398 191.729 245.398C190.659 245.398 189.791 244.531 189.791 243.461C189.791 242.391 190.659 241.523 191.729 241.523C192.799 241.523 193.666 242.391 193.666 243.461Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M198.39 243.461C198.39 244.531 197.522 245.398 196.452 245.398C195.382 245.398 194.514 244.531 194.514 243.461C194.514 242.391 195.382 241.523 196.452 241.523C197.522 241.523 198.39 242.391 198.39 243.461Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M198.39 238.734C198.39 239.804 197.522 240.672 196.452 240.672C195.382 240.672 194.514 239.804 194.514 238.734C194.514 237.664 195.382 236.797 196.452 236.797C197.522 236.797 198.39 237.664 198.39 238.734Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M155.881 200.949C155.881 202.019 155.013 202.887 153.943 202.887C152.873 202.887 152.006 202.019 152.006 200.949C152.006 199.879 152.873 199.012 153.943 199.012C155.013 199.012 155.881 199.879 155.881 200.949Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M217.282 229.289C217.282 230.359 216.415 231.227 215.345 231.227C214.275 231.227 213.407 230.359 213.407 229.289C213.407 228.219 214.275 227.351 215.345 227.351C216.415 227.351 217.282 228.219 217.282 229.289Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M122.819 219.844C122.819 220.914 121.951 221.781 120.881 221.781C119.811 221.781 118.944 220.914 118.944 219.844C118.944 218.774 119.811 217.906 120.881 217.906C121.951 217.906 122.819 218.774 122.819 219.844Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M146.435 224.566C146.435 225.636 145.567 226.504 144.497 226.504C143.427 226.504 142.56 225.636 142.56 224.566C142.56 223.496 143.427 222.629 144.497 222.629C145.567 222.629 146.435 223.496 146.435 224.566Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M207.836 257.629C207.836 258.699 206.968 259.566 205.898 259.566C204.828 259.566 203.961 258.699 203.961 257.629C203.961 256.559 204.828 255.691 205.898 255.691C206.968 255.691 207.836 256.559 207.836 257.629Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M212.559 257.629C212.559 258.699 211.691 259.566 210.621 259.566C209.551 259.566 208.684 258.699 208.684 257.629C208.684 256.559 209.551 255.691 210.621 255.691C211.691 255.691 212.559 256.559 212.559 257.629Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M212.559 252.906C212.559 253.976 211.691 254.844 210.621 254.844C209.551 254.844 208.684 253.976 208.684 252.906C208.684 251.836 209.551 250.969 210.621 250.969C211.691 250.969 212.559 251.836 212.559 252.906Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M212.559 248.184C212.559 249.253 211.691 250.121 210.621 250.121C209.551 250.121 208.684 249.253 208.684 248.184C208.684 247.114 209.551 246.246 210.621 246.246C211.691 246.246 212.559 247.114 212.559 248.184Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M212.559 243.461C212.559 244.531 211.691 245.398 210.621 245.398C209.551 245.398 208.684 244.531 208.684 243.461C208.684 242.391 209.551 241.523 210.621 241.523C211.691 241.523 212.559 242.391 212.559 243.461Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M212.559 238.734C212.559 239.804 211.691 240.672 210.621 240.672C209.551 240.672 208.684 239.804 208.684 238.734C208.684 237.664 209.551 236.797 210.621 236.797C211.691 236.797 212.559 237.664 212.559 238.734Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M217.282 238.734C217.282 239.804 216.415 240.672 215.345 240.672C214.275 240.672 213.407 239.804 213.407 238.734C213.407 237.664 214.275 236.797 215.345 236.797C216.415 236.797 217.282 237.664 217.282 238.734Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M217.282 234.012C217.282 235.082 216.415 235.949 215.345 235.949C214.275 235.949 213.407 235.082 213.407 234.012C213.407 232.942 214.275 232.074 215.345 232.074C216.415 232.074 217.282 232.942 217.282 234.012Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M222.005 234.012C222.005 235.082 221.138 235.949 220.068 235.949C218.998 235.949 218.13 235.082 218.13 234.012C218.13 232.942 218.998 232.074 220.068 232.074C221.138 232.074 222.005 232.942 222.005 234.012Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M170.05 267.074C170.05 268.144 169.183 269.012 168.113 269.012C167.043 269.012 166.175 268.144 166.175 267.074C166.175 266.004 167.043 265.137 168.113 265.137C169.183 265.137 170.05 266.004 170.05 267.074Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M170.05 271.797C170.05 272.867 169.183 273.734 168.113 273.734C167.043 273.734 166.175 272.867 166.175 271.797C166.175 270.727 167.043 269.859 168.113 269.859C169.183 269.859 170.05 270.727 170.05 271.797Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M174.774 271.797C174.774 272.867 173.906 273.734 172.836 273.734C171.766 273.734 170.898 272.867 170.898 271.797C170.898 270.727 171.766 269.859 172.836 269.859C173.906 269.859 174.774 270.727 174.774 271.797Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M179.497 271.797C179.497 272.867 178.629 273.734 177.559 273.734C176.489 273.734 175.622 272.867 175.622 271.797C175.622 270.727 176.489 269.859 177.559 269.859C178.629 269.859 179.497 270.727 179.497 271.797Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M184.22 271.797C184.22 272.867 183.352 273.734 182.282 273.734C181.212 273.734 180.345 272.867 180.345 271.797C180.345 270.727 181.212 269.859 182.282 269.859C183.352 269.859 184.22 270.727 184.22 271.797Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M174.774 267.074C174.774 268.144 173.906 269.012 172.836 269.012C171.766 269.012 170.898 268.144 170.898 267.074C170.898 266.004 171.766 265.137 172.836 265.137C173.906 265.137 174.774 266.004 174.774 267.074Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M179.497 267.074C179.497 268.144 178.629 269.012 177.559 269.012C176.489 269.012 175.622 268.144 175.622 267.074C175.622 266.004 176.489 265.137 177.559 265.137C178.629 265.137 179.497 266.004 179.497 267.074Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M184.22 267.074C184.22 268.144 183.352 269.012 182.282 269.012C181.212 269.012 180.345 268.144 180.345 267.074C180.345 266.004 181.212 265.137 182.282 265.137C183.352 265.137 184.22 266.004 184.22 267.074Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M170.051 285.969C170.051 287.039 169.183 287.906 168.113 287.906C167.043 287.906 166.176 287.039 166.176 285.969C166.176 284.899 167.043 284.031 168.113 284.031C169.183 284.031 170.051 284.899 170.051 285.969Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M170.051 290.691C170.051 291.761 169.183 292.629 168.113 292.629C167.043 292.629 166.176 291.761 166.176 290.691C166.176 289.621 167.043 288.754 168.113 288.754C169.183 288.754 170.051 289.621 170.051 290.691Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M170.051 295.414C170.051 296.484 169.183 297.352 168.113 297.352C167.043 297.352 166.176 296.484 166.176 295.414C166.176 294.344 167.043 293.476 168.113 293.476C169.183 293.476 170.051 294.344 170.051 295.414Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M174.774 295.414C174.774 296.484 173.906 297.352 172.836 297.352C171.766 297.352 170.899 296.484 170.899 295.414C170.899 294.344 171.766 293.476 172.836 293.476C173.906 293.476 174.774 294.344 174.774 295.414Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M174.774 290.691C174.774 291.761 173.906 292.629 172.836 292.629C171.766 292.629 170.899 291.761 170.899 290.691C170.899 289.621 171.766 288.754 172.836 288.754C173.906 288.754 174.774 289.621 174.774 290.691Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M174.774 285.969C174.774 287.039 173.906 287.906 172.836 287.906C171.766 287.906 170.899 287.039 170.899 285.969C170.899 284.899 171.766 284.031 172.836 284.031C173.906 284.031 174.774 284.899 174.774 285.969Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M179.497 285.969C179.497 287.039 178.629 287.906 177.559 287.906C176.489 287.906 175.622 287.039 175.622 285.969C175.622 284.899 176.489 284.031 177.559 284.031C178.629 284.031 179.497 284.899 179.497 285.969Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M179.497 290.691C179.497 291.761 178.629 292.629 177.559 292.629C176.489 292.629 175.622 291.761 175.622 290.691C175.622 289.621 176.489 288.754 177.559 288.754C178.629 288.754 179.497 289.621 179.497 290.691Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M184.22 290.691C184.22 291.761 183.353 292.629 182.283 292.629C181.213 292.629 180.345 291.761 180.345 290.691C180.345 289.621 181.213 288.754 182.283 288.754C183.353 288.754 184.22 289.621 184.22 290.691Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M184.22 285.969C184.22 287.039 183.353 287.906 182.283 287.906C181.213 287.906 180.345 287.039 180.345 285.969C180.345 284.899 181.213 284.031 182.283 284.031C183.353 284.031 184.22 284.899 184.22 285.969Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M184.22 281.246C184.22 282.316 183.353 283.184 182.283 283.184C181.213 283.184 180.345 282.316 180.345 281.246C180.345 280.176 181.213 279.308 182.283 279.308C183.353 279.308 184.22 280.176 184.22 281.246Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M188.943 281.246C188.943 282.316 188.076 283.184 187.006 283.184C185.936 283.184 185.068 282.316 185.068 281.246C185.068 280.176 185.936 279.308 187.006 279.308C188.076 279.308 188.943 280.176 188.943 281.246Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M193.666 281.246C193.666 282.316 192.799 283.184 191.729 283.184C190.659 283.184 189.791 282.316 189.791 281.246C189.791 280.176 190.659 279.308 191.729 279.308C192.799 279.308 193.666 280.176 193.666 281.246Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M193.666 276.523C193.666 277.593 192.799 278.461 191.729 278.461C190.659 278.461 189.791 277.593 189.791 276.523C189.791 275.453 190.659 274.586 191.729 274.586C192.799 274.586 193.666 275.453 193.666 276.523Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M193.666 271.797C193.666 272.867 192.799 273.734 191.729 273.734C190.659 273.734 189.791 272.867 189.791 271.797C189.791 270.727 190.659 269.859 191.729 269.859C192.799 269.859 193.666 270.727 193.666 271.797Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M198.39 271.797C198.39 272.867 197.522 273.734 196.452 273.734C195.382 273.734 194.515 272.867 194.515 271.797C194.515 270.727 195.382 269.859 196.452 269.859C197.522 269.859 198.39 270.727 198.39 271.797Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M198.39 267.074C198.39 268.144 197.522 269.012 196.452 269.012C195.382 269.012 194.515 268.144 194.515 267.074C194.515 266.004 195.382 265.137 196.452 265.137C197.522 265.137 198.39 266.004 198.39 267.074Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M193.666 267.074C193.666 268.144 192.799 269.012 191.729 269.012C190.659 269.012 189.791 268.144 189.791 267.074C189.791 266.004 190.659 265.137 191.729 265.137C192.799 265.137 193.666 266.004 193.666 267.074Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M188.943 267.074C188.943 268.144 188.075 269.012 187.005 269.012C185.935 269.012 185.068 268.144 185.068 267.074C185.068 266.004 185.935 265.137 187.005 265.137C188.075 265.137 188.943 266.004 188.943 267.074Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M188.943 271.797C188.943 272.867 188.075 273.734 187.005 273.734C185.935 273.734 185.068 272.867 185.068 271.797C185.068 270.727 185.935 269.859 187.005 269.859C188.075 269.859 188.943 270.727 188.943 271.797Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M188.943 276.519C188.943 277.589 188.076 278.457 187.006 278.457C185.936 278.457 185.068 277.589 185.068 276.519C185.068 275.449 185.936 274.582 187.006 274.582C188.076 274.582 188.943 275.449 188.943 276.519Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M184.22 276.519C184.22 277.589 183.353 278.457 182.283 278.457C181.213 278.457 180.345 277.589 180.345 276.519C180.345 275.449 181.213 274.582 182.283 274.582C183.353 274.582 184.22 275.449 184.22 276.519Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M179.497 276.519C179.497 277.589 178.629 278.457 177.559 278.457C176.489 278.457 175.622 277.589 175.622 276.519C175.622 275.449 176.489 274.582 177.559 274.582C178.629 274.582 179.497 275.449 179.497 276.519Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M174.774 276.519C174.774 277.589 173.906 278.457 172.836 278.457C171.766 278.457 170.899 277.589 170.899 276.519C170.899 275.449 171.766 274.582 172.836 274.582C173.906 274.582 174.774 275.449 174.774 276.519Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M170.051 276.519C170.051 277.589 169.183 278.457 168.113 278.457C167.043 278.457 166.176 277.589 166.176 276.519C166.176 275.449 167.043 274.582 168.113 274.582C169.183 274.582 170.051 275.449 170.051 276.519Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M170.051 281.246C170.051 282.316 169.183 283.184 168.113 283.184C167.043 283.184 166.176 282.316 166.176 281.246C166.176 280.176 167.043 279.308 168.113 279.308C169.183 279.308 170.051 280.176 170.051 281.246Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M174.774 281.246C174.774 282.316 173.906 283.184 172.836 283.184C171.766 283.184 170.899 282.316 170.899 281.246C170.899 280.176 171.766 279.308 172.836 279.308C173.906 279.308 174.774 280.176 174.774 281.246Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M179.497 281.246C179.497 282.316 178.629 283.184 177.559 283.184C176.489 283.184 175.622 282.316 175.622 281.246C175.622 280.176 176.489 279.308 177.559 279.308C178.629 279.308 179.497 280.176 179.497 281.246Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M179.497 295.414C179.497 296.484 178.629 297.352 177.559 297.352C176.489 297.352 175.622 296.484 175.622 295.414C175.622 294.344 176.489 293.476 177.559 293.476C178.629 293.476 179.497 294.344 179.497 295.414Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M170.051 309.582C170.051 310.652 169.183 311.52 168.113 311.52C167.043 311.52 166.176 310.652 166.176 309.582C166.176 308.512 167.043 307.644 168.113 307.644C169.183 307.644 170.051 308.512 170.051 309.582Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M170.051 304.859C170.051 305.929 169.183 306.797 168.113 306.797C167.043 306.797 166.176 305.929 166.176 304.859C166.176 303.789 167.043 302.922 168.113 302.922C169.183 302.922 170.051 303.789 170.051 304.859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M174.774 304.859C174.774 305.929 173.906 306.797 172.836 306.797C171.766 306.797 170.899 305.929 170.899 304.859C170.899 303.789 171.766 302.922 172.836 302.922C173.906 302.922 174.774 303.789 174.774 304.859Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M174.774 300.137C174.774 301.207 173.906 302.074 172.836 302.074C171.766 302.074 170.899 301.207 170.899 300.137C170.899 299.067 171.766 298.199 172.836 298.199C173.906 298.199 174.774 299.067 174.774 300.137Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M170.051 300.137C170.051 301.207 169.183 302.074 168.113 302.074C167.043 302.074 166.176 301.207 166.176 300.137C166.176 299.067 167.043 298.199 168.113 298.199C169.183 298.199 170.051 299.067 170.051 300.137Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M392.1 153.719C392.1 154.789 391.233 155.656 390.163 155.656C389.093 155.656 388.225 154.789 388.225 153.719C388.225 152.649 389.093 151.781 390.163 151.781C391.233 151.781 392.1 152.649 392.1 153.719Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M392.1 148.996C392.1 150.066 391.233 150.934 390.163 150.934C389.093 150.934 388.225 150.066 388.225 148.996C388.225 147.926 389.093 147.058 390.163 147.058C391.233 147.058 392.1 147.926 392.1 148.996Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M396.823 148.996C396.823 150.066 395.956 150.934 394.886 150.934C393.816 150.934 392.948 150.066 392.948 148.996C392.948 147.926 393.816 147.058 394.886 147.058C395.956 147.058 396.823 147.926 396.823 148.996Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M396.823 153.719C396.823 154.789 395.956 155.656 394.886 155.656C393.816 155.656 392.948 154.789 392.948 153.719C392.948 152.649 393.816 151.781 394.886 151.781C395.956 151.781 396.823 152.649 396.823 153.719Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M401.455 148.996C401.455 150.066 400.588 150.934 399.518 150.934C398.448 150.934 397.58 150.066 397.58 148.996C397.58 147.926 398.448 147.058 399.518 147.058C400.588 147.058 401.455 147.926 401.455 148.996Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M401.455 153.719C401.455 154.789 400.588 155.656 399.518 155.656C398.448 155.656 397.58 154.789 397.58 153.719C397.58 152.649 398.448 151.781 399.518 151.781C400.588 151.781 401.455 152.649 401.455 153.719Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M406.178 153.719C406.178 154.789 405.311 155.656 404.241 155.656C403.171 155.656 402.303 154.789 402.303 153.719C402.303 152.649 403.171 151.781 404.241 151.781C405.311 151.781 406.178 152.649 406.178 153.719Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M406.178 148.996C406.178 150.066 405.311 150.934 404.241 150.934C403.171 150.934 402.303 150.066 402.303 148.996C402.303 147.926 403.171 147.058 404.241 147.058C405.311 147.058 406.178 147.926 406.178 148.996Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M410.902 148.996C410.902 150.066 410.034 150.934 408.964 150.934C407.894 150.934 407.026 150.066 407.026 148.996C407.026 147.926 407.894 147.058 408.964 147.058C410.034 147.058 410.902 147.926 410.902 148.996Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M410.902 153.719C410.902 154.789 410.034 155.656 408.964 155.656C407.894 155.656 407.026 154.789 407.026 153.719C407.026 152.649 407.894 151.781 408.964 151.781C410.034 151.781 410.902 152.649 410.902 153.719Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M415.685 153.719C415.685 154.789 414.817 155.656 413.748 155.656C412.678 155.656 411.81 154.789 411.81 153.719C411.81 152.649 412.678 151.781 413.748 151.781C414.817 151.781 415.685 152.649 415.685 153.719Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M415.685 148.996C415.685 150.066 414.817 150.934 413.748 150.934C412.678 150.934 411.81 150.066 411.81 148.996C411.81 147.926 412.678 147.058 413.748 147.058C414.817 147.058 415.685 147.926 415.685 148.996Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M420.408 148.996C420.408 150.066 419.541 150.934 418.471 150.934C417.401 150.934 416.533 150.066 416.533 148.996C416.533 147.926 417.401 147.058 418.471 147.058C419.541 147.058 420.408 147.926 420.408 148.996Z"
                      fill="#D4D4D4"
                    />
                    <path
                      d="M420.408 153.719C420.408 154.789 419.541 155.656 418.471 155.656C417.401 155.656 416.533 154.789 416.533 153.719C416.533 152.649 417.401 151.781 418.471 151.781C419.541 151.781 420.408 152.649 420.408 153.719Z"
                      fill="#D4D4D4"
                    />
                  </svg>

                  <div className={styles.group_12}>
                    <div className={styles.ellipse_24}></div>
                    <div className={styles.ellipse_25}></div>
                  </div>
                  <div className={styles.group_5}>
                    <div className={styles.ellipse_242}></div>
                    <div className={styles.ellipse_252}></div>
                  </div>
                  <div className={styles.group_4}>
                    <div className={styles.ellipse_243}></div>
                    <div className={styles.ellipse_253}></div>
                  </div>
                  <img className={styles.image_1} src="/images/Dashboard_Detail/image-10.png" />
                  <div className={styles.map2}>
                    <div className={styles.circle}></div>
                    <div className={styles.circle2}></div>
                    <div className={styles.circle3}></div>
                  </div>
                  <div className={styles.map3}>
                    <div className={styles.circle}></div>
                    <div className={styles.circle2}></div>
                    <div className={styles.circle3}></div>
                  </div>
                  <div className={styles.map4}>
                    <div className={styles.circle}></div>
                    <div className={styles.circle2}></div>
                    <div className={styles.circle3}></div>
                  </div>
                  <div className={styles.map5}>
                    <div className={styles.circle}></div>
                    <div className={styles.circle2}></div>
                    <div className={styles.circle3}></div>
                  </div>
                  <div className={styles.map6}>
                    <div className={styles.circle}></div>
                    <div className={styles.circle2}></div>
                    <div className={styles.circle3}></div>
                  </div>
                  <div className={styles.map7}>
                    <div className={styles.circle}></div>
                    <div className={styles.circle2}></div>
                    <div className={styles.circle3}></div>
                  </div>
                  <div className={styles.group_13}>
                    <svg
                      className={styles.union2}
                      width="200"
                      height="128"
                      viewBox="0 0 200 128"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g filter="url(#filter0_dd_593_44047)">
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M40 20.1367C31.1634 20.1367 24 27.3002 24 36.1367V76.1367C24 84.9733 31.1634 92.1367 40 92.1367H92.9999L98.4435 99.1152C99.2442 100.142 100.797 100.142 101.597 99.1152L107.041 92.1367H160C168.837 92.1367 176 84.9733 176 76.1367V36.1367C176 27.3002 168.837 20.1367 160 20.1367H40Z"
                          fill="white"
                        />
                      </g>
                      <defs>
                        <filter
                          id="filter0_dd_593_44047"
                          x="0"
                          y="0.136719"
                          width="200"
                          height="127.75"
                          filterUnits="userSpaceOnUse"
                          color-interpolation-filters="sRGB"
                        >
                          <feFlood
                            flood-opacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="4" />
                          <feGaussianBlur stdDeviation="12" />
                          <feComposite in2="hardAlpha" operator="out" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_593_44047"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="2" />
                          <feGaussianBlur stdDeviation="4" />
                          <feComposite in2="hardAlpha" operator="out" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="effect1_dropShadow_593_44047"
                            result="effect2_dropShadow_593_44047"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect2_dropShadow_593_44047"
                            result="shape"
                          />
                        </filter>
                      </defs>
                    </svg>

                    <div className={styles.frame_146}>
                      <img className={styles.ellipse_23} src="/images/Dashboard_Detail/ellipse-230.png" />
                      <div className={styles.frame_145}>
                        <div className={styles.london_uk}>London, UK</div>
                        <div className={styles._523_users}>523 users</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={styles.frame_136}>
                  <div className={styles._8_8_k}>8.8k</div>
                  <div className={styles.frame_141}>
                    <div className={styles.frame_137}>
                      <img className={styles.ellipse_23} src="/images/Dashboard_Detail/ellipse-231.png" />
                      <div className={styles.frame_138}>
                        <div className={styles.united_states}>United States</div>
                        <div className={styles.frame_140}>
                          <div className={styles.frame_139}>
                            <div className={styles.rectangle_28}></div>
                            <div className={styles.rectangle_27}></div>
                          </div>
                          <div className={styles._55}>55%</div>
                        </div>
                      </div>
                    </div>
                    <div className={styles.frame_1382}>
                      <img className={styles.ellipse_23} src="/images/Dashboard_Detail/ellipse-232.png" />
                      <div className={styles.frame_138}>
                        <div className={styles.canada}>Canada</div>
                        <div className={styles.frame_140}>
                          <div className={styles.frame_139}>
                            <div className={styles.rectangle_28}></div>
                            <div className={styles.rectangle_272}></div>
                          </div>
                          <div className={styles._45}>45%</div>
                        </div>
                      </div>
                    </div>
                    <div className={styles.frame_1392}>
                      <img className={styles.ellipse_23} src="/images/Dashboard_Detail/ellipse-233.png" />
                      <div className={styles.frame_138}>
                        <div className={styles.australia}>Australia</div>
                        <div className={styles.frame_140}>
                          <div className={styles.frame_139}>
                            <div className={styles.rectangle_28}></div>
                            <div className={styles.rectangle_273}></div>
                          </div>
                          <div className={styles._25}>25%</div>
                        </div>
                      </div>
                    </div>
                    <div className={styles.frame_1402}>
                      <img className={styles.ellipse_23} src="/images/Dashboard_Detail/ellipse-234.png" />
                      <div className={styles.frame_138}>
                        <div className={styles.united_kingdom}>United Kingdom</div>
                        <div className={styles.frame_140}>
                          <div className={styles.frame_139}>
                            <div className={styles.rectangle_28}></div>
                            <div className={styles.rectangle_274}></div>
                          </div>
                          <div className={styles._15}>15%</div>
                        </div>
                      </div>
                    </div>
                    <div className={styles.frame_1412}>
                      <img className={styles.ellipse_23} src="/images/Dashboard_Detail/ellipse-235.png" />
                      <div className={styles.frame_138}>
                        <div className={styles.ireland}>Ireland</div>
                        <div className={styles.frame_140}>
                          <div className={styles.frame_139}>
                            <div className={styles.rectangle_28}></div>
                            <div className={styles.rectangle_275}></div>
                          </div>
                          <div className={styles._10}>10%</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.range_calendar}>
        <div className={styles.start_month}>
          <div className={styles.month_header}>
            <div className={styles.buttons}>
              <div className={styles.icon_button}>
                <svg
                  className={styles.caret_left}
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <mask id="path-1-inside-1_856_11676" fill="white">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M9.40588 4.4609C9.59333 4.64836 9.59333 4.95228 9.40588 5.13973L6.54529 8.00032L9.40588 10.8609C9.59333 11.0483 9.59333 11.3522 9.40588 11.5397C9.21843 11.7272 8.91451 11.7272 8.72706 11.5397L5.52706 8.33973C5.43705 8.2497 5.38647 8.12761 5.38647 8.00032C5.38647 7.87301 5.43705 7.75092 5.52706 7.6609L8.72706 4.4609C8.91451 4.27345 9.21843 4.27345 9.40588 4.4609Z"
                    />
                  </mask>
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.40588 4.4609C9.59333 4.64836 9.59333 4.95228 9.40588 5.13973L6.54529 8.00032L9.40588 10.8609C9.59333 11.0483 9.59333 11.3522 9.40588 11.5397C9.21843 11.7272 8.91451 11.7272 8.72706 11.5397L5.52706 8.33973C5.43705 8.2497 5.38647 8.12761 5.38647 8.00032C5.38647 7.87301 5.43705 7.75092 5.52706 7.6609L8.72706 4.4609C8.91451 4.27345 9.21843 4.27345 9.40588 4.4609Z"
                    fill="#262626"
                  />
                  <path
                    d="M9.40588 4.4609L8.69875 5.16799L8.69877 5.16801L9.40588 4.4609ZM9.40588 5.13973L10.113 5.84684V5.84684L9.40588 5.13973ZM6.54529 8.00032L5.83818 7.29321L5.13108 8.00032L5.83818 8.70742L6.54529 8.00032ZM9.40588 10.8609L8.69877 11.568L8.69885 11.5681L9.40588 10.8609ZM9.40588 11.5397L10.1129 12.2469L10.1131 12.2467L9.40588 11.5397ZM8.72706 11.5397L8.01995 12.2468L8.02001 12.2469L8.72706 11.5397ZM5.52706 8.33973L4.81991 9.0468L4.81995 9.04684L5.52706 8.33973ZM5.52706 7.6609L6.23417 8.36801H6.23417L5.52706 7.6609ZM8.72706 4.4609L9.43417 5.16801L9.43419 5.16799L8.72706 4.4609ZM8.69877 5.16801C8.4957 4.96494 8.4957 4.63569 8.69877 4.43262L10.113 5.84684C10.691 5.26886 10.691 4.33178 10.113 3.7538L8.69877 5.16801ZM8.69877 4.43262L5.83818 7.29321L7.2524 8.70743L10.113 5.84684L8.69877 4.43262ZM5.83818 8.70742L8.69877 11.568L10.113 10.1538L7.2524 7.29321L5.83818 8.70742ZM8.69885 11.5681C8.49556 11.3649 8.49585 11.0356 8.69865 10.8328L10.1131 12.2467C10.6908 11.6688 10.6911 10.7318 10.1129 10.1537L8.69885 11.5681ZM8.69883 10.8326C8.9019 10.6295 9.23104 10.6295 9.43411 10.8326L8.02001 12.2469C8.59797 12.8248 9.53497 12.8248 10.1129 12.2469L8.69883 10.8326ZM9.43417 10.8326L6.23417 7.63263L4.81995 9.04684L8.01995 12.2468L9.43417 10.8326ZM6.23421 7.63267C6.33168 7.73015 6.38647 7.86239 6.38647 8.00032H4.38647C4.38647 8.39284 4.54241 8.76926 4.81991 9.0468L6.23421 7.63267ZM6.38647 8.00032C6.38647 8.13822 6.3317 8.27048 6.23417 8.36801L4.81995 6.9538C4.5424 7.23136 4.38647 7.6078 4.38647 8.00032H6.38647ZM6.23417 8.36801L9.43417 5.16801L8.01995 3.7538L4.81995 6.9538L6.23417 8.36801ZM9.43419 5.16799C9.2311 5.37109 8.90183 5.37109 8.69875 5.16799L10.113 3.75382C9.53503 3.17581 8.59791 3.17581 8.01993 3.75382L9.43419 5.16799Z"
                    fill="#262626"
                    mask="url(#path-1-inside-1_856_11676)"
                  />
                </svg>
              </div>
              <div className={styles.blank}></div>
            </div>
            <div className={styles.month}>
              <div className={styles.june_2023}>June 2023</div>
            </div>
          </div>
          <div className={styles.day_picker}>
            <div className={styles.week_header}>
              <div className={styles.week_day}>
                <div className={styles.su}>Su</div>
              </div>
              <div className={styles.week_day}>
                <div className={styles.mo}>Mo</div>
              </div>
              <div className={styles.week_day}>
                <div className={styles.tu}>Tu</div>
              </div>
              <div className={styles.week_day}>
                <div className={styles.we}>We</div>
              </div>
              <div className={styles.week_day}>
                <div className={styles.th}>Th</div>
              </div>
              <div className={styles.week_day}>
                <div className={styles.fr}>Fr</div>
              </div>
              <div className={styles.week_day}>
                <div className={styles.sa}>Sa</div>
              </div>
            </div>
            <div className={styles.container}>
              <div className={styles.range_week_days}>
                <div className={styles.range_day}>
                  <div className={styles.button4}>
                    <div className={styles._30}>28</div>
                  </div>
                </div>
                <div className={styles.range_day2}>
                  <div className={styles.button4}>
                    <div className={styles._30}>29</div>
                  </div>
                </div>
                <div className={styles.range_day2}>
                  <div className={styles.button4}>
                    <div className={styles._30}>30</div>
                  </div>
                </div>
                <div className={styles.range_day2}>
                  <div className={styles.button4}>
                    <div className={styles._30}>31</div>
                  </div>
                </div>
                <div className={styles.range_day3}>
                  <div className={styles.button5}>
                    <div className={styles._302}>1</div>
                  </div>
                </div>
                <div className={styles.range_day3}>
                  <div className={styles.button5}>
                    <div className={styles._302}>2</div>
                  </div>
                </div>
                <div className={styles.range_day3}>
                  <div className={styles.button5}>
                    <div className={styles._302}>3</div>
                  </div>
                </div>
              </div>
              <div className={styles.range_week_days}>
                <div className={styles.range_day4}>
                  <div className={styles.button5}>
                    <div className={styles._302}>4</div>
                  </div>
                </div>
                <div className={styles.range_day3}>
                  <div className={styles.button5}>
                    <div className={styles._302}>5</div>
                  </div>
                </div>
                <div className={styles.range_day3}>
                  <div className={styles.button5}>
                    <div className={styles._302}>6</div>
                  </div>
                </div>
                <div className={styles.range_day3}>
                  <div className={styles.button5}>
                    <div className={styles._302}>7</div>
                  </div>
                </div>
                <div className={styles.range_day3}>
                  <div className={styles.button5}>
                    <div className={styles._302}>8</div>
                  </div>
                </div>
                <div className={styles.range_day3}>
                  <div className={styles.button5}>
                    <div className={styles._302}>9</div>
                  </div>
                </div>
                <div className={styles.range_day3}>
                  <div className={styles.button5}>
                    <div className={styles._302}>10</div>
                  </div>
                </div>
              </div>
              <div className={styles.range_week_days}>
                <div className={styles.range_day4}>
                  <div className={styles.button5}>
                    <div className={styles._302}>11</div>
                  </div>
                </div>
                <div className={styles.range_day3}>
                  <div className={styles.button5}>
                    <div className={styles._302}>12</div>
                  </div>
                </div>
                <div className={styles.range_day5}>
                  <div className={styles.button6}>
                    <div className={styles._303}>13</div>
                  </div>
                </div>
                <div className={styles.range_day6}>
                  <div className={styles.button5}>
                    <div className={styles._302}>14</div>
                  </div>
                </div>
                <div className={styles.range_day6}>
                  <div className={styles.button5}>
                    <div className={styles._302}>15</div>
                  </div>
                </div>
                <div className={styles.range_day6}>
                  <div className={styles.button5}>
                    <div className={styles._302}>16</div>
                  </div>
                </div>
                <div className={styles.range_day6}>
                  <div className={styles.button5}>
                    <div className={styles._302}>17</div>
                  </div>
                </div>
              </div>
              <div className={styles.range_week_days}>
                <div className={styles.range_day7}>
                  <div className={styles.button5}>
                    <div className={styles._302}>18</div>
                  </div>
                </div>
                <div className={styles.range_day6}>
                  <div className={styles.button5}>
                    <div className={styles._302}>19</div>
                  </div>
                </div>
                <div className={styles.range_day6}>
                  <div className={styles.button5}>
                    <div className={styles._302}>20</div>
                  </div>
                </div>
                <div className={styles.range_day6}>
                  <div className={styles.button5}>
                    <div className={styles._302}>21</div>
                  </div>
                </div>
                <div className={styles.range_day6}>
                  <div className={styles.button5}>
                    <div className={styles._302}>22</div>
                  </div>
                </div>
                <div className={styles.range_day6}>
                  <div className={styles.button5}>
                    <div className={styles._302}>23</div>
                  </div>
                </div>
                <div className={styles.range_day6}>
                  <div className={styles.button5}>
                    <div className={styles._302}>24</div>
                  </div>
                </div>
              </div>
              <div className={styles.range_week_days}>
                <div className={styles.range_day7}>
                  <div className={styles.button5}>
                    <div className={styles._302}>25</div>
                  </div>
                </div>
                <div className={styles.range_day6}>
                  <div className={styles.button5}>
                    <div className={styles._302}>26</div>
                  </div>
                </div>
                <div className={styles.range_day6}>
                  <div className={styles.button5}>
                    <div className={styles._302}>27</div>
                  </div>
                </div>
                <div className={styles.range_day6}>
                  <div className={styles.button5}>
                    <div className={styles._302}>28</div>
                  </div>
                </div>
                <div className={styles.range_day6}>
                  <div className={styles.button5}>
                    <div className={styles._302}>29</div>
                  </div>
                </div>
                <div className={styles.range_day6}>
                  <div className={styles.button5}>
                    <div className={styles._302}>30</div>
                  </div>
                </div>
                <div className={styles.range_day6}>
                  <div className={styles.button5}>
                    <div className={styles._302}>1</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.start_month}>
          <div className={styles.month_header}>
            <div className={styles.buttons}>
              <div className={styles.blank}></div>
              <div className={styles.icon_button}>
                <svg
                  className={styles.chevron_right}
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.91092 3.70825L6.91094 3.70823C6.92435 3.69566 6.94544 3.69632 6.95805 3.70976C6.95805 3.70976 6.95805 3.70976 6.95805 3.70976L10.958 7.97643L11.3228 7.63446L10.958 7.97643C10.97 7.98923 10.97 8.00919 10.958 8.02202C10.958 8.02203 10.958 8.02203 10.958 8.02203L6.95805 12.2887L6.95802 12.2887C6.94543 12.3021 6.92439 12.3028 6.91097 12.2902L6.91096 12.2902C6.89744 12.2775 6.89688 12.2565 6.90936 12.2432L6.90941 12.2431L10.5674 8.34119L10.888 7.99922L10.5674 7.65725L6.90941 3.75536L6.90941 3.75535C6.89681 3.74192 6.8975 3.72083 6.91092 3.70825Z"
                    fill="#262626"
                    stroke="#262626"
                  />
                </svg>
              </div>
            </div>
            <div className={styles.month}>
              <div className={styles.june_2023}>July 2023</div>
            </div>
          </div>
          <div className={styles.day_picker}>
            <div className={styles.week_header}>
              <div className={styles.week_day}>
                <div className={styles.su}>Su</div>
              </div>
              <div className={styles.week_day}>
                <div className={styles.mo}>Mo</div>
              </div>
              <div className={styles.week_day}>
                <div className={styles.tu}>Tu</div>
              </div>
              <div className={styles.week_day}>
                <div className={styles.we}>We</div>
              </div>
              <div className={styles.week_day}>
                <div className={styles.th}>Th</div>
              </div>
              <div className={styles.week_day}>
                <div className={styles.fr}>Fr</div>
              </div>
              <div className={styles.week_day}>
                <div className={styles.sa}>Sa</div>
              </div>
            </div>
            <div className={styles.container}>
              <div className={styles.range_week_days}>
                <div className={styles.range_day7}>
                  <div className={styles.button5}>
                    <div className={styles._302}>25</div>
                  </div>
                </div>
                <div className={styles.range_day6}>
                  <div className={styles.button5}>
                    <div className={styles._302}>26</div>
                  </div>
                </div>
                <div className={styles.range_day6}>
                  <div className={styles.button5}>
                    <div className={styles._302}>27</div>
                  </div>
                </div>
                <div className={styles.range_day6}>
                  <div className={styles.button5}>
                    <div className={styles._302}>28</div>
                  </div>
                </div>
                <div className={styles.range_day6}>
                  <div className={styles.button5}>
                    <div className={styles._302}>29</div>
                  </div>
                </div>
                <div className={styles.range_day6}>
                  <div className={styles.button5}>
                    <div className={styles._302}>30</div>
                  </div>
                </div>
                <div className={styles.range_day6}>
                  <div className={styles.button5}>
                    <div className={styles._302}>1</div>
                  </div>
                </div>
              </div>
              <div className={styles.range_week_days}>
                <div className={styles.range_day7}>
                  <div className={styles.button5}>
                    <div className={styles._302}>2</div>
                  </div>
                </div>
                <div className={styles.range_day6}>
                  <div className={styles.button5}>
                    <div className={styles._302}>3</div>
                  </div>
                </div>
                <div className={styles.range_day6}>
                  <div className={styles.button5}>
                    <div className={styles._302}>4</div>
                  </div>
                </div>
                <div className={styles.range_day6}>
                  <div className={styles.button5}>
                    <div className={styles._302}>5</div>
                  </div>
                </div>
                <div className={styles.range_day6}>
                  <div className={styles.button5}>
                    <div className={styles._302}>6</div>
                  </div>
                </div>
                <div className={styles.range_day6}>
                  <div className={styles.button5}>
                    <div className={styles._302}>7</div>
                  </div>
                </div>
                <div className={styles.range_day6}>
                  <div className={styles.button5}>
                    <div className={styles._302}>8</div>
                  </div>
                </div>
              </div>
              <div className={styles.range_week_days}>
                <div className={styles.range_day7}>
                  <div className={styles.button5}>
                    <div className={styles._302}>9</div>
                  </div>
                </div>
                <div className={styles.range_day6}>
                  <div className={styles.button5}>
                    <div className={styles._302}>10</div>
                  </div>
                </div>
                <div className={styles.range_day6}>
                  <div className={styles.button5}>
                    <div className={styles._302}>11</div>
                  </div>
                </div>
                <div className={styles.range_day6}>
                  <div className={styles.button5}>
                    <div className={styles._302}>12</div>
                  </div>
                </div>
                <div className={styles.range_day6}>
                  <div className={styles.button5}>
                    <div className={styles._302}>13</div>
                  </div>
                </div>
                <div className={styles.range_day8}>
                  <div className={styles.button6}>
                    <div className={styles._303}>14</div>
                  </div>
                </div>
                <div className={styles.range_day3}>
                  <div className={styles.button5}>
                    <div className={styles._302}>15</div>
                  </div>
                </div>
              </div>
              <div className={styles.range_week_days}>
                <div className={styles.range_day4}>
                  <div className={styles.button5}>
                    <div className={styles._302}>16</div>
                  </div>
                </div>
                <div className={styles.range_day3}>
                  <div className={styles.button5}>
                    <div className={styles._302}>17</div>
                  </div>
                </div>
                <div className={styles.range_day3}>
                  <div className={styles.button5}>
                    <div className={styles._302}>18</div>
                  </div>
                </div>
                <div className={styles.range_day3}>
                  <div className={styles.button5}>
                    <div className={styles._302}>19</div>
                  </div>
                </div>
                <div className={styles.range_day3}>
                  <div className={styles.button5}>
                    <div className={styles._302}>20</div>
                  </div>
                </div>
                <div className={styles.range_day3}>
                  <div className={styles.button5}>
                    <div className={styles._302}>21</div>
                  </div>
                </div>
                <div className={styles.range_day3}>
                  <div className={styles.button5}>
                    <div className={styles._302}>22</div>
                  </div>
                </div>
              </div>
              <div className={styles.range_week_days}>
                <div className={styles.range_day4}>
                  <div className={styles.button5}>
                    <div className={styles._302}>23</div>
                  </div>
                </div>
                <div className={styles.range_day3}>
                  <div className={styles.button5}>
                    <div className={styles._302}>24</div>
                  </div>
                </div>
                <div className={styles.range_day3}>
                  <div className={styles.button5}>
                    <div className={styles._302}>25</div>
                  </div>
                </div>
                <div className={styles.range_day3}>
                  <div className={styles.button5}>
                    <div className={styles._302}>26</div>
                  </div>
                </div>
                <div className={styles.range_day3}>
                  <div className={styles.button5}>
                    <div className={styles._302}>27</div>
                  </div>
                </div>
                <div className={styles.range_day3}>
                  <div className={styles.button5}>
                    <div className={styles._302}>28</div>
                  </div>
                </div>
                <div className={styles.range_day3}>
                  <div className={styles.button5}>
                    <div className={styles._302}>29</div>
                  </div>
                </div>
              </div>
              <div className={styles.range_week_days}>
                <div className={styles.range_day4}>
                  <div className={styles.button5}>
                    <div className={styles._302}>30</div>
                  </div>
                </div>
                <div className={styles.range_day3}>
                  <div className={styles.button5}>
                    <div className={styles._302}>31</div>
                  </div>
                </div>
                <div className={styles.range_day2}>
                  <div className={styles.button4}>
                    <div className={styles._30}>1</div>
                  </div>
                </div>
                <div className={styles.range_day2}>
                  <div className={styles.button4}>
                    <div className={styles._30}>2</div>
                  </div>
                </div>
                <div className={styles.range_day2}>
                  <div className={styles.button4}>
                    <div className={styles._30}>3</div>
                  </div>
                </div>
                <div className={styles.range_day2}>
                  <div className={styles.button4}>
                    <div className={styles._30}>4</div>
                  </div>
                </div>
                <div className={styles.range_day2}>
                  <div className={styles.button4}>
                    <div className={styles._30}>5</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.help_resources}>
        <div className={styles.group_16}>
          <div className={styles.overlay}>
            <div className={styles.help_resources2}>Help &amp; Resources</div>
          </div>
          <svg
            className={styles.polygon_7}
            width="15.999999046325684"
            height="16.000001907348633"
          ></svg>
        </div>
        <div className={styles.button7}>
          <svg
            className={styles.question_mark_cr_fr}
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.13926 8.22264C8.53765 8.45309 9.04742 8.31696 9.27787 7.91857C10.0754 6.76413 11.617 8.3013 10.353 9.05267C10.1258 9.18773 9.82874 9.41253 9.60277 9.68792C9.38879 9.94867 9.19228 10.3073 9.16916 10.748C9.16622 10.7765 9.16471 10.8054 9.16471 10.8346C9.16471 11.2949 9.53781 11.668 9.99805 11.668C10.6333 11.668 10.7542 11.3305 10.8762 10.99C10.9547 10.7709 11.0336 10.5506 11.2502 10.418C11.9391 9.99629 12.5002 9.24941 12.5002 8.33464C12.5002 6.95392 11.3809 5.83464 10.0002 5.83464C9.07383 5.83464 8.2662 6.33895 7.8352 7.08403C7.60474 7.48241 7.74088 7.99219 8.13926 8.22264Z"
              fill="white"
            />
            <path
              d="M9.16471 13.3346C9.16471 12.8744 9.53781 12.5013 9.99805 12.5013C10.4583 12.5013 10.8314 12.8744 10.8314 13.3346C10.8314 13.7949 10.4583 14.168 9.99805 14.168C9.53781 14.168 9.16471 13.7949 9.16471 13.3346Z"
              fill="white"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M10.0001 1.66797C5.39771 1.66797 1.66675 5.39893 1.66675 10.0013C1.66675 14.6037 5.39771 18.3346 10.0001 18.3346C14.6025 18.3346 18.3334 14.6037 18.3334 10.0013C18.3334 5.39893 14.6025 1.66797 10.0001 1.66797ZM3.33341 10.0013C3.33341 6.3194 6.31818 3.33464 10.0001 3.33464C13.682 3.33464 16.6667 6.3194 16.6667 10.0013C16.6667 13.6832 13.682 16.668 10.0001 16.668C6.31818 16.668 3.33341 13.6832 3.33341 10.0013Z"
              fill="white"
            />
          </svg>
        </div>
      </div>
    </div>
  </>
    );
};

export default Dashboard_Detail;
